let compositionsFetched = [
  {
    compositionName: "The Mill on the River",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/269966",
    dateCreated: "1774",
    imageUrl: "images/The_Mill_on_the_River.webp",
  },
  {
    compositionName: "Anthony van Dyck",
    author: ["Gustave Nicolas Bertinot", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/270039",
    dateCreated: "19th century",
    imageUrl: "images/Anthony_van_Dyck.webp",
  },
  {
    compositionName: "The Water-Mill",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/270089",
    dateCreated: "1782",
    imageUrl: "images/The_Water_Mill.webp",
  },
  {
    compositionName: "Herdsman and Bull",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/270553",
    dateCreated: "1772",
    imageUrl: "images/Herdsman_and_Bull.webp",
  },
  {
    compositionName: "The Wheat Field",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/270619",
    dateCreated: "1772",
    imageUrl: "images/The_Wheat_Field.webp",
  },
  {
    compositionName: "The Old Man in the Magistrate's (or Jockey's) Cap",
    author: ["Antoine Marcenay de Ghuy", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/271701",
    dateCreated: "1771",
    imageUrl: "images/The_Old_Man_in_the_Magistrate_s__or_Jockey_s__Cap.webp",
  },
  {
    compositionName: "Charles I of England and Two Grooms",
    author: ["Emile-Armand Mathey-Doret", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/271776",
    dateCreated: "19th century",
    imageUrl: "images/Charles_I_of_England_and_Two_Grooms.webp",
  },
  {
    compositionName: "N. Chrystin",
    author: ["Jean Morin", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/272188",
    dateCreated: "17th century",
    imageUrl: "images/N__Chrystin.webp",
  },
  {
    compositionName: "The Farmer",
    author: ["Jacques Villon", "After Vincent van Gogh"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/272584",
    dateCreated: "1927",
    imageUrl: "images/The_Farmer.webp",
  },
  {
    compositionName: "Two Peasants at a Table with an Old Woman",
    author: ["Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184385",
    dateCreated: "17th century",
    imageUrl: "images/Two_Peasants_at_a_Table_with_an_Old_Woman.webp",
  },
  {
    compositionName: "Standing Peasant, Left Arm in Sling",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184386",
    dateCreated: "17th century",
    imageUrl: "images/Standing_Peasant__Left_Arm_in_Sling.webp",
  },
  {
    compositionName:
      "Design for a Stained Glass Window: Saint Bernardino Preaching",
    author: ["Hendrik van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/185118",
    dateCreated: "c. 1565",
    imageUrl:
      "images/Design_for_a_Stained_Glass_Window__Saint_Bernardino_Preaching.webp",
  },
  {
    compositionName: "Farm to the Right of a Canal",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/186159",
    dateCreated: "c. 1614",
    imageUrl: "images/Farm_to_the_Right_of_a_Canal.webp",
  },
  {
    compositionName: "Landscape with a Cart",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188219",
    dateCreated: "1628",
    imageUrl: "images/Landscape_with_a_Cart.webp",
  },
  {
    compositionName: "Checkerboard Bonnet Shell (Phalium Areola)",
    author: [
      "Balthasar van der Ast",
      "previously attributed to Bartholomeus Abrahamsz. Assteyn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188232",
    dateCreated: "c. 1620-40",
    imageUrl: "images/Checkerboard_Bonnet_Shell__Phalium_Areola_.webp",
  },
  {
    compositionName: "Christ before Caiaphus",
    author: [
      "Master of the Mocking of Christ",
      "Previously attributed to School of Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188344",
    dateCreated: "17th century",
    imageUrl: "images/Christ_before_Caiaphus.webp",
  },
  {
    compositionName: "Temperance",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188345",
    dateCreated: "c. 1530",
    imageUrl: "images/Temperance.webp",
  },
  {
    compositionName:
      "Paul Joseph Kiederich in His Studio, Painting a Portrait of Emperor Charles V",
    author: ["Lucas van Leyden", "Wilhelm Camphausen", "Paul Joseph Kiederich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188622",
    dateCreated: "1845",
    imageUrl:
      "images/Paul_Joseph_Kiederich_in_His_Studio__Painting_a_Portrait_of_Emperor_Charles_V.webp",
  },
  {
    compositionName: "Cardinal Mazarin",
    author: ["Robert Nanteuil", "After Pieter van Mol"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/272706",
    dateCreated: "c. 1657",
    imageUrl: "images/Cardinal_Mazarin.webp",
  },
  {
    compositionName: "Brisk Gale",
    author: ["Pierre Charles Canot", "After Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273044",
    dateCreated: "1765",
    imageUrl: "images/Brisk_Gale.webp",
  },
  {
    compositionName: "Flemish Gentleman",
    author: ["Giuseppe Canale", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273075",
    dateCreated: "18th century",
    imageUrl: "images/Flemish_Gentleman.webp",
  },
  {
    compositionName: "Theresa Valladou",
    author: ["P. van Ryssel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273260",
    dateCreated: "1891",
    imageUrl: "images/Theresa_Valladou.webp",
  },
  {
    compositionName: "Van Dyck",
    author: ["Johann August Eduard Mandel", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273317",
    dateCreated: "19th century",
    imageUrl: "images/Van_Dyck.webp",
  },
  {
    compositionName: "Carl I, K\u00f6nig von England",
    author: ["Johann August Eduard Mandel", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273318",
    dateCreated: "19th century",
    imageUrl: "images/Carl_I__Konig_von_England.webp",
  },
  {
    compositionName: "The Mass of Saint Gregory",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273431",
    dateCreated: "c. 1490-1500",
    imageUrl: "images/The_Mass_of_Saint_Gregory.webp",
  },
  {
    compositionName: "Christ Scourged",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273470",
    dateCreated: "15th century",
    imageUrl: "images/Christ_Scourged.webp",
  },
  {
    compositionName: "Christ Disputing with the Doctors",
    author: [
      "Israhel van Meckenem the younger",
      "After Hans Holbein the Younger",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273471",
    dateCreated: "15th century",
    imageUrl: "images/Christ_Disputing_with_the_Doctors.webp",
  },
  {
    compositionName: "Evening",
    author: [
      "Johann Gottlieb Abraham Frenzel",
      "After Jacob van Ruisdael",
      "After Willem Romeyn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273657",
    dateCreated: "19th century",
    imageUrl: "images/Evening.webp",
  },
  {
    compositionName: "Landscape with a Milkmaid; verso: illegible mark",
    author: ["Jan van Goyen"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188868",
    dateCreated: "1637",
    imageUrl: "images/Landscape_with_a_Milkmaid__verso__illegible_mark.webp",
  },
  {
    compositionName:
      "Blank page; verso: Italianate Landscape with Ancient Ruins",
    author: ["Pieter Anthonisz. van Groenewegen"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188871",
    dateCreated: "17th century",
    imageUrl:
      "images/Blank_page__verso__Italianate_Landscape_with_Ancient_Ruins.webp",
  },
  {
    compositionName: "Wooded Landscape with Barn",
    author: ["Pieter van Asch"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188895",
    dateCreated: "17th century",
    imageUrl: "images/Wooded_Landscape_with_Barn.webp",
  },
  {
    compositionName: "Blank page; verso: Vanitas Still Life with Armor",
    author: ["Willem van Aelst"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188935",
    dateCreated: "17th century",
    imageUrl: "images/Blank_page__verso__Vanitas_Still_Life_with_Armor.webp",
  },
  {
    compositionName: "Mountain Landscape with a River and Distant City",
    author: ["Joris Abrahamsz. van der Haagen"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188964",
    dateCreated: "c. 1640-1642",
    imageUrl: "images/Mountain_Landscape_with_a_River_and_Distant_City.webp",
  },
  {
    compositionName: "Wooded Landscape with Peasants",
    author: ["Joris Abrahamsz. van der Haagen"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188981",
    dateCreated: "17th century",
    imageUrl: "images/Wooded_Landscape_with_Peasants.webp",
  },
  {
    compositionName: "Lute Player",
    author: ["Evert van Aelst"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188988",
    dateCreated: "17th century",
    imageUrl: "images/Lute_Player.webp",
  },
  {
    compositionName: "River Landscape with Cottage",
    author: ["Jan van Goyen"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188990",
    dateCreated: "1637",
    imageUrl: "images/River_Landscape_with_Cottage.webp",
  },
  {
    compositionName: "Seated Peasant Drinking; verso: Blank page",
    author: ["Adriaen van Ostade"],
    tale: "This sheet forms part of a seventeenth-century Dutch album, in its original binding, which contains 41 small, full-page drawings on parchment by more than 27 different artists.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/188997",
    dateCreated: "c. 1637",
    imageUrl: "images/Seated_Peasant_Drinking__verso__Blank_page.webp",
  },
  {
    compositionName: "The Thick Forest",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/190792",
    dateCreated: "17th century",
    imageUrl: "images/The_Thick_Forest.webp",
  },
  {
    compositionName: "Descent from the Cross",
    author: ["Francesco Novelli", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274027",
    dateCreated: "1790",
    imageUrl: "images/Descent_from_the_Cross.webp",
  },
  {
    compositionName: "View of Skervin",
    author: ["Jacques Philippe Le Bas", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274199",
    dateCreated: "18th century",
    imageUrl: "images/View_of_Skervin.webp",
  },
  {
    compositionName: "Young Woman with Scalloped Collar in Profile to Right",
    author: ["Wenceslaus Hollar", "After Jan Hermansz van Bijlert"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274208",
    dateCreated: "17th century",
    imageUrl:
      "images/Young_Woman_with_Scalloped_Collar_in_Profile_to_Right.webp",
  },
  {
    compositionName: "Lelio Brancacci",
    author: ["Nicolas Lauwers", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274222",
    dateCreated: "17th century",
    imageUrl: "images/Lelio_Brancacci.webp",
  },
  {
    compositionName: "Meleager and Atalanta Killing the Calydonian Boar",
    author: ["Theodor van Kessel", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274246",
    dateCreated: "17th century",
    imageUrl: "images/Meleager_and_Atalanta_Killing_the_Calydonian_Boar.webp",
  },
  {
    compositionName: "Artus Wolfaerts",
    author: ["Cornelis Galle the Elder", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274284",
    dateCreated: "17th century",
    imageUrl: "images/Artus_Wolfaerts.webp",
  },
  {
    compositionName: "Jan Meyssens",
    author: ["Cornelis Galle the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274285",
    dateCreated: "17th century",
    imageUrl: "images/Jan_Meyssens.webp",
  },
  {
    compositionName: "Engelbert Taie",
    author: ["Cornelis Galle the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274286",
    dateCreated: "17th century",
    imageUrl: "images/Engelbert_Taie.webp",
  },
  {
    compositionName: "Adriaen van de Venne",
    author: ["Wenceslaus Hollar", "After Adriaen van de Venne"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274305",
    dateCreated: "1646",
    imageUrl: "images/Adriaen_van_de_Venne.webp",
  },
  {
    compositionName: "Seated Figure of Diana the Huntress",
    author: ["Wenceslaus Hollar", "Paulus Pontius", "After Peeter van Avont"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274335",
    dateCreated: "17th century",
    imageUrl: "images/Seated_Figure_of_Diana_the_Huntress.webp",
  },
  {
    compositionName: "River Landscape with Ferryboat",
    author: ["Jan van de Capelle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/195671",
    dateCreated: "17th century",
    imageUrl: "images/River_Landscape_with_Ferryboat.webp",
  },
  {
    compositionName: "The Temple of the Sibyl at Tivoli",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197886",
    dateCreated: "1615",
    imageUrl: "images/The_Temple_of_the_Sibyl_at_Tivoli.webp",
  },
  {
    compositionName: "Watermill near a Village",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197887",
    dateCreated: "1615",
    imageUrl: "images/Watermill_near_a_Village.webp",
  },
  {
    compositionName: "View of a Village",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197889",
    dateCreated: "1615",
    imageUrl: "images/View_of_a_Village.webp",
  },
  {
    compositionName: "Ruins of a Tower and a Bridge",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197890",
    dateCreated: "1615",
    imageUrl: "images/Ruins_of_a_Tower_and_a_Bridge.webp",
  },
  {
    compositionName: "Two Cows on a Ferry near a Bastion",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197892",
    dateCreated: "1616",
    imageUrl: "images/Two_Cows_on_a_Ferry_near_a_Bastion.webp",
  },
  {
    compositionName: "Sheep on a Ferry near a Square Tower and a Village Gate",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197893",
    dateCreated: "1616",
    imageUrl:
      "images/Sheep_on_a_Ferry_near_a_Square_Tower_and_a_Village_Gate.webp",
  },
  {
    compositionName: "View of a Valley",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197894",
    dateCreated: "1616",
    imageUrl: "images/View_of_a_Valley.webp",
  },
  {
    compositionName: "Landscape with Tower of 'Het Huis te Kleef'",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197895",
    dateCreated: "1616",
    imageUrl: "images/Landscape_with_Tower_of__Het_Huis_te_Kleef_.webp",
  },
  {
    compositionName: "Landscape with Pigs and Two Pedlars",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197896",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Pigs_and_Two_Pedlars.webp",
  },
  {
    compositionName: "Paulus Halmalius",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274467",
    dateCreated: "17th century",
    imageUrl: "images/Paulus_Halmalius.webp",
  },
  {
    compositionName: "Hendrik Liberti",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274468",
    dateCreated: "17th century",
    imageUrl: "images/Hendrik_Liberti.webp",
  },
  {
    compositionName: "Cornelis van Poelenburg",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274469",
    dateCreated: "17th century",
    imageUrl: "images/Cornelis_van_Poelenburg.webp",
  },
  {
    compositionName: "Laurens Janszoon Koster",
    author: ["Cornelis Koning", "After Jacob van Campen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274470",
    dateCreated: "17th century",
    imageUrl: "images/Laurens_Janszoon_Koster.webp",
  },
  {
    compositionName: "Thomas Wentworth, earl of Strafford",
    author: ["Jacobus Houbraken", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274475",
    dateCreated: "1740",
    imageUrl: "images/Thomas_Wentworth__earl_of_Strafford.webp",
  },
  {
    compositionName: "Johann T'Serclaes, Count of Tilly",
    author: ["Pieter de Jode, the Elder", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274517",
    dateCreated: "17th century",
    imageUrl: "images/Johann_T_Serclaes__Count_of_Tilly.webp",
  },
  {
    compositionName: "The Last Supper",
    author: ["Dirck Volkertsz. Coornhert", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274602",
    dateCreated: "c. 1548",
    imageUrl: "images/The_Last_Supper.webp",
  },
  {
    compositionName: "Three Goats on the Edge of the Water",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274654",
    dateCreated: "17th century",
    imageUrl: "images/Three_Goats_on_the_Edge_of_the_Water.webp",
  },
  {
    compositionName: "Rock in the Middle of the River",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274655",
    dateCreated: "17th century",
    imageUrl: "images/Rock_in_the_Middle_of_the_River.webp",
  },
  {
    compositionName: "Three Huts on the Top of a Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274656",
    dateCreated: "17th century",
    imageUrl: "images/Three_Huts_on_the_Top_of_a_Rock.webp",
  },
  {
    compositionName: "River at the Foot of a Steep Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274657",
    dateCreated: "17th century",
    imageUrl: "images/River_at_the_Foot_of_a_Steep_Rock.webp",
  },
  {
    compositionName: "Little Covered Bridge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274658",
    dateCreated: "17th century",
    imageUrl: "images/Little_Covered_Bridge.webp",
  },
  {
    compositionName: "Two Men at the  Door",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274659",
    dateCreated: "17th century",
    imageUrl: "images/Two_Men_at_the__Door.webp",
  },
  {
    compositionName: "Village Carpenter",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274660",
    dateCreated: "17th century",
    imageUrl: "images/Village_Carpenter.webp",
  },
  {
    compositionName: "Horseman on the Little Bridge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274661",
    dateCreated: "17th century",
    imageUrl: "images/Horseman_on_the_Little_Bridge.webp",
  },
  {
    compositionName: "Goat on the Little Bridge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274662",
    dateCreated: "17th century",
    imageUrl: "images/Goat_on_the_Little_Bridge.webp",
  },
  {
    compositionName: "Row-boat Drawn up on the Shore",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274663",
    dateCreated: "17th century",
    imageUrl: "images/Row_boat_Drawn_up_on_the_Shore.webp",
  },
  {
    compositionName: "Little Wooden Bridge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274664",
    dateCreated: "17th century",
    imageUrl: "images/Little_Wooden_Bridge.webp",
  },
  {
    compositionName: "Two Gentlemen Sketching",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274665",
    dateCreated: "17th century",
    imageUrl: "images/Two_Gentlemen_Sketching.webp",
  },
  {
    compositionName: "Inscription on the Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274666",
    dateCreated: "17th century",
    imageUrl: "images/Inscription_on_the_Rock.webp",
  },
  {
    compositionName: "Lime-kiln in Stormy Weather",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198171",
    dateCreated: "17th century",
    imageUrl: "images/Lime_kiln_in_Stormy_Weather.webp",
  },
  {
    compositionName: "Dilapidated Farm",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198256",
    dateCreated: "1615",
    imageUrl: "images/Dilapidated_Farm.webp",
  },
  {
    compositionName: "Ruins of a House and a Herdsman Playing the Flute",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198257",
    dateCreated: "1615",
    imageUrl: "images/Ruins_of_a_House_and_a_Herdsman_Playing_the_Flute.webp",
  },
  {
    compositionName: "Market Day in a Town",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198258",
    dateCreated: "1616",
    imageUrl: "images/Market_Day_in_a_Town.webp",
  },
  {
    compositionName: "Tower on the River Niers",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198259",
    dateCreated: "1616",
    imageUrl: "images/Tower_on_the_River_Niers.webp",
  },
  {
    compositionName: "Trees and a Cottage at the Edge of a Road",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198735",
    dateCreated: "c. 1648-1655",
    imageUrl: "images/Trees_and_a_Cottage_at_the_Edge_of_a_Road.webp",
  },
  {
    compositionName: "Sheet of Studies with Six Figures",
    author: ["Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198738",
    dateCreated: "c. 1643-1646",
    imageUrl: "images/Sheet_of_Studies_with_Six_Figures.webp",
  },
  {
    compositionName: "Bathing Shepherdesses",
    author: ["Dirck van der Lisse"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198939",
    dateCreated: "17th century",
    imageUrl: "images/Bathing_Shepherdesses.webp",
  },
  {
    compositionName: "Woman Doing Handwork; verso: Landscape [by a later hand]",
    author: ["Gerbrand van den Eeckhout"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/199114",
    dateCreated: "c. 1655",
    imageUrl:
      "images/Woman_Doing_Handwork__verso__Landscape__by_a_later_hand_.webp",
  },
  {
    compositionName: "Winter Landscape",
    author: ["Anthonie van Borssom"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/199373",
    dateCreated: "17th century",
    imageUrl: "images/Winter_Landscape.webp",
  },
  {
    compositionName: "Drunk Peasant Couple; verso: Sketch of a Farmhouse",
    author: ["Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/199376",
    dateCreated: "c. 1639-41",
    imageUrl: "images/Drunk_Peasant_Couple__verso__Sketch_of_a_Farmhouse.webp",
  },
  {
    compositionName: "A Satyr and a Peasant Woman, after Jordaens",
    author: ["Leendert van der Cooghen", "After Jacques Jordaens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/199377",
    dateCreated: "1652",
    imageUrl: "images/A_Satyr_and_a_Peasant_Woman__after_Jordaens.webp",
  },
  {
    compositionName: "Christ in the House of Martha and Mary",
    author: [
      "Circle of Rembrandt Harmensz. van Rijn",
      "Previously attributed to Samuel van Hoogstraten",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/211851",
    dateCreated: "17th century",
    imageUrl: "images/Christ_in_the_House_of_Martha_and_Mary.webp",
  },
  {
    compositionName: "Landscape with Cottage and Ruined Castle",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212278",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Cottage_and_Ruined_Castle.webp",
  },
  {
    compositionName: "Dragonfly and Toadstool",
    author: ["Rocho van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212310",
    dateCreated: "1677",
    imageUrl: "images/Dragonfly_and_Toadstool.webp",
  },
  {
    compositionName: 'Juffrouw Braet-Haringh ("Mistress Grilled Herring")',
    author: ["Jan Philipsz. van Bouckhorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212402",
    dateCreated: "1617",
    imageUrl: "images/Juffrouw_Braet_Haringh___Mistress_Grilled_Herring__.webp",
  },
  {
    compositionName: "A River Landscape",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212405",
    dateCreated: "1653",
    imageUrl: "images/A_River_Landscape.webp",
  },
  {
    compositionName: "A Scandinavian Landscape",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212406",
    dateCreated: "1660s",
    imageUrl: "images/A_Scandinavian_Landscape.webp",
  },
  {
    compositionName: "The Kamperbuitenpoort in Amersfoort",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212434",
    dateCreated: "c. 1650",
    imageUrl: "images/The_Kamperbuitenpoort_in_Amersfoort.webp",
  },
  {
    compositionName: "Spring",
    author: ["Adriaen van de Venne"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212649",
    dateCreated: "1622",
    imageUrl: "images/Spring.webp",
  },
  {
    compositionName: "Elisha and the Shunammite Woman",
    author: ["Samuel van Hoogstraten"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212651",
    dateCreated: "c. 1650",
    imageUrl: "images/Elisha_and_the_Shunammite_Woman.webp",
  },
  {
    compositionName: "A Seated Man in Middle Eastern Costume",
    author: ["Gerbrand van den Eeckhout"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212653",
    dateCreated: "c. 1646",
    imageUrl: "images/A_Seated_Man_in_Middle_Eastern_Costume.webp",
  },
  {
    compositionName: "Landscape with a Bridge",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212692",
    dateCreated: "1616",
    imageUrl: "images/Landscape_with_a_Bridge.webp",
  },
  {
    compositionName:
      "Farms and a Dovecote by a Frozen River; verso: River Scene with a Ferry",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212693",
    dateCreated: "c. 1617-1618",
    imageUrl:
      "images/Farms_and_a_Dovecote_by_a_Frozen_River__verso__River_Scene_with_a_Ferry.webp",
  },
  {
    compositionName: "Landscape with Riders",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212694",
    dateCreated: "c. 1618-20",
    imageUrl: "images/Landscape_with_Riders.webp",
  },
  {
    compositionName: "A Farm on the Amsteldijk",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213432",
    dateCreated: "c. 1648-50",
    imageUrl: "images/A_Farm_on_the_Amsteldijk____.webp",
  },
  {
    compositionName: "Earth",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213489",
    dateCreated: "17th century",
    imageUrl: "images/Earth.webp",
  },
  {
    compositionName: "The Spaernwouder",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213551",
    dateCreated: "17th century",
    imageUrl: "images/The_Spaernwouder.webp",
  },
  {
    compositionName: "A Forest Marsh with Travelers on a Bank",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213776",
    dateCreated: "c. 1652",
    imageUrl: "images/A_Forest_Marsh_with_Travelers_on_a_Bank.webp",
  },
  {
    compositionName: "Landscape with Snipe Hunters",
    author: ["Nicolaes de Bruyn", "After Gillis van Coninxloo III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213820",
    dateCreated: "1600",
    imageUrl: "images/Landscape_with_Snipe_Hunters.webp",
  },
  {
    compositionName: "Wheatfield",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213927",
    dateCreated: "1648",
    imageUrl: "images/Wheatfield.webp",
  },
  {
    compositionName: "January",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213996",
    dateCreated: "1618",
    imageUrl: "images/January.webp",
  },
  {
    compositionName: "Allegory of Fall",
    author: ["Lodewijk van Schoor"],
    tale: 'This work exemplifies a popular late seventeenth-century tapestry type: hybrid genre-landscapes ("genres mythologiques"), which were usually marketed as sets. A female figure representing Fall is seated on a rocky mound and holds a tall rod with grapevines. While the foreground and sides are framed with sharply rendered foliage and still-life elements, the landscape opens into a soft valley at right. The copper wine vessels, squash, grapes, and apple tree in bloom are all attributes of Fall, as are the five male and female attendant figures bearing the fruits of the season\'s harvest on silver platters.',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/215028",
    dateCreated: "c. 1700",
    imageUrl: "images/Allegory_of_Fall.webp",
  },
  {
    compositionName:
      'Bauhaus Books No. 6 "Basic Principles of New Creative Art"',
    author: [
      "Author: Theo van Doesburg",
      "Typography by L\u00e1szl\u00f3 Moholy-Nagy",
    ],
    tale: "Cardstock binder is glued to the spine. Dust jacket folds over cardstock and is attached with glued on the inside flaps.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/215227",
    dateCreated: "1924",
    imageUrl:
      "images/Bauhaus_Books_No__6__Basic_Principles_of_New_Creative_Art_.webp",
  },
  {
    compositionName: 'Untitled, from the portfolio "Saltoarte"',
    author: ["Paul Van Rafelghem", "POUR"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/217830",
    dateCreated: "1975",
    imageUrl: "images/Untitled__from_the_portfolio__Saltoarte_.webp",
  },
  {
    compositionName:
      'Untitled, from the portfolio "from source to use: Contemporary Archaeology; Pandora Part One"',
    author: ["Arie van Geest", "Publishing House B\u00e9bert"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/218395",
    dateCreated: "1985",
    imageUrl:
      "images/Untitled__from_the_portfolio__from_source_to_use__Contemporary_Archaeology__Pandora_Part_One_.webp",
  },
  {
    compositionName: "Barrels and Planks on the Shore of a River",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274984",
    dateCreated: "17th century",
    imageUrl: "images/Barrels_and_Planks_on_the_Shore_of_a_River.webp",
  },
  {
    compositionName: "Boat under the Hollow of a Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274985",
    dateCreated: "17th century",
    imageUrl: "images/Boat_under_the_Hollow_of_a_Rock.webp",
  },
  {
    compositionName: "Two Men Riding Along Rocks",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274986",
    dateCreated: "17th century",
    imageUrl: "images/Two_Men_Riding_Along_Rocks.webp",
  },
  {
    compositionName: "Pines in the Water",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274987",
    dateCreated: "17th century",
    imageUrl: "images/Pines_in_the_Water.webp",
  },
  {
    compositionName: "Peasant on Horseback",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274988",
    dateCreated: "17th century",
    imageUrl: "images/Peasant_on_Horseback.webp",
  },
  {
    compositionName: "Three Travellers at the Foot of a Great Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274989",
    dateCreated: "17th century",
    imageUrl: "images/Three_Travellers_at_the_Foot_of_a_Great_Rock.webp",
  },
  {
    compositionName: "Woman Watching a Boat",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274990",
    dateCreated: "17th century",
    imageUrl: "images/Woman_Watching_a_Boat.webp",
  },
  {
    compositionName: "Sinking Hut",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274991",
    dateCreated: "17th century",
    imageUrl: "images/Sinking_Hut.webp",
  },
  {
    compositionName: "Boat among the Willows",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274992",
    dateCreated: "17th century",
    imageUrl: "images/Boat_among_the_Willows.webp",
  },
  {
    compositionName: "Saint Mary Magdalen in the Clouds",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/222759",
    dateCreated: "1518",
    imageUrl: "images/Saint_Mary_Magdalen_in_the_Clouds.webp",
  },
  {
    compositionName: "Museum for a Small City",
    author: ["Unidentified Artist", "Design by Ludwig Mies van der Rohe"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/222830",
    dateCreated: "1942",
    imageUrl: "images/Museum_for_a_Small_City.webp",
  },
  {
    compositionName: 'Tropon, from "Pan"',
    author: ["Henry van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223094",
    dateCreated: "1898",
    imageUrl: "images/Tropon__from__Pan_.webp",
  },
  {
    compositionName: "De Stijl vol. 7 no. 3-4",
    author: ["Theo van Doesburg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223204",
    dateCreated: "1926",
    imageUrl: "images/De_Stijl_vol__7_no__3_4.webp",
  },
  {
    compositionName: "De Stijl final issue",
    author: ["Theo van Doesburg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223215",
    dateCreated: "1931",
    imageUrl: "images/De_Stijl_final_issue.webp",
  },
  {
    compositionName: "De Stijl vol. 6 no.2",
    author: ["Theo van Doesburg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223234",
    dateCreated: "1923",
    imageUrl: "images/De_Stijl_vol__6_no_2.webp",
  },
  {
    compositionName: "De Stijl vol. 6 no. 8",
    author: ["Theo van Doesburg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223235",
    dateCreated: "1924",
    imageUrl: "images/De_Stijl_vol__6_no__8.webp",
  },
  {
    compositionName: "De Stijl vol. 5 no. 12",
    author: ["Theo van Doesburg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223236",
    dateCreated: "1922",
    imageUrl: "images/De_Stijl_vol__5_no__12.webp",
  },
  {
    compositionName: '"Also Sprach Zarathustra" by Friedrich Nietzsche',
    author: [
      "Designed by Henry van de Velde",
      "Author: Friedrich Nietzsche",
      "Published by Insel Verlag",
    ],
    tale: "Letterpress text, designs and illustrations printed in red, gold and black inks",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223590",
    dateCreated: "1908",
    imageUrl: "images/_Also_Sprach_Zarathustra__by_Friedrich_Nietzsche.webp",
  },
  {
    compositionName: "Photograph of project by Mies van der Rohe",
    author: ["Unidentified Artist", "Design by Ludwig Mies van der Rohe"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/224762",
    dateCreated: "20th century",
    imageUrl: "images/Photograph_of_project_by_Mies_van_der_Rohe.webp",
  },
  {
    compositionName: "Slaughtering the Pig",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/226290",
    dateCreated: "c. 1642",
    imageUrl: "images/Slaughtering_the_Pig.webp",
  },
  {
    compositionName: "One Gulden",
    author: ["Sibertus van Romondt"],
    tale: "Obverse: allegorical figure of Holland [?] standing with book and pike [?]; reverse: coat of arms: lion with sword and bundle of arrows [the coat of arms of the Netherlands, consisting of a combination of the lion from the arms of the Royal Family, Orange-Nassau, and the arrows and sword from the Dutch Republic in the 17th century].  Beaded outer border on obverse.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/226569",
    dateCreated: "1713",
    imageUrl: "images/One_Gulden.webp",
  },
  {
    compositionName: "The Return of the Herd",
    author: ["Salomon van Ruysdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227264",
    dateCreated: "c. 1665-1669",
    imageUrl: "images/The_Return_of_the_Herd.webp",
  },
  {
    compositionName: "Portrait of a Young Girl",
    author: [
      "Attributed to Louis-Michel van Loo",
      "Previously Charles-Andr\u00e9, called Carle Vanloo",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227465",
    dateCreated: "18th century",
    imageUrl: "images/Portrait_of_a_Young_Girl.webp",
  },
  {
    compositionName: "Portrait of an Old Man",
    author: ["Follower of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227666",
    dateCreated: "c. 1650-1655",
    imageUrl: "images/Portrait_of_an_Old_Man.webp",
  },
  {
    compositionName: "Group of Men and Horse",
    author: ["Adriaen van de Venne"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227740",
    dateCreated: "16th-17th century",
    imageUrl: "images/Group_of_Men_and_Horse.webp",
  },
  {
    compositionName: "Harbor Scene with a Watchtower and Beacon",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227791",
    dateCreated: "1636",
    imageUrl: "images/Harbor_Scene_with_a_Watchtower_and_Beacon.webp",
  },
  {
    compositionName: "Road Lined with Trees",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227796",
    dateCreated: "c. 1675",
    imageUrl: "images/Road_Lined_with_Trees.webp",
  },
  {
    compositionName: "River Landscape with Fishing Boats",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227804",
    dateCreated: "1634",
    imageUrl: "images/River_Landscape_with_Fishing_Boats.webp",
  },
  {
    compositionName: "Portrait of a Woman",
    author: ["Dirck Dirckszoon van Santvoort"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227805",
    dateCreated: "1640",
    imageUrl: "images/Portrait_of_a_Woman.webp",
  },
  {
    compositionName: "Portrait of a Man",
    author: ["Dirck Dirckszoon van Santvoort"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227843",
    dateCreated: "c. 1640-1650",
    imageUrl: "images/Portrait_of_a_Man.webp",
  },
  {
    compositionName: "Portrait of a Young Woman",
    author: ["Bartholomeus van der Helst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227844",
    dateCreated: "c. 1640",
    imageUrl: "images/Portrait_of_a_Young_Woman.webp",
  },
  {
    compositionName: "Rembrandt Harmensz van Rijn (1606-1669)",
    author: [
      "Workshop of Rembrandt Harmensz. van Rijn",
      "Previously attributed to Rembrandt Harmensz. van Rijn",
      "Previously after Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227853",
    dateCreated: "17th century",
    imageUrl: "images/Rembrandt_Harmensz_van_Rijn__1606_1669_.webp",
  },
  {
    compositionName: "George Washington (1732-1799)",
    author: ["Rembrandt Peale"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227898",
    dateCreated: "c. 1852",
    imageUrl: "images/George_Washington__1732_1799_.webp",
  },
  {
    compositionName: "Woman at Her Toilet",
    author: [
      " After Jan van Eyck",
      "Previously attributed to Unidentified Artist",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227899",
    dateCreated: "early 16th century",
    imageUrl: "images/Woman_at_Her_Toilet.webp",
  },
  {
    compositionName: "Horse",
    author: ["after Abraham Pietersz. van Calraet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227941",
    dateCreated: "17th-18th century",
    imageUrl: "images/Horse.webp",
  },
  {
    compositionName: "Fruit, Vegetables and Flowers",
    author: ["Jacob van de Kerckhoven"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227944",
    dateCreated: "17th century",
    imageUrl: "images/Fruit__Vegetables_and_Flowers.webp",
  },
  {
    compositionName: "Head of Christ",
    author: [
      "Rembrandt Harmensz. van Rijn",
      "Previously attributed to Follower of Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228065",
    dateCreated: "c. 1648-1656",
    imageUrl: "images/Head_of_Christ.webp",
  },
  {
    compositionName: "River Landscape at Sunset",
    author: ["Style of Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228079",
    dateCreated: "17th century",
    imageUrl: "images/River_Landscape_at_Sunset.webp",
  },
  {
    compositionName: "River Landscape",
    author: ["Style of Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228080",
    dateCreated: "17th century",
    imageUrl: "images/River_Landscape.webp",
  },
  {
    compositionName: "River Landscape with Fishermen",
    author: ["Style of Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228081",
    dateCreated: "17th century",
    imageUrl: "images/River_Landscape_with_Fishermen.webp",
  },
  {
    compositionName: "Bust of a Young Man",
    author: ["Circle of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228144",
    dateCreated: "1629",
    imageUrl: "images/Bust_of_a_Young_Man.webp",
  },
  {
    compositionName: "Bust of a Man",
    author: ["Style of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228145",
    dateCreated: "1629",
    imageUrl: "images/Bust_of_a_Man.webp",
  },
  {
    compositionName: "Cardinal Guido Bentivoglio (1579-1644), after Van Dyck",
    author: [
      "Attributed to John Smibert",
      "After Anthony van Dyck",
      "Previously attributed to John Trumbull",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228156",
    dateCreated: "c. 1719-1720",
    imageUrl:
      "images/Cardinal_Guido_Bentivoglio__1579_1644___after_Van_Dyck.webp",
  },
  {
    compositionName: "The Dam and Damrak, Amsterdam",
    author: [
      "Jan van der Heyden",
      "Figures by Adriaen van de Velde",
      "Previously attributed to Gerrit Adriaensz Berckheyde",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228161",
    dateCreated: "c. 1663",
    imageUrl: "images/The_Dam_and_Damrak__Amsterdam.webp",
  },
  {
    compositionName: "Peasants in a Tavern",
    author: [
      "Unidentified Artist",
      "Previously attributed to Pieter Verelst",
      "Previously attributed to Pieter Coecke van Aelst",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228162",
    dateCreated: "18th-19th century",
    imageUrl: "images/Peasants_in_a_Tavern.webp",
  },
  {
    compositionName: "Rest on the Flight into Egypt",
    author: ["Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228320",
    dateCreated: "c. 1630-1640",
    imageUrl: "images/Rest_on_the_Flight_into_Egypt.webp",
  },
  {
    compositionName: "Wooded Landscape with an Old Oak",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228325",
    dateCreated: "c. 1650-1653",
    imageUrl: "images/Wooded_Landscape_with_an_Old_Oak.webp",
  },
  {
    compositionName: "Saint Jerome in His Study",
    author: ["Joos van Cleve", "Previously attributed to Quentin Metsys"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228385",
    dateCreated: "1521",
    imageUrl: "images/Saint_Jerome_in_His_Study.webp",
  },
  {
    compositionName: "Seascape",
    author: [
      "Attributed to Cornelis Pietersz de Mooy",
      "Previously Willem van de Velde II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228493",
    dateCreated: "17th century",
    imageUrl: "images/Seascape.webp",
  },
  {
    compositionName: "Equestrian Statue of Louis XIV (1638-1715)",
    author: [
      "After Martin Desjardins",
      "Plaquettes by Adam Frans van der Meulen",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228515",
    dateCreated: "early 18th century",
    imageUrl: "images/Equestrian_Statue_of_Louis_XIV__1638_1715_.webp",
  },
  {
    compositionName: "Religious Scene",
    author: ["Hans van Meegeren"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228586",
    dateCreated: "19th-20th century",
    imageUrl: "images/Religious_Scene.webp",
  },
  {
    compositionName: "Still Life",
    author: ["Jeremias van Winghen", "Previously attributed to Georg Flegel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228608",
    dateCreated: "16th-17th century",
    imageUrl: "images/Still_Life.webp",
  },
  {
    compositionName:
      "Portrait of an Old Man (Adriaen van Rijn, Rembrandt's brother)",
    author: ["Follower of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228612",
    dateCreated: "17th century",
    imageUrl:
      "images/Portrait_of_an_Old_Man__Adriaen_van_Rijn__Rembrandt_s_brother_.webp",
  },
  {
    compositionName:
      "Bust of an Old Woman (commonly called Rembrandt's Mother)",
    author: ["Copy after Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228633",
    dateCreated: "after 1675",
    imageUrl:
      "images/Bust_of_an_Old_Woman__commonly_called_Rembrandt_s_Mother_.webp",
  },
  {
    compositionName: "Thomas Killigrew, after van Dyck",
    author: ["Copy after Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228695",
    dateCreated: "17th century",
    imageUrl: "images/Thomas_Killigrew__after_van_Dyck.webp",
  },
  {
    compositionName: "Three Pairs of Shoes",
    author: ["Vincent van Gogh"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228744",
    dateCreated: "1886-1887",
    imageUrl: "images/Three_Pairs_of_Shoes.webp",
  },
  {
    compositionName: "Portrait of a Lady with Castle and Trees in Background",
    author: ["School of Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228839",
    dateCreated: "17th century",
    imageUrl:
      "images/Portrait_of_a_Lady_with_Castle_and_Trees_in_Background.webp",
  },
  {
    compositionName: "Peasants Brawling in a Tavern",
    author: ["Style of Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228877",
    dateCreated: "17th century",
    imageUrl: "images/Peasants_Brawling_in_a_Tavern.webp",
  },
  {
    compositionName: "Peasant Scene",
    author: ["Attributed to Egbert van Heemskerck the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228911",
    dateCreated: "17th century",
    imageUrl: "images/Peasant_Scene.webp",
  },
  {
    compositionName: "A Wooded Landscape with Deer",
    author: ["Hendrik van de Sande Bakhuyzen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/229213",
    dateCreated: "1831",
    imageUrl: "images/A_Wooded_Landscape_with_Deer.webp",
  },
  {
    compositionName: "View of a River in Moonlight",
    author: ["Style of Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/229555",
    dateCreated: "17th century",
    imageUrl: "images/View_of_a_River_in_Moonlight.webp",
  },
  {
    compositionName: "The Angel Leaving Tobias and His Family, after Rembrandt",
    author: [
      "Attributed to Richard Parkes Bonington",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/230136",
    dateCreated: "1820-1828",
    imageUrl:
      "images/The_Angel_Leaving_Tobias_and_His_Family__after_Rembrandt.webp",
  },
  {
    compositionName: "The Descent from the Cross",
    author: ["after Hugo van der Goes"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/230485",
    dateCreated: "16th-17th century",
    imageUrl: "images/The_Descent_from_the_Cross.webp",
  },
  {
    compositionName:
      "Rest on the Flight into Egypt with the Infant Saint John the Baptist",
    author: [
      "Unidentified Artist",
      "Previously attributed to Hendrik van Balen",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/230512",
    dateCreated: "16th-17th century",
    imageUrl:
      "images/Rest_on_the_Flight_into_Egypt_with_the_Infant_Saint_John_the_Baptist.webp",
  },
  {
    compositionName:
      "Portrait of a Man, traditionally said to be Roger, Count Blitterswyk-Geldern",
    author: [
      "Bartholomaeus Bruyn the Elder",
      "Previously Attributed to Joos van Cleve",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/230522",
    dateCreated: "c. 1528-29",
    imageUrl:
      "images/Portrait_of_a_Man__traditionally_said_to_be_Roger__Count_Blitterswyk_Geldern.webp",
  },
  {
    compositionName: "Angel",
    author: ["Attributed to Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/230597",
    dateCreated: "c. 1530",
    imageUrl: "images/Angel.webp",
  },
  {
    compositionName: "Self-portrait with a Bandaged Ear and Pipe",
    author: [
      "Unidentified Artist",
      "Imitator of Vincent van Gogh",
      "Previously attributed to Vincent van Gogh",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/230942",
    dateCreated: "1889",
    imageUrl: "images/Self_portrait_with_a_Bandaged_Ear_and_Pipe.webp",
  },
  {
    compositionName: "Seacoast Scene",
    author: ["Salomon van Ruysdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231033",
    dateCreated: "1663",
    imageUrl: "images/Seacoast_Scene.webp",
  },
  {
    compositionName: "View of a Village with a Castle to the Right",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Bol",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231282",
    dateCreated: "1562",
    imageUrl: "images/View_of_a_Village_with_a_Castle_to_the_Right.webp",
  },
  {
    compositionName: "Portrait of a Young Woman in a Red Hat, after Vermeer",
    author: ["Kanji Nakamura", "After Jan Vermeer van Haarlem the Elder"],
    tale: "The original by Vermeer is in the National Gallery, Washington DC.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231315",
    dateCreated: "19th-20th century",
    imageUrl:
      "images/Portrait_of_a_Young_Woman_in_a_Red_Hat__after_Vermeer.webp",
  },
  {
    compositionName: "Nicolas Triest, Count d'Auweghem",
    author: [
      "Gaspar de Crayer",
      "Previously attributed to Cornelis de Vos",
      "Previously attributed to Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231698",
    dateCreated: "1620",
    imageUrl: "images/Nicolas_Triest__Count_d_Auweghem.webp",
  },
  {
    compositionName:
      "The Oyster Meal (original, 1661, in the Mauritshuis, The Hague)",
    author: ["Copy after Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231813",
    dateCreated: "17th century",
    imageUrl:
      "images/The_Oyster_Meal__original__1661__in_the_Mauritshuis__The_Hague_.webp",
  },
  {
    compositionName: "The Virgin and Child",
    author: [
      "Follower of Rogier van der Weyden",
      "Previously attributed to Rogier van der Weyden",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231968",
    dateCreated: "c. 1480",
    imageUrl: "images/The_Virgin_and_Child.webp",
  },
  {
    compositionName: "Landscape with Sheep and Fowl",
    author: ["Frans Van Severdonck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232264",
    dateCreated: "1863",
    imageUrl: "images/Landscape_with_Sheep_and_Fowl.webp",
  },
  {
    compositionName: "Abraham's Sacrifice",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232349",
    dateCreated: "1620",
    imageUrl: "images/Abraham_s_Sacrifice.webp",
  },
  {
    compositionName: "Jan Cornelis Sylvius",
    author: ["Francesco Novelli", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232563",
    dateCreated: "1792",
    imageUrl: "images/Jan_Cornelis_Sylvius.webp",
  },
  {
    compositionName: "Portrait of the Artist's Wife, Margareta Rees",
    author: ["Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232653",
    dateCreated: "1698",
    imageUrl: "images/Portrait_of_the_Artist_s_Wife__Margareta_Rees.webp",
  },
  {
    compositionName: "America, Your Gold and Silver Fill My People",
    author: ["Copy after Pieter Nagel", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232663",
    dateCreated: "c. 1590",
    imageUrl: "images/America__Your_Gold_and_Silver_Fill_My_People.webp",
  },
  {
    compositionName: "Resurrection of Lazarus",
    author: ["Dominique Vivant Denon", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232825",
    dateCreated: "c. 1780",
    imageUrl: "images/Resurrection_of_Lazarus.webp",
  },
  {
    compositionName: "Sepulcrum trium Horatiorum",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232831",
    dateCreated: "16th century",
    imageUrl: "images/Sepulcrum_trium_Horatiorum.webp",
  },
  {
    compositionName: "Naples (Neapolitana urbis pars)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232832",
    dateCreated: "16th century",
    imageUrl: "images/Naples__Neapolitana_urbis_pars_.webp",
  },
  {
    compositionName:
      "The Temple of Fortune, Palestrina (Templum Fortunae, Praenestae)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232833",
    dateCreated: "16th century",
    imageUrl:
      "images/The_Temple_of_Fortune__Palestrina__Templum_Fortunae__Praenestae_.webp",
  },
  {
    compositionName: "Temple of Venus, Greece (Venorii templum, in Graecia)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232834",
    dateCreated: "16th century",
    imageUrl:
      "images/Temple_of_Venus__Greece__Venorii_templum__in_Graecia_.webp",
  },
  {
    compositionName: "The Falls at Tivoli (Cataractes Tiburti)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232835",
    dateCreated: "16th century",
    imageUrl: "images/The_Falls_at_Tivoli__Cataractes_Tiburti_.webp",
  },
  {
    compositionName: "Cagliari (Calaris, in Sardinia)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232836",
    dateCreated: "16th century",
    imageUrl: "images/Cagliari__Calaris__in_Sardinia_.webp",
  },
  {
    compositionName: "Puteoli",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232866",
    dateCreated: "16th century",
    imageUrl: "images/Puteoli.webp",
  },
  {
    compositionName: "The Segovian Bridge, Spain (Pons Segoviae in Hispania)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232867",
    dateCreated: "16th century",
    imageUrl:
      "images/The_Segovian_Bridge__Spain__Pons_Segoviae_in_Hispania_.webp",
  },
  {
    compositionName: "Portus Pontis nigri",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232868",
    dateCreated: "16th century",
    imageUrl: "images/Portus_Pontis_nigri.webp",
  },
  {
    compositionName: "Giovanni Boccaccio",
    author: [
      "Cornelis van Dalen, the Younger",
      "After Titian (Tiziano Vecellio)",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275389",
    dateCreated: "17th century",
    imageUrl: "images/Giovanni_Boccaccio.webp",
  },
  {
    compositionName: "Cascade",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275402",
    dateCreated: "17th century",
    imageUrl: "images/Cascade.webp",
  },
  {
    compositionName: "Swine Drover",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275403",
    dateCreated: "17th century",
    imageUrl: "images/Swine_Drover.webp",
  },
  {
    compositionName: "Landscape, with a Millstone",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275404",
    dateCreated: "17th century",
    imageUrl: "images/Landscape__with_a_Millstone.webp",
  },
  {
    compositionName: "Chapel",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275405",
    dateCreated: "17th century",
    imageUrl: "images/Chapel.webp",
  },
  {
    compositionName: "Two Barrels before a Hut",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275435",
    dateCreated: "17th century",
    imageUrl: "images/Two_Barrels_before_a_Hut.webp",
  },
  {
    compositionName: "Pilgrim with a Dog",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275436",
    dateCreated: "17th century",
    imageUrl: "images/Pilgrim_with_a_Dog.webp",
  },
  {
    compositionName: "Fisherman's Hut",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275437",
    dateCreated: "17th century",
    imageUrl: "images/Fisherman_s_Hut.webp",
  },
  {
    compositionName: "Marine Piece, with three figures",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275438",
    dateCreated: "17th century",
    imageUrl: "images/Marine_Piece__with_three_figures.webp",
  },
  {
    compositionName: "Dilapidated Hut Surrounded by Water",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275439",
    dateCreated: "17th century",
    imageUrl: "images/Dilapidated_Hut_Surrounded_by_Water.webp",
  },
  {
    compositionName: "The Emilian Fountain, Greece (Fons Aemilii, in Graecia)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232927",
    dateCreated: "16th century",
    imageUrl:
      "images/The_Emilian_Fountain__Greece__Fons_Aemilii__in_Graecia_.webp",
  },
  {
    compositionName: "The Island of Corfu (Corfu insula)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232928",
    dateCreated: "16th century",
    imageUrl: "images/The_Island_of_Corfu__Corfu_insula_.webp",
  },
  {
    compositionName: "Dresden (Dresda)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232929",
    dateCreated: "16th century",
    imageUrl: "images/Dresden__Dresda_.webp",
  },
  {
    compositionName: "Gaspard de Coligny, Marechal of France",
    author: ["Willem Jacobszoon Delff", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232947",
    dateCreated: "1631",
    imageUrl: "images/Gaspard_de_Coligny__Marechal_of_France.webp",
  },
  {
    compositionName:
      "Title Page, with Neptune, Flora, an Image of the Globe, and Portraits of Explorers",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232956",
    dateCreated: "c. 1595",
    imageUrl:
      "images/Title_Page__with_Neptune__Flora__an_Image_of_the_Globe__and_Portraits_of_Explorers.webp",
  },
  {
    compositionName: "A Tuscan Bridge (Pontis effigies. In Tuscia uspiam)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232957",
    dateCreated: "16th century",
    imageUrl: "images/A_Tuscan_Bridge__Pontis_effigies__In_Tuscia_uspiam_.webp",
  },
  {
    compositionName: "Hadrian's Villa (Villae Hadriani prospectus)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232958",
    dateCreated: "16th century",
    imageUrl: "images/Hadrian_s_Villa__Villae_Hadriani_prospectus_.webp",
  },
  {
    compositionName: "Ferdinand Magellan on His Ship",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233001",
    dateCreated: "c. 1595",
    imageUrl: "images/Ferdinand_Magellan_on_His_Ship.webp",
  },
  {
    compositionName: "The Postilion Receives the Dispatches from the Long-boat",
    author: ["Joost van Geel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233003",
    dateCreated: "1665",
    imageUrl:
      "images/The_Postilion_Receives_the_Dispatches_from_the_Long_boat.webp",
  },
  {
    compositionName: "Christopher Columbus on His Ship",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233024",
    dateCreated: "c. 1595",
    imageUrl: "images/Christopher_Columbus_on_His_Ship.webp",
  },
  {
    compositionName: "Hugo Grotius",
    author: ["Willem Jacobszoon Delff", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275519",
    dateCreated: "17th century",
    imageUrl: "images/Hugo_Grotius.webp",
  },
  {
    compositionName: "Regnier Hansloe, An Anabaptist Minister, and His Wife",
    author: ["Josiah Boydell", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275531",
    dateCreated: "1781",
    imageUrl:
      "images/Regnier_Hansloe__An_Anabaptist_Minister__and_His_Wife.webp",
  },
  {
    compositionName: "George Villiers, Duke of Buckingham",
    author: ["Willem Jacobszoon Delff", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275548",
    dateCreated: "17th century",
    imageUrl: "images/George_Villiers__Duke_of_Buckingham.webp",
  },
  {
    compositionName: "Michiel Jansz Mierevelt",
    author: ["Willem Jacobszoon Delff", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275564",
    dateCreated: "17th century",
    imageUrl: "images/Michiel_Jansz_Mierevelt.webp",
  },
  {
    compositionName: "Jan Breughel",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275722",
    dateCreated: "17th century",
    imageUrl: "images/Jan_Breughel.webp",
  },
  {
    compositionName: "Theodor Rogiers",
    author: ["Pieter Clouet", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275767",
    dateCreated: "17th century",
    imageUrl: "images/Theodor_Rogiers.webp",
  },
  {
    compositionName: "Fishmonger",
    author: ["Lambert Antoine Claessens", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275814",
    dateCreated: "18th-19th century",
    imageUrl: "images/Fishmonger.webp",
  },
  {
    compositionName: "A Smoker",
    author: ["Lambert Antoine Claessens", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275816",
    dateCreated: "18th-19th century",
    imageUrl: "images/A_Smoker.webp",
  },
  {
    compositionName: "Head of the Princess of Orange",
    author: ["Ignace Joseph de Claussin", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275890",
    dateCreated: "19th century",
    imageUrl: "images/Head_of_the_Princess_of_Orange.webp",
  },
  {
    compositionName: "Carolus Scribanius",
    author: ["Pieter Clouet", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275892",
    dateCreated: "17th century",
    imageUrl: "images/Carolus_Scribanius.webp",
  },
  {
    compositionName: "Forum boarium, Romae",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233274",
    dateCreated: "16th century",
    imageUrl: "images/Forum_boarium__Romae.webp",
  },
  {
    compositionName: "Rome (Burgus Romae)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233275",
    dateCreated: "16th century",
    imageUrl: "images/Rome__Burgus_Romae_.webp",
  },
  {
    compositionName: "Exterior of the Colosseum (Colisei prospectus)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233276",
    dateCreated: "16th century",
    imageUrl: "images/Exterior_of_the_Colosseum__Colisei_prospectus_.webp",
  },
  {
    compositionName: "The Baths of Caracalla (Thermae Caracallae)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233277",
    dateCreated: "16th century",
    imageUrl: "images/The_Baths_of_Caracalla__Thermae_Caracallae_.webp",
  },
  {
    compositionName: "Interior of the Colosseum (Colisei prospectus)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233278",
    dateCreated: "16th century",
    imageUrl: "images/Interior_of_the_Colosseum__Colisei_prospectus_.webp",
  },
  {
    compositionName: "The Pyramid of Cestus (Mons Testaceus)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233279",
    dateCreated: "16th century",
    imageUrl: "images/The_Pyramid_of_Cestus__Mons_Testaceus_.webp",
  },
  {
    compositionName: "Ericis portus",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233280",
    dateCreated: "16th century",
    imageUrl: "images/Ericis_portus.webp",
  },
  {
    compositionName: "'Het Huis te Kleef'",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233285",
    dateCreated: "1615",
    imageUrl: "images/_Het_Huis_te_Kleef_.webp",
  },
  {
    compositionName: "The Baths of Diocletian (Thermae Diocletiani)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233290",
    dateCreated: "16th century",
    imageUrl: "images/The_Baths_of_Diocletian__Thermae_Diocletiani_.webp",
  },
  {
    compositionName: "The Colosseum (Coliseum Romanum)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233291",
    dateCreated: "16th century",
    imageUrl: "images/The_Colosseum__Coliseum_Romanum_.webp",
  },
  {
    compositionName: "The Palatine Hill (Palatini montis prospectus)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233292",
    dateCreated: "16th century",
    imageUrl: "images/The_Palatine_Hill__Palatini_montis_prospectus_.webp",
  },
  {
    compositionName: "Tamar Brought to Execution, Showing Judah's Pledge",
    author: ["Dirck Volkertsz. Coornhert", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233295",
    dateCreated: "c. 1549",
    imageUrl: "images/Tamar_Brought_to_Execution__Showing_Judah_s_Pledge.webp",
  },
  {
    compositionName: "February",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233300",
    dateCreated: "1618",
    imageUrl: "images/February.webp",
  },
  {
    compositionName: "September",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233301",
    dateCreated: "1618",
    imageUrl: "images/September.webp",
  },
  {
    compositionName: "The Belevedere, Rome (Belvedere Romanum)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233323",
    dateCreated: "16th century",
    imageUrl: "images/The_Belevedere__Rome__Belvedere_Romanum_.webp",
  },
  {
    compositionName: "Old St. Peter's, Rome (S. Petri templum, Romae)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233324",
    dateCreated: "16th century",
    imageUrl: "images/Old_St__Peter_s__Rome__S__Petri_templum__Romae_.webp",
  },
  {
    compositionName: "April",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233327",
    dateCreated: "1618",
    imageUrl: "images/April.webp",
  },
  {
    compositionName: "July",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233328",
    dateCreated: "1618",
    imageUrl: "images/July.webp",
  },
  {
    compositionName: "The Dutch Cafe",
    author: ["Jacques Firmin Beauvarlet", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276104",
    dateCreated: "18th century",
    imageUrl: "images/The_Dutch_Cafe.webp",
  },
  {
    compositionName: "Madonna of the Rosaries",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276113",
    dateCreated: "17th-18th century",
    imageUrl: "images/Madonna_of_the_Rosaries.webp",
  },
  {
    compositionName: "Aurora with Apollo and the Hours",
    author: ["Robert van Auden-Aerd", "After Guido Reni"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276114",
    dateCreated: "17th-18th century",
    imageUrl: "images/Aurora_with_Apollo_and_the_Hours.webp",
  },
  {
    compositionName:
      "Charles the First, King of England, and the Duke d'Espernon",
    author: ["Bernard Baron", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276119",
    dateCreated: "1741",
    imageUrl:
      "images/Charles_the_First__King_of_England__and_the_Duke_d_Espernon.webp",
  },
  {
    compositionName: "Andreas van Ertvelt",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276120",
    dateCreated: "17th century",
    imageUrl: "images/Andreas_van_Ertvelt.webp",
  },
  {
    compositionName: "Justus Lipsius",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276121",
    dateCreated: "17th century",
    imageUrl: "images/Justus_Lipsius.webp",
  },
  {
    compositionName: "Paul de Vos",
    author: [
      "Schelte Adamsz. Bolswert",
      "Anthony van Dyck",
      "After Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276122",
    dateCreated: "17th century",
    imageUrl: "images/Paul_de_Vos.webp",
  },
  {
    compositionName: "Night Watch",
    author: ["Lambert Antoine Claessens", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276131",
    dateCreated: "18th-19th century",
    imageUrl: "images/Night_Watch.webp",
  },
  {
    compositionName: "Rembrandt",
    author: ["Lambert Antoine Claessens", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276162",
    dateCreated: "18th-19th century",
    imageUrl: "images/Rembrandt.webp",
  },
  {
    compositionName: "Aged Rabbi",
    author: ["William Baillie", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276170",
    dateCreated: "18th century",
    imageUrl: "images/Aged_Rabbi.webp",
  },
  {
    compositionName: "Bust of an Old Man with Long Hair",
    author: ["William Baillie", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276171",
    dateCreated: "18th century",
    imageUrl: "images/Bust_of_an_Old_Man_with_Long_Hair.webp",
  },
  {
    compositionName: "Gold Weigher",
    author: ["William Baillie", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276172",
    dateCreated: "18th century",
    imageUrl: "images/Gold_Weigher.webp",
  },
  {
    compositionName: "Adriaen Brouwer",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276176",
    dateCreated: "17th century",
    imageUrl: "images/Adriaen_Brouwer.webp",
  },
  {
    compositionName: "A Man",
    author: ["Jean-Jacques de Boissieu", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276183",
    dateCreated: "1770",
    imageUrl: "images/A_Man.webp",
  },
  {
    compositionName: "Willem de Vos",
    author: [
      "Schelte Adamsz. Bolswert",
      "Anthony van Dyck",
      "After Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276196",
    dateCreated: "17th century",
    imageUrl: "images/Willem_de_Vos.webp",
  },
  {
    compositionName: "The Judgement of Paris",
    author: ["Maurice Blot", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276209",
    dateCreated: "18th-19th century",
    imageUrl: "images/The_Judgement_of_Paris.webp",
  },
  {
    compositionName: "Marquis de Mirabelle",
    author: ["Abraham Blooteling", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276240",
    dateCreated: "17th century",
    imageUrl: "images/Marquis_de_Mirabelle.webp",
  },
  {
    compositionName: "Portrait of Jacques Callot",
    author: ["Esme de Boulonois", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276290",
    dateCreated: "c. 1682",
    imageUrl: "images/Portrait_of_Jacques_Callot.webp",
  },
  {
    compositionName: "Young Woman Gone to Sleep over Her Wine",
    author: ["Hendrik Bary", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276308",
    dateCreated: "1670",
    imageUrl: "images/Young_Woman_Gone_to_Sleep_over_Her_Wine.webp",
  },
  {
    compositionName: "View of Boom on the Rupel",
    author: ["Jean Jacques Aliamet", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276401",
    dateCreated: "18th century",
    imageUrl: "images/View_of_Boom_on_the_Rupel.webp",
  },
  {
    compositionName: "Christ Crowned with Thorns",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276471",
    dateCreated: "17th century",
    imageUrl: "images/Christ_Crowned_with_Thorns.webp",
  },
  {
    compositionName: "Van Dyck's Wife",
    author: ["Francesco Bartolozzi", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276520",
    dateCreated: "18th century",
    imageUrl: "images/Van_Dyck_s_Wife.webp",
  },
  {
    compositionName: "Dead Christ and Mourners",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276572",
    dateCreated: "17th-18th century",
    imageUrl: "images/Dead_Christ_and_Mourners.webp",
  },
  {
    compositionName: "Chateau de Ryswick",
    author: ["Jacques Bacheley", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276573",
    dateCreated: "1773",
    imageUrl: "images/Chateau_de_Ryswick.webp",
  },
  {
    compositionName: "Martin Pepyn",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276577",
    dateCreated: "17th century",
    imageUrl: "images/Martin_Pepyn.webp",
  },
  {
    compositionName: "Dismissal of Hagar",
    author: ["Friedrich Jentzen", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276591",
    dateCreated: "19th century",
    imageUrl: "images/Dismissal_of_Hagar.webp",
  },
  {
    compositionName: "Forest with a Road through the Middle",
    author: ["Johann Friedrich Franz Bruder", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276618",
    dateCreated: "19th century",
    imageUrl: "images/Forest_with_a_Road_through_the_Middle.webp",
  },
  {
    compositionName: "A Young Man with a Hat",
    author: ["Peter von Hess", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276626",
    dateCreated: "19th century",
    imageUrl: "images/A_Young_Man_with_a_Hat.webp",
  },
  {
    compositionName: "The Feast of Ahasuerus",
    author: ["Franz Hanfstaengl", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276633",
    dateCreated: "19th century",
    imageUrl: "images/The_Feast_of_Ahasuerus.webp",
  },
  {
    compositionName: "The Trumpeter at the Guardhouse",
    author: ["Franz Hanfstaengl", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276636",
    dateCreated: "19th century",
    imageUrl: "images/The_Trumpeter_at_the_Guardhouse.webp",
  },
  {
    compositionName: "Franz van Mieris in his Studio",
    author: ["Franz Hanfstaengl", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276638",
    dateCreated: "19th century",
    imageUrl: "images/Franz_van_Mieris_in_his_Studio.webp",
  },
  {
    compositionName: "Rembrandt's Daughter",
    author: ["Franz Hanfstaengl", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276711",
    dateCreated: "19th century",
    imageUrl: "images/Rembrandt_s_Daughter.webp",
  },
  {
    compositionName: "Waterfall",
    author: ["Christian Haldenwang", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276715",
    dateCreated: "19th century",
    imageUrl: "images/Waterfall.webp",
  },
  {
    compositionName: "Philosopher in Contemplation",
    author: [
      "Giuseppe Longhi",
      "Paolo Caronni",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276730",
    dateCreated: "19th century",
    imageUrl: "images/Philosopher_in_Contemplation.webp",
  },
  {
    compositionName: "Philosopher in Meditation",
    author: [
      "Giuseppe Longhi",
      "Giuseppe Cozzi",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276731",
    dateCreated: "19th century",
    imageUrl: "images/Philosopher_in_Meditation.webp",
  },
  {
    compositionName: "Marie de Barbancon, wife of Albert, Duc d'Arenberg",
    author: ["Adriaen Lommelin", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276734",
    dateCreated: "17th century",
    imageUrl: "images/Marie_de_Barbancon__wife_of_Albert__Duc_d_Arenberg.webp",
  },
  {
    compositionName: "Man with Book and Cane",
    author: ["Giuseppe Longhi", "After School of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276873",
    dateCreated: "19th century",
    imageUrl: "images/Man_with_Book_and_Cane.webp",
  },
  {
    compositionName: "Cemetery",
    author: ["Johann Friedrich Franz Bruder", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276876",
    dateCreated: "19th century",
    imageUrl: "images/Cemetery.webp",
  },
  {
    compositionName: "Bridge",
    author: ["Johann Friedrich Franz Bruder", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276993",
    dateCreated: "19th century",
    imageUrl: "images/Bridge.webp",
  },
  {
    compositionName: "The Trophies of Marius",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235945",
    dateCreated: "17th century",
    imageUrl: "images/The_Trophies_of_Marius.webp",
  },
  {
    compositionName: "Ruins of An Imperial Palace",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235946",
    dateCreated: "17th century",
    imageUrl: "images/Ruins_of_An_Imperial_Palace.webp",
  },
  {
    compositionName: "Man in a Boat",
    author: ["Jan van Brosterhuisen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235947",
    dateCreated: "17th century",
    imageUrl: "images/Man_in_a_Boat.webp",
  },
  {
    compositionName: "Venus and Cupid",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235965",
    dateCreated: "1636",
    imageUrl: "images/Venus_and_Cupid.webp",
  },
  {
    compositionName: "Antiope Surprised by Jupiter",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235966",
    dateCreated: "17th century",
    imageUrl: "images/Antiope_Surprised_by_Jupiter.webp",
  },
  {
    compositionName:
      "Peasant Feast before an Inn with a Banner of St. Sebastian",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Bol",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235972",
    dateCreated: "1562",
    imageUrl:
      "images/Peasant_Feast_before_an_Inn_with_a_Banner_of_St__Sebastian.webp",
  },
  {
    compositionName: "The Smoker and the Drinker",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236032",
    dateCreated: "c. 1682",
    imageUrl: "images/The_Smoker_and_the_Drinker.webp",
  },
  {
    compositionName: "Three Grotesque Figures",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236033",
    dateCreated: "c. 1638",
    imageUrl: "images/Three_Grotesque_Figures.webp",
  },
  {
    compositionName: "The Spectacle Seller",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236034",
    dateCreated: "c. 1646",
    imageUrl: "images/The_Spectacle_Seller.webp",
  },
  {
    compositionName: "The Concert",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236035",
    dateCreated: "c. 1644",
    imageUrl: "images/The_Concert.webp",
  },
  {
    compositionName: "The Painter",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236036",
    dateCreated: "1667",
    imageUrl: "images/The_Painter.webp",
  },
  {
    compositionName: "The Backgammon Players",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236037",
    dateCreated: "1682",
    imageUrl: "images/The_Backgammon_Players.webp",
  },
  {
    compositionName: "The Hunchbacked Fiddler",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236038",
    dateCreated: "1654",
    imageUrl: "images/The_Hunchbacked_Fiddler.webp",
  },
  {
    compositionName: "The Dance under the Trellis",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236039",
    dateCreated: "c. 1652",
    imageUrl: "images/The_Dance_under_the_Trellis.webp",
  },
  {
    compositionName: "The Fair",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236040",
    dateCreated: "c. 1660",
    imageUrl: "images/The_Fair.webp",
  },
  {
    compositionName: "The Dance in the Inn",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236041",
    dateCreated: "c. 1664",
    imageUrl: "images/The_Dance_in_the_Inn.webp",
  },
  {
    compositionName: "The Breakfast",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236042",
    dateCreated: "c. 1664",
    imageUrl: "images/The_Breakfast.webp",
  },
  {
    compositionName: "The Smokers in the Inn",
    author: ["Manner of Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236043",
    dateCreated: "17th century",
    imageUrl: "images/The_Smokers_in_the_Inn.webp",
  },
  {
    compositionName: "The Baker Sounding His Horn",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236065",
    dateCreated: "c. 1664",
    imageUrl: "images/The_Baker_Sounding_His_Horn.webp",
  },
  {
    compositionName: "The Smoker at the Window",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236066",
    dateCreated: "c. 1667",
    imageUrl: "images/The_Smoker_at_the_Window.webp",
  },
  {
    compositionName: "Rubens and van Dyck",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277799",
    dateCreated: "17th century",
    imageUrl: "images/Rubens_and_van_Dyck.webp",
  },
  {
    compositionName: "Raphael Urbin",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277800",
    dateCreated: "17th century",
    imageUrl: "images/Raphael_Urbin.webp",
  },
  {
    compositionName: "Jan van den Wouwer",
    author: ["Paulus Pontius", "Anthony van Dyck", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277802",
    dateCreated: "17th century",
    imageUrl: "images/Jan_van_den_Wouwer.webp",
  },
  {
    compositionName: "Hendrik van Balen",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277803",
    dateCreated: "17th century",
    imageUrl: "images/Hendrik_van_Balen.webp",
  },
  {
    compositionName: "Old Tobias Mocked by His Wife",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277829",
    dateCreated: "1773",
    imageUrl: "images/Old_Tobias_Mocked_by_His_Wife.webp",
  },
  {
    compositionName: "Cemetary",
    author: ["Johann George Primavesi", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277845",
    dateCreated: "18th-19th century",
    imageUrl: "images/Cemetary.webp",
  },
  {
    compositionName: "Man in Armor",
    author: ["Carl Gottlieb Rasp", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277847",
    dateCreated: "18th-19th century",
    imageUrl: "images/Man_in_Armor.webp",
  },
  {
    compositionName: "Old Castellated Dutch Building on the Bank of a Canal",
    author: ["Peter Vischer", "After ? Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277998",
    dateCreated: "19th century",
    imageUrl:
      "images/Old_Castellated_Dutch_Building_on_the_Bank_of_a_Canal.webp",
  },
  {
    compositionName: "Wood near the Hague",
    author: ["Carl Wilhelm Weisbrod", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278016",
    dateCreated: "18th century",
    imageUrl: "images/Wood_near_the_Hague.webp",
  },
  {
    compositionName: "Flagellation",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278133",
    dateCreated: "1509",
    imageUrl: "images/Flagellation.webp",
  },
  {
    compositionName: "The Players' Quarrel",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236106",
    dateCreated: "1653",
    imageUrl: "images/The_Players__Quarrel.webp",
  },
  {
    compositionName: "The Singers",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236107",
    dateCreated: "c. 1667",
    imageUrl: "images/The_Singers.webp",
  },
  {
    compositionName: "Man with His Hands behind His Back",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236108",
    dateCreated: "c. 1640",
    imageUrl: "images/Man_with_His_Hands_behind_His_Back.webp",
  },
  {
    compositionName: "Demanding the Doll",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236121",
    dateCreated: "1679",
    imageUrl: "images/Demanding_the_Doll.webp",
  },
  {
    compositionName: "The Schoolmaster",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236122",
    dateCreated: "c. 1644",
    imageUrl: "images/The_Schoolmaster.webp",
  },
  {
    compositionName: "Man with a Crooked Back",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236133",
    dateCreated: "c. 1675",
    imageUrl: "images/Man_with_a_Crooked_Back.webp",
  },
  {
    compositionName: "The Empty Jug",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236156",
    dateCreated: "17th century",
    imageUrl: "images/The_Empty_Jug.webp",
  },
  {
    compositionName: "Man with His Hand in His Cloak",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236160",
    dateCreated: "c. 1638",
    imageUrl: "images/Man_with_His_Hand_in_His_Cloak.webp",
  },
  {
    compositionName:
      "Landscape With a Traveler Assaulted by Bandits (From the Parable of the Good Samaritan)",
    author: ["Willem van Nieulandt II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236195",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_With_a_Traveler_Assaulted_by_Bandits__From_the_Parable_of_the_Good_Samaritan_.webp",
  },
  {
    compositionName: "The Seated Cowherd, Roman Monuments",
    author: ["Jean Morin", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236216",
    dateCreated: "17th century",
    imageUrl: "images/The_Seated_Cowherd__Roman_Monuments.webp",
  },
  {
    compositionName: "Good Friends",
    author: ["Johann Georg Wille", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278373",
    dateCreated: "1773",
    imageUrl: "images/Good_Friends.webp",
  },
  {
    compositionName: "The Dutch Knitter",
    author: ["Johann Georg Wille", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278375",
    dateCreated: "1757",
    imageUrl: "images/The_Dutch_Knitter.webp",
  },
  {
    compositionName: "The Distracted Observer",
    author: ["Johann Georg Wille", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278376",
    dateCreated: "1766",
    imageUrl: "images/The_Distracted_Observer.webp",
  },
  {
    compositionName: "Crowning with Thorns",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278412",
    dateCreated: "1509",
    imageUrl: "images/Crowning_with_Thorns.webp",
  },
  {
    compositionName: "Christ Presented to the People",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278413",
    dateCreated: "1509",
    imageUrl: "images/Christ_Presented_to_the_People.webp",
  },
  {
    compositionName: "Christ Bearing the Cross",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278414",
    dateCreated: "1509",
    imageUrl: "images/Christ_Bearing_the_Cross.webp",
  },
  {
    compositionName: "Crucifixion",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278415",
    dateCreated: "1509",
    imageUrl: "images/Crucifixion.webp",
  },
  {
    compositionName: "Dance of the Magdalen",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278416",
    dateCreated: "1519",
    imageUrl: "images/Dance_of_the_Magdalen.webp",
  },
  {
    compositionName: "Cardinalis Guido Bentivolus",
    author: ["Jean Morin", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278424",
    dateCreated: "17th century",
    imageUrl: "images/Cardinalis_Guido_Bentivolus.webp",
  },
  {
    compositionName: "Adoration of the Magi",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278425",
    dateCreated: "1513",
    imageUrl: "images/Adoration_of_the_Magi.webp",
  },
  {
    compositionName: "Saint Mark",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278426",
    dateCreated: "16th century",
    imageUrl: "images/Saint_Mark.webp",
  },
  {
    compositionName: "Saint John",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278427",
    dateCreated: "16th century",
    imageUrl: "images/Saint_John.webp",
  },
  {
    compositionName: "Saint George Liberating the Princess",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278428",
    dateCreated: "c. 1508",
    imageUrl: "images/Saint_George_Liberating_the_Princess.webp",
  },
  {
    compositionName: "Mahomet and the Monk Sergius",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278429",
    dateCreated: "1508",
    imageUrl: "images/Mahomet_and_the_Monk_Sergius.webp",
  },
  {
    compositionName: "Esther before Ahasuerus",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278460",
    dateCreated: "1518",
    imageUrl: "images/Esther_before_Ahasuerus.webp",
  },
  {
    compositionName: "Christ on the Mount of Olives",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278461",
    dateCreated: "1509",
    imageUrl: "images/Christ_on_the_Mount_of_Olives.webp",
  },
  {
    compositionName: "Christ Betrayed",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278462",
    dateCreated: "1509",
    imageUrl: "images/Christ_Betrayed.webp",
  },
  {
    compositionName: "Christ before Annas",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278463",
    dateCreated: "1509",
    imageUrl: "images/Christ_before_Annas.webp",
  },
  {
    compositionName: "Christ Mocked",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278464",
    dateCreated: "1509",
    imageUrl: "images/Christ_Mocked.webp",
  },
  {
    compositionName: "Christ appearing to Magdalen as a Gardener",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278479",
    dateCreated: "1519",
    imageUrl: "images/Christ_appearing_to_Magdalen_as_a_Gardener.webp",
  },
  {
    compositionName: "Saint Matthew",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278480",
    dateCreated: "1518",
    imageUrl: "images/Saint_Matthew.webp",
  },
  {
    compositionName: "The Fall of Man",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278496",
    dateCreated: "c. 1530",
    imageUrl: "images/The_Fall_of_Man.webp",
  },
  {
    compositionName: "Cain Killing Abel",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278497",
    dateCreated: "1524",
    imageUrl: "images/Cain_Killing_Abel.webp",
  },
  {
    compositionName: "David Playing His Harp before Saul",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278504",
    dateCreated: "c. 1508",
    imageUrl: "images/David_Playing_His_Harp_before_Saul.webp",
  },
  {
    compositionName: "Virgil Suspended in a Basket",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278505",
    dateCreated: "1525",
    imageUrl: "images/Virgil_Suspended_in_a_Basket.webp",
  },
  {
    compositionName: "A Nobleman and a Lady Seated in a Landscape",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278506",
    dateCreated: "1520",
    imageUrl: "images/A_Nobleman_and_a_Lady_Seated_in_a_Landscape.webp",
  },
  {
    compositionName: "Lucas van Leyden",
    author: ["Manner of Lucas van Leyden", "After Albrecht D\u00fcrer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278507",
    dateCreated: "1525",
    imageUrl: "images/Lucas_van_Leyden.webp",
  },
  {
    compositionName: "Saint Luke",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278511",
    dateCreated: "16th century",
    imageUrl: "images/Saint_Luke.webp",
  },
  {
    compositionName: "The Anglers",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236512",
    dateCreated: "c. 1653",
    imageUrl: "images/The_Anglers.webp",
  },
  {
    compositionName: "The Cobbler",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236513",
    dateCreated: "1671",
    imageUrl: "images/The_Cobbler.webp",
  },
  {
    compositionName: "Man and Woman Talking",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236514",
    dateCreated: "c. 1650",
    imageUrl: "images/Man_and_Woman_Talking.webp",
  },
  {
    compositionName: "The Quacksalver",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236515",
    dateCreated: "1648",
    imageUrl: "images/The_Quacksalver.webp",
  },
  {
    compositionName: "The Fiddler and the Hurdy-Gurdy Boy",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236516",
    dateCreated: "c. 1660",
    imageUrl: "images/The_Fiddler_and_the_Hurdy_Gurdy_Boy.webp",
  },
  {
    compositionName: "Saying Grace",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236527",
    dateCreated: "1653",
    imageUrl: "images/Saying_Grace.webp",
  },
  {
    compositionName: "The Pater Familias",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236544",
    dateCreated: "1648",
    imageUrl: "images/The_Pater_Familias.webp",
  },
  {
    compositionName: "The Knifegrinder",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236545",
    dateCreated: "c. 1682",
    imageUrl: "images/The_Knifegrinder.webp",
  },
  {
    compositionName: "The Wandering Musicians",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236546",
    dateCreated: "c. 1642",
    imageUrl: "images/The_Wandering_Musicians.webp",
  },
  {
    compositionName: "Mill",
    author: ["Jean Mathieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278664",
    dateCreated: "1772",
    imageUrl: "images/Mill.webp",
  },
  {
    compositionName: "Charles I of England with the Duke of Hamilton",
    author: ["Robert Strange", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278675",
    dateCreated: "1782",
    imageUrl: "images/Charles_I_of_England_with_the_Duke_of_Hamilton.webp",
  },
  {
    compositionName: "Cobbler",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278700",
    dateCreated: "1671",
    imageUrl: "images/Cobbler.webp",
  },
  {
    compositionName: "Smoker and Drinker",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278712",
    dateCreated: "1682",
    imageUrl: "images/Smoker_and_Drinker.webp",
  },
  {
    compositionName: "Marten Ryckaert",
    author: ["Jacob Neeffs", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278713",
    dateCreated: "17th century",
    imageUrl: "images/Marten_Ryckaert.webp",
  },
  {
    compositionName:
      "Charles, Prince of Wales, James, Duke of York, and Princess Mary, Children of King Charles I",
    author: ["Robert Strange", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278725",
    dateCreated: "18th century",
    imageUrl:
      "images/Charles__Prince_of_Wales__James__Duke_of_York__and_Princess_Mary__Children_of_King_Charles_I.webp",
  },
  {
    compositionName: "Artist",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278735",
    dateCreated: "c. 1667",
    imageUrl: "images/Artist.webp",
  },
  {
    compositionName: "Prince William I",
    author: ["Edward Taurel", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278745",
    dateCreated: "19th century",
    imageUrl: "images/Prince_William_I.webp",
  },
  {
    compositionName:
      "The Meeting of Ferdinand, King of Hungary, and the Cardinal-Infante Ferdinand of Spain at N\u00f6rdlingen",
    author: ["Theodor van Thulden", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278784",
    dateCreated: "1641",
    imageUrl:
      "images/The_Meeting_of_Ferdinand__King_of_Hungary__and_the_Cardinal_Infante_Ferdinand_of_Spain_at_Nordlingen.webp",
  },
  {
    compositionName: "Peasant Paying His Bill",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278804",
    dateCreated: "17th century",
    imageUrl: "images/Peasant_Paying_His_Bill.webp",
  },
  {
    compositionName: "Man with High Cap and Feather",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278807",
    dateCreated: "1647",
    imageUrl: "images/Man_with_High_Cap_and_Feather.webp",
  },
  {
    compositionName: "Grange",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278808",
    dateCreated: "1647",
    imageUrl: "images/Grange.webp",
  },
  {
    compositionName: "Butcher",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278809",
    dateCreated: "c. 1642",
    imageUrl: "images/Butcher.webp",
  },
  {
    compositionName: "Francisco de Moncada",
    author: ["Raphael Morghen", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278818",
    dateCreated: "18th-19th century",
    imageUrl: "images/Francisco_de_Moncada.webp",
  },
  {
    compositionName: "Wilhelmus II. Princeps Nassoviae",
    author: ["Raphael Morghen", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278823",
    dateCreated: "18th-19th century",
    imageUrl: "images/Wilhelmus_II__Princeps_Nassoviae.webp",
  },
  {
    compositionName: "Father of the Family",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278842",
    dateCreated: "1648",
    imageUrl: "images/Father_of_the_Family.webp",
  },
  {
    compositionName: "Blessing",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278855",
    dateCreated: "1653",
    imageUrl: "images/Blessing.webp",
  },
  {
    compositionName: "Solomon Worshipping the Idol",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278876",
    dateCreated: "16th century",
    imageUrl: "images/Solomon_Worshipping_the_Idol.webp",
  },
  {
    compositionName:
      "Daughter of Herodias with the Head of S. John the Baptist",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278877",
    dateCreated: "c. 1514",
    imageUrl:
      "images/Daughter_of_Herodias_with_the_Head_of_S__John_the_Baptist.webp",
  },
  {
    compositionName: "Christ bearing the cross",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278880",
    dateCreated: "1515",
    imageUrl: "images/Christ_bearing_the_cross.webp",
  },
  {
    compositionName: "Virgin in Glory, Standing on a Crescent",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278881",
    dateCreated: "1523",
    imageUrl: "images/Virgin_in_Glory__Standing_on_a_Crescent.webp",
  },
  {
    compositionName: "Saint Jerome in a Landscape",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278882",
    dateCreated: "1513",
    imageUrl: "images/Saint_Jerome_in_a_Landscape.webp",
  },
  {
    compositionName: "The Standard Bearer",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278883",
    dateCreated: "c. 1510",
    imageUrl: "images/The_Standard_Bearer.webp",
  },
  {
    compositionName: "Promenade",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278884",
    dateCreated: "1520",
    imageUrl: "images/Promenade.webp",
  },
  {
    compositionName: "Milkmaid",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278885",
    dateCreated: "1510",
    imageUrl: "images/Milkmaid.webp",
  },
  {
    compositionName: "Time clipping the wings of love",
    author: ["James McArdell", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278886",
    dateCreated: "18th century",
    imageUrl: "images/Time_clipping_the_wings_of_love.webp",
  },
  {
    compositionName: "Return of the Prodigal Son",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278928",
    dateCreated: "16th century",
    imageUrl: "images/Return_of_the_Prodigal_Son.webp",
  },
  {
    compositionName: "The Gentleman with a Hawk and the Lady",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278929",
    dateCreated: "c. 1507",
    imageUrl: "images/The_Gentleman_with_a_Hawk_and_the_Lady.webp",
  },
  {
    compositionName: "Sim\u00e9on Joseph Barbot de Lardeinne",
    author: ["Pieter van Schuppen", "After Jakob-Ferdinand Voet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278955",
    dateCreated: "17th century",
    imageUrl: "images/Simeon_Joseph_Barbot_de_Lardeinne.webp",
  },
  {
    compositionName: "Self-Portrait with Saskia",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278957",
    dateCreated: "1636",
    imageUrl: "images/Self_Portrait_with_Saskia.webp",
  },
  {
    compositionName: "Self-Portrait in a Velvet Cap with Plume",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278958",
    dateCreated: "1638",
    imageUrl: "images/Self_Portrait_in_a_Velvet_Cap_with_Plume.webp",
  },
  {
    compositionName: "Claude Adrien Helvetius",
    author: ["Augustin de Saint-Aubin", "After Louis-Michel van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278973",
    dateCreated: "1778",
    imageUrl: "images/Claude_Adrien_Helvetius.webp",
  },
  {
    compositionName: "Saint Jerome Reading in an Italian Landscape",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278975",
    dateCreated: "c. 1653-c. 1654",
    imageUrl: "images/Saint_Jerome_Reading_in_an_Italian_Landscape.webp",
  },
  {
    compositionName: "Old Man with Beard, Fur Cap, and Velvet Cloak",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278976",
    dateCreated: "1627 - 1637",
    imageUrl: "images/Old_Man_with_Beard__Fur_Cap__and_Velvet_Cloak.webp",
  },
  {
    compositionName:
      "Bust of an Old Man with a Fur Cap and Flowing Beard, nearly Full Face",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278982",
    dateCreated: "c. 1631",
    imageUrl:
      "images/Bust_of_an_Old_Man_with_a_Fur_Cap_and_Flowing_Beard__nearly_Full_Face.webp",
  },
  {
    compositionName: "Bust of a Man Wearing a High Cap",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278983",
    dateCreated: "1630",
    imageUrl: "images/Bust_of_a_Man_Wearing_a_High_Cap.webp",
  },
  {
    compositionName: "Rembrandt's Mother Seated at a Table",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278984",
    dateCreated: "c.1631",
    imageUrl: "images/Rembrandt_s_Mother_Seated_at_a_Table.webp",
  },
  {
    compositionName: "Anne Boleyn",
    author: ["Cornelis Vermeulen", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278985",
    dateCreated: "17th century",
    imageUrl: "images/Anne_Boleyn.webp",
  },
  {
    compositionName: "Jan de Moff",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278989",
    dateCreated: "17th century",
    imageUrl: "images/Jan_de_Moff.webp",
  },
  {
    compositionName: "Effigies Paracelsi Medici Celeberrimi",
    author: ["Pieter van Sompel", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278993",
    dateCreated: "17th century",
    imageUrl: "images/Effigies_Paracelsi_Medici_Celeberrimi.webp",
  },
  {
    compositionName: "Warrior",
    author: ["William Pether", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279033",
    dateCreated: "18th century",
    imageUrl: "images/Warrior.webp",
  },
  {
    compositionName: "Eug\u00e8ne Fran\u00e7ois Prince of Savoy and of Piemont",
    author: ["Bernard Picart", "After Jacques van Schuppen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279034",
    dateCreated: "1722",
    imageUrl: "images/Eugene_Francois_Prince_of_Savoy_and_of_Piemont.webp",
  },
  {
    compositionName: "The Great Knife-Fight",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279070",
    dateCreated: "17th century",
    imageUrl: "images/The_Great_Knife_Fight.webp",
  },
  {
    compositionName: "Jewish Rabbi",
    author: [
      "William Pether",
      "After Rembrandt Harmensz. van Rijn",
      "Published by John Boydell",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279095",
    dateCreated: "1764",
    imageUrl: "images/Jewish_Rabbi.webp",
  },
  {
    compositionName: "Infant Jesus Sleeping",
    author: ["Robert Strange", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279097",
    dateCreated: "18th century",
    imageUrl: "images/Infant_Jesus_Sleeping.webp",
  },
  {
    compositionName: "Eleazer Swalm",
    author: ["Jonas Suyderhoef", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279159",
    dateCreated: "17th century",
    imageUrl: "images/Eleazer_Swalm.webp",
  },
  {
    compositionName: "Pieter Snayers",
    author: ["Andries Jacobsz Stock", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279167",
    dateCreated: "17th century",
    imageUrl: "images/Pieter_Snayers.webp",
  },
  {
    compositionName: "The Love Letter",
    author: ["Jan van Somer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279172",
    dateCreated: "17th century",
    imageUrl: "images/The_Love_Letter.webp",
  },
  {
    compositionName: "Piet\u00e0",
    author: ["Frans van der Steen", "After Annibale Carracci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279173",
    dateCreated: "17th century",
    imageUrl: "images/Pieta.webp",
  },
  {
    compositionName: "Marie Th\u00e9r\u00e8se, Queen of Hungary",
    author: ["Gilles Edme Petit", "After Martin van Meytens II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279175",
    dateCreated: "1743",
    imageUrl: "images/Marie_Therese__Queen_of_Hungary.webp",
  },
  {
    compositionName: "Charles I, King of Great Britain",
    author: ["Robert Strange", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279182",
    dateCreated: "1770",
    imageUrl: "images/Charles_I__King_of_Great_Britain.webp",
  },
  {
    compositionName: "Henrietta Maria, Magnae Britanniae Regina",
    author: [
      "Robert Strange",
      "After Anthony van Dyck",
      "Published by Robert Strange",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279183",
    dateCreated: "1784",
    imageUrl: "images/Henrietta_Maria__Magnae_Britanniae_Regina.webp",
  },
  {
    compositionName: "Entombment",
    author: ["Willem van de Passe", "After Albrecht D\u00fcrer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279194",
    dateCreated: "17th century",
    imageUrl: "images/Entombment.webp",
  },
  {
    compositionName: "Maurice, prince of Orange",
    author: ["Pieter Tanj\u00e9", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279207",
    dateCreated: "18th century",
    imageUrl: "images/Maurice__prince_of_Orange.webp",
  },
  {
    compositionName: "William I of Nassau, Prince of Orange",
    author: ["Pieter Tanj\u00e9", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279208",
    dateCreated: "18th century",
    imageUrl: "images/William_I_of_Nassau__Prince_of_Orange.webp",
  },
  {
    compositionName: "Standard Bearer",
    author: ["William Pether", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279211",
    dateCreated: "18th century",
    imageUrl: "images/Standard_Bearer.webp",
  },
  {
    compositionName: "The Three Crones",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237390",
    dateCreated: "17th century",
    imageUrl: "images/The_Three_Crones.webp",
  },
  {
    compositionName: "Landscape with Two Men in a Boat",
    author: ["Frans van den Wyngaerde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237466",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Two_Men_in_a_Boat.webp",
  },
  {
    compositionName: "The Babylonians Are Devoured by the Lions (Dan.14:41)",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237481",
    dateCreated: "1565",
    imageUrl:
      "images/The_Babylonians_Are_Devoured_by_the_Lions__Dan_14_41_.webp",
  },
  {
    compositionName:
      "Habakuk Bringing Daniel Food in the Lion's Den (Dan.14:32-36)",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237501",
    dateCreated: "1565",
    imageUrl:
      "images/Habakuk_Bringing_Daniel_Food_in_the_Lion_s_Den__Dan_14_32_36_.webp",
  },
  {
    compositionName: "Beached Sperm Whale at Noordwijk",
    author: ["Claes Jansz. Visscher", "After Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237545",
    dateCreated: "17th century",
    imageUrl: "images/Beached_Sperm_Whale_at_Noordwijk.webp",
  },
  {
    compositionName: "Dance outside an Inn",
    author: ["Johannes Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237572",
    dateCreated: "17th century",
    imageUrl: "images/Dance_outside_an_Inn.webp",
  },
  {
    compositionName: "Dance in the Barn",
    author: ["Johannes Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237573",
    dateCreated: "17th century",
    imageUrl: "images/Dance_in_the_Barn.webp",
  },
  {
    compositionName: "Interior of an Inn",
    author: ["Johannes Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237574",
    dateCreated: "17th century",
    imageUrl: "images/Interior_of_an_Inn.webp",
  },
  {
    compositionName: "The Village in the Wood",
    author: ["Matthijs van Plattenberg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237603",
    dateCreated: "17th century",
    imageUrl: "images/The_Village_in_the_Wood.webp",
  },
  {
    compositionName: "The Skaters",
    author: ["Matthijs van Plattenberg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237624",
    dateCreated: "17th century",
    imageUrl: "images/The_Skaters.webp",
  },
  {
    compositionName: "A Winter Landscape",
    author: ["Matthijs van Plattenberg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237645",
    dateCreated: "17th century",
    imageUrl: "images/A_Winter_Landscape.webp",
  },
  {
    compositionName: "Farms to the Left of a Path, Village at the Right",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237647",
    dateCreated: "17th century",
    imageUrl: "images/Farms_to_the_Left_of_a_Path__Village_at_the_Right.webp",
  },
  {
    compositionName: "Air",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237648",
    dateCreated: "17th century",
    imageUrl: "images/Air.webp",
  },
  {
    compositionName: "The Angel Appears to Zacharias in the Temple",
    author: ["Cornelis Galle the Younger", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237672",
    dateCreated: "17th century",
    imageUrl: "images/The_Angel_Appears_to_Zacharias_in_the_Temple.webp",
  },
  {
    compositionName: "John the Baptist Preaching",
    author: ["Cornelis Galle the Younger", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237673",
    dateCreated: "17th century",
    imageUrl: "images/John_the_Baptist_Preaching.webp",
  },
  {
    compositionName: "The Farmyard",
    author: ["Pierre Charles Canot", "After Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237683",
    dateCreated: "1768",
    imageUrl: "images/The_Farmyard.webp",
  },
  {
    compositionName: "Two Ladders",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237721",
    dateCreated: "17th century",
    imageUrl: "images/Two_Ladders.webp",
  },
  {
    compositionName: "Self-Portrait in a Cap: Laughing",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279274",
    dateCreated: "1630",
    imageUrl: "images/Self_Portrait_in_a_Cap__Laughing.webp",
  },
  {
    compositionName:
      "James Stanley, seventh earl of Derby and Charlotte de La Tremouille, his countess",
    author: ["John Henry Robinson", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279279",
    dateCreated: "18th-19th century",
    imageUrl:
      "images/James_Stanley__seventh_earl_of_Derby_and_Charlotte_de_La_Tremouille__his_countess.webp",
  },
  {
    compositionName: 'Saint Catherine ("The Little Jewish Bride")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279289",
    dateCreated: "1638",
    imageUrl: "images/Saint_Catherine___The_Little_Jewish_Bride__.webp",
  },
  {
    compositionName: "Catherine of Aragon",
    author: ["Cornelis Vermeulen", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279301",
    dateCreated: "17th century",
    imageUrl: "images/Catherine_of_Aragon.webp",
  },
  {
    compositionName: "Man with a Jug and Pipe",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279331",
    dateCreated: "17th century",
    imageUrl: "images/Man_with_a_Jug_and_Pipe.webp",
  },
  {
    compositionName: "The Triumph of Mordecai",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279332",
    dateCreated: "c. 1641",
    imageUrl: "images/The_Triumph_of_Mordecai.webp",
  },
  {
    compositionName: "Circumcision",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279333",
    dateCreated: "1654",
    imageUrl: "images/Circumcision.webp",
  },
  {
    compositionName: "The Hundred Guilder Print (detail)",
    author: ["Rembrandt Harmensz. van Rijn", "William Baillie"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279334",
    dateCreated: "17th century",
    imageUrl: "images/The_Hundred_Guilder_Print__detail_.webp",
  },
  {
    compositionName: "The Good Samaritan",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279337",
    dateCreated: "1633",
    imageUrl: "images/The_Good_Samaritan.webp",
  },
  {
    compositionName: "Baptism of the Eunuch",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279338",
    dateCreated: "1641",
    imageUrl: "images/Baptism_of_the_Eunuch.webp",
  },
  {
    compositionName: "Death of the Virgin",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279339",
    dateCreated: "1639",
    imageUrl: "images/Death_of_the_Virgin.webp",
  },
  {
    compositionName: "Peasant in a High Cap",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279340",
    dateCreated: "1639",
    imageUrl: "images/Peasant_in_a_High_Cap.webp",
  },
  {
    compositionName: "Polander Leaning on a Stick",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279341",
    dateCreated: "17th century",
    imageUrl: "images/Polander_Leaning_on_a_Stick.webp",
  },
  {
    compositionName: "A Student at a Table by Candlelight",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279342",
    dateCreated: "c. 1642",
    imageUrl: "images/A_Student_at_a_Table_by_Candlelight.webp",
  },
  {
    compositionName: "Beggar Man and Woman behind a Bank",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279343",
    dateCreated: "17th century",
    imageUrl: "images/Beggar_Man_and_Woman_behind_a_Bank.webp",
  },
  {
    compositionName: "The Three Trees",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279344",
    dateCreated: "1643",
    imageUrl: "images/The_Three_Trees.webp",
  },
  {
    compositionName: "Landscape with Three Gabled Cottages beside a Road",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279345",
    dateCreated: "1650",
    imageUrl: "images/Landscape_with_Three_Gabled_Cottages_beside_a_Road.webp",
  },
  {
    compositionName: "Landscape with a Square Tower",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279346",
    dateCreated: "1650",
    imageUrl: "images/Landscape_with_a_Square_Tower.webp",
  },
  {
    compositionName: "Landscape with a Cottage and a Large Tree",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279347",
    dateCreated: "1641",
    imageUrl: "images/Landscape_with_a_Cottage_and_a_Large_Tree.webp",
  },
  {
    compositionName: "Christ Crucified between the Two Thieves",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279352",
    dateCreated: "1653",
    imageUrl: "images/Christ_Crucified_between_the_Two_Thieves.webp",
  },
  {
    compositionName:
      "Daniel Shows King Cyrus the Footprints in the Ashes (Dan.14:18-21)",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237841",
    dateCreated: "1565",
    imageUrl:
      "images/Daniel_Shows_King_Cyrus_the_Footprints_in_the_Ashes__Dan_14_18_21_.webp",
  },
  {
    compositionName: "Village Street, with Logs in the Foreground",
    author: [
      "Joannes van Doetecum",
      "and Lucas van Doetecum",
      "After Master of the Small Landscapes",
      "Published by Philips Galle",
      "Or published by Theodoor Galle",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237866",
    dateCreated: "1559-1561; printed 1601 or c. 1612",
    imageUrl: "images/Village_Street__with_Logs_in_the_Foreground.webp",
  },
  {
    compositionName: "Farms, a Pond with a Decoy in the Foreground",
    author: [
      "Joannes van Doetecum",
      "and Lucas van Doetecum",
      "After Master of the Small Landscapes",
      "Published by Theodoor Galle",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237867",
    dateCreated: "1559-1561; printed c. 1612",
    imageUrl: "images/Farms__a_Pond_with_a_Decoy_in_the_Foreground.webp",
  },
  {
    compositionName: "Landscape with Large Rocks",
    author: ["Frans van den Wyngaerde", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237937",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Large_Rocks.webp",
  },
  {
    compositionName: "Soldiers Near Kettles",
    author: ["R. van den Hoecke"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237950",
    dateCreated: "17th century",
    imageUrl: "images/Soldiers_Near_Kettles.webp",
  },
  {
    compositionName: "Mater dolorosa",
    author: ["Alphonse Leroy", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237966",
    dateCreated: "19th century",
    imageUrl: "images/Mater_dolorosa.webp",
  },
  {
    compositionName: "Farm, Cows with Milk-Maids in the Foreground",
    author: [
      "Joannes van Doetecum",
      "and Lucas van Doetecum",
      "After Master of the Small Landscapes",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237997",
    dateCreated: "1559",
    imageUrl: "images/Farm__Cows_with_Milk_Maids_in_the_Foreground.webp",
  },
  {
    compositionName: "Two Empty Skiffs",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237998",
    dateCreated: "17th century",
    imageUrl: "images/Two_Empty_Skiffs.webp",
  },
  {
    compositionName: "Landscape in Mezzotint",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237999",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_in_Mezzotint.webp",
  },
  {
    compositionName: "Claude Joseph Vernet",
    author: ["Louis Jacques Cathelin", "After Louis-Michel van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238018",
    dateCreated: "1770",
    imageUrl: "images/Claude_Joseph_Vernet.webp",
  },
  {
    compositionName: "Gottfried Heinrich, Count of Pappenheim",
    author: ["Cornelis Galle the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238073",
    dateCreated: "17th century",
    imageUrl: "images/Gottfried_Heinrich__Count_of_Pappenheim.webp",
  },
  {
    compositionName: "Joan Jacob Wolff \u00e0 Todenwartt",
    author: ["Cornelis Galle the Younger", "After Anselmus van Hulle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238074",
    dateCreated: "17th century",
    imageUrl: "images/Joan_Jacob_Wolff_a_Todenwartt.webp",
  },
  {
    compositionName: "Georgius Ubricus comes to Wolckenstein and Rodeneg",
    author: ["Cornelis Galle the Younger", "After Anselmus van Hulle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238075",
    dateCreated: "17th century",
    imageUrl: "images/Georgius_Ubricus_comes_to_Wolckenstein_and_Rodeneg.webp",
  },
  {
    compositionName:
      "Copper Plate: Self-Portrait in a Flat Cap and Embroidered Dress",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238157",
    dateCreated: "c. 1642",
    imageUrl:
      "images/Copper_Plate__Self_Portrait_in_a_Flat_Cap_and_Embroidered_Dress.webp",
  },
  {
    compositionName: "Saint Barbara",
    author: ["Copy after Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238161",
    dateCreated: "20th century",
    imageUrl: "images/Saint_Barbara.webp",
  },
  {
    compositionName: "Fire",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238167",
    dateCreated: "17th century",
    imageUrl: "images/Fire.webp",
  },
  {
    compositionName: "Water",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238168",
    dateCreated: "17th century",
    imageUrl: "images/Water.webp",
  },
  {
    compositionName: "Bastion on a River",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238169",
    dateCreated: "17th century",
    imageUrl: "images/Bastion_on_a_River.webp",
  },
  {
    compositionName: "Three Gunners",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238170",
    dateCreated: "17th century",
    imageUrl: "images/Three_Gunners.webp",
  },
  {
    compositionName: "Kleine Houtpoort at Haarlem",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238171",
    dateCreated: "17th century",
    imageUrl: "images/Kleine_Houtpoort_at_Haarlem.webp",
  },
  {
    compositionName: "White Cow",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238172",
    dateCreated: "17th century",
    imageUrl: "images/White_Cow.webp",
  },
  {
    compositionName: "Dawn",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238173",
    dateCreated: "17th century",
    imageUrl: "images/Dawn.webp",
  },
  {
    compositionName: "Riverscape with a Traveler with a Pack on a Road",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238187",
    dateCreated: "17th century",
    imageUrl: "images/Riverscape_with_a_Traveler_with_a_Pack_on_a_Road.webp",
  },
  {
    compositionName: "Riverscape with an Inn and a Watch Tower",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238188",
    dateCreated: "17th century",
    imageUrl: "images/Riverscape_with_an_Inn_and_a_Watch_Tower.webp",
  },
  {
    compositionName: "Bastion and a Town Gate on a River",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238189",
    dateCreated: "17th century",
    imageUrl: "images/Bastion_and_a_Town_Gate_on_a_River.webp",
  },
  {
    compositionName: "Summer",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238190",
    dateCreated: "17th century",
    imageUrl: "images/Summer.webp",
  },
  {
    compositionName: "Midday",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238191",
    dateCreated: "17th century",
    imageUrl: "images/Midday.webp",
  },
  {
    compositionName: "Teijlingen Castle",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238210",
    dateCreated: "17th century",
    imageUrl: "images/Teijlingen_Castle.webp",
  },
  {
    compositionName: "Title Page",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238211",
    dateCreated: "1615",
    imageUrl: "images/Title_Page.webp",
  },
  {
    compositionName: "Riverscape with Two Monks on a Road by a Chapel",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238212",
    dateCreated: "17th century",
    imageUrl: "images/Riverscape_with_Two_Monks_on_a_Road_by_a_Chapel.webp",
  },
  {
    compositionName: "Country Road along a Ruined Church",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238213",
    dateCreated: "17th century",
    imageUrl: "images/Country_Road_along_a_Ruined_Church.webp",
  },
  {
    compositionName: "Title for Playsante Lantschappen...",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238214",
    dateCreated: "17th century",
    imageUrl: "images/Title_for_Playsante_Lantschappen___.webp",
  },
  {
    compositionName: "Title page: Various Ruins and Views ...",
    author: ["After Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238216",
    dateCreated: "c. 1560",
    imageUrl: "images/Title_page__Various_Ruins_and_Views____.webp",
  },
  {
    compositionName: "Ruins of the Baths of Diocletian",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238217",
    dateCreated: "1561",
    imageUrl: "images/Ruins_of_the_Baths_of_Diocletian.webp",
  },
  {
    compositionName: "View of Flanders",
    author: ["Pierre Laurent", "After Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238228",
    dateCreated: "18th century",
    imageUrl: "images/View_of_Flanders.webp",
  },
  {
    compositionName: "Sunstroke",
    author: ["Pierre Laurent", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238229",
    dateCreated: "18th century",
    imageUrl: "images/Sunstroke.webp",
  },
  {
    compositionName: "Virgin and Child in the Clouds",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279618",
    dateCreated: "1641",
    imageUrl: "images/Virgin_and_Child_in_the_Clouds.webp",
  },
  {
    compositionName: "The Tribute Money",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279619",
    dateCreated: "c. 1634",
    imageUrl: "images/The_Tribute_Money.webp",
  },
  {
    compositionName: "The Descent from the Cross: Second Plate",
    author: [
      "Rembrandt Harmensz. van Rijn",
      "Etched and engraved basis for the composition by Jan Joris van Vliet",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279624",
    dateCreated: "1633",
    imageUrl: "images/The_Descent_from_the_Cross__Second_Plate.webp",
  },
  {
    compositionName: "The Stoning of Saint Stephen",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279625",
    dateCreated: "1635",
    imageUrl: "images/The_Stoning_of_Saint_Stephen.webp",
  },
  {
    compositionName: "Saint Jerome Kneeling",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279626",
    dateCreated: "1635",
    imageUrl: "images/Saint_Jerome_Kneeling.webp",
  },
  {
    compositionName: "Saint Jerome in a Dark Chamber",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279627",
    dateCreated: "1642",
    imageUrl: "images/Saint_Jerome_in_a_Dark_Chamber.webp",
  },
  {
    compositionName: "The Ship of Fortune",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279628",
    dateCreated: "1633",
    imageUrl: "images/The_Ship_of_Fortune.webp",
  },
  {
    compositionName: "Abraham Entertaining the Three Angels",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279633",
    dateCreated: "1656",
    imageUrl: "images/Abraham_Entertaining_the_Three_Angels.webp",
  },
  {
    compositionName: "The Image Seen by Nebuchadnezzar",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279634",
    dateCreated: "1655",
    imageUrl: "images/The_Image_Seen_by_Nebuchadnezzar.webp",
  },
  {
    compositionName: "Flight into Egypt: A Night Piece",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279635",
    dateCreated: "1651",
    imageUrl: "images/Flight_into_Egypt__A_Night_Piece.webp",
  },
  {
    compositionName: "Christ Seated Disputing with the Doctors",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279636",
    dateCreated: "1654",
    imageUrl: "images/Christ_Seated_Disputing_with_the_Doctors.webp",
  },
  {
    compositionName: "Christ Driving the Money Changers from the Temple",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279637",
    dateCreated: "1635",
    imageUrl: "images/Christ_Driving_the_Money_Changers_from_the_Temple.webp",
  },
  {
    compositionName: "Christ and the Woman of Samaria",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279638",
    dateCreated: "1634",
    imageUrl: "images/Christ_and_the_Woman_of_Samaria.webp",
  },
  {
    compositionName: "The Resurrection of Lazarus",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279639",
    dateCreated: "1642",
    imageUrl: "images/The_Resurrection_of_Lazarus.webp",
  },
  {
    compositionName: "Travelling Musicians",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279645",
    dateCreated: "c. 1635",
    imageUrl: "images/Travelling_Musicians.webp",
  },
  {
    compositionName: "The Artist Drawing from the Model",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279654",
    dateCreated: "c. 1639",
    imageUrl: "images/The_Artist_Drawing_from_the_Model.webp",
  },
  {
    compositionName: "Old Man with a Divided Fur Cap",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279655",
    dateCreated: "1640",
    imageUrl: "images/Old_Man_with_a_Divided_Fur_Cap.webp",
  },
  {
    compositionName:
      "Lieven Williamsz. van Coppenol, Writing Master: The Larger Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "This print is made from the larger plate",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279656",
    dateCreated: "c. 1658",
    imageUrl:
      "images/Lieven_Williamsz__van_Coppenol__Writing_Master__The_Larger_Plate.webp",
  },
  {
    compositionName: "Field Bordered by Trees",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279664",
    dateCreated: "17th century",
    imageUrl: "images/Field_Bordered_by_Trees.webp",
  },
  {
    compositionName: "Medea",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279695",
    dateCreated: "1648",
    imageUrl: "images/Medea.webp",
  },
  {
    compositionName: "Star of the Three Kings",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279696",
    dateCreated: "c. 1651",
    imageUrl: "images/Star_of_the_Three_Kings.webp",
  },
  {
    compositionName: "Small Lion Hunt, with Two Lions",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279697",
    dateCreated: "c. 1629-1631",
    imageUrl: "images/Small_Lion_Hunt__with_Two_Lions.webp",
  },
  {
    compositionName: "The Pancake Woman",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279698",
    dateCreated: "1635",
    imageUrl: "images/The_Pancake_Woman.webp",
  },
  {
    compositionName: "Jews in the Synagogue",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279699",
    dateCreated: "1648",
    imageUrl: "images/Jews_in_the_Synagogue.webp",
  },
  {
    compositionName: "A Blind Hurdy-Gurdy Player and His Family Receiving Alms",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279700",
    dateCreated: "1648",
    imageUrl:
      "images/A_Blind_Hurdy_Gurdy_Player_and_His_Family_Receiving_Alms.webp",
  },
  {
    compositionName:
      'A Peasant Calling Out: "Tis Vinnich Hout" ("It\'s Cold Out")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279701",
    dateCreated: "1634",
    imageUrl:
      "images/A_Peasant_Calling_Out___Tis_Vinnich_Hout____It_s_Cold_Out__.webp",
  },
  {
    compositionName: 'A Peasant Replying: "Dats Niet" ("That\'s Nothing")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279702",
    dateCreated: "1634",
    imageUrl: "images/A_Peasant_Replying___Dats_Niet____That_s_Nothing__.webp",
  },
  {
    compositionName: "Woman Sitting Half-dressed before a Stove",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279703",
    dateCreated: "1658",
    imageUrl: "images/Woman_Sitting_Half_dressed_before_a_Stove.webp",
  },
  {
    compositionName: "Woman at the Bath, with a Hat beside Her",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279704",
    dateCreated: "1658",
    imageUrl: "images/Woman_at_the_Bath__with_a_Hat_beside_Her.webp",
  },
  {
    compositionName: "Christ Healing the Sick",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238551",
    dateCreated: "16th-17th century",
    imageUrl: "images/Christ_Healing_the_Sick.webp",
  },
  {
    compositionName: "Return from the Countryside",
    author: ["Pierre Filloeul", "After Carel van Falens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238569",
    dateCreated: "18th century",
    imageUrl: "images/Return_from_the_Countryside.webp",
  },
  {
    compositionName: "An Aged Man",
    author: ["Pierre Filloeul", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238574",
    dateCreated: "1754",
    imageUrl: "images/An_Aged_Man.webp",
  },
  {
    compositionName: "Woman of Utrecht",
    author: ["L\u00e9opold Flameng", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238577",
    dateCreated: "19th century",
    imageUrl: "images/Woman_of_Utrecht.webp",
  },
  {
    compositionName: "Christ and Nicodemus",
    author: ["Pieter de Jode, the Elder", "After Adam van Noort"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238612",
    dateCreated: "16th-17th century",
    imageUrl: "images/Christ_and_Nicodemus.webp",
  },
  {
    compositionName: "David Playing the Harp Before Saul",
    author: ["Willem Pietersz. de Leeuw", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238620",
    dateCreated: "17th century",
    imageUrl: "images/David_Playing_the_Harp_Before_Saul.webp",
  },
  {
    compositionName: "The Flemish Purveyor",
    author: ["Marie Madeleine Igonet", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238621",
    dateCreated: "c. 1754",
    imageUrl: "images/The_Flemish_Purveyor.webp",
  },
  {
    compositionName: "Flemish Man and Flemish Woman",
    author: [
      "Fran\u00e7ois-Robert Ingouf",
      "Voyer",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238624",
    dateCreated: "1786",
    imageUrl: "images/Flemish_Man_and_Flemish_Woman.webp",
  },
  {
    compositionName: "Head of an Old Man",
    author: [
      "Jules Ferdinand Jacquemart",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238626",
    dateCreated: "19th century",
    imageUrl: "images/Head_of_an_Old_Man.webp",
  },
  {
    compositionName: "Louis XV, King of France and Navarre",
    author: ["Nicolas Larmessin the Younger", "After Louis-Michel van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238632",
    dateCreated: "1726",
    imageUrl: "images/Louis_XV__King_of_France_and_Navarre.webp",
  },
  {
    compositionName: "La Musique",
    author: ["Jules Ferdinand Jacquemart", "After Bartholomeus van der Helst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238639",
    dateCreated: "1879",
    imageUrl: "images/La_Musique.webp",
  },
  {
    compositionName: "Simon Bosboom",
    author: ["Pieter de Jode, the Younger", "After Nicolaes van Helt Stockade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238651",
    dateCreated: "17th century",
    imageUrl: "images/Simon_Bosboom.webp",
  },
  {
    compositionName: "The Rabbi",
    author: ["L\u00e9opold Flameng", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238653",
    dateCreated: "19th century",
    imageUrl: "images/The_Rabbi.webp",
  },
  {
    compositionName: "Henrietta Maria, Queen of England",
    author: ["Jean Ferdinand Joubert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238698",
    dateCreated: "19th century",
    imageUrl: "images/Henrietta_Maria__Queen_of_England.webp",
  },
  {
    compositionName: "Ernestus, archidux Austriae",
    author: ["Pieter de Jode, the Younger", "After Otto van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238700",
    dateCreated: "17th century",
    imageUrl: "images/Ernestus__archidux_Austriae.webp",
  },
  {
    compositionName: "Jean de Montfort",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238702",
    dateCreated: "17th century",
    imageUrl: "images/Jean_de_Montfort.webp",
  },
  {
    compositionName: "Jan Snellincx",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238704",
    dateCreated: "17th century",
    imageUrl: "images/Jan_Snellincx.webp",
  },
  {
    compositionName: "Plate Four",
    author: ["Theodor van Kessel", "After Jan van den Hecke the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238706",
    dateCreated: "1651",
    imageUrl: "images/Plate_Four.webp",
  },
  {
    compositionName: "Andreas Colyns de Nole",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238715",
    dateCreated: "17th century",
    imageUrl: "images/Andreas_Colyns_de_Nole.webp",
  },
  {
    compositionName: "Pieter de Jode, the Younger",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238717",
    dateCreated: "17th century",
    imageUrl: "images/Pieter_de_Jode__the_Younger.webp",
  },
  {
    compositionName: "Jacob Jordaens",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238719",
    dateCreated: "17th century",
    imageUrl: "images/Jacob_Jordaens.webp",
  },
  {
    compositionName: "Plate Two",
    author: ["Theodor van Kessel", "After Jan van den Hecke the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238722",
    dateCreated: "1651",
    imageUrl: "images/Plate_Two.webp",
  },
  {
    compositionName: "Plate Three",
    author: ["Theodor van Kessel", "After Jan van den Hecke the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238723",
    dateCreated: "1651",
    imageUrl: "images/Plate_Three.webp",
  },
  {
    compositionName: "Plate One",
    author: ["Theodor van Kessel", "After Jan van den Hecke the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238756",
    dateCreated: "1651",
    imageUrl: "images/Plate_One.webp",
  },
  {
    compositionName: "Countryside",
    author: [
      "Fran\u00e7ois Godefroy",
      "Pierre Antoine Marchais",
      "After Jan Frans van Bloemen",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238783",
    dateCreated: "18th century",
    imageUrl: "images/Countryside.webp",
  },
  {
    compositionName: "Sir William Pope, bart.",
    author: ["Jean Godefroy", "After Cornelius Janssen van Ceulen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238786",
    dateCreated: "18th-19th century",
    imageUrl: "images/Sir_William_Pope__bart_.webp",
  },
  {
    compositionName: "Rembrandt's Mill",
    author: [
      "Charles-\u00c9mile Jacque",
      "After ? Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238790",
    dateCreated: "19th century",
    imageUrl: "images/Rembrandt_s_Mill.webp",
  },
  {
    compositionName: "Holy Family",
    author: ["Frederik van Hulsen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238838",
    dateCreated: "17th century",
    imageUrl: "images/Holy_Family.webp",
  },
  {
    compositionName:
      "Carolus Henricus baron \u00e0 Metternich, Winneburg et Beilstein",
    author: ["Pieter de Jode, the Younger", "After Anselmus van Hulle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238879",
    dateCreated: "16th-17th century",
    imageUrl:
      "images/Carolus_Henricus_baron_a_Metternich__Winneburg_et_Beilstein.webp",
  },
  {
    compositionName: "Henricus de La Tour d' Auvergne, vice-comes de Turenne",
    author: ["Pieter de Jode, the Younger", "After Anselmus van Hulle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238880",
    dateCreated: "16th-17th century",
    imageUrl:
      "images/Henricus_de_La_Tour_d__Auvergne__vice_comes_de_Turenne.webp",
  },
  {
    compositionName: "Women at the Bath",
    author: [
      "Fran\u00e7ois Godefroy",
      "After Felice Marie Ferdinand Storelli",
      "After Jan van Huysum II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238896",
    dateCreated: "c. 1807",
    imageUrl: "images/Women_at_the_Bath.webp",
  },
  {
    compositionName: "The Parable of the Sower, Plate I",
    author: ["Gerard de Jode", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238922",
    dateCreated: "16th century",
    imageUrl: "images/The_Parable_of_the_Sower__Plate_I.webp",
  },
  {
    compositionName: "Allegorical Subject",
    author: ["Christophe Gu\u00e9rin", "After Hendrik van Limborch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238965",
    dateCreated: "c. 1779",
    imageUrl: "images/Allegorical_Subject.webp",
  },
  {
    compositionName: "The Wife of Martin Day",
    author: ["L\u00e9opold Flameng", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239017",
    dateCreated: "19th century",
    imageUrl: "images/The_Wife_of_Martin_Day.webp",
  },
  {
    compositionName: "Saskia, Wife of Rembrandt",
    author: ["L\u00e9opold Flameng", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239018",
    dateCreated: "19th century",
    imageUrl: "images/Saskia__Wife_of_Rembrandt.webp",
  },
  {
    compositionName: "River Scene",
    author: ["Louis Dujardin", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239028",
    dateCreated: "19th century",
    imageUrl: "images/River_Scene.webp",
  },
  {
    compositionName: "The Party",
    author: ["Charles Jean Louis Courtry", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239029",
    dateCreated: "19th century",
    imageUrl: "images/The_Party.webp",
  },
  {
    compositionName: "View of a Village near Rome",
    author: ["Pierre Jean Duret", "After Salomon van Ruysdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239046",
    dateCreated: "18th century",
    imageUrl: "images/View_of_a_Village_near_Rome.webp",
  },
  {
    compositionName: "Woman with a Basket of Fish",
    author: ["Robert Delaunay", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239057",
    dateCreated: "c. 1808",
    imageUrl: "images/Woman_with_a_Basket_of_Fish.webp",
  },
  {
    compositionName: "Flower piece",
    author: ["Alfred Alexandre Delauney", "After Jan van Huysum II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239058",
    dateCreated: "1865",
    imageUrl: "images/Flower_piece.webp",
  },
  {
    compositionName: "Departure for the Market",
    author: ["Anne Philiberte Coulet", "After Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239061",
    dateCreated: "18th century",
    imageUrl: "images/Departure_for_the_Market.webp",
  },
  {
    compositionName: "Ox and Three Sheep",
    author: ["Louis Dujardin", "After Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239074",
    dateCreated: "19th century",
    imageUrl: "images/Ox_and_Three_Sheep.webp",
  },
  {
    compositionName: "The Trouble with Sport",
    author: ["Jean Baptiste Michel Dupr\u00e9el", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239087",
    dateCreated: "18th-19th century",
    imageUrl: "images/The_Trouble_with_Sport.webp",
  },
  {
    compositionName: "Joannes Breugel",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239154",
    dateCreated: "17th century",
    imageUrl: "images/Joannes_Breugel.webp",
  },
  {
    compositionName: "Erasmus Rotterdamus",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239189",
    dateCreated: "17th century",
    imageUrl: "images/Erasmus_Rotterdamus.webp",
  },
  {
    compositionName: "Maison de Gutenberg \u00e0 Mayence",
    author: ["Pierre T\u00e9tar van Elven"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239252",
    dateCreated: "19th century",
    imageUrl: "images/Maison_de_Gutenberg_a_Mayence.webp",
  },
  {
    compositionName: "Peter Paul Rubens",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279973",
    dateCreated: "17th century",
    imageUrl: "images/Peter_Paul_Rubens.webp",
  },
  {
    compositionName: "Gerard Seghers",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279974",
    dateCreated: "17th century",
    imageUrl: "images/Gerard_Seghers.webp",
  },
  {
    compositionName: "Interior of a Gothic Church",
    author: ["Noach Vandermeer", "After Hendrick van Steenwijck the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279977",
    dateCreated: "18th century",
    imageUrl: "images/Interior_of_a_Gothic_Church.webp",
  },
  {
    compositionName: "Orazio Gentleschi",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279985",
    dateCreated: "17th century",
    imageUrl: "images/Orazio_Gentleschi.webp",
  },
  {
    compositionName: "Pieter de Jode, the Elder",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279987",
    dateCreated: "17th century",
    imageUrl: "images/Pieter_de_Jode__the_Elder.webp",
  },
  {
    compositionName: "Jan Lievens",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279988",
    dateCreated: "17th century",
    imageUrl: "images/Jan_Lievens.webp",
  },
  {
    compositionName: "Nicolas Rockox",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279990",
    dateCreated: "17th century",
    imageUrl: "images/Nicolas_Rockox.webp",
  },
  {
    compositionName: "Details of Entablature and Capitals, and Two Consoles",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280008",
    dateCreated: "1578",
    imageUrl:
      "images/Details_of_Entablature_and_Capitals__and_Two_Consoles.webp",
  },
  {
    compositionName: "Maurice, Prince of Orange",
    author: ["Gerard Valck", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280036",
    dateCreated: "17th century",
    imageUrl: "images/Maurice__Prince_of_Orange.webp",
  },
  {
    compositionName: "View of Tivoli",
    author: [
      "Nicolas Barth\u00e9lemy-Fran\u00e7ois Dequevauviller",
      "After Sovebac",
      "After Adriaen van der Werff",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239426",
    dateCreated: "18th century",
    imageUrl: "images/View_of_Tivoli.webp",
  },
  {
    compositionName: "Esau Selling His Birthright to Jacob ('Jacob and Esau')",
    author: ["Adriaen Collaert", "After Chrispijn van den Broeck"],
    tale: "in medallions at top, left: Isaac's blessing [Gen. 27:18-29], center: Jacob's dream [Gen. 28:10-22], right: Jacob and Rachel [Gen. 29:15-30]",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239443",
    dateCreated: "c.1581",
    imageUrl:
      "images/Esau_Selling_His_Birthright_to_Jacob___Jacob_and_Esau__.webp",
  },
  {
    compositionName: "Pierre Augustin Le Mercier",
    author: ["Jean Daull\u00e9", "After Louis-Michel van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239447",
    dateCreated: "18th century",
    imageUrl: "images/Pierre_Augustin_Le_Mercier.webp",
  },
  {
    compositionName: "Fishing",
    author: [
      "Nicolas Barth\u00e9lemy-Fran\u00e7ois Dequevauviller",
      "After Adriaan van Stalbemt",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239464",
    dateCreated: "c. 1786",
    imageUrl: "images/Fishing.webp",
  },
  {
    compositionName: "A River and Ruins",
    author: ["Jean Desaulx", "After Jan van Huysum II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239468",
    dateCreated: "19th century",
    imageUrl: "images/A_River_and_Ruins.webp",
  },
  {
    compositionName: "Fruit Piece",
    author: ["Alfred Alexandre Delauney", "After Jan van Huysum II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239470",
    dateCreated: "19th century",
    imageUrl: "images/Fruit_Piece.webp",
  },
  {
    compositionName: "Consideration",
    author: [
      "Th\u00e9ophile Victor Desclaux",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239486",
    dateCreated: "19th century",
    imageUrl: "images/Consideration.webp",
  },
  {
    compositionName: "Madonna and Child",
    author: ["Pieter Clouet", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239507",
    dateCreated: "17th century",
    imageUrl: "images/Madonna_and_Child.webp",
  },
  {
    compositionName: "Hendrickye Stoffele",
    author: ["Lambert Antoine Claessens", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239526",
    dateCreated: "18th-19th century",
    imageUrl: "images/Hendrickye_Stoffele.webp",
  },
  {
    compositionName: "Five Peasants at a Tavern Window",
    author: ["C. Closin", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239527",
    dateCreated: "17th century",
    imageUrl: "images/Five_Peasants_at_a_Tavern_Window.webp",
  },
  {
    compositionName: "Washerwomen at the Lake",
    author: ["Marie Alexandre Duparc", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239531",
    dateCreated: "18th-19th century",
    imageUrl: "images/Washerwomen_at_the_Lake.webp",
  },
  {
    compositionName: "Forest Scene",
    author: ["Louis Dujardin", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239550",
    dateCreated: "19th century",
    imageUrl: "images/Forest_Scene.webp",
  },
  {
    compositionName: "Entrance to a Forest",
    author: ["? Dumont", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239552",
    dateCreated: "19th century",
    imageUrl: "images/Entrance_to_a_Forest.webp",
  },
  {
    compositionName: "Jan Lutma",
    author: ["Charles Blanc", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239573",
    dateCreated: "19th century",
    imageUrl: "images/Jan_Lutma.webp",
  },
  {
    compositionName: "Judgement of Paris",
    author: ["Nicolaes de Bruyn", "After Gillis van Coninxloo III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239591",
    dateCreated: "1600",
    imageUrl: "images/Judgement_of_Paris.webp",
  },
  {
    compositionName: "Writing School",
    author: ["Pierre-Quentin Chedel", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239598",
    dateCreated: "18th century",
    imageUrl: "images/Writing_School.webp",
  },
  {
    compositionName: "The Rest of the Gleaners",
    author: ["Jean-Jacques de Boissieu", "After Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239620",
    dateCreated: "1795",
    imageUrl: "images/The_Rest_of_the_Gleaners.webp",
  },
  {
    compositionName: "Paysage",
    author: ["Lambert Antoine Claessens", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239637",
    dateCreated: "18th-19th century",
    imageUrl: "images/Paysage.webp",
  },
  {
    compositionName: "Marquis of Montrose",
    author: ["Robert Cooper", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239640",
    dateCreated: "19th century",
    imageUrl: "images/Marquis_of_Montrose.webp",
  },
  {
    compositionName: "Un Fumeur",
    author: ["Lambert Antoine Claessens", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239646",
    dateCreated: "18th-19th century",
    imageUrl: "images/Un_Fumeur.webp",
  },
  {
    compositionName: "Fishing by Night",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239668",
    dateCreated: "16th-17th century",
    imageUrl: "images/Fishing_by_Night.webp",
  },
  {
    compositionName: "Fishing in the Tiber",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239669",
    dateCreated: "16th-17th century",
    imageUrl: "images/Fishing_in_the_Tiber.webp",
  },
  {
    compositionName: "Christophe van der Lamen",
    author: ["Pieter Clouet", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239758",
    dateCreated: "17th century",
    imageUrl: "images/Christophe_van_der_Lamen.webp",
  },
  {
    compositionName: "Daphne and Apollo",
    author: ["Jacques Bouillard", "After Louis-Michel van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239795",
    dateCreated: "1796",
    imageUrl: "images/Daphne_and_Apollo.webp",
  },
  {
    compositionName: "Landscape with Seated Figure and Horse",
    author: [
      "Wouter Joannes van Troostwijk",
      "Previously attributed to Jan Hulswit",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294423",
    dateCreated: "18th century",
    imageUrl: "images/Landscape_with_Seated_Figure_and_Horse.webp",
  },
  {
    compositionName: "Study of Heather (Erica)",
    author: ["Jacobus van Eynden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294425",
    dateCreated: "18th-19th century",
    imageUrl: "images/Study_of_Heather__Erica_.webp",
  },
  {
    compositionName: "Tavern Scene under an Arbor",
    author: ["Cornelis Dusart", "Previously attributed to Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294455",
    dateCreated: "17th century",
    imageUrl: "images/Tavern_Scene_under_an_Arbor.webp",
  },
  {
    compositionName: "Genre Scene with a Man, a Woman and a Cat",
    author: ["Gerbrand van den Eeckhout"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294666",
    dateCreated: "17th century",
    imageUrl: "images/Genre_Scene_with_a_Man__a_Woman_and_a_Cat.webp",
  },
  {
    compositionName: "Kitchen Maid with a Knife",
    author: ["Jan van Noordt"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294680",
    dateCreated: "17th century",
    imageUrl: "images/Kitchen_Maid_with_a_Knife.webp",
  },
  {
    compositionName: 'Study for "Christ in the House of Martha and Mary"',
    author: [
      "Michel II Corneille",
      "Previously attributed to Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294694",
    dateCreated: "17th-18th century",
    imageUrl: "images/Study_for__Christ_in_the_House_of_Martha_and_Mary_.webp",
  },
  {
    compositionName:
      "Seven Sketches of Jews; verso: Studies of Birds and a Bat",
    author: ["Paulus van Vianen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294848",
    dateCreated: "c. 1604-1607",
    imageUrl:
      "images/Seven_Sketches_of_Jews__verso__Studies_of_Birds_and_a_Bat.webp",
  },
  {
    compositionName:
      "Five Sketches of Jews in the Synagogue; verso: Seven Sketches of Jews including One Woman",
    author: ["Paulus van Vianen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294849",
    dateCreated: "c. 1604-1607",
    imageUrl:
      "images/Five_Sketches_of_Jews_in_the_Synagogue__verso__Seven_Sketches_of_Jews_including_One_Woman.webp",
  },
  {
    compositionName: "Figure Studies",
    author: ["Copy after Paulus van Vianen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294850",
    dateCreated: "16th-17th century",
    imageUrl: "images/Figure_Studies.webp",
  },
  {
    compositionName: "Landscape with a Road and a Forest",
    author: ["? Jan Vermeer van Haarlem the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294852",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_Road_and_a_Forest.webp",
  },
  {
    compositionName: "Plate VI",
    author: ["Hermanus van Brussel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239878",
    dateCreated: "18th-19th century",
    imageUrl: "images/Plate_VI.webp",
  },
  {
    compositionName: "Contest Between Apollo and Pan",
    author: ["Nicolaes de Bruyn", "After Gillis van Coninxloo III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239881",
    dateCreated: "16th-17th century",
    imageUrl: "images/Contest_Between_Apollo_and_Pan.webp",
  },
  {
    compositionName: "The Gardener",
    author: ["Jacques Firmin Beauvarlet", "After Jan van Assen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239888",
    dateCreated: "18th century",
    imageUrl: "images/The_Gardener.webp",
  },
  {
    compositionName: "The Cabaret",
    author: ["F\u00e9lix Henri Bracquemond", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239926",
    dateCreated: "19th century",
    imageUrl: "images/The_Cabaret.webp",
  },
  {
    compositionName: "Philosopher, Meditating",
    author: ["Lambert Antoine Claessens", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239937",
    dateCreated: "18th-19th century",
    imageUrl: "images/Philosopher__Meditating.webp",
  },
  {
    compositionName: "Deer Hunt",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239939",
    dateCreated: "16th-17th century",
    imageUrl: "images/Deer_Hunt.webp",
  },
  {
    compositionName: "Hunting the Mountain Goat",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239940",
    dateCreated: "16th-17th century",
    imageUrl: "images/Hunting_the_Mountain_Goat.webp",
  },
  {
    compositionName: "Cottages by a Stream",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294992",
    dateCreated: "17th century",
    imageUrl: "images/Cottages_by_a_Stream.webp",
  },
  {
    compositionName: "A Woman, a Child, an Old Man and a Fool",
    author: ["Jan Philipsz. van Bouckhorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295000",
    dateCreated: "16th-17th century",
    imageUrl: "images/A_Woman__a_Child__an_Old_Man_and_a_Fool.webp",
  },
  {
    compositionName: "Landscape with a Cottage",
    author: ["Anthonie van Borssom"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295088",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_Cottage.webp",
  },
  {
    compositionName: "An Inn by a Country Road",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295090",
    dateCreated: "17th century",
    imageUrl: "images/An_Inn_by_a_Country_Road.webp",
  },
  {
    compositionName: "Study of a Seated Boy",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295134",
    dateCreated: "17th century",
    imageUrl: "images/Study_of_a_Seated_Boy.webp",
  },
  {
    compositionName: "Adoration of the Shepherds",
    author: [
      "Isaac Claesz. van Swanenburg",
      "Previously attributed to J. Nicola",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295139",
    dateCreated: "16th-17th century",
    imageUrl: "images/Adoration_of_the_Shepherds.webp",
  },
  {
    compositionName: "Head of a Beggar; verso: Half-length Study of a Nude Man",
    author: ["Copy after Anthony van Dyck", "after Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295319",
    dateCreated: "17th century",
    imageUrl:
      "images/Head_of_a_Beggar__verso__Half_length_Study_of_a_Nude_Man.webp",
  },
  {
    compositionName: "Lamentation of Christ",
    author: ["Attributed to Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295509",
    dateCreated: "17th century",
    imageUrl: "images/Lamentation_of_Christ.webp",
  },
  {
    compositionName: "Three Women and a Child",
    author: ["Copy after Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295538",
    dateCreated: "17th century",
    imageUrl: "images/Three_Women_and_a_Child.webp",
  },
  {
    compositionName: "Study of an English Third-Rate Ship",
    author: ["Willem van de Velde the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295544",
    dateCreated: "17th century",
    imageUrl: "images/Study_of_an_English_Third_Rate_Ship.webp",
  },
  {
    compositionName: "Scene with Boats and Figures",
    author: ["Attributed to Willem van de Velde the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295546",
    dateCreated: "17th century",
    imageUrl: "images/Scene_with_Boats_and_Figures.webp",
  },
  {
    compositionName: "Group of Men in a Boat",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295549",
    dateCreated: "17th century",
    imageUrl: "images/Group_of_Men_in_a_Boat.webp",
  },
  {
    compositionName: "Landscape with a Watermill; verso: Monastery ",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295554",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_Watermill__verso__Monastery_____.webp",
  },
  {
    compositionName: "Shepherds and Sheep before a Rock",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295576",
    dateCreated: "c. 1615-16",
    imageUrl: "images/Shepherds_and_Sheep_before_a_Rock.webp",
  },
  {
    compositionName: "Shepherd and Shepherdess near a Pool",
    author: ["Egbert van Drielst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295600",
    dateCreated: "c. 1780",
    imageUrl: "images/Shepherd_and_Shepherdess_near_a_Pool.webp",
  },
  {
    compositionName: "Supper at Emmaus",
    author: [
      "School of Rembrandt Harmensz. van Rijn",
      "Previously attributed to Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295715",
    dateCreated: "c. 1630-1633",
    imageUrl: "images/Supper_at_Emmaus.webp",
  },
  {
    compositionName: "Pilate Washing his Hands",
    author: ["School of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295796",
    dateCreated: "17th century",
    imageUrl: "images/Pilate_Washing_his_Hands.webp",
  },
  {
    compositionName: "The Forge of Vulcan",
    author: ["Unidentified Artist", "Copy after Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295797",
    dateCreated: "16th century",
    imageUrl: "images/The_Forge_of_Vulcan.webp",
  },
  {
    compositionName:
      "Seated Male Nude with Left Leg Extended (after Rembrandt)",
    author: ["Joseph Wintergerst", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295938",
    dateCreated: "19th century",
    imageUrl:
      "images/Seated_Male_Nude_with_Left_Leg_Extended__after_Rembrandt_.webp",
  },
  {
    compositionName: "Study of a Ship",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295998",
    dateCreated: "17th-18th century",
    imageUrl: "images/Study_of_a_Ship.webp",
  },
  {
    compositionName: "Italian Castle on a Hill",
    author: ["Willem van Nieulandt II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296162",
    dateCreated: "16th-17th century",
    imageUrl: "images/Italian_Castle_on_a_Hill.webp",
  },
  {
    compositionName: "Ship in a Storm",
    author: [
      "Attributed to Matthijs van Plattenberg",
      "Attributed to Ludolf Backhuyzen",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296221",
    dateCreated: "17th century",
    imageUrl: "images/Ship_in_a_Storm.webp",
  },
  {
    compositionName:
      "Seascape with Boats arriving at a Dutch Warship and Others at Anchor Beyond",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296363",
    dateCreated: "17th century",
    imageUrl:
      "images/Seascape_with_Boats_arriving_at_a_Dutch_Warship_and_Others_at_Anchor_Beyond.webp",
  },
  {
    compositionName: "Peasants Reaping Grain",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296366",
    dateCreated: "17th century",
    imageUrl: "images/Peasants_Reaping_Grain.webp",
  },
  {
    compositionName: "Two Dutch Warships at Anchor with Three Barges",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296367",
    dateCreated: "17th-18th century",
    imageUrl: "images/Two_Dutch_Warships_at_Anchor_with_Three_Barges.webp",
  },
  {
    compositionName:
      'Study after the Painting "Saint Ignatius Loyola Healing Those Possessed" by Rubens',
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296371",
    dateCreated: "17th century",
    imageUrl:
      "images/Study_after_the_Painting__Saint_Ignatius_Loyola_Healing_Those_Possessed__by_Rubens.webp",
  },
  {
    compositionName: "Trinity",
    author: ["Robert van Auden-Aerd", "After Guido Reni"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240167",
    dateCreated: "17th-18th century",
    imageUrl: "images/Trinity.webp",
  },
  {
    compositionName:
      "Christ on the Cross with the Virgin, Mary Magdalen, and Saint John",
    author: ["Assuerus van Londerseel", "After Pieter van der Borcht"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240168",
    dateCreated: "17th century",
    imageUrl:
      "images/Christ_on_the_Cross_with_the_Virgin__Mary_Magdalen__and_Saint_John.webp",
  },
  {
    compositionName: "Henri, Marquis de Lagrange d' Arquien",
    author: [
      "Robert van Auden-Aerd",
      "After Alexandre-Fran\u00e7ois Desportes",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240184",
    dateCreated: "18th century",
    imageUrl: "images/Henri__Marquis_de_Lagrange_d__Arquien.webp",
  },
  {
    compositionName: "Adoration of the Kings",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240185",
    dateCreated: "17th-18th century",
    imageUrl: "images/Adoration_of_the_Kings.webp",
  },
  {
    compositionName: "Rebecca at the Well",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240187",
    dateCreated: "17th-18th century",
    imageUrl: "images/Rebecca_at_the_Well.webp",
  },
  {
    compositionName: "Repose in Egypt",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240189",
    dateCreated: "17th-18th century",
    imageUrl: "images/Repose_in_Egypt.webp",
  },
  {
    compositionName: "Romulus and Remus",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240190",
    dateCreated: "17th-18th century",
    imageUrl: "images/Romulus_and_Remus.webp",
  },
  {
    compositionName: "Apollo and Daphne",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240223",
    dateCreated: "17th-18th century",
    imageUrl: "images/Apollo_and_Daphne.webp",
  },
  {
    compositionName: "Birth of the Virgin",
    author: ["Robert van Auden-Aerd", "After Annibale Carracci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240224",
    dateCreated: "17th-18th century",
    imageUrl: "images/Birth_of_the_Virgin.webp",
  },
  {
    compositionName: "Christ and the Samaritan Woman",
    author: ["Robert van Auden-Aerd", "After Annibale Carracci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240225",
    dateCreated: "17th-18th century",
    imageUrl: "images/Christ_and_the_Samaritan_Woman.webp",
  },
  {
    compositionName: "Death of Demetria, sister of Saint Bibiana",
    author: ["Robert van Auden-Aerd", "After Pietro da Cortona"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240226",
    dateCreated: "17th-18th century",
    imageUrl: "images/Death_of_Demetria__sister_of_Saint_Bibiana.webp",
  },
  {
    compositionName: "Annunciation",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240227",
    dateCreated: "17th-18th century",
    imageUrl: "images/Annunciation.webp",
  },
  {
    compositionName: "Assumption of the Virgin",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240228",
    dateCreated: "17th-18th century",
    imageUrl: "images/Assumption_of_the_Virgin.webp",
  },
  {
    compositionName: "The Happy Accident",
    author: ["Pierre Alexandre Aveline", "After Carel van Falens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240231",
    dateCreated: "18th century",
    imageUrl: "images/The_Happy_Accident.webp",
  },
  {
    compositionName: "Martyrdom of Saint Blaise",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240269",
    dateCreated: "17th-18th century",
    imageUrl: "images/Martyrdom_of_Saint_Blaise.webp",
  },
  {
    compositionName: "Abraham Sacrificing Isaac",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240270",
    dateCreated: "17th-18th century",
    imageUrl: "images/Abraham_Sacrificing_Isaac.webp",
  },
  {
    compositionName: "Hagar and Ishmael in the Desert",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240271",
    dateCreated: "17th-18th century",
    imageUrl: "images/Hagar_and_Ishmael_in_the_Desert.webp",
  },
  {
    compositionName: "Susanna at her Bath",
    author: ["Jean Jacques Avril the Elder", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240274",
    dateCreated: "1816",
    imageUrl: "images/Susanna_at_her_Bath.webp",
  },
  {
    compositionName: "Rinaldo and Armida",
    author: ["Pieter de Balliu", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240279",
    dateCreated: "17th century",
    imageUrl: "images/Rinaldo_and_Armida.webp",
  },
  {
    compositionName: "Fountain at the Head of a Stairway",
    author: ["Jan Frans van Bloemen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240286",
    dateCreated: "17th-18th century",
    imageUrl: "images/Fountain_at_the_Head_of_a_Stairway.webp",
  },
  {
    compositionName: "Thomas Lamplugh, Archbishop of York",
    author: ["Pieter van der Banck", "After Sir Godfrey Kneller"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240296",
    dateCreated: "17th century",
    imageUrl: "images/Thomas_Lamplugh__Archbishop_of_York.webp",
  },
  {
    compositionName: "The Tipplers",
    author: ["Pierre Fran\u00e7ois Basan", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240302",
    dateCreated: "18th century",
    imageUrl: "images/The_Tipplers.webp",
  },
  {
    compositionName: "A Canal near Delft",
    author: ["Pierre Fran\u00e7ois Basan", "After Jan van der Heyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240303",
    dateCreated: "18th century",
    imageUrl: "images/A_Canal_near_Delft.webp",
  },
  {
    compositionName: "Crossing on the Escaut",
    author: ["Pierre Fran\u00e7ois Basan", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240304",
    dateCreated: "18th century",
    imageUrl: "images/Crossing_on_the_Escaut.webp",
  },
  {
    compositionName: "John Tillotson, Archbishop of Canterbury",
    author: ["Pieter van der Banck", "After Mary Beale"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240329",
    dateCreated: "17th century",
    imageUrl: "images/John_Tillotson__Archbishop_of_Canterbury.webp",
  },
  {
    compositionName: "The Dutch Siesta",
    author: ["Pierre Fran\u00e7ois Basan", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240336",
    dateCreated: "18th century",
    imageUrl: "images/The_Dutch_Siesta.webp",
  },
  {
    compositionName: "Healing of the Sick; verso: faint sketch",
    author: ["School of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297051",
    dateCreated: "17th century",
    imageUrl: "images/Healing_of_the_Sick__verso__faint_sketch.webp",
  },
  {
    compositionName: "Seated Old Man",
    author: ["? Jan van den Bergh"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297052",
    dateCreated: "17th century",
    imageUrl: "images/Seated_Old_Man.webp",
  },
  {
    compositionName: "A Ship",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297101",
    dateCreated: "17th century",
    imageUrl: "images/A_Ship.webp",
  },
  {
    compositionName: "Seated Man",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297109",
    dateCreated: "17th century",
    imageUrl: "images/Seated_Man.webp",
  },
  {
    compositionName: "Courtyard with Two Figures",
    author: ["Imitator of Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297218",
    dateCreated: "18th century",
    imageUrl: "images/Courtyard_with_Two_Figures.webp",
  },
  {
    compositionName: "Landscape with Trees",
    author: ["Attributed to Gaspar van Wittel (called Vanvitelli)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297352",
    dateCreated: "17th-18th century",
    imageUrl: "images/Landscape_with_Trees.webp",
  },
  {
    compositionName: "Sylvan Landscape with Cottage and Two Figures",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297421",
    dateCreated: "17th century",
    imageUrl: "images/Sylvan_Landscape_with_Cottage_and_Two_Figures.webp",
  },
  {
    compositionName: "Study of Rocks and Trees",
    author: ["Gaspar van Wittel (called Vanvitelli)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297425",
    dateCreated: "17th-18th century",
    imageUrl: "images/Study_of_Rocks_and_Trees.webp",
  },
  {
    compositionName: "A Man in Armor",
    author: [
      "Circle of Anthony van Dyck",
      "Previously attributed to Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297780",
    dateCreated: "c. 1650",
    imageUrl: "images/A_Man_in_Armor.webp",
  },
  {
    compositionName: "Two Blocked-up Windows of a Ruined House",
    author: ["Attributed to Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297785",
    dateCreated: "17th century",
    imageUrl: "images/Two_Blocked_up_Windows_of_a_Ruined_House.webp",
  },
  {
    compositionName:
      "Crucifixion; verso: Standing Man in Fancy Dress (headless) and Sketch of a Shrine",
    author: ["Anthony van Dyck"],
    tale: "paper tabs at top (1.0 x 20.9 cm) and bottom (1.0 x 20.6)",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298182",
    dateCreated: "17th century",
    imageUrl:
      "images/Crucifixion__verso__Standing_Man_in_Fancy_Dress__headless__and_Sketch_of_a_Shrine.webp",
  },
  {
    compositionName: "Landscape with a River View",
    author: ["Follower of Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298220",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_River_View.webp",
  },
  {
    compositionName: "A Seated Scholar",
    author: ["School of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298222",
    dateCreated: "17th century",
    imageUrl: "images/A_Seated_Scholar.webp",
  },
  {
    compositionName: "March: Ships at Sea",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298224",
    dateCreated: "17th century",
    imageUrl: "images/March__Ships_at_Sea.webp",
  },
  {
    compositionName: "Finding of Moses",
    author: ["Manner of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298231",
    dateCreated: "17th century",
    imageUrl: "images/Finding_of_Moses.webp",
  },
  {
    compositionName: "A Road in Holland",
    author: ["Fredericus Jacobus van Rossum du Chattel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298280",
    dateCreated: "19th century",
    imageUrl: "images/A_Road_in_Holland.webp",
  },
  {
    compositionName:
      "Saint Lawrence Distributing the Treasures of the Church to the Poor and Christ Washing the Feet of the Apostles",
    author: [
      "Jean-Robert Ango",
      "After Giovanni Serodine",
      "After Dirck van Baburen",
      "Previously attributed to Jean-Honor\u00e9 Fragonard",
      "Previously attributed to after Anthony van Dyck",
      "Previously attributed to after Guercino (Giovanni Francesco Barbieri)",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298360",
    dateCreated: "18th century",
    imageUrl:
      "images/Saint_Lawrence_Distributing_the_Treasures_of_the_Church_to_the_Poor_and_Christ_Washing_the_Feet_of_the_Apostles.webp",
  },
  {
    compositionName: "Landscape; verso: Landscape sketch with monument",
    author: ["Gaspar van Wittel (called Vanvitelli)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298518",
    dateCreated: "17th-18th century",
    imageUrl: "images/Landscape__verso__Landscape_sketch_with_monument.webp",
  },
  {
    compositionName: "Head of a Monk",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298522",
    dateCreated: "17th century",
    imageUrl: "images/Head_of_a_Monk____.webp",
  },
  {
    compositionName: "The Angel Gabriel Appearing to Zachariah",
    author: ["Copy after Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298523",
    dateCreated: "17th century",
    imageUrl: "images/The_Angel_Gabriel_Appearing_to_Zachariah.webp",
  },
  {
    compositionName: "Ships in a Storm",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298560",
    dateCreated: "17th century",
    imageUrl: "images/Ships_in_a_Storm.webp",
  },
  {
    compositionName: "Elsje Christiaens Hanging on a Gibbet",
    author: [
      "School of Rembrandt Harmensz. van Rijn",
      "Previously attributed to Nicolaes Maes",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298562",
    dateCreated: "17th century",
    imageUrl: "images/Elsje_Christiaens_Hanging_on_a_Gibbet.webp",
  },
  {
    compositionName: "Portrait of Aurangzeb (after a Mughal painting)",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298585",
    dateCreated: "c. 1655",
    imageUrl: "images/Portrait_of_Aurangzeb__after_a_Mughal_painting_.webp",
  },
  {
    compositionName: "Marcus Curtius Refusing the Gifts of the Samnites",
    author: ["Bernard Picart", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241030",
    dateCreated: "17th-18th century",
    imageUrl: "images/Marcus_Curtius_Refusing_the_Gifts_of_the_Samnites.webp",
  },
  {
    compositionName: "Pleasures of the Satyrs",
    author: ["Jean Charles Levasseur", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241051",
    dateCreated: "1772",
    imageUrl: "images/Pleasures_of_the_Satyrs.webp",
  },
  {
    compositionName: "View of the Ypres Canal at Furnes",
    author: ["Jean Jacques Leveau", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241069",
    dateCreated: "18th century",
    imageUrl: "images/View_of_the_Ypres_Canal_at_Furnes.webp",
  },
  {
    compositionName: "Beggar Woman Before a Window",
    author: ["Bernard Picart", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241098",
    dateCreated: "17th-18th century",
    imageUrl: "images/Beggar_Woman_Before_a_Window.webp",
  },
  {
    compositionName: "Journey to Emmaus",
    author: ["Bernard Picart", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241129",
    dateCreated: "17th-18th century",
    imageUrl: "images/Journey_to_Emmaus.webp",
  },
  {
    compositionName: "Christ Blessing Little Children",
    author: ["Jan van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241134",
    dateCreated: "17th century",
    imageUrl: "images/Christ_Blessing_Little_Children.webp",
  },
  {
    compositionName: "Guillaume de Harouys",
    author: ["Pieter van Schuppen", "After Fran\u00e7ois de Troy"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241166",
    dateCreated: "17th-18th century",
    imageUrl: "images/Guillaume_de_Harouys.webp",
  },
  {
    compositionName: "Nicolas Gabriel de la Reynie",
    author: ["Pieter van Schuppen", "After Pierre Mignard"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241179",
    dateCreated: "1665",
    imageUrl: "images/Nicolas_Gabriel_de_la_Reynie.webp",
  },
  {
    compositionName: "Pierre de Marca, Archbishop of Paris",
    author: ["Pieter van Schuppen", "After Jacob van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241180",
    dateCreated: "1663",
    imageUrl: "images/Pierre_de_Marca__Archbishop_of_Paris.webp",
  },
  {
    compositionName: "J\u00e9r\u00f4me Bignon",
    author: ["Pieter van Schuppen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241181",
    dateCreated: "17th-18th century",
    imageUrl: "images/Jerome_Bignon.webp",
  },
  {
    compositionName: "Pierre Ignace de Braux, Baron de Champagne",
    author: ["Pieter van Schuppen", "After Henri Beaubrun"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241182",
    dateCreated: "1661",
    imageUrl: "images/Pierre_Ignace_de_Braux__Baron_de_Champagne.webp",
  },
  {
    compositionName: "Paris and Oenone",
    author: ["Jean Fran\u00e7ois Ribault", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241183",
    dateCreated: "1817",
    imageUrl: "images/Paris_and_Oenone.webp",
  },
  {
    compositionName: "Marie Luissa de Tassis",
    author: ["Cornelis Vermeulen", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241186",
    dateCreated: "17th century",
    imageUrl: "images/Marie_Luissa_de_Tassis.webp",
  },
  {
    compositionName: "Anna Hyde, Wife of King James II of England",
    author: ["Charles Simonneau", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241189",
    dateCreated: "18th century",
    imageUrl: "images/Anna_Hyde__Wife_of_King_James_II_of_England.webp",
  },
  {
    compositionName: "S. Sebastian",
    author: ["Pieter van Schuppen", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241192",
    dateCreated: "17th-18th century",
    imageUrl: "images/S__Sebastian.webp",
  },
  {
    compositionName: "Paracelsus",
    author: ["Pieter van Sompel", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241226",
    dateCreated: "17th century",
    imageUrl: "images/Paracelsus.webp",
  },
  {
    compositionName: "Fiddler Playing Before a House",
    author: ["L\u00e9on Subercaze", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241275",
    dateCreated: "19th century",
    imageUrl: "images/Fiddler_Playing_Before_a_House.webp",
  },
  {
    compositionName: "Fran\u00e7ois Langlois, called Ciartres",
    author: ["Jean Pesne", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241318",
    dateCreated: "17th century",
    imageUrl: "images/Francois_Langlois__called_Ciartres.webp",
  },
  {
    compositionName: "Young Girl at a Table",
    author: [
      "Louis Surugue",
      "After Santere",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241345",
    dateCreated: "18th century",
    imageUrl: "images/Young_Girl_at_a_Table.webp",
  },
  {
    compositionName: "Christ at the Well of Sychar",
    author: ["School of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299430",
    dateCreated: "17th century",
    imageUrl: "images/Christ_at_the_Well_of_Sychar.webp",
  },
  {
    compositionName: "Triumphal Entry of an Emperor into a City",
    author: ["Unidentified Artist", "Attributed to Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299594",
    dateCreated: "15th-16th century",
    imageUrl: "images/Triumphal_Entry_of_an_Emperor_into_a_City.webp",
  },
  {
    compositionName: "A Draped Male Figure Holding a Staff (John the Baptist?)",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299632",
    dateCreated: "17th century",
    imageUrl:
      "images/A_Draped_Male_Figure_Holding_a_Staff__John_the_Baptist__.webp",
  },
  {
    compositionName: "Lamentation with Saint Francis of Assisi",
    author: ["Deodat van der Mont", "Previously attributed to Michiel Coxcie"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299638",
    dateCreated: "c. 1623",
    imageUrl: "images/Lamentation_with_Saint_Francis_of_Assisi.webp",
  },
  {
    compositionName: "Christ on the Cross, after Van Dyck",
    author: ["Attributed to Jacob Johannes Nilson", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299683",
    dateCreated: "18th-19th century",
    imageUrl: "images/Christ_on_the_Cross__after_Van_Dyck.webp",
  },
  {
    compositionName: "Landscape: Canal Scene",
    author: ["Circle of Pieter Jan van Liender"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299715",
    dateCreated: "18th century",
    imageUrl: "images/Landscape__Canal_Scene.webp",
  },
  {
    compositionName: "Ships",
    author: ["Ary van Wanum", "Previously attributed to Unidentified Artist"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299718",
    dateCreated: "18th century",
    imageUrl: "images/Ships.webp",
  },
  {
    compositionName:
      "Peasant Leaning on his Doorway, copy after Adriaen van Ostade",
    author: ["Copy after Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299723",
    dateCreated: "18th century",
    imageUrl:
      "images/Peasant_Leaning_on_his_Doorway__copy_after_Adriaen_van_Ostade.webp",
  },
  {
    compositionName: "Woman Before a King",
    author: ["After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299748",
    dateCreated: "17th century",
    imageUrl: "images/Woman_Before_a_King.webp",
  },
  {
    compositionName: "View in a Village",
    author: ["Pieter Jan van Liender"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299749",
    dateCreated: "18th century",
    imageUrl: "images/View_in_a_Village.webp",
  },
  {
    compositionName: "Plague of Frogs",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241537",
    dateCreated: "16th-17th century",
    imageUrl: "images/Plague_of_Frogs.webp",
  },
  {
    compositionName: "Plague of Hail and Locusts",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241538",
    dateCreated: "16th-17th century",
    imageUrl: "images/Plague_of_Hail_and_Locusts.webp",
  },
  {
    compositionName: "Institution of Passover",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241539",
    dateCreated: "16th-17th century",
    imageUrl: "images/Institution_of_Passover.webp",
  },
  {
    compositionName: "Moses and the Tables of Law",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241560",
    dateCreated: "16th-17th century",
    imageUrl: "images/Moses_and_the_Tables_of_Law.webp",
  },
  {
    compositionName: "Golden Calf",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241561",
    dateCreated: "16th-17th century",
    imageUrl: "images/Golden_Calf.webp",
  },
  {
    compositionName: "Brazen Serpent",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241562",
    dateCreated: "16th-17th century",
    imageUrl: "images/Brazen_Serpent.webp",
  },
  {
    compositionName: "View on a Canal in Winter",
    author: ["Fran\u00e7ois Auguste Trichon", "After Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241594",
    dateCreated: "19th century",
    imageUrl: "images/View_on_a_Canal_in_Winter.webp",
  },
  {
    compositionName: "Rudolph I",
    author: ["Pieter van Sompel", "After Pieter Soutman"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241607",
    dateCreated: "1644",
    imageUrl: "images/Rudolph_I.webp",
  },
  {
    compositionName: "Daughters of Cecrops Disclosing Erichthonius in a Basket",
    author: ["Pieter van Sompel", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241634",
    dateCreated: "17th century",
    imageUrl:
      "images/Daughters_of_Cecrops_Disclosing_Erichthonius_in_a_Basket.webp",
  },
  {
    compositionName: "Cornelis Claesz Anslo, Preacher",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299986",
    dateCreated: "1641",
    imageUrl: "images/Cornelis_Claesz_Anslo__Preacher.webp",
  },
  {
    compositionName: "Clement de Jonghe, Printseller",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299987",
    dateCreated: "1651",
    imageUrl: "images/Clement_de_Jonghe__Printseller.webp",
  },
  {
    compositionName: "Waterfall with a Half-Timbered House and Castle",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299988",
    dateCreated: "c. 1665-1670",
    imageUrl: "images/Waterfall_with_a_Half_Timbered_House_and_Castle.webp",
  },
  {
    compositionName: "Abraham Francen, Art Dealer",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/300006",
    dateCreated: "c. 1658",
    imageUrl: "images/Abraham_Francen__Art_Dealer.webp",
  },
  {
    compositionName: "Jared Sparks (1789-1866)",
    author: ["Rembrandt Peale", "Jared Sparks"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/300059",
    dateCreated: "c. 1819",
    imageUrl: "images/Jared_Sparks__1789_1866_.webp",
  },
  {
    compositionName: "Jan Cornelis Sylvius, Preacher",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/303495",
    dateCreated: "1646",
    imageUrl: "images/Jan_Cornelis_Sylvius__Preacher.webp",
  },
  {
    compositionName: "Three Studies of a Child and One of a Woman",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/303699",
    dateCreated: "c. 1638-40",
    imageUrl: "images/Three_Studies_of_a_Child_and_One_of_a_Woman.webp",
  },
  {
    compositionName: 'Landscape with a Farmstead ("Winter Landscape")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/303771",
    dateCreated: "c. 1650",
    imageUrl: "images/Landscape_with_a_Farmstead___Winter_Landscape__.webp",
  },
  {
    compositionName: "Increase Mather (1639-1723), after van der Spriett",
    author: [
      "Alexander Robertson James",
      "After Jan van der Spriett",
      "Increase Mather",
    ],
    tale: "Original by van der Spriett is in collection of the Massachusetts Historical Society.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304768",
    dateCreated: "1931",
    imageUrl: "images/Increase_Mather__1639_1723___after_van_der_Spriett.webp",
  },
  {
    compositionName: "John Warren (1753-1815), after Rembrandt Peale",
    author: [
      "Mary Brewster Hazelton",
      "Copy after Rembrandt Peale",
      "John Warren",
    ],
    tale: "Harvard owns the original by Rembrandt Peale. See object number H175.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304796",
    dateCreated: "c. 1900-1930",
    imageUrl: "images/John_Warren__1753_1815___after_Rembrandt_Peale.webp",
  },
  {
    compositionName:
      "George Washington (1732-1799),  after Rembrandt Peale (1778-1860)",
    author: [
      "Constantino Brumidi",
      "After Rembrandt Peale",
      "George Washington",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304889",
    dateCreated: "c. 1855-1865",
    imageUrl:
      "images/George_Washington__1732_1799____after_Rembrandt_Peale__1778_1860_.webp",
  },
  {
    compositionName: "Portrait of a Man (once thought to be Benjamin Colman)",
    author: [
      "Attributed to Jan van der Spriett",
      "Previously attributed to Attributed to John Smibert",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304950",
    dateCreated: "17th century",
    imageUrl:
      "images/Portrait_of_a_Man__once_thought_to_be_Benjamin_Colman_.webp",
  },
  {
    compositionName: "John Warren (1753-1815)",
    author: ["Rembrandt Peale", "John Warren"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305211",
    dateCreated: "c. 1805-1815",
    imageUrl: "images/John_Warren__1753_1815_.webp",
  },
  {
    compositionName: "The Mill, after Rembrandt",
    author: ["Matthew J. Whipple", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305870",
    dateCreated: "19th century",
    imageUrl: "images/The_Mill__after_Rembrandt____.webp",
  },
  {
    compositionName: "Van Wyck Brooks (1886-1963)",
    author: ["George Biddle", "Van Wyck Brooks"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/308837",
    dateCreated: "1955",
    imageUrl: "images/Van_Wyck_Brooks__1886_1963_.webp",
  },
  {
    compositionName: "Study of a Woman",
    author: ["Caroline van Evera"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/308856",
    dateCreated: "1947",
    imageUrl: "images/Study_of_a_Woman.webp",
  },
  {
    compositionName: "McKean Buchanan (1798-1872)",
    author: ["Rembrandt Peale"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/311174",
    dateCreated: "c. 1830-1835",
    imageUrl: "images/McKean_Buchanan__1798_1872_.webp",
  },
  {
    compositionName:
      "Charles I (after a van Dyck painting in the Staatliche Museen, Gemaldegalerie, Dresden)",
    author: ["Unidentified Artist", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/311644",
    dateCreated: "",
    imageUrl:
      "images/Charles_I__after_a_van_Dyck_painting_in_the_Staatliche_Museen__Gemaldegalerie__Dresden_.webp",
  },
  {
    compositionName: "Giving Drink to the Thirsty",
    author: ["Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/311893",
    dateCreated: "1552",
    imageUrl: "images/Giving_Drink_to_the_Thirsty.webp",
  },
  {
    compositionName: "Three Trees",
    author: ["Heliodore Joseph Pisan", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241777",
    dateCreated: "19th century",
    imageUrl: "images/Three_Trees.webp",
  },
  {
    compositionName: "Virgin Presenting the Child to Saint Francis",
    author: ["Arnold van Westerhout", "After Ciro Ferri"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241796",
    dateCreated: "18th century",
    imageUrl: "images/Virgin_Presenting_the_Child_to_Saint_Francis.webp",
  },
  {
    compositionName: "Christ Child Appearing to a Carmelite",
    author: ["Arnold van Westerhout", "After Pietro Nelli"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241797",
    dateCreated: "18th century",
    imageUrl: "images/Christ_Child_Appearing_to_a_Carmelite.webp",
  },
  {
    compositionName: "Hugo Fredericus van Eltz",
    author: ["Conrad Waumans", "After Anselmus van Hulle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241808",
    dateCreated: "c. 1697",
    imageUrl: "images/Hugo_Fredericus_van_Eltz.webp",
  },
  {
    compositionName: "Carolus Bruxellensis, Father General of the Capuchins",
    author: ["Paulus Pontius", "After Abraham van Diepenbeeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241810",
    dateCreated: "17th century",
    imageUrl:
      "images/Carolus_Bruxellensis__Father_General_of_the_Capuchins.webp",
  },
  {
    compositionName: "Simon de Vos",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241811",
    dateCreated: "17th century",
    imageUrl: "images/Simon_de_Vos.webp",
  },
  {
    compositionName: "Jan Wildens",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241812",
    dateCreated: "17th century",
    imageUrl: "images/Jan_Wildens.webp",
  },
  {
    compositionName: "Frederick Henry of Nassau, Prince of Orange",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241813",
    dateCreated: "17th century",
    imageUrl: "images/Frederick_Henry_of_Nassau__Prince_of_Orange.webp",
  },
  {
    compositionName: "Fran\u00e7ois Thomas, Prince of Savoie-Carignan",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241814",
    dateCreated: "17th century",
    imageUrl: "images/Francois_Thomas__Prince_of_Savoie_Carignan.webp",
  },
  {
    compositionName: "Chrisius, Fabius",
    author: ["Paulus Pontius", "After Anselmus van Hulle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241815",
    dateCreated: "17th century",
    imageUrl: "images/Chrisius__Fabius.webp",
  },
  {
    compositionName: "Saint Margaret",
    author: ["Arnold van Westerhout", "After Pietro Locatelli"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241825",
    dateCreated: "18th century",
    imageUrl: "images/Saint_Margaret.webp",
  },
  {
    compositionName: "Jacques de Breuck",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241853",
    dateCreated: "17th century",
    imageUrl: "images/Jacques_de_Breuck.webp",
  },
  {
    compositionName: "Gaspar de Crayer",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241854",
    dateCreated: "17th century",
    imageUrl: "images/Gaspar_de_Crayer.webp",
  },
  {
    compositionName: "Constantin Huygens",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241855",
    dateCreated: "17th century",
    imageUrl: "images/Constantin_Huygens.webp",
  },
  {
    compositionName: "Daniel Mytens, the Elder",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241856",
    dateCreated: "17th century",
    imageUrl: "images/Daniel_Mytens__the_Elder.webp",
  },
  {
    compositionName: "Casare Alessandro Scaglia",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241857",
    dateCreated: "17th century",
    imageUrl: "images/Casare_Alessandro_Scaglia.webp",
  },
  {
    compositionName: "Hendrik van Steenwyck",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241858",
    dateCreated: "17th century",
    imageUrl: "images/Hendrik_van_Steenwyck.webp",
  },
  {
    compositionName: "Reuben",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241860",
    dateCreated: "16th-17th century",
    imageUrl: "images/Reuben.webp",
  },
  {
    compositionName: "Simeon",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241861",
    dateCreated: "16th-17th century",
    imageUrl: "images/Simeon.webp",
  },
  {
    compositionName: "Madonna And Child with Saint Anthony",
    author: ["Gilles Rousselet", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241865",
    dateCreated: "18th century",
    imageUrl: "images/Madonna_And_Child_with_Saint_Anthony.webp",
  },
  {
    compositionName: "Levi",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241868",
    dateCreated: "16th-17th century",
    imageUrl: "images/Levi.webp",
  },
  {
    compositionName: "Judah",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241869",
    dateCreated: "16th-17th century",
    imageUrl: "images/Judah.webp",
  },
  {
    compositionName: "Gad",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241870",
    dateCreated: "16th-17th century",
    imageUrl: "images/Gad.webp",
  },
  {
    compositionName: "Joseph",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241879",
    dateCreated: "16th-17th century",
    imageUrl: "images/Joseph.webp",
  },
  {
    compositionName: "Gerard van Honthorst",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241880",
    dateCreated: "17th century",
    imageUrl: "images/Gerard_van_Honthorst.webp",
  },
  {
    compositionName: "Phineas Killing Zimri and Cozbi",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241883",
    dateCreated: "16th century",
    imageUrl: "images/Phineas_Killing_Zimri_and_Cozbi.webp",
  },
  {
    compositionName: "Zebulan",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241884",
    dateCreated: "16th-17th century",
    imageUrl: "images/Zebulan.webp",
  },
  {
    compositionName: "Issachar",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241885",
    dateCreated: "16th-17th century",
    imageUrl: "images/Issachar.webp",
  },
  {
    compositionName: "Dan",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241900",
    dateCreated: "16th-17th century",
    imageUrl: "images/Dan.webp",
  },
  {
    compositionName: "Asher",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241901",
    dateCreated: "16th-17th century",
    imageUrl: "images/Asher.webp",
  },
  {
    compositionName: "Naphtali",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241902",
    dateCreated: "16th-17th century",
    imageUrl: "images/Naphtali.webp",
  },
  {
    compositionName: "The Creation of Eve",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241936",
    dateCreated: "16th-17th century",
    imageUrl: "images/The_Creation_of_Eve.webp",
  },
  {
    compositionName: "Eve Tempting Adam",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241937",
    dateCreated: "16th-17th century",
    imageUrl: "images/Eve_Tempting_Adam.webp",
  },
  {
    compositionName: "Life of Adam and Eve",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241938",
    dateCreated: "16th-17th century",
    imageUrl: "images/Life_of_Adam_and_Eve.webp",
  },
  {
    compositionName: "Lord of the Vineyard Paying His Labourers",
    author: [
      "Simon Fran\u00e7ois Ravenet, the Elder",
      "After William Pether",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241949",
    dateCreated: "1767",
    imageUrl: "images/Lord_of_the_Vineyard_Paying_His_Labourers.webp",
  },
  {
    compositionName: "Moonlight",
    author: ["Fran\u00e7ois Vivares", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241984",
    dateCreated: "1775",
    imageUrl: "images/Moonlight.webp",
  },
  {
    compositionName: "Battle of Staffarde in Piedmont",
    author: ["Jan van Huchtenburg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242025",
    dateCreated: "17th-18th century",
    imageUrl: "images/Battle_of_Staffarde_in_Piedmont.webp",
  },
  {
    compositionName: "The Ganimede of Rembrandt",
    author: ["Antoine Cardon", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242027",
    dateCreated: "18th-19th century",
    imageUrl: "images/The_Ganimede_of_Rembrandt.webp",
  },
  {
    compositionName: "Joos de Momper",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324150",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Joos_de_Momper.webp",
  },
  {
    compositionName: "Adam van Noort",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324151",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Adam_van_Noort.webp",
  },
  {
    compositionName: "Paulus Pontius",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324152",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Paulus_Pontius.webp",
  },
  {
    compositionName: "Philippe Le Roy",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324153",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Philippe_Le_Roy.webp",
  },
  {
    compositionName: "Jan Snellinck",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324154",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Jan_Snellinck.webp",
  },
  {
    compositionName: "Frans Snyders",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324155",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Frans_Snyders.webp",
  },
  {
    compositionName: "Justus Susterman",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324156",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Justus_Susterman.webp",
  },
  {
    compositionName: "Lucas Vosterman",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324157",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Lucas_Vosterman.webp",
  },
  {
    compositionName: "Temptation of Saint Anthoy",
    author: ["Guillaume der Vivier", "After Anton van den Heuvel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242135",
    dateCreated: "17th century",
    imageUrl: "images/Temptation_of_Saint_Anthoy.webp",
  },
  {
    compositionName: "Lucas van Uden",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242195",
    dateCreated: "17th century",
    imageUrl: "images/Lucas_van_Uden.webp",
  },
  {
    compositionName: "Henricus Liberti Groeningensis",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242217",
    dateCreated: "17th century",
    imageUrl: "images/Henricus_Liberti_Groeningensis.webp",
  },
  {
    compositionName: "Madonna and Child adored by Cesare Alessandro Scaglia",
    author: ["Conrad Waumans", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242235",
    dateCreated: "17th century",
    imageUrl:
      "images/Madonna_and_Child_adored_by_Cesare_Alessandro_Scaglia.webp",
  },
  {
    compositionName: "Young Nobleman in Prayer",
    author: ["Henri Vion", "After Jan van Eyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242237",
    dateCreated: "19th century",
    imageUrl: "images/Young_Nobleman_in_Prayer.webp",
  },
  {
    compositionName: "Emmanuel Pimental Frockas, Count de Feria",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242243",
    dateCreated: "17th century",
    imageUrl: "images/Emmanuel_Pimental_Frockas__Count_de_Feria.webp",
  },
  {
    compositionName: "Herd of Cattle in a Stream",
    author: [
      "Johann Gottlieb Abraham Frenzel",
      "After Cornelis van Poelenburch",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242300",
    dateCreated: "1817",
    imageUrl: "images/Herd_of_Cattle_in_a_Stream.webp",
  },
  {
    compositionName: "Landscape with Gallows",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/327366",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Gallows.webp",
  },
  {
    compositionName: "Landscape with a Well",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/327367",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_Well.webp",
  },
  {
    compositionName: "Wooded Landscape with Temple",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/327368",
    dateCreated: "17th century",
    imageUrl: "images/Wooded_Landscape_with_Temple.webp",
  },
  {
    compositionName: "Landscape with a Roman Ruin",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/327370",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_Roman_Ruin.webp",
  },
  {
    compositionName: "Imaginary View of Florence",
    author: ["Circle of Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/336324",
    dateCreated: "late 16th century",
    imageUrl: "images/Imaginary_View_of_Florence.webp",
  },
  {
    compositionName: "Customs and Fashions of the Turks",
    author: ["Pieter Coecke van Aelst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/337313",
    dateCreated: "1553",
    imageUrl: "images/Customs_and_Fashions_of_the_Turks.webp",
  },
  {
    compositionName: "Study for Book Cover: Composition of Peaches and Pears",
    author: ["Claes Oldenburg", "Coosje van Bruggen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/339394",
    dateCreated: "2001",
    imageUrl:
      "images/Study_for_Book_Cover__Composition_of_Peaches_and_Pears.webp",
  },
  {
    compositionName: "The Ages of Man",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/339687",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Ages_of_Man.webp",
  },
  {
    compositionName: "Thomas Howard, Duke of Norfolk (26th Earl of Arundel)",
    author: ["Eduard Kretzschmar", "After ? Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242857",
    dateCreated: "19th century",
    imageUrl:
      "images/Thomas_Howard__Duke_of_Norfolk__26th_Earl_of_Arundel_.webp",
  },
  {
    compositionName: "Landscape with Cattle",
    author: ["Carl Kuntz", "After Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242917",
    dateCreated: "1810",
    imageUrl: "images/Landscape_with_Cattle.webp",
  },
  {
    compositionName: "Horseman on a Wooden Bridge",
    author: ["Johann Georg von Dillis", "After Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242956",
    dateCreated: "18th-19th century",
    imageUrl: "images/Horseman_on_a_Wooden_Bridge.webp",
  },
  {
    compositionName: "Saint Jerome",
    author: ["Friedrich August Ludy", "After Johann van Schraudolph"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243013",
    dateCreated: "19th century",
    imageUrl: "images/Saint_Jerome.webp",
  },
  {
    compositionName: "Cruxifixion",
    author: [
      "Joseph Leudner",
      "Carl Friedrich Mayr",
      "After Johann van Schraudolph",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243060",
    dateCreated: "19th century",
    imageUrl: "images/Cruxifixion.webp",
  },
  {
    compositionName: "Sir Balthazar Gerbier",
    author: ["Thomas Chambars", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243146",
    dateCreated: "18th century",
    imageUrl: "images/Sir_Balthazar_Gerbier.webp",
  },
  {
    compositionName: "Burial of Saint Stephen [Acts 8:2-3]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243147",
    dateCreated: "1575-1582",
    imageUrl: "images/Burial_of_Saint_Stephen__Acts_8_2_3_.webp",
  },
  {
    compositionName: "The Age of Thirty",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342298",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Thirty.webp",
  },
  {
    compositionName: "The Age of Forty",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342299",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Forty.webp",
  },
  {
    compositionName: "The Age of Fifty",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342300",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Fifty.webp",
  },
  {
    compositionName: "The Age of Sixty",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342301",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Sixty.webp",
  },
  {
    compositionName: "The Age of Seventy",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342302",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Seventy.webp",
  },
  {
    compositionName: "The Age of Eighty",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342303",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Eighty.webp",
  },
  {
    compositionName: "The Age of Ninety",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342304",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Ninety.webp",
  },
  {
    compositionName: "The Age of One Hundred",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342305",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_One_Hundred.webp",
  },
  {
    compositionName: "The Creation of Light",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342310",
    dateCreated: "1579-1585",
    imageUrl: "images/The_Creation_of_Light.webp",
  },
  {
    compositionName: "The Creation of the Animals",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342311",
    dateCreated: "1575",
    imageUrl: "images/The_Creation_of_the_Animals.webp",
  },
  {
    compositionName: "De philosophe",
    author: ["Jan Pieter de Frey", "After Quiringh Gerritsz van Brekelenkam"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243437",
    dateCreated: "18th-19th century",
    imageUrl: "images/De_philosophe.webp",
  },
  {
    compositionName: "The Power of Woman [3 Esdras 4:18-19, 22-23, 29-32]",
    author: ["Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243518",
    dateCreated: "c.1574",
    imageUrl: "images/The_Power_of_Woman__3_Esdras_4_18_19__22_23__29_32_.webp",
  },
  {
    compositionName: "The Power of the King [3 Esdras 4:3-8]",
    author: ["Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243519",
    dateCreated: "c.1574",
    imageUrl: "images/The_Power_of_the_King__3_Esdras_4_3_8_.webp",
  },
  {
    compositionName: "The Power of Wine [3 Esdras 3:19-23]",
    author: ["Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243520",
    dateCreated: "c.1574",
    imageUrl: "images/The_Power_of_Wine__3_Esdras_3_19_23_.webp",
  },
  {
    compositionName:
      "The Seed Received Among the Thorns [Matt.13:22] Avarice and Care of this world choking the word",
    author: ["Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243521",
    dateCreated: "1574",
    imageUrl:
      "images/The_Seed_Received_Among_the_Thorns__Matt_13_22__Avarice_and_Care_of_this_world_choking_the_word.webp",
  },
  {
    compositionName: "Descent of the Holy Ghost [Acts 2:1-6]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243542",
    dateCreated: "1575-1582",
    imageUrl: "images/Descent_of_the_Holy_Ghost__Acts_2_1_6_.webp",
  },
  {
    compositionName: "Saint Peter Preaching in Jerusalem",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243543",
    dateCreated: "1575-1582",
    imageUrl: "images/Saint_Peter_Preaching_in_Jerusalem.webp",
  },
  {
    compositionName: "The Apostles Baptizing in Jerusalem [Acts 2:41-45]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243544",
    dateCreated: "1575-1582",
    imageUrl: "images/The_Apostles_Baptizing_in_Jerusalem__Acts_2_41_45_.webp",
  },
  {
    compositionName: "Peter Healing the Sick with his Shadow [Acts 5:15-16]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243545",
    dateCreated: "1575-1582",
    imageUrl:
      "images/Peter_Healing_the_Sick_with_his_Shadow__Acts_5_15_16_.webp",
  },
  {
    compositionName:
      "The Angel Delivering the Apostles out of Prison [Acts 5:19-20]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243546",
    dateCreated: "1575-1582",
    imageUrl:
      "images/The_Angel_Delivering_the_Apostles_out_of_Prison__Acts_5_19_20_.webp",
  },
  {
    compositionName:
      "Saint Stephen before the Council and teh Council [Acts 6:12-7:60]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243547",
    dateCreated: "1575-1582",
    imageUrl:
      "images/Saint_Stephen_before_the_Council_and_teh_Council__Acts_6_12_7_60_.webp",
  },
  {
    compositionName: "Lucy Harington, Countess of Bedford",
    author: ["Samuel Freeman", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243552",
    dateCreated: "19th century",
    imageUrl: "images/Lucy_Harington__Countess_of_Bedford.webp",
  },
  {
    compositionName: "Old Man Sitting and Holding a Book",
    author: ["Jan Pieter de Frey", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243554",
    dateCreated: "18th-19th century",
    imageUrl: "images/Old_Man_Sitting_and_Holding_a_Book.webp",
  },
  {
    compositionName: "Giovanni de Medici  Surrounded at Rome",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243657",
    dateCreated: "1582-1583",
    imageUrl: "images/Giovanni_de_Medici__Surrounded_at_Rome.webp",
  },
  {
    compositionName: "Christ Entering Jerusalem",
    author: ["Dirck Volkertsz. Coornhert", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243685",
    dateCreated: "c. 1548",
    imageUrl: "images/Christ_Entering_Jerusalem.webp",
  },
  {
    compositionName: "Lion Hunt on Horseback",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243690",
    dateCreated: "1578",
    imageUrl: "images/Lion_Hunt_on_Horseback.webp",
  },
  {
    compositionName: "Angels with the Sudarium",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243691",
    dateCreated: "16th-17th century",
    imageUrl: "images/Angels_with_the_Sudarium.webp",
  },
  {
    compositionName: "P\u00e6dop\u00e6gnion",
    author: ["Wenceslaus Hollar", "After Peeter van Avont"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243701",
    dateCreated: "1646",
    imageUrl: "images/Paedopaegnion.webp",
  },
  {
    compositionName: "Jesus, Saint John the Baptist, and Four Cherubs",
    author: ["Wenceslaus Hollar", "After Peeter van Avont"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243702",
    dateCreated: "1646",
    imageUrl: "images/Jesus__Saint_John_the_Baptist__and_Four_Cherubs.webp",
  },
  {
    compositionName: "The Bridge over the Waterfall",
    author: [
      "Wenceslaus Hollar",
      "After Jacques d'Arthois",
      "Published by Peeter van Avont",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243704",
    dateCreated: "1648",
    imageUrl: "images/The_Bridge_over_the_Waterfall.webp",
  },
  {
    compositionName: "Saint Philip Baptizing the Eunuch [Acts 8:30-38]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243708",
    dateCreated: "1575-1582",
    imageUrl: "images/Saint_Philip_Baptizing_the_Eunuch__Acts_8_30_38_.webp",
  },
  {
    compositionName: "The Battle of Marciano",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243748",
    dateCreated: "1582-1583",
    imageUrl: "images/The_Battle_of_Marciano.webp",
  },
  {
    compositionName: "The Capture of Portus Herculis",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243749",
    dateCreated: "1582-1583",
    imageUrl: "images/The_Capture_of_Portus_Herculis.webp",
  },
  {
    compositionName:
      "Title Plate: Sol and the Personifications of the Four Seasons",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243750",
    dateCreated: "c.1565",
    imageUrl:
      "images/Title_Plate__Sol_and_the_Personifications_of_the_Four_Seasons.webp",
  },
  {
    compositionName: "A Jewish Merchant",
    author: ["Moritz Kellerhoven", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243772",
    dateCreated: "18th century",
    imageUrl: "images/A_Jewish_Merchant.webp",
  },
  {
    compositionName: '"Rembrandt\'s Father"',
    author: ["Moritz Kellerhoven", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243773",
    dateCreated: "18th century",
    imageUrl: "images/_Rembrandt_s_Father_.webp",
  },
  {
    compositionName: "The Statue Court of the Palazzo Valle Capranica",
    author: ["Maarten van Heemskerck", "Printed by Hieronymus Cock"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243775",
    dateCreated: "1553",
    imageUrl: "images/The_Statue_Court_of_the_Palazzo_Valle_Capranica.webp",
  },
  {
    compositionName: "Saint Peter Raising Tabitha At Joppa [Acts 9:36-40]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243793",
    dateCreated: "1582",
    imageUrl: "images/Saint_Peter_Raising_Tabitha_At_Joppa__Acts_9_36_40_.webp",
  },
  {
    compositionName: "The Fall of Jericho",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342369",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Fall_of_Jericho.webp",
  },
  {
    compositionName: "Achan Stealing from the Spoils",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342370",
    dateCreated: "c. 1567-70",
    imageUrl: "images/Achan_Stealing_from_the_Spoils.webp",
  },
  {
    compositionName: "Achan before Joshua",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342371",
    dateCreated: "c. 1567-70",
    imageUrl: "images/Achan_before_Joshua.webp",
  },
  {
    compositionName: "The Battle at Gibeon",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342372",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Battle_at_Gibeon.webp",
  },
  {
    compositionName: "The Five Amorite Kings Hung from Trees",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342373",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Five_Amorite_Kings_Hung_from_Trees.webp",
  },
  {
    compositionName: "The Thirty-One Kings Defeated by Joshua",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342374",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Thirty_One_Kings_Defeated_by_Joshua.webp",
  },
  {
    compositionName: "Uriah before David",
    author: [
      "Adriaen Collaert",
      "After Maarten van Cleve",
      "Previously attributed to Johann Sadeler I",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342409",
    dateCreated: "c. 1579",
    imageUrl: "images/Uriah_before_David.webp",
  },
  {
    compositionName: "The Death of Uriah",
    author: [
      "Unidentified Artist",
      "Previously attributed to Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342410",
    dateCreated: "c. 1579",
    imageUrl: "images/The_Death_of_Uriah.webp",
  },
  {
    compositionName: "Nathan Criticizing David for Uriah's Death",
    author: [
      "Unidentified Artist",
      "Previously attributed to Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342411",
    dateCreated: "c. 1579",
    imageUrl: "images/Nathan_Criticizing_David_for_Uriah_s_Death.webp",
  },
  {
    compositionName: "Elisha Seeing Elijah's Ascension in a Chariot of Fire",
    author: [
      "Unidentified Artist",
      "After Pieter van der Borcht",
      "Published by Gerard de Jode",
      "Previously attributed to Jacob Floris",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342429",
    dateCreated: "c. 1579",
    imageUrl:
      "images/Elisha_Seeing_Elijah_s_Ascension_in_a_Chariot_of_Fire.webp",
  },
  {
    compositionName: "Mary Villiers, Duchess of Lennox and Richmond",
    author: [
      "Wenceslaus Hollar",
      "After Anthony van Dyck",
      "Published by Johannes Meyssens",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243826",
    dateCreated: "17th century",
    imageUrl: "images/Mary_Villiers__Duchess_of_Lennox_and_Richmond.webp",
  },
  {
    compositionName: "The Beheading of Saint James",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243827",
    dateCreated: "1582",
    imageUrl: "images/The_Beheading_of_Saint_James.webp",
  },
  {
    compositionName:
      "Saint Peter Freed from Prison by the Angel (Acts 12:7-10)",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243828",
    dateCreated: "1582",
    imageUrl:
      "images/Saint_Peter_Freed_from_Prison_by_the_Angel__Acts_12_7_10_.webp",
  },
  {
    compositionName: "The Blinding of Elymas (Acts 13:6-12)",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243829",
    dateCreated: "1582",
    imageUrl: "images/The_Blinding_of_Elymas__Acts_13_6_12_.webp",
  },
  {
    compositionName:
      "Saint Paul Speaking to the Women at Philippi  (Acts 16:11-15)",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243830",
    dateCreated: "1582",
    imageUrl:
      "images/Saint_Paul_Speaking_to_the_Women_at_Philippi___Acts_16_11_15_.webp",
  },
  {
    compositionName: "The Arrest of Saint Paul",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243831",
    dateCreated: "1582",
    imageUrl: "images/The_Arrest_of_Saint_Paul.webp",
  },
  {
    compositionName: "Saint Paul before the High Priest (Acts 23:1-3)",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243832",
    dateCreated: "1582",
    imageUrl: "images/Saint_Paul_before_the_High_Priest__Acts_23_1_3_.webp",
  },
  {
    compositionName: "Saint Paul Before Festus and Agrippa",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243833",
    dateCreated: "1582",
    imageUrl: "images/Saint_Paul_Before_Festus_and_Agrippa.webp",
  },
  {
    compositionName: "The Defeat of the Turks at Plumbinum",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243834",
    dateCreated: "1582-1583",
    imageUrl: "images/The_Defeat_of_the_Turks_at_Plumbinum.webp",
  },
  {
    compositionName: "The Power of Truth [3 Esdras 4:36, 38]",
    author: ["Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243835",
    dateCreated: "c.1574",
    imageUrl: "images/The_Power_of_Truth__3_Esdras_4_36__38_.webp",
  },
  {
    compositionName: "Daniel's Dream of the Four Animals",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342484",
    dateCreated: "before 1576",
    imageUrl: "images/Daniel_s_Dream_of_the_Four_Animals.webp",
  },
  {
    compositionName: "Daniel Feeding the Dragon",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342485",
    dateCreated: "before 1576",
    imageUrl: "images/Daniel_Feeding_the_Dragon.webp",
  },
  {
    compositionName: "Belshazzar's Feast",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342486",
    dateCreated: "before 1576",
    imageUrl: "images/Belshazzar_s_Feast.webp",
  },
  {
    compositionName: "Mattathias Killing a Jew and a Royal Servant at Modin",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342495",
    dateCreated: "c. 1573",
    imageUrl:
      "images/Mattathias_Killing_a_Jew_and_a_Royal_Servant_at_Modin.webp",
  },
  {
    compositionName: "Judas Maccabee Ordering the Cleansing of the Holy Place",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342496",
    dateCreated: "c. 1573",
    imageUrl:
      "images/Judas_Maccabee_Ordering_the_Cleansing_of_the_Holy_Place.webp",
  },
  {
    compositionName: "The Consecration of the New Altar",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342497",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Consecration_of_the_New_Altar.webp",
  },
  {
    compositionName: "The Head and Hand of Nicanor Shown to the People",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342498",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Head_and_Hand_of_Nicanor_Shown_to_the_People.webp",
  },
  {
    compositionName: "The Five Heavenly Warriors in the War against Timotheus",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342499",
    dateCreated: "c. 1573",
    imageUrl:
      "images/The_Five_Heavenly_Warriors_in_the_War_against_Timotheus.webp",
  },
  {
    compositionName: "The Death of Timotheus, Chaereas, and Apollophanes",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342500",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Death_of_Timotheus__Chaereas__and_Apollophanes.webp",
  },
  {
    compositionName: "The Annunciation to the Shepherds",
    author: [
      "Johann Sadeler I",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342516",
    dateCreated: "1585",
    imageUrl: "images/The_Annunciation_to_the_Shepherds.webp",
  },
  {
    compositionName:
      "Saint Peter, Saint John, and Saint Philip Laying Their Hands on the Baptized at Samaria [Acts 8:7, 12, 14-17]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243876",
    dateCreated: "1575-1582",
    imageUrl:
      "images/Saint_Peter__Saint_John__and_Saint_Philip_Laying_Their_Hands_on_the_Baptized_at_Samaria__Acts_8_7__12__14_17_.webp",
  },
  {
    compositionName: "The Angel Appearing to Saint Philip [Acts 8:25-28]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243877",
    dateCreated: "1575-1582",
    imageUrl: "images/The_Angel_Appearing_to_Saint_Philip__Acts_8_25_28_.webp",
  },
  {
    compositionName: "George Monk, Duke of Albemarle",
    author: ["Michael van der Gucht"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243884",
    dateCreated: "18th century",
    imageUrl: "images/George_Monk__Duke_of_Albemarle.webp",
  },
  {
    compositionName: "Thomas Wood",
    author: ["Michael van der Gucht"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243885",
    dateCreated: "18th century",
    imageUrl: "images/Thomas_Wood.webp",
  },
  {
    compositionName: "Philippus \u00e0 Limborch",
    author: ["Pieter van Gunst", "After David van der Plas"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243888",
    dateCreated: "18th century",
    imageUrl: "images/Philippus_a_Limborch.webp",
  },
  {
    compositionName: "Pieter Burmann",
    author: ["Jacobus Houbraken", "After Hieronymus van der Mij"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243894",
    dateCreated: "c. 1727",
    imageUrl: "images/Pieter_Burmann.webp",
  },
  {
    compositionName: "Matthew Parker, Archbishop of Canterbury",
    author: ["Pieter van Gunst", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243923",
    dateCreated: "17th-18th century",
    imageUrl: "images/Matthew_Parker__Archbishop_of_Canterbury.webp",
  },
  {
    compositionName:
      "Hercules Slaying the Dragon Which Watched Over the Golden Apples of the Hesperides",
    author: ["Gerard van der Gucht"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243955",
    dateCreated: "18th century",
    imageUrl:
      "images/Hercules_Slaying_the_Dragon_Which_Watched_Over_the_Golden_Apples_of_the_Hesperides.webp",
  },
  {
    compositionName: "Tancredus and Erminia",
    author: ["Gerard van der Gucht", "After Nicolas Poussin"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243956",
    dateCreated: "18th century",
    imageUrl: "images/Tancredus_and_Erminia.webp",
  },
  {
    compositionName: "Frans van Aarsens",
    author: ["Jacobus Houbraken", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243983",
    dateCreated: "18th century",
    imageUrl: "images/Frans_van_Aarsens.webp",
  },
  {
    compositionName: "Christ Relating the Parable from a Ship",
    author: [
      "Pieter Jalhea Furnius",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342532",
    dateCreated: "1568",
    imageUrl: "images/Christ_Relating_the_Parable_from_a_Ship.webp",
  },
  {
    compositionName: "Satan Sowing Darnel",
    author: [
      "Pieter Jalhea Furnius",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342533",
    dateCreated: "1568",
    imageUrl: "images/Satan_Sowing_Darnel.webp",
  },
  {
    compositionName: "The Farmer Inspecting the Field",
    author: [
      "Pieter Jalhea Furnius",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342534",
    dateCreated: "1568",
    imageUrl: "images/The_Farmer_Inspecting_the_Field.webp",
  },
  {
    compositionName: "The Burning of the Tares, the Harvest of Wheat",
    author: [
      "Pieter Jalhea Furnius",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342535",
    dateCreated: "1568",
    imageUrl: "images/The_Burning_of_the_Tares__the_Harvest_of_Wheat.webp",
  },
  {
    compositionName: "The Marriage at Cana",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Previously attributed to Maerten de Vos",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342536",
    dateCreated: "c. 1574",
    imageUrl: "images/The_Marriage_at_Cana.webp",
  },
  {
    compositionName: "The Multiplication of Loaves and Fishes",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342537",
    dateCreated: "c. 1574",
    imageUrl: "images/The_Multiplication_of_Loaves_and_Fishes.webp",
  },
  {
    compositionName: "The Resurrection of the Son of the Widow of Na\u00efm",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342538",
    dateCreated: "c. 1574",
    imageUrl: "images/The_Resurrection_of_the_Son_of_the_Widow_of_Naim.webp",
  },
  {
    compositionName: "Christ Healing the Man in the Pool of Bethesda",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342539",
    dateCreated: "c. 1574",
    imageUrl: "images/Christ_Healing_the_Man_in_the_Pool_of_Bethesda.webp",
  },
  {
    compositionName: "The Raising of Lazarus",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342541",
    dateCreated: "c. 1574",
    imageUrl: "images/The_Raising_of_Lazarus.webp",
  },
  {
    compositionName: "Christ Healing a Blind Man",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342542",
    dateCreated: "c. 1574",
    imageUrl: "images/Christ_Healing_a_Blind_Man.webp",
  },
  {
    compositionName: "Christ Healing the Ten Lepers",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342543",
    dateCreated: "c. 1574",
    imageUrl: "images/Christ_Healing_the_Ten_Lepers.webp",
  },
  {
    compositionName: "The Woman Who Was Cured of the Issue of Blood",
    author: [
      "Hans Collaert the Elder",
      "Previously attributed to Hans Collaert the Younger",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342544",
    dateCreated: "c. 1574",
    imageUrl: "images/The_Woman_Who_Was_Cured_of_the_Issue_of_Blood.webp",
  },
  {
    compositionName: "Christ Healing the Paralytic",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342545",
    dateCreated: "c. 1574",
    imageUrl: "images/Christ_Healing_the_Paralytic.webp",
  },
  {
    compositionName: "Christ Healing the Man Possessed with Devils",
    author: [
      "Johannes Wierix",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342546",
    dateCreated: "c. 1574",
    imageUrl: "images/Christ_Healing_the_Man_Possessed_with_Devils.webp",
  },
  {
    compositionName: "The Man and His Servants",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342547",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Man_and_His_Servants.webp",
  },
  {
    compositionName: "The Servant of the Five Talents Trading",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342548",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Servant_of_the_Five_Talents_Trading.webp",
  },
  {
    compositionName: "The Servant Hiding His One Talent in a Pit",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342549",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Servant_Hiding_His_One_Talent_in_a_Pit.webp",
  },
  {
    compositionName: "The Master Returning Home",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342550",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Master_Returning_Home.webp",
  },
  {
    compositionName: "The Servant of the Five Talents Presenting His Profits",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342551",
    dateCreated: "c. 1567-70",
    imageUrl:
      "images/The_Servant_of_the_Five_Talents_Presenting_His_Profits.webp",
  },
  {
    compositionName: "The Unprofitable Servant Cast into Darkness",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Pieter de Jode, the Elder",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342552",
    dateCreated: "c. 1567-70",
    imageUrl: "images/The_Unprofitable_Servant_Cast_into_Darkness.webp",
  },
  {
    compositionName: "The Prodigal Son Wasting His Substance",
    author: [
      "Hans Collaert the Elder",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342568",
    dateCreated: "c. 1571",
    imageUrl: "images/The_Prodigal_Son_Wasting_His_Substance.webp",
  },
  {
    compositionName: "The Prodigal Son as a Swineherd",
    author: [
      "Hans Collaert the Elder",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342569",
    dateCreated: "c. 1571",
    imageUrl: "images/The_Prodigal_Son_as_a_Swineherd.webp",
  },
  {
    compositionName: "The Return of the Prodigal Son",
    author: [
      "Hans Collaert the Elder",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342570",
    dateCreated: "c. 1571",
    imageUrl: "images/The_Return_of_the_Prodigal_Son.webp",
  },
  {
    compositionName: "The Transfiguration of Christ",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342571",
    dateCreated: "1585",
    imageUrl: "images/The_Transfiguration_of_Christ.webp",
  },
  {
    compositionName: "Christ in the House of Nicodemus",
    author: [
      "Pieter de Jode, the Elder",
      "After Adam van Noort",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342572",
    dateCreated: "after 1585",
    imageUrl: "images/Christ_in_the_House_of_Nicodemus.webp",
  },
  {
    compositionName: "Christ Blessing the Children",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342574",
    dateCreated: "before 1585",
    imageUrl: "images/Christ_Blessing_the_Children.webp",
  },
  {
    compositionName: "Christ Foretelling the Desolation of the Holy Sites",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342581",
    dateCreated: "c. 1572",
    imageUrl: "images/Christ_Foretelling_the_Desolation_of_the_Holy_Sites.webp",
  },
  {
    compositionName: "The Parable of the Publican and the Pharisee",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342582",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Parable_of_the_Publican_and_the_Pharisee.webp",
  },
  {
    compositionName: "The Widow's Mite",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342583",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Widow_s_Mite.webp",
  },
  {
    compositionName: "Cornelis de Witt",
    author: ["Pieter van Gunst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244387",
    dateCreated: "18th century",
    imageUrl: "images/Cornelis_de_Witt.webp",
  },
  {
    compositionName: "Jan de Witt",
    author: ["Pieter van Gunst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244388",
    dateCreated: "18th century",
    imageUrl: "images/Jan_de_Witt.webp",
  },
  {
    compositionName: "Thomas Ridgley",
    author: ["John van der Gucht", "After Bartholomew Dandridge"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244395",
    dateCreated: "18th century",
    imageUrl: "images/Thomas_Ridgley.webp",
  },
  {
    compositionName: "Willem Hondius",
    author: ["Willem Hondius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244403",
    dateCreated: "17th century",
    imageUrl: "images/Willem_Hondius.webp",
  },
  {
    compositionName: "William Congreve",
    author: ["Michael van der Gucht", "After Sir Godfrey Kneller"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244448",
    dateCreated: "18th century",
    imageUrl: "images/William_Congreve.webp",
  },
  {
    compositionName: "John Lilborne",
    author: ["Michael van der Gucht"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244449",
    dateCreated: "18th century",
    imageUrl: "images/John_Lilborne.webp",
  },
  {
    compositionName: "Christ before the High Priest",
    author: ["Pietro Fontana", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244489",
    dateCreated: "18th century",
    imageUrl: "images/Christ_before_the_High_Priest.webp",
  },
  {
    compositionName: "Giovanni de' Medici Defeated",
    author: ["Hendrick Goltzius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244557",
    dateCreated: "c. 1578",
    imageUrl: "images/Giovanni_de__Medici_Defeated.webp",
  },
  {
    compositionName: "Martin Folkes",
    author: ["After Jan Faber the Younger", "John van der Banck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244575",
    dateCreated: "1737",
    imageUrl: "images/Martin_Folkes.webp",
  },
  {
    compositionName:
      "The Gathering of Mulberry Leaves and the Feeding of the Silkworms",
    author: [
      "Karel de Mallery",
      "After Jan van der Straet",
      "Published by Philips Galle",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342835",
    dateCreated: "c. 1595",
    imageUrl:
      "images/The_Gathering_of_Mulberry_Leaves_and_the_Feeding_of_the_Silkworms.webp",
  },
  {
    compositionName: "The Reeling of Silk",
    author: [
      "Karel de Mallery",
      "After Jan van der Straet",
      "Published by Philips Galle",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342836",
    dateCreated: "c. 1595",
    imageUrl: "images/The_Reeling_of_Silk.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Mark"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative; Detail : head\r\n\r\nBurroughs Number: 021\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: St. Mark\r\nDate: ca.1663\r\nDescription: Oil on canvas; 104.5 x 84.5 cm (41 1/8 x 33 1/4 in.)\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 39.581",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343629",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Mark_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Lady of the van Bersteyn Family"',
    author: [
      "Artist of original: Jacob Adriaensz. Backer",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head ; Detail : hand\r\n\r\nBurroughs Number: 67\r\n\r\nX-Radiograph(s) of: \r\nArtist: Backer, Jacob Adriaensz, Dutch, 1608-1651\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Lady of the van Bersteyn Family\r\nDate: 1632\r\nDescription: canvas\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 29.100 ",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343710",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Lady_of_the_van_Bersteyn_Family_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man of van Beresteyn Family"',
    author: [
      "Artist of original: Jacob Adriaensz. Backer",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 68\r\n\r\nX-Radiograph(s) of: \r\nArtist: Backer, Jacob Adriaensz, Dutch, 1608-1651\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man of van Beresteyn Family\r\nDate: 1632\r\nDescription: Canvas\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 29.100 ",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343712",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_of_van_Beresteyn_Family_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Hendrickje Stoffels"',
    author: [
      "Artist of original: Reynier van Gherwen",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative, Print, X-Radiograph\r\n\r\nBurroughs Number: 068\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gherwen, Reynier van, Dutch, active 1640-ca.1660\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Hendrickje Stoffels\r\nDate: 1654\r\nOwner: Walters Art Museum, Baltimore, MD\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343713",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Hendrickje_Stoffels_____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Young Woman"',
    author: [
      "Artist of original: Ferdinand Bol",
      "Artist of original: Also att. to Jacob Adriaensz. Backer",
      "Artist of original: Also att. to Samuel van Hoogstraten",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 71\r\n\r\nX-Radiograph(s) of: \r\nArtist: Bol, Ferdinand, Dutch, 1616-1680\r\nArtist: Also att. to Backer, Jacob Adriaensz, Dutch, 1608-1651\r\nArtist: Also att. to Hoogstraten, Samuel van, Dutch, 1627-1678\r\nTitle: Young Woman\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 484",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343718",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Young_Woman_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Youth\'s Portrait"',
    author: [
      "Artist of original: Jacob Adriaensz. Backer",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Print\r\n\r\nBurroughs Number: 72\r\n\r\nX-Radiograph(s) of: \r\nArtist: Backer, Jacob Adriaensz, Dutch, 1608-1651\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Youth's Portrait\r\nDescription: (under Rembrandt School)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 15.30.1 ",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343720",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Youth_s_Portrait_.webp",
  },
  {
    compositionName: "Peasant Leaning on his Doorway",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244779",
    dateCreated: "18th-19th century",
    imageUrl: "images/Peasant_Leaning_on_his_Doorway.webp",
  },
  {
    compositionName: "Mother and Two Children",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244780",
    dateCreated: "18th-19th century",
    imageUrl: "images/Mother_and_Two_Children.webp",
  },
  {
    compositionName: "Man Stooping, Leaning on a Stick",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244793",
    dateCreated: "18th-19th century",
    imageUrl: "images/Man_Stooping__Leaning_on_a_Stick.webp",
  },
  {
    compositionName: "Bust of a Man with Bushy Hair",
    author: ["David Deuchar", "After ? Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244822",
    dateCreated: "18th-19th century",
    imageUrl: "images/Bust_of_a_Man_with_Bushy_Hair.webp",
  },
  {
    compositionName: "School",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244827",
    dateCreated: "18th-19th century",
    imageUrl: "images/School.webp",
  },
  {
    compositionName: "Spinner",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244828",
    dateCreated: "18th-19th century",
    imageUrl: "images/Spinner.webp",
  },
  {
    compositionName: "Rembrandt",
    author: ["David Deuchar", "After ? Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244829",
    dateCreated: "18th-19th century",
    imageUrl: "images/Rembrandt____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Still-Life"',
    author: ["Artist of original: Vincent van Gogh"],
    tale: "X-Radiograph Description: Negative, Print\r\n\r\nBurroughs Number: 0128\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gogh, Vincent van, Dutch, 1853-1890\r\nTitle: Still-Life\r\nOwner: Through David Rosen\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343829",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Still_Life_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Wife of Admiral"',
    author: [
      "Artist of original: Ferdinand Bol",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-radiograph; Negative; Detail : Head; Detail : Left hand\r\n\r\nBurroughs Number: 169\r\n\r\nX-Radiograph(s) of: \r\nArtist: Bol, Ferdinand, Dutch, 1616-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Wife of Admiral\r\nDate: 1643\r\nDescription: Oil on canvas; 47 5/8 x 38 5/8 in. (121 x 98.1 cm), Inscriptions: Inscribed (left, on chair): Rembrandt f / 1643\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 29.100.103",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343881",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Wife_of_Admiral_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of an Admiral"',
    author: [
      "Artist of original: Ferdinand Bol",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 170\r\n\r\nX-Radiograph(s) of: \r\nArtist: Bol, Ferdinand, Dutch, 1616-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of an Admiral\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 29.100",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343882",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_an_Admiral_____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Saskia"',
    author: [
      "Artist of original: Ferdinand Bol",
      "Artist of original: And Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-radiograph; Print; Detail : Head; Detail : Hand; SIze : 11 1/2 x 15 1/2 and 9 x 7\r\n\r\nBurroughs Number: 172\r\n\r\nX-Radiograph(s) of: \r\nArtist: Bol, Ferdinand, Dutch, 1616-1680\r\nArtist: And Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Saskia \r\nDate: 1643\r\nDescription: Wood\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 812",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343884",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Saskia_____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Young Lady"',
    author: [
      "Artist of original: Ferdinand Bol",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 173\r\n\r\nX-Radiograph(s) of: \r\nArtist: Bol, Ferdinand, Dutch, 1616-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Young Lady\r\nDate: ca.1635\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 238",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343885",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Young_Lady_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Madonna and Child"',
    author: [
      "Artist of original: Hugo van der Goes",
      "Artist of original: Formerly att. to Dieric Bouts",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 254\r\n\r\nX-Radiograph(s) of: \r\nArtist: Goes, Hugo van der, Netherlandish, ca.1440-1482\r\nArtist: Formerly att. to Bouts, Dirk, Flemish, ca. 1415-1475\r\nTitle: Madonna and Child\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343964",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Madonna_and_Child_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Finding of Moses"',
    author: [
      "Artist of original: Leonaert Bramer",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 260\r\n\r\nX-Radiograph(s) of: \r\nArtist: Bramer, Leonard, Dutch, 1596-1674\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Finding of Moses\r\nDate: ca.1633\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 474",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/343970",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Finding_of_Moses_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Tower of Babel"',
    author: ["Artist of original: Hendrick van Cleve III"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 409\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Hendrick van, Flemish, ca. 1525-1589\r\nTitle: Tower of Babel\r\nOwner: Hamburg Museum\r\nObject Number: 417",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344120",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Tower_of_Babel_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Man"',
    author: ["Artist of original: Joos van Cleve"],
    tale: "X-Radiograph Description: X-radiograph; Negative; Overall\r\n\r\nBurroughs Number: 411\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Joos van, Netherlandish, ca. 1485-1541\r\nTitle: Portrait of a Man\r\nDescription: Wood (mahogany) (cradle) 17 1/8 x 11 7/8 (43.5 x 30 cm)\r\nOwner: Worcester Art Museum, MA\r\nObject Number: 1920.48",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344122",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Man_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Crucifixion"',
    author: ["Artist of original: Joos van Cleve"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : Virgin\r\n\r\nBurroughs Number: 413\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Joos van, Netherlandish, ca. 1485-1541\r\nTitle: Crucifixion\r\nDate: ca. 1525\r\nDescription: Oil on panel (cradle), 80.4 x 63.2 cm (31 5/8 x 24 7/8 in.)\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 12.170",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344124",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Crucifixion_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Cecilia"',
    author: [
      "Artist of original: Peter Paul Rubens",
      "Artist of original: Also att. to Abraham van Diepenbeeck",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head of St Cecilia; Detail : cherubs\r\n\r\nBurroughs Number: 482\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rubens, Peter Paul, Flemish, 1577-1640\r\nArtist: Also att. to Diepenbeeck, Abraham Jansz. van, Flemish, 1596-1675\r\nTitle: St. Cecilia\r\nDescription: Oil on canvas (stretcher); 47 7/8 x 40 3/4 in. (121.6 x 103.5 cm)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 29.100.14",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344193",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Cecilia_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Girl"',
    author: [
      "Artist of original: Formerly att. to Aelbert Cuyp",
      "Artist of original: Possibly Jacob Fransz. van der Merck",
      "Artist of original: Possibly Pieter van Noort",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 500\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dutch School\r\nArtist: Formerly att. to Cuyp, Aelbert, Dutch, 1620-1691\r\nArtist: Possibly Merck, Jacob Fransz. van der, Dutch, 1610-1664\r\nArtist: Possibly Noort, Pieter van, Dutch, 1602-after 1662\r\nTitle: Portrait of a Girl\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 74.10",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344211",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Girl_.webp",
  },
  {
    compositionName: "Jacob Lamenting the Death of Joseph",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245135",
    dateCreated: "18th-19th century",
    imageUrl: "images/Jacob_Lamenting_the_Death_of_Joseph.webp",
  },
  {
    compositionName: "Asking for the Doll",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245143",
    dateCreated: "18th-19th century",
    imageUrl: "images/Asking_for_the_Doll.webp",
  },
  {
    compositionName: "Bust of an Old Man with Long Beard and High Hat",
    author: ["David Deuchar", "After ? Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245145",
    dateCreated: "18th-19th century",
    imageUrl: "images/Bust_of_an_Old_Man_with_Long_Beard_and_High_Hat.webp",
  },
  {
    compositionName: "Backgammon Players",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245154",
    dateCreated: "18th-19th century",
    imageUrl: "images/Backgammon_Players.webp",
  },
  {
    compositionName: "Beggar Sitting on a Knoll",
    author: ["David Deuchar", "After Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245155",
    dateCreated: "18th-19th century",
    imageUrl: "images/Beggar_Sitting_on_a_Knoll.webp",
  },
  {
    compositionName: "Bust of a Man, Facing Front",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245158",
    dateCreated: "18th-19th century",
    imageUrl: "images/Bust_of_a_Man__Facing_Front.webp",
  },
  {
    compositionName: "Bust of a Man Wearing a Cap, Profile Right",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245161",
    dateCreated: "18th-19th century",
    imageUrl: "images/Bust_of_a_Man_Wearing_a_Cap__Profile_Right.webp",
  },
  {
    compositionName: "Charlatan",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245164",
    dateCreated: "18th-19th century",
    imageUrl: "images/Charlatan.webp",
  },
  {
    compositionName: "Smoker",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245168",
    dateCreated: "18th-19th century",
    imageUrl: "images/Smoker.webp",
  },
  {
    compositionName: "Smokers",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245170",
    dateCreated: "18th-19th century",
    imageUrl: "images/Smokers.webp",
  },
  {
    compositionName: "Two Men and a Woman in Coversation",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245173",
    dateCreated: "18th-19th century",
    imageUrl: "images/Two_Men_and_a_Woman_in_Coversation.webp",
  },
  {
    compositionName: "Rembrandt with Bushy Hair",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245174",
    dateCreated: "18th-19th century",
    imageUrl: "images/Rembrandt_with_Bushy_Hair.webp",
  },
  {
    compositionName: "Flute Player and Drummer Boy in front of a House",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245184",
    dateCreated: "18th-19th century",
    imageUrl: "images/Flute_Player_and_Drummer_Boy_in_front_of_a_House.webp",
  },
  {
    compositionName: "School (second plate)",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245186",
    dateCreated: "18th-19th century",
    imageUrl: "images/School__second_plate_.webp",
  },
  {
    compositionName: "Game of Cards (second plate)",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "This print is after A. van Ostade, with variations",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245188",
    dateCreated: "18th-19th century",
    imageUrl: "images/Game_of_Cards__second_plate_.webp",
  },
  {
    compositionName: "Boy with a Hoop in Conversation",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245210",
    dateCreated: "18th-19th century",
    imageUrl: "images/Boy_with_a_Hoop_in_Conversation.webp",
  },
  {
    compositionName: "Rat Catcher",
    author: ["David Deuchar", "After Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245215",
    dateCreated: "18th-19th century",
    imageUrl: "images/Rat_Catcher.webp",
  },
  {
    compositionName: "Fiddler and Hurdy-gurdy Boy",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245223",
    dateCreated: "18th-19th century",
    imageUrl: "images/Fiddler_and_Hurdy_gurdy_Boy.webp",
  },
  {
    compositionName: "Three Peasants in Conversation",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245236",
    dateCreated: "18th-19th century",
    imageUrl: "images/Three_Peasants_in_Conversation.webp",
  },
  {
    compositionName: "Empty Jug",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245238",
    dateCreated: "18th-19th century",
    imageUrl: "images/Empty_Jug.webp",
  },
  {
    compositionName: "Head of a Young Man with Long Hair",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245242",
    dateCreated: "18th-19th century",
    imageUrl: "images/Head_of_a_Young_Man_with_Long_Hair.webp",
  },
  {
    compositionName: "Head of Rembrandt",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245243",
    dateCreated: "18th-19th century",
    imageUrl: "images/Head_of_Rembrandt____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Mlle de Gottignes"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative; Nothing shows\r\n\r\nBurroughs Number: 624\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Mlle de Gottignes\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 21.175.407",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344334",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Mlle_de_Gottignes_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "John Milton"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 625\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nArtist: Also att. to Johnson, Cornelis, Dutch or British, active 17th century\r\nTitle: John Milton\r\nOwner: J.P. Morgan Collection, New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344335",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__John_Milton_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Samson and Dalilah"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 626\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Samson and Dalilah\r\nDate: 1618-20\r\nOwner: Chicago Art Institute, IL\r\nObject Number: 23.551",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344336",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Samson_and_Dalilah_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Man (copy)"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Detail : head\r\n\r\nBurroughs Number: 627\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Portrait of a Man (copy)\r\nDescription: Canvas\r\nOwner: Bell Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344337",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Man__copy__.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Man in Armour (Copy after Dresden Picture)"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 628\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Man in Armour (Copy after Dresden Picture)\r\nOwner: Bell Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344338",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Man_in_Armour__Copy_after_Dresden_Picture__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Sebastian"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: Print\r\n\r\nBurroughs Number: 631\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nArtist: Or Copy\r\nTitle: St. Sebastian\r\nOwner: E.F. Long Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344341",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Sebastian_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Lady Wharton"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 632\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nArtist: Also att. to Johnson, Cornelis, Dutch or British, active 17th century\r\nTitle: Lady Wharton\r\nDate: 1636\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 674",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344342",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Lady_Wharton_.webp",
  },
  {
    compositionName: "Supper at Emmaus (Detail)",
    author: ["Timothy Cole", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245416",
    dateCreated: "19th-20th century",
    imageUrl: "images/Supper_at_Emmaus__Detail_.webp",
  },
  {
    compositionName: "Fish-market",
    author: ["Timothy Cole", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245418",
    dateCreated: "19th-20th century",
    imageUrl: "images/Fish_market.webp",
  },
  {
    compositionName: "Thicket",
    author: ["Timothy Cole", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245420",
    dateCreated: "19th century",
    imageUrl: "images/Thicket.webp",
  },
  {
    compositionName: "Richardot and His Son",
    author: ["Timothy Cole", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245422",
    dateCreated: "19th-20th century",
    imageUrl: "images/Richardot_and_His_Son.webp",
  },
  {
    compositionName: "A Lady and Her Daughter",
    author: ["Timothy Cole", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245423",
    dateCreated: "19th-20th century",
    imageUrl: "images/A_Lady_and_Her_Daughter.webp",
  },
  {
    compositionName: "Paulus Potter",
    author: ["Timothy Cole", "After Bartholomeus van der Helst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245430",
    dateCreated: "19th-20th century",
    imageUrl: "images/Paulus_Potter.webp",
  },
  {
    compositionName: "Madonna of the Donors",
    author: ["Timothy Cole", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245431",
    dateCreated: "19th-20th century",
    imageUrl: "images/Madonna_of_the_Donors.webp",
  },
  {
    compositionName: "Hendrickje Stoffels",
    author: ["Timothy Cole", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245438",
    dateCreated: "19th-20th century",
    imageUrl: "images/Hendrickje_Stoffels.webp",
  },
  {
    compositionName: "Two Women by the Border of the Water",
    author: ["Adriaan van der Cabel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245459",
    dateCreated: "17th century",
    imageUrl: "images/Two_Women_by_the_Border_of_the_Water.webp",
  },
  {
    compositionName: "Man, Woman, and Child Sitting Under a Tree",
    author: ["Adriaan van der Cabel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245460",
    dateCreated: "17th century",
    imageUrl: "images/Man__Woman__and_Child_Sitting_Under_a_Tree.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Adoration of the Lamb, Just Judges, Holy Knights"',
    author: ["Artist of original: Hubert van Eyck"],
    tale: "X-Radiograph Description: Negative, 3 details\r\n\r\nBurroughs Number: 659\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Brothers van, Netherlandish\r\nTitle: Adoration of the Lamb, Just Judges, Holy Knights\r\nDate: 1432\r\nOwner: St. Bavon, Ghent\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344369",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Adoration_of_the_Lamb__Just_Judges__Holy_Knights_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Adoration of the Lamb, St. Christopher and the Pilgrims"',
    author: ["Artist of original: Hubert van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 660\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Brothers van, Netherlandish\r\nTitle: Adoration of the Lamb, St. Christopher and the Pilgrims\r\nOwner: St. Bavon, Ghent\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344370",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Adoration_of_the_Lamb__St__Christopher_and_the_Pilgrims_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Adoration of the Lamb, Central Panel - Female Martyrs"',
    author: ["Artist of original: Hubert van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 661\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Brothers van, Netherlandish\r\nTitle: Adoration of the Lamb, Central Panel - Female Martyrs\r\nOwner: St. Bavon, Ghent\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344371",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Adoration_of_the_Lamb__Central_Panel___Female_Martyrs_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Adoration of the Lamb, Bishops"',
    author: ["Artist of original: Hubert van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 662\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Brothers van, Netherlandish\r\nTitle: Adoration of the Lamb, Bishops\r\nOwner: St. Bavon, Ghent\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344372",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Adoration_of_the_Lamb__Bishops_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Madonna and Child with Chancellor Rolin"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 665\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Madonna and Child with Chancellor Rolin\r\nOwner: Louvre, Paris\r\nObject Number: 1986",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344375",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Madonna_and_Child_with_Chancellor_Rolin_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Madonna and Child with Saints and Canon van der Paele"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Negative, 4 details\r\n\r\nBurroughs Number: 666, 668\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Madonna and Child with Saints and Canon van der Paele\r\nDate: 1436\r\nOwner: Bruges Museum\r\nObject Number: 1",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344376",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Madonna_and_Child_with_Saints_and_Canon_van_der_Paele_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Virgin and Child in a Church"',
    author: [
      "Artist of original: Jan van Eyck",
      "Artist of original: Or Hubert van Eyck",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 667\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nArtist: Or Eyck, Hubert van, Netherlandish, died 1426\r\nTitle: Virgin and Child in a Church\r\nDate: early\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 525 C",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344377",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Virgin_and_Child_in_a_Church_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jean Arnolfini"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 669\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Jean Arnolfini\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 525 A",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344378",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jean_Arnolfini_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Balduyn de Lannoy"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 670\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Balduyn de Lannoy\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 525 G",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344380",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Balduyn_de_Lannoy_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Margareta van Eyck"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Overall\r\n\r\nBurroughs Number: 674\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Margareta van Eyck\r\nDate: 1439\r\nOwner: Bruges Museum\r\nObject Number: 2",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344384",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Margareta_van_Eyck_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Madonna at the Well"',
    author: [
      "Artist of original: School of Jacques Daret",
      "Artist of original: Also att. to Jan van Eyck",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 675\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Jacques Daret\r\nArtist: Also att. to Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Madonna at the Well\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 525 B",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344385",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Madonna_at_the_Well_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Christ in the Temple"',
    author: [
      "Artist of original: Gerbrand van den Eeckhout",
      "Artist of original: Also att. to Barent Fabritius",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 681\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eeckhout, Gerbrand van den, Dutch, 1621-1674\r\nArtist: Also att. to Fabritius, Barent (called Bernard Fabritius), Dutch, 1624-1673\r\nTitle: Christ in the Temple\r\nOwner: Hamburg Museum\r\nObject Number: 419",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344391",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Christ_in_the_Temple_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Girl at Half-open Door"',
    author: [
      "Artist of original: Barent Fabritius",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 682\r\n\r\nX-Radiograph(s) of: \r\nArtist: Fabritius, Barent (called Bernard Fabritius), Dutch, 1624-1673\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Girl at Half-open Door\r\nDate: 1645\r\nOwner: Chicago Art Institute, IL\r\nObject Number: 94.1022",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344392",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Girl_at_Half_open_Door_.webp",
  },
  {
    compositionName:
      "Landscape with a river crossed by a bridge with three arches",
    author: ["Jan van Almeloveen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245915",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_a_river_crossed_by_a_bridge_with_three_arches.webp",
  },
  {
    compositionName: "Holy Family with an Angel Holding a Crown of Flowers",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246000",
    dateCreated: "17th century",
    imageUrl:
      "images/Holy_Family_with_an_Angel_Holding_a_Crown_of_Flowers.webp",
  },
  {
    compositionName: "Holy Family with Angels Dancing",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246011",
    dateCreated: "17th century",
    imageUrl: "images/Holy_Family_with_Angels_Dancing.webp",
  },
  {
    compositionName: "Silenus Drunk",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246014",
    dateCreated: "17th century",
    imageUrl: "images/Silenus_Drunk.webp",
  },
  {
    compositionName: "Waterfall with Rocks",
    author: ["Christian Haldenwang", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246089",
    dateCreated: "19th century",
    imageUrl: "images/Waterfall_with_Rocks.webp",
  },
  {
    compositionName: "A Young Man",
    author: ["Johann Georg Janota", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246206",
    dateCreated: "18th century",
    imageUrl: "images/A_Young_Man.webp",
  },
  {
    compositionName: "Lievens van Coppenol",
    author: ["Pierre Filloeul", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246271",
    dateCreated: "1754",
    imageUrl: "images/Lievens_van_Coppenol.webp",
  },
  {
    compositionName: "Ben Johnson",
    author: ["Philip Audinet", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246311",
    dateCreated: "19th century",
    imageUrl: "images/Ben_Johnson.webp",
  },
  {
    compositionName: "Old Woman Cutting Her Nails",
    author: ["Johann Gottfried Haid", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246490",
    dateCreated: "18th century",
    imageUrl: "images/Old_Woman_Cutting_Her_Nails.webp",
  },
  {
    compositionName: "Otto Ludwig, Count Palatine of the Rhine",
    author: ["Jakob van der Heyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246553",
    dateCreated: "1634",
    imageUrl: "images/Otto_Ludwig__Count_Palatine_of_the_Rhine.webp",
  },
  {
    compositionName: "Woman with Child",
    author: ["Franz Hanfstaengl", "After Bartholomeus van der Helst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246554",
    dateCreated: "19th century",
    imageUrl: "images/Woman_with_Child.webp",
  },
  {
    compositionName: "Maria Ruthven",
    author: ["Tommaso Benedetti", "After ? Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246657",
    dateCreated: "19th century",
    imageUrl: "images/Maria_Ruthven.webp",
  },
  {
    compositionName: "Gustavus Adolphus of Sweden",
    author: ["Amadeus Wenzel B\u00f6hm", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246668",
    dateCreated: "19th century",
    imageUrl: "images/Gustavus_Adolphus_of_Sweden.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Monk"',
    author: ["Artist of original: Hugo van der Goes"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 919\r\n\r\nX-Radiograph(s) of: \r\nArtist: Goes, Hugo van der, Netherlandish, ca.1440-1482\r\nTitle: Portrait of a Monk\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 22.60.53",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344629",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Monk_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Village Street (illegible)"',
    author: ["Artist of original: Jan van Goyen"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 932\r\n\r\nX-Radiograph(s) of: \r\nArtist: Goyen, Jan van, Dutch, 1596-1656\r\nTitle: Village Street (illegible)\r\nOwner: Stadel Museum, Frankfort\r\nObject Number: 1236",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344642",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Village_Street__illegible__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Officiers of the Sebastian Company"',
    author: ["Artist of original: Bartholomeus van der Helst"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1003\r\n\r\nX-Radiograph(s) of: \r\nArtist: Helst, Bartholomeus van der, Dutch, 1613-1670\r\nTitle: Officiers of the Sebastian Company\r\nOwner: Rijksmuseum, Amsterdam\r\nObject Number: 1136",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344711",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Officiers_of_the_Sebastian_Company_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jean van Male"',
    author: ["Artist of original: Bartholomeus van der Helst"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1004\r\n\r\nX-Radiograph(s) of: \r\nArtist: Helst, Bartholomeus van der, Dutch, 1613-1670\r\nTitle: Jean van Male\r\nDate: 1654\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 00.171",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344712",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jean_van_Male_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Michael Heusch"',
    author: ["Artist of original: Bartholomeus van der Helst"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1005\r\n\r\nX-Radiograph(s) of: \r\nArtist: Helst, Bartholomeus van der, Dutch, 1613-1670\r\nTitle: Michael Heusch\r\nDate: 1653\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 495",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344713",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Michael_Heusch_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Burgomaster"',
    author: ["Artist of original: Bartholomeus van der Helst"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1007\r\n\r\nX-Radiograph(s) of: \r\nArtist: Helst, Bartholomeus van der, Dutch, 1613-1670\r\nTitle: Portrait of a Burgomaster\r\nDate: 1647\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 71.1.38",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344715",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Burgomaster_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Woman"',
    author: [
      "Artist of original: Ludolf de Jongh",
      "Artist of original: Also att. to School of Bartholomeus van der Helst",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1009\r\n\r\nX-Radiograph(s) of: \r\nArtist: Jongh, Ludolf de, Dutch,  1616-1679\r\nArtist: Also att. to School of Bartholomeus van der Helst\r\nTitle: Portrait of a Woman\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 103.97",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344717",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Woman_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Street Scene"',
    author: ["Artist of original: Jan van der Heyden"],
    tale: "X-Radiograph Description: X-Radiograph; Overall\r\n\r\nBurroughs Number: 1011\r\n\r\nX-Radiograph(s) of: \r\nArtist: Heyden, Jan van der, Dutch, 1637-1712\r\nTitle: Street Scene\r\nDate: 1692\r\nDescription: Wood\r\nOwner: Metropolitan Museum, New York  (Davis Collection)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344719",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Street_Scene_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Servant with Fruit and Flowers"',
    author: [
      "Artist of original: Jan Boeckhorst",
      "Artist of original: Also att. to R. van den Hoecke",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1016\r\n\r\nX-Radiograph(s) of: \r\nArtist: Boeckhorst, Jan, German, 1605-1668\r\nArtist: Also att. to van der Hoecke\r\nTitle: Servant with Fruit and Flowers\r\nOwner: Metropolitan Museum, New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344724",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Servant_with_Fruit_and_Flowers_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Descent from the Cross"',
    author: [
      "Artist of original: Gerritt Willemsz Horst",
      "Artist of original: Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-radiograph; Sent to A. Burroughs 7/28/51; Detail : body of Christ \r\n\r\nBurroughs Number: 1045\r\n\r\nX-Radiograph(s) of: \r\nArtist: Horst, Gerritt Willemsz, Dutch, ca.1612-1652\r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Descent from the Cross\r\nDate: 1650-2\r\nDescription: Oil on canvas (stretcher), 142 x 110.9 cm (55 7/8 x 43 5/8 in.)\r\nOwner: National Gallery (Widener Collection), Washington, DC \r\nObject Number: 1942.9.61",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344753",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Descent_from_the_Cross_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Rembrandt\'s Father"',
    author: [
      "Artist of original: Salomon Koninck",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1161\r\n\r\nX-Radiograph(s) of: \r\nArtist: Koninck, Salomon, Dutch, 1609-1656\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Rembrandt's Father\r\nDate: ca.1629\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 03.1080",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344870",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Rembrandt_s_Father_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Paul"',
    author: [
      "Artist of original: Salomon Koninck",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1162\r\n\r\nX-Radiograph(s) of: \r\nArtist: Koninck, Salomon, Dutch, 1609-1656\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: St. Paul\r\nDate: ca.1630\r\nOwner: Kunsthistorisches Museum, Vienna\r\nObject Number: 1270",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344871",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Paul_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Old Woman Reading"',
    author: [
      "Artist of original: Jacobus Levecq",
      "Artist of original: Also att. to Nicolaes Maes",
      "Artist of original: Also att. to Karel van der Pluym",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1183\r\n\r\nX-Radiograph(s) of: \r\nArtist: Levecq, Jacobus, Dutch, 1634-1675\r\nArtist: Also att. to Maes, Nicolaes, Dutch, 1634-1693\r\nArtist: Also att. to Pluym, Karel van der, Dutch, 1625-1672\r\nTitle: Old Woman Reading\r\nDescription: (under J. Lievens)\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 487",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344892",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Old_Woman_Reading_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Samson Berating His Father-in-Law"',
    author: [
      "Artist of original: Jan Lievens",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1191\r\n\r\nX-Radiograph(s) of: \r\nArtist: Lievensz, Jan, Dutch, 1607-1674\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Samson Berating His Father-in-Law\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 802",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344900",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Samson_Berating_His_Father_in_Law_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Old Man"',
    author: [
      "Artist of original: Jan Lievens",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-radiograph; Negative; Detail : head\r\n\r\nBurroughs Number: 1195\r\n\r\nX-Radiograph(s) of: \r\nArtist: Lievensz, Jan, Dutch, 1607-1674\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Old Man\r\nDate: 1632\r\nDescription: Oil on oak panel (cradle) ; 66.9 cm. x 50.7 cm., actual\r\nOwner: Harvard University Art Museums\r\nObject Number: 1930.191",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344904",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Old_Man_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of Rembrandt"',
    author: [
      "Artist of original: Gerhard Dou",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1200\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dou, Gerrit, Dutch, 1613-1675\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of Rembrandt\r\nDate: 1629\r\nOwner: Isabella Stewart Gardner Museum, Boston, MA\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344909",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_Rembrandt_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Head of a Turk"',
    author: ["Artist of original: Imitation from Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1201\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (Imitation from), Dutch, 1606-1669\r\nTitle: Head of a Turk\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 473",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344910",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Head_of_a_Turk_.webp",
  },
  {
    compositionName: "Storm",
    author: ["J. L. L. C. Zentner", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247412",
    dateCreated: "1791",
    imageUrl: "images/Storm.webp",
  },
  {
    compositionName: "Herdsman with Cattle",
    author: ["J. L. L. C. Zentner", "After Salomon van Ruysdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247413",
    dateCreated: "1791",
    imageUrl: "images/Herdsman_with_Cattle.webp",
  },
  {
    compositionName: "Saints Bartholomew, Thomas, John Baptist",
    author: [
      "Johann Nepomuk Strixner",
      "After Israhel van Meckenem the younger",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247418",
    dateCreated: "19th century",
    imageUrl: "images/Saints_Bartholomew__Thomas__John_Baptist.webp",
  },
  {
    compositionName: "Herdsman Tending Cattle",
    author: ["J. L. L. C. Zentner", "After Pieter van Asch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247420",
    dateCreated: "1791",
    imageUrl: "images/Herdsman_Tending_Cattle.webp",
  },
  {
    compositionName: "Cottage on a Hill",
    author: ["J. L. L. C. Zentner", "After Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247431",
    dateCreated: "1791",
    imageUrl: "images/Cottage_on_a_Hill.webp",
  },
  {
    compositionName: "Moonlight on a River",
    author: ["J. L. L. C. Zentner", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247433",
    dateCreated: "1792",
    imageUrl: "images/Moonlight_on_a_River.webp",
  },
  {
    compositionName: "Peasants before the Door of a House",
    author: ["J. L. L. C. Zentner", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247434",
    dateCreated: "1795",
    imageUrl: "images/Peasants_before_the_Door_of_a_House.webp",
  },
  {
    compositionName: "Two Women Carrying Pails to the River",
    author: ["J. L. L. C. Zentner", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247435",
    dateCreated: "1791",
    imageUrl: "images/Two_Women_Carrying_Pails_to_the_River.webp",
  },
  {
    compositionName: "Sir Sheffield",
    author: ["Johann Conrad Ulmer", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247503",
    dateCreated: "19th century",
    imageUrl: "images/Sir_Sheffield.webp",
  },
  {
    compositionName: "Flemish Occupation",
    author: ["Paul Wolfgang Schwarz", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247558",
    dateCreated: "19th century",
    imageUrl: "images/Flemish_Occupation.webp",
  },
  {
    compositionName: "Bust of a Man, Profile, Wearing a Turban",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247580",
    dateCreated: "18th century",
    imageUrl: "images/Bust_of_a_Man__Profile__Wearing_a_Turban.webp",
  },
  {
    compositionName: "Lot with His Daughters",
    author: ["Johann Gotthard von M\u00fcller", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247678",
    dateCreated: "18th century",
    imageUrl: "images/Lot_with_His_Daughters.webp",
  },
  {
    compositionName: "Mary with the Child",
    author: ["Anton Heinrich Riedel", "After ? Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247800",
    dateCreated: "18th century",
    imageUrl: "images/Mary_with_the_Child.webp",
  },
  {
    compositionName: "Bittern Held by the Feet",
    author: ["Johann Anton Riedel", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247801",
    dateCreated: "1754",
    imageUrl: "images/Bittern_Held_by_the_Feet.webp",
  },
  {
    compositionName: "Peasant Seated",
    author: ["Otto Christian Sahler", "After Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247808",
    dateCreated: "18th century",
    imageUrl: "images/Peasant_Seated.webp",
  },
  {
    compositionName: "The Solitude of the Forest",
    author: ["Carl August Richter", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247885",
    dateCreated: "19th century",
    imageUrl: "images/The_Solitude_of_the_Forest.webp",
  },
  {
    compositionName: "Willem Burggraeff",
    author: ["Johann Anton Riedel", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247910",
    dateCreated: "1754",
    imageUrl: "images/Willem_Burggraeff.webp",
  },
  {
    compositionName: "A Woman Weighing Money",
    author: ["Johann Anton Riedel", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247939",
    dateCreated: "1754",
    imageUrl: "images/A_Woman_Weighing_Money.webp",
  },
  {
    compositionName: "An Old Man",
    author: ["Johann Anton Riedel", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247997",
    dateCreated: "1764",
    imageUrl: "images/An_Old_Man.webp",
  },
  {
    compositionName: "An Old Woman",
    author: ["Johann Anton Riedel", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247998",
    dateCreated: "1755",
    imageUrl: "images/An_Old_Woman.webp",
  },
  {
    compositionName: "Union of Autumn and Winter",
    author: ["Jan van Munnickhuysen", "After G\u00e9rard de Lairesse"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248031",
    dateCreated: "17th-18th century",
    imageUrl: "images/Union_of_Autumn_and_Winter.webp",
  },
  {
    compositionName: "Hiram, King of Tyre, sends presents to King Solomon",
    author: ["John Murphy", "After Gerbrand van den Eeckhout"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248033",
    dateCreated: "18th century",
    imageUrl: "images/Hiram__King_of_Tyre__sends_presents_to_King_Solomon.webp",
  },
  {
    compositionName: "Apollo Standing on the Clouds",
    author: ["Jacob Matham", "After Cornelis Cornelisz. van Haarlem"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248043",
    dateCreated: "16th-17th century",
    imageUrl: "images/Apollo_Standing_on_the_Clouds.webp",
  },
  {
    compositionName: "Franciscus Burmann",
    author: ["Jan van Munnickhuysen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248110",
    dateCreated: "17th century",
    imageUrl: "images/Franciscus_Burmann.webp",
  },
  {
    compositionName: "Adoration of the Shepherds, with Six Prophets",
    author: ["Jacob Matham", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248118",
    dateCreated: "1588",
    imageUrl: "images/Adoration_of_the_Shepherds__with_Six_Prophets.webp",
  },
  {
    compositionName: "Continence of Scipio",
    author: ["Johann Sebastian M\u00fcller", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248153",
    dateCreated: "18th century",
    imageUrl: "images/Continence_of_Scipio.webp",
  },
  {
    compositionName: "Man of Letters",
    author: ["Albert Heinrich Payne", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248250",
    dateCreated: "19th century",
    imageUrl: "images/Man_of_Letters.webp",
  },
  {
    compositionName: "Sts. Simon and Paul",
    author: [
      "Johann Gottlieb Prestel",
      "After Israhel van Meckenem the younger",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248268",
    dateCreated: "18th-19th century",
    imageUrl: "images/Sts__Simon_and_Paul.webp",
  },
  {
    compositionName: "Sts. Bartholomew and John the Evangelist",
    author: [
      "Johann Gottlieb Prestel",
      "After Israhel van Meckenem the younger",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248269",
    dateCreated: "18th-19th century",
    imageUrl: "images/Sts__Bartholomew_and_John_the_Evangelist.webp",
  },
  {
    compositionName: "Saint Nicholas of Myra",
    author: ["Heinrich N\u00fcsser", "After Johann van Schraudolph"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248281",
    dateCreated: "19th century",
    imageUrl: "images/Saint_Nicholas_of_Myra.webp",
  },
  {
    compositionName: "The little bird-catcher",
    author: ["Pieter Willem van Megen", "After Pierre-Alexandre Wille"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248328",
    dateCreated: "18th century",
    imageUrl: "images/The_little_bird_catcher.webp",
  },
  {
    compositionName: "Achilles de Harlay",
    author: ["Theodor van Merlen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248340",
    dateCreated: "1652",
    imageUrl: "images/Achilles_de_Harlay.webp",
  },
  {
    compositionName: "Parable of the Talents",
    author: ["Harmen Jansz. M\u00fcller", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248493",
    dateCreated: "16th century",
    imageUrl: "images/Parable_of_the_Talents.webp",
  },
  {
    compositionName: "Blind Fortune Distributing Gifts",
    author: ["Jan Harmensz. Muller", "After Cornelis Cornelisz. van Haarlem"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248511",
    dateCreated: "16th-17th century",
    imageUrl: "images/Blind_Fortune_Distributing_Gifts.webp",
  },
  {
    compositionName: "F\u00eate under the Great Tree",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248566",
    dateCreated: "c. 1660",
    imageUrl: "images/Fete_under_the_Great_Tree.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Saskia"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative (2 details)\r\n\r\nBurroughs Number: 1643\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Saskia\r\nDate: 1634\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 236",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345348",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Saskia_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Self-Portrait in Plumed Hat"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1647\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Self-Portrait in Plumed Hat\r\nDate: 1650\r\nOwner: Fitzwilliam Museum, Cambridge, England\r\nObject Number: 152",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345352",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Self_Portrait_in_Plumed_Hat_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Self-Portrait in Helmet"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1648\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Self-Portrait in Helmet\r\nDate: 1634\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 237",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345353",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Self_Portrait_in_Helmet_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Hendrijke at the Window"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1649\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Hendrijke at the Window\r\nDate: 1658-9\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 828b",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345354",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Hendrijke_at_the_Window_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Noble Slave"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1652\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of a Noble Slave\r\nDate: 1632\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 20.155.2",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345357",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Noble_Slave_.webp",
  },
  {
    compositionName: "Shepherd Separating Sheep from Goats",
    author: ["Pieter Nagel", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248607",
    dateCreated: "c. 1571",
    imageUrl: "images/Shepherd_Separating_Sheep_from_Goats.webp",
  },
  {
    compositionName: "Philosopher in Deep Study",
    author: ["S. Paul", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248613",
    dateCreated: "18th century",
    imageUrl: "images/Philosopher_in_Deep_Study.webp",
  },
  {
    compositionName: "Vertumnus and Pomona",
    author: ["Richard van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248635",
    dateCreated: "17th century",
    imageUrl: "images/Vertumnus_and_Pomona.webp",
  },
  {
    compositionName: "Hunting the Calydonian Boar",
    author: ["Richard van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248636",
    dateCreated: "17th century",
    imageUrl: "images/Hunting_the_Calydonian_Boar.webp",
  },
  {
    compositionName: "Last Supper",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248654",
    dateCreated: "1521",
    imageUrl: "images/Last_Supper.webp",
  },
  {
    compositionName: "Betrayal of Christ",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248655",
    dateCreated: "1521",
    imageUrl: "images/Betrayal_of_Christ.webp",
  },
  {
    compositionName: "Silenus Drunken",
    author: ["Richard van Orley", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248683",
    dateCreated: "17th century",
    imageUrl: "images/Silenus_Drunken.webp",
  },
  {
    compositionName: "Christ Raising Jarius's Daughter",
    author: ["Richard van Orley", "After Jan van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248684",
    dateCreated: "17th century",
    imageUrl: "images/Christ_Raising_Jarius_s_Daughter.webp",
  },
  {
    compositionName: "Christ Healing the Infirm Man",
    author: ["Richard van Orley", "After Jan van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248685",
    dateCreated: "17th century",
    imageUrl: "images/Christ_Healing_the_Infirm_Man.webp",
  },
  {
    compositionName: "Christ in Limbo",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248715",
    dateCreated: "1521",
    imageUrl: "images/Christ_in_Limbo.webp",
  },
  {
    compositionName: "Resurrection",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248716",
    dateCreated: "1521",
    imageUrl: "images/Resurrection.webp",
  },
  {
    compositionName: "Canal Scene Near Haarlem",
    author: ["Thomas Major", "After Aert van der Neer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248721",
    dateCreated: "18th century",
    imageUrl: "images/Canal_Scene_Near_Haarlem.webp",
  },
  {
    compositionName: "Rembrandt's mother",
    author: ["James McArdell", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248738",
    dateCreated: "18th century",
    imageUrl: "images/Rembrandt_s_mother.webp",
  },
  {
    compositionName: "Tempest",
    author: ["Christopher Norton", "After Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248789",
    dateCreated: "1760",
    imageUrl: "images/Tempest.webp",
  },
  {
    compositionName: "Andrew",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248801",
    dateCreated: "16th century",
    imageUrl: "images/Andrew.webp",
  },
  {
    compositionName: "Matthew",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248802",
    dateCreated: "16th century",
    imageUrl: "images/Matthew.webp",
  },
  {
    compositionName: "Dr. [William] Harvey",
    author: ["James McArdell", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248804",
    dateCreated: "18th century",
    imageUrl: "images/Dr___William__Harvey.webp",
  },
  {
    compositionName: "Tribute money",
    author: ["James McArdell", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248805",
    dateCreated: "18th century",
    imageUrl: "images/Tribute_money.webp",
  },
  {
    compositionName: "Tobias Tucher",
    author: ["Mathys van Somer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248859",
    dateCreated: "17th century",
    imageUrl: "images/Tobias_Tucher.webp",
  },
  {
    compositionName: "Return from Egypt",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248871",
    dateCreated: "17th century",
    imageUrl: "images/Return_from_Egypt.webp",
  },
  {
    compositionName: "Dumb Beggar",
    author: ["William James Smith", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248873",
    dateCreated: "19th century",
    imageUrl: "images/Dumb_Beggar.webp",
  },
  {
    compositionName: "Onion Woman",
    author: ["William James Smith", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248874",
    dateCreated: "19th century",
    imageUrl: "images/Onion_Woman.webp",
  },
  {
    compositionName: "A Flemish Collation",
    author: ["After Willem van Herp", "After Isaac Taylor the elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248878",
    dateCreated: "1765",
    imageUrl: "images/A_Flemish_Collation.webp",
  },
  {
    compositionName: "Baldassare Castiglione",
    author: ["Reinier van Persyn", "After Raphael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248882",
    dateCreated: "17th century",
    imageUrl: "images/Baldassare_Castiglione.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "In the Studio"',
    author: ["Artist of original: Copy after Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1693\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (copy after ?), Dutch, 1606-1669\r\nTitle: In the Studio\r\nOwner: Formerly N.E. Montross Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345398",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__In_the_Studio_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "An Old Man"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1694\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: An Old Man\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 2060",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345399",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__An_Old_Man_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Suzanna"',
    author: ["Artist of original: School of Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1695\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Rembrandt\r\nTitle: Suzanna\r\nOwner: Van Hengel, Arnheim\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345400",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Suzanna_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Titus"',
    author: ["Artist of original: Copy after Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1696\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (copy after), Dutch, 1606-1669\r\nTitle: Titus\r\nOwner: Van Hengel, Arnheim\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345401",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Titus_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Flora"',
    author: [
      "Artist of original: Willem Drost",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1697\r\n\r\nX-Radiograph(s) of: \r\nArtist: Drost, Willem, Dutch, 1630-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Flora\r\nDate: 1650-60\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 26.101.10",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345402",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Flora_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jacob\'s Blessing"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1698\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Jacob's Blessing\r\nDate: 1656\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 249",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345403",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jacob_s_Blessing_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man in Armour"',
    author: [
      "Artist of original: Willem Drost",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1699\r\n\r\nX-Radiograph(s) of: \r\nArtist: Drost, Willem, Dutch, 1630-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man in Armour\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 245",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345404",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_in_Armour_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "An Architect"',
    author: [
      "Artist of original: Abraham van Dyck",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1700\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Abraham van, Dutch, ca.1635-1672\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: An Architect\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 246",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345405",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__An_Architect_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "A Sibyl"',
    author: [
      "Artist of original: Willem Drost",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : left shoulder\r\n\r\nBurroughs Number: 1701\r\n\r\nX-Radiograph(s) of: \r\nArtist: Drost, Willem, Dutch, 1630-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: A Sibyl\r\nDate: ca. 1656\r\nDescription: Oil on canvas; 38 1/2 x 30 3/4 in. (97.8 x 78.1 cm)\r\nOwner: Metropolitan Museum, New York  (Davis Collection)\r\nObject Number: 30.95.268",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345406",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__A_Sibyl_.webp",
  },
  {
    compositionName: "Procris and Cephalus",
    author: ["Richard van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249057",
    dateCreated: "17th century",
    imageUrl: "images/Procris_and_Cephalus.webp",
  },
  {
    compositionName: "Sacrifice to Diana",
    author: ["Richard van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249058",
    dateCreated: "17th century",
    imageUrl: "images/Sacrifice_to_Diana.webp",
  },
  {
    compositionName: "Gustav Willem Imhoff",
    author: ["Pieter Tanj\u00e9", "After Philip van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249065",
    dateCreated: "18th century",
    imageUrl: "images/Gustav_Willem_Imhoff.webp",
  },
  {
    compositionName: "Spinner at the Door of the House",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249077",
    dateCreated: "c. 1684",
    imageUrl: "images/Spinner_at_the_Door_of_the_House.webp",
  },
  {
    compositionName: "Humpbacked Fiddler",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249078",
    dateCreated: "1654",
    imageUrl: "images/Humpbacked_Fiddler.webp",
  },
  {
    compositionName: "Fiddler and Hurdy-Gurdy Boy",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249079",
    dateCreated: "17th century",
    imageUrl: "images/Fiddler_and_Hurdy_Gurdy_Boy.webp",
  },
  {
    compositionName: "F\u00eate under the Trellis",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249080",
    dateCreated: "17th century",
    imageUrl: "images/Fete_under_the_Trellis.webp",
  },
  {
    compositionName: "Frans Decker",
    author: ["Cornelis van Noorde", "After Tako Hajo Jelgersma"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249088",
    dateCreated: "1756",
    imageUrl: "images/Frans_Decker.webp",
  },
  {
    compositionName: "Lady and Child",
    author: ["Edward Smith", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249197",
    dateCreated: "19th century",
    imageUrl: "images/Lady_and_Child.webp",
  },
  {
    compositionName: "Theodor Corenhert",
    author: ["Frans van der Steen", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249233",
    dateCreated: "17th century",
    imageUrl: "images/Theodor_Corenhert.webp",
  },
  {
    compositionName: "Pepin,Duke of Brabant, with His Daughter, Ste. Begghe",
    author: ["Frans van der Steen", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249243",
    dateCreated: "17th century",
    imageUrl:
      "images/Pepin_Duke_of_Brabant__with_His_Daughter__Ste__Begghe.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Seascape"',
    author: ["Artist of original: Willem van de Velde II"],
    tale: "X-Radiograph Description: X-Radiograph; Overall\r\n\r\nBurroughs Number: 1999\r\n\r\nX-Radiograph(s) of: \r\nArtist: Velde, Willem van de, II, Dutch, 1633-1707\r\nTitle: Seascape\r\nDescription: Wood\r\nOwner: F.M. Sedgwick Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345696",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Seascape_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Marine Battle"',
    author: ["Artist of original: Adriaen van de Velde"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2000\r\n\r\nX-Radiograph(s) of: \r\nArtist: Velde, Adriaen van de, Dutch, 1636-1672\r\nTitle: Marine Battle\r\nDescription: Oil on Canvas\r\nOwner: Warren Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345697",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Marine_Battle_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with Extended Hand"',
    author: [
      "Artist of original: Jan Victors",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: 2 Negatives\r\n\r\nBurroughs Number: 2030\r\n\r\nX-Radiograph(s) of: \r\nArtist: Victors, Jan, Dutch, 1619-after 1676\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man with Extended Hand\r\nDate: 1664 ?\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 14.40.60",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345727",
    dateCreated: "January 16, 1964",
    imageUrl: "images/X_radiograph_s__of__Man_with_Extended_Hand_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Head of Christ"',
    author: [
      "Artist of original: Jan Victors",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 2031\r\n\r\nX-Radiograph(s) of: \r\nArtist: Victors, Jan, Dutch, 1619-after 1676\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Head of Christ\r\nDate: ca.1659\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 17.120.222",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345728",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Head_of_Christ_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jacob and Family"',
    author: [
      "Artist of original: Jan Victors",
      "Artist of original: Also att. to School of Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative, X-Radiograph\r\n\r\nBurroughs Number: 2032\r\n\r\nX-Radiograph(s) of: \r\nArtist: Victors, Jan, Dutch, 1619-after 1676\r\nArtist: Also att. to School of Rembrandt\r\nTitle: Jacob and Family\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 253a",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345729",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jacob_and_Family_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Unknown Man Standing"',
    author: [
      "Artist of original: Gerritt Willemsz Horst",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 2033\r\n\r\nX-Radiograph(s) of: \r\nArtist: Horst, Gerritt Willemsz, Dutch, ca.1612-1652\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Unknown Man Standing\r\nDate: 1639\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 239",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345730",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Unknown_Man_Standing_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Lady"',
    author: [
      "Artist of original: Anthony van Dyck",
      "Artist of original: Also att. to Cornelis Vos",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 2050\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nArtist: Also att. to Vos, Cornelis de, Flemish, ca. 1584-1651\r\nTitle: Portrait of a Lady\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 671",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345747",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Lady_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Anna Maria de Schodt"',
    author: [
      "Artist of original: Anthony van Dyck",
      "Artist of original: Also att. to Jacques Jordaens",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Details : head and hands\r\n\r\nBurroughs Number: 2053\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nArtist: Also att. to Jordaens, Jacob, Flemish, 1593-1678\r\nTitle: Anna Maria de Schodt\r\nDate: ca. 1620\r\nDescription: Oil on canvas ; 182.9 x 119.7 cm (72 x 47 1/8 in.)\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 03.25",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345750",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Anna_Maria_de_Schodt_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Christ and His Mother"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2061\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Christ and His Mother\r\nDate: earliest\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 20.60.58",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345758",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Christ_and_His_Mother_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Madonna and Child with Saints (Medici Madonna)"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2062\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Madonna and Child with Saints (Medici Madonna)\r\nDate: 1450\r\nOwner: Stadel Museum, Frankfort\r\nObject Number: 850",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345759",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Madonna_and_Child_with_Saints__Medici_Madonna__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. John\'s Altar"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2064\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: St. John's Altar\r\nDate: early\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 534b",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345761",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__John_s_Altar_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. John\'s Altar (copy)"',
    author: ["Artist of original: After Rogier van der Weyden"],
    tale: "Burroughs Number: 2065\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der (after), Flemish, ca. 1399-1464\r\nTitle: St. John's Altar (copy)\r\nOwner: Stadel Museum, Frankfort\r\nObject Number: 878",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345762",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__John_s_Altar__copy__.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Madonna and Child (left half of diptych) (see Gerard David for right half with David, Bishop and Donors)"',
    author: ["Artist of original: Follower of Rogier van der Weyden"],
    tale: 'unframed, 4-ply mat, reuse existing hingesX-Radiograph Description: X-radiograph; Tracing-Mylar overlay of a Madonna and Child by the Master of St Ursula Legend in the Met, NY, which is close to 1906.6A; Portion of Picture covered: ca.75%; \r\n\r\nX-Radiograph Settings: #1 : 22 kv, 3 ma, 2 min., 41"; #2 : Traverse focus, 22 kv, 3 ma, 2 min., 41"; #4 : Traverse focus, 20 degrees to plane of rotation, 22 kv, 6 ma, 3 min., 41"; #5 : Traverse focus, 70 degrees to plane of rotation, 22 kv, 6 ma, 3 min., 41"; \r\n\r\nBurroughs Number: 2068\r\n\r\nX-Radiograph(s) of: \r\nArtist: Follower of Rogier van der Weyden\r\nTitle: Madonna and Child (left half of diptych) (see Gerard David for right half with David, Bishop and Donors)\r\nDate: ca.1480\r\nDescription: Oil (and tempera?) on panel; 55.5 cm. x 35.7 cm., actual\r\nOwner: Harvard University Art Museums\r\nObject Number: 1906.6.A',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345765",
    dateCreated: "between June 3, 1945 and May 16, 1947",
    imageUrl:
      "images/X_radiograph_s__of__Madonna_and_Child__left_half_of_diptych___see_Gerard_David_for_right_half_with_David__Bishop_and_Donors__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Sacraments Altar"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2071\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Sacraments Altar\r\nOwner: Royal Museum of Fine Arts, Antwerp\r\nObject Number: 393-5",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345768",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Sacraments_Altar_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Pieta"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2072\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Pieta\r\nOwner: Royal Museum of Fine Arts, Brussels, Belgium\r\nObject Number: 516",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345769",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Pieta_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with Arrow"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2073\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Man with Arrow\r\nDate: 1455-60\r\nOwner: Royal Museum of Fine Arts, Brussels, Belgium\r\nObject Number: 190",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345770",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_with_Arrow_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Laurent Froiment"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2074\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Laurent Froiment\r\nOwner: Royal Museum of Fine Arts, Brussels, Belgium\r\nObject Number: 922",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345771",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Laurent_Froiment_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Two Saints"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2076\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nArtist: Or Master of the Exhumation of Saint Hubert , Netherlandish, active 15th century\r\nTitle: Two Saints\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 534c",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345773",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Two_Saints_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Philippe de Croy"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 2078\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Philippe de Croy\r\nDate: 1459-60\r\nOwner: Royal Museum of Fine Arts, Antwerp\r\nObject Number: 254",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345775",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Philippe_de_Croy_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Annunciation"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "X-Radiograph Description: Detail : Head of angel; Head of Virgin; \r\n\r\nBurroughs Number: 2079\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Annunciation\r\nDate: 1465-75\r\nDescription: Oil on wood (cradle); 73 1/4 x 45 1/4 in. (186.1 x 114.9 cm)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 17.190.7",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345776",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Annunciation_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Luke Painting the Virgin"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "X-Radiograph Description: X-radiograph; Detail : Virgin and Child; Head of St Luke\r\n\r\nBurroughs Number: 2080\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: St. Luke Painting the Virgin\r\nDate: about 1435?40\r\nDescription: Oil and tempera on panel (cradle) ; 137.5 x 110.8 cm (54 1/8 x 43 5/8 in.)\r\nOwner: Boston Museum of Fine Arts, MA\r\nObject Number: 93.153",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345777",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Luke_Painting_the_Virgin_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Deposition (copy)"',
    author: ["Artist of original: After Rogier van der Weyden"],
    tale: "Burroughs Number: 2081\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der (after), Flemish, ca. 1399-1464\r\nTitle: Deposition (copy)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 17.187",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345778",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Deposition__copy__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Rembrandt\'s Mother"',
    author: [
      "Artist of original: Govert Flinck",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative, Print\r\n\r\nBurroughs Number: 2112\r\n\r\nX-Radiograph(s) of: \r\nArtist: Flinck, Govaert, Dutch, 1615-1660\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Rembrandt's Mother\r\nDate: 1639\r\nOwner: Kunsthistorisches Museum, Vienna\r\nObject Number: 1273",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345810",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Rembrandt_s_Mother_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Eleazer Swalmius"',
    author: [
      "Artist of original: Govert Flinck",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 2116\r\n\r\nX-Radiograph(s) of: \r\nArtist: Flinck, Govaert, Dutch, 1615-1660\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Eleazer Swalmius\r\nOwner: Royal Museum of Fine Arts, Antwerp\r\nObject Number: 705 ",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345814",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Eleazer_Swalmius_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Susanna"',
    author: [
      "Artist of original: Govert Flinck",
      "Artist of original: Also att. to Follower of Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 2118\r\n\r\nX-Radiograph(s) of: \r\nArtist: Flinck, Govaert, Dutch, 1615-1660\r\nArtist: Also att. to Follower of Rembrandt van Rijn\r\nTitle: Susanna\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 183 B",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345816",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Susanna_.webp",
  },
  {
    compositionName: "Old Beggar Woman with a Gourd",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249477",
    dateCreated: "17th century",
    imageUrl: "images/Old_Beggar_Woman_with_a_Gourd.webp",
  },
  {
    compositionName: "Cottage beside a Canal with a View of Ouderkerk",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249478",
    dateCreated: "c. 1641-1643",
    imageUrl: "images/Cottage_beside_a_Canal_with_a_View_of_Ouderkerk.webp",
  },
  {
    compositionName: "Young Sportsman",
    author: ["Pieter Jan van Reysschoot", "After David Teniers II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249485",
    dateCreated: "18th century",
    imageUrl: "images/Young_Sportsman.webp",
  },
  {
    compositionName: "Jews in a Synagogue",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249490",
    dateCreated: "1648",
    imageUrl: "images/Jews_in_a_Synagogue.webp",
  },
  {
    compositionName: "Jan Uytenbogaert, Preacher of the Remanstrants",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249491",
    dateCreated: "1635",
    imageUrl: "images/Jan_Uytenbogaert__Preacher_of_the_Remanstrants.webp",
  },
  {
    compositionName: "Rembrandt's Mother in Widow's Dress",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249500",
    dateCreated: "17th century",
    imageUrl: "images/Rembrandt_s_Mother_in_Widow_s_Dress.webp",
  },
  {
    compositionName: "Rembrandt's Mother with her Hand on her Breast",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249501",
    dateCreated: "19th century",
    imageUrl: "images/Rembrandt_s_Mother_with_her_Hand_on_her_Breast.webp",
  },
  {
    compositionName: "The Artist's Son, Titus",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249533",
    dateCreated: "17th century",
    imageUrl: "images/The_Artist_s_Son__Titus.webp",
  },
  {
    compositionName: "Rembrandt Leaning on a Stone Sill",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249567",
    dateCreated: "17th century",
    imageUrl: "images/Rembrandt_Leaning_on_a_Stone_Sill.webp",
  },
  {
    compositionName: "Self-portrait in a Flat Cap and Embroidered Dress",
    author: ["After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249568",
    dateCreated: "c. 1642",
    imageUrl: "images/Self_portrait_in_a_Flat_Cap_and_Embroidered_Dress.webp",
  },
  {
    compositionName: "The Presentation in the Temple: Oblong Print",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249569",
    dateCreated: "c, 1639",
    imageUrl: "images/The_Presentation_in_the_Temple__Oblong_Print.webp",
  },
  {
    compositionName: "Saint Jerome Praying: Arched",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249576",
    dateCreated: "1635",
    imageUrl: "images/Saint_Jerome_Praying__Arched.webp",
  },
  {
    compositionName: 'Pieter Haaringh ("Young Haaringh")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249581",
    dateCreated: "1655",
    imageUrl: "images/Pieter_Haaringh___Young_Haaringh__.webp",
  },
  {
    compositionName: "Esther Before Ahasuerus",
    author: ["Christoffel van Sichem I", "After Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249600",
    dateCreated: "16th century",
    imageUrl: "images/Esther_Before_Ahasuerus.webp",
  },
  {
    compositionName: "View of Amsterdam",
    author: ["Charles Walker", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249625",
    dateCreated: "19th century",
    imageUrl: "images/View_of_Amsterdam.webp",
  },
  {
    compositionName: "Thomas Howard, Earl of Arundel",
    author: ["William Sharp", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249649",
    dateCreated: "18th century",
    imageUrl: "images/Thomas_Howard__Earl_of_Arundel.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Family Group"',
    author: [
      "Artist of original: Maarten van Heemskerck",
      "Artist of original: Also att. to Jan van Scorel",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : heads\r\n\r\nBurroughs Number: 2310\r\n\r\nX-Radiograph(s) of: \r\nArtist: Heemskerck, Maerten van, Dutch, 1498-1574\r\nArtist: Also att. to van Scorel, Jan, Flemish, 1495-1562\r\nTitle: Family Group\r\nDescription: Wood (cradle)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 33",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346007",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Family_Group_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "House and Garden"',
    author: [
      "Artist of original: Pieter de Hooch",
      "Artist of original: Also att. to Jan van Kessel",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : figures at left\r\n\r\nBurroughs Number: 2324\r\n\r\nX-Radiograph(s) of: \r\nArtist: Hooch, Pieter de, Dutch, 1629-1684\r\nArtist: Also att. to Kessel, Jan van \r\nTitle: House and Garden\r\nDescription: Wood (cradle)\r\nOwner: Brooklyn Museum (Friedsam Collection), New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346022",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__House_and_Garden_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Mattheus van der Broucke"',
    author: ["Artist of original: Samuel van Hoogstraten"],
    tale: "X-Radiograph Description: X-Radiograph; Number : 2 (duplicates) Detail : head (text on verso visible)\r\n\r\nBurroughs Number: 2325\r\n\r\nX-Radiograph(s) of: \r\nArtist: Hoogstraten, Samuel van, Dutch, 1627-1678\r\nTitle: Mattheus van der Broucke\r\nDate: 1676\r\nDescription: Canvas (stretcher), 88,5 x 70,5 cm\r\nOwner: Dordrechts Museum (formerly Rijksmuseum 1255)\r\nObject Number: 83",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346023",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Mattheus_van_der_Broucke_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St Francis"',
    author: [
      "Artist of original: Peter Paul Rubens",
      "Artist of original: And Theodor van Thulden",
    ],
    tale: "X-Radiograph Description: X-Radiograph; detail of head\r\n\r\nBurroughs Number: 2334\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rubens, Peter Paul, Flemish, 1577-1640\r\nArtist: And Thulden, Theodor van, Flemish, 1606-1669\r\nTitle: St Francis\r\nDescription: Canvas\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 93A",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346032",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St_Francis_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Diana and Nymphs"',
    author: ["Artist of original: Jacob van Loo"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : Diana\r\n\r\nBurroughs Number: 2357\r\n\r\nX-Radiograph(s) of: \r\nArtist: Loo, Jacob van, Dutch, 1614-1670\r\nTitle: Diana and Nymphs\r\nDate: 1648\r\nDescription: Canvas\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 765a",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346055",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Diana_and_Nymphs_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jan Hermanz Krul"',
    author: [
      "Artist of original: Jacob Adriaensz. Backer",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2424\r\n\r\nX-Radiograph(s) of: \r\nArtist: Backer, Jacob Adriaensz, Dutch, 1608-1651\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Jan Hermanz Krul\r\nDate: 1633\r\nDescription: Canvas (stetcher)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 235",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346122",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jan_Hermanz_Krul_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Study Head"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2426\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Study Head\r\nDate: 1632\r\nDescription: Wood\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 232",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346124",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Study_Head_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of Rembrandt"',
    author: [
      "Artist of original: Thomas de Keyser",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2427\r\n\r\nX-Radiograph(s) of: \r\nArtist: Keyser, Thomas de, Dutch, 1596/7-1667\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of Rembrandt \r\nDescription: (under Rembrandt ca. 1627-8)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 229",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346125",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_Rembrandt_____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Winter Landscape"',
    author: [
      "Artist of original: Esaias van de Velde",
      "Artist of original: Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2428\r\n\r\nX-Radiograph(s) of: \r\nArtist: Velde, Esaias van de, I, Dutch, 1587-1630\r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Winter Landscape\r\nDate: 1646\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 241",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346126",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Winter_Landscape_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with a Red Nose"',
    author: [
      "Artist of original: Salomon Koninck",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2429\r\n\r\nX-Radiograph(s) of: \r\nArtist: Koninck, Salomon, Dutch, 1609-1656\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man with a Red Nose\r\nDate: 1632\r\nDescription: Wood\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 233",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346127",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_with_a_Red_Nose_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of Old Man (copy)"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiorgaph; Overall\r\n\r\nX-Radiograph Settings: Number: 12\r\n\r\nBurroughs Number: 2430\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of Old Man (copy)\r\nDate: ca.1645\r\nDescription: Wood\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 248",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346128",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_Old_Man__copy__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Study of Head of an Old Man"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Little shows\r\n\r\nBurroughs Number: 2431\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Study of Head of an Old Man\r\nDate: 1643-4\r\nDescription: Wood\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 247",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346129",
    dateCreated: "January 16, 1964",
    imageUrl: "images/X_radiograph_s__of__Study_of_Head_of_an_Old_Man_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Young Jew"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiorgaph; Overall\r\n\r\nBurroughs Number: 2432\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Young Jew\r\nDescription: Wood\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 828 m",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346130",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Young_Jew_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Joseph\'s Dream"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-radiograph; Detail : central figures\r\n\r\nBurroughs Number: 2433\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Joseph's Dream\r\nDescription: Wood\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 866",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346131",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Joseph_s_Dream_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Tobias\' Wife with the Goat"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-radiograph; Detail : central figures (little shows)\r\n\r\nBurroughs Number: 2434\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Tobias' Wife with the Goat\r\nDate: 1645\r\nDescription: Wood\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 805",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346132",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Tobias__Wife_with_the_Goat_.webp",
  },
  {
    compositionName: "Mill on a Canal",
    author: ["Cornelis Ploos van Amstel", "After Anthonie van Borssom"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249765",
    dateCreated: "18th century",
    imageUrl: "images/Mill_on_a_Canal.webp",
  },
  {
    compositionName: "Stag-hunting",
    author: ["Cornelis Ploos van Amstel", "After Adam Pynacker"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249773",
    dateCreated: "18th century",
    imageUrl: "images/Stag_hunting.webp",
  },
  {
    compositionName: "Steer in a Wood",
    author: ["Cornelis Ploos van Amstel", "After Adam Pynacker"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249774",
    dateCreated: "18th century",
    imageUrl: "images/Steer_in_a_Wood.webp",
  },
  {
    compositionName: "Wooded Landscape with a River",
    author: ["Cornelis Ploos van Amstel", "After Herman Swanevelt"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249775",
    dateCreated: "18th century",
    imageUrl: "images/Wooded_Landscape_with_a_River.webp",
  },
  {
    compositionName: "Gate with Travellers and Whinny",
    author: ["Cornelis Ploos van Amstel", "After Thomas Wyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249776",
    dateCreated: "18th century",
    imageUrl: "images/Gate_with_Travellers_and_Whinny.webp",
  },
  {
    compositionName: 'Illustrations to "Emblemata ex Horatio Flacco"',
    author: ["Gysbrecht van Veen", "After Otto van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249780",
    dateCreated: "16th-17th century",
    imageUrl: "images/Illustrations_to__Emblemata_ex_Horatio_Flacco_.webp",
  },
  {
    compositionName: "Cow Lying Down",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249804",
    dateCreated: "17th century",
    imageUrl: "images/Cow_Lying_Down.webp",
  },
  {
    compositionName: "Three Cows",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249805",
    dateCreated: "17th century",
    imageUrl: "images/Three_Cows.webp",
  },
  {
    compositionName: "Calf",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249806",
    dateCreated: "17th century",
    imageUrl: "images/Calf.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Slaughtered Ox"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Overall\r\n\r\nBurroughs Number: 2445\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Slaughtered Ox\r\nDate: ca.1655\r\nDescription: Wood (cradle)\r\nOwner: Glasgow Art Gallery\r\nObject Number: 377",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346143",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Slaughtered_Ox_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Self-Portrait (female portrait underneath)"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head (female portrait underneath)\r\n\r\nBurroughs Number: 2446\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Self-Portrait (female portrait underneath)\r\nDate: ca.1655\r\nDescription: Canvas (stretcher)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 244",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346144",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Self_Portrait__female_portrait_underneath__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Girl in a Kitchen"',
    author: ["Artist of original: Adriaen van Utrecht"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head  (seam visible)\r\n\r\nBurroughs Number: 2491\r\n\r\nX-Radiograph(s) of: \r\nArtist: Utrecht, Adriaen van, Flemish, 1599-ca.1652\r\nTitle: Girl in a Kitchen\r\nDate: 1629\r\nDescription: Canvas\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 156",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346189",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Girl_in_a_Kitchen_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "The Beach at Scheveningen"',
    author: ["Artist of original: Adriaen van de Velde"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : little shows\r\n\r\nBurroughs Number: 2492\r\n\r\nX-Radiograph(s) of: \r\nArtist: Velde, Adriaen van de, Dutch, 1636-1672\r\nTitle: The Beach at Scheveningen\r\nDate: 1658\r\nDescription: Oil on canvas (stretcher)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 374",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346190",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__The_Beach_at_Scheveningen_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Calm Sea"',
    author: ["Artist of original: Willem van de Velde II"],
    tale: "X-Radiograph Description: X-radiograph; Detail : boat\r\n\r\nBurroughs Number: 2495\r\n\r\nX-Radiograph(s) of: \r\nArtist: Velde, Willem van de, II, Dutch, 1633-1707\r\nTitle: Calm Sea\r\nDate: 1653\r\nDescription: Wood (cradle)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 420",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346193",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Calm_Sea_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Francesco d\'Este"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : overall (little shows on recto, better view of verso with coat of arms)\r\n\r\nBurroughs Number: 2509\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Francesco d'Este\r\nDate: ca. 1460\r\nDescription: Oil on wood; Overall 12 1/2 x 8 3/4 in. (31.8 x 22.2 cm): painted surface, each side 11 3/4 x 8 in. (29.8 x 20.3 cm)\r\nOwner: Metropolitan Museum, New York (Friedsam Collection)\r\nObject Number: 32.100.43",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346207",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Francesco_d_Este_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Holy Family, Donors and St. Paul"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "X-Radiograph Description: X-radiograph; Detail : central figures\r\n\r\nBurroughs Number: 2510\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: Holy Family, Donors and St. Paul\r\nDescription: Oil on wood (cradle); Overall, with added strip, 22 5/8 x 19 in. (57.5 x 48.3 cm); painted surface 22 x 18 1/8 in. (55.9 x 46 cm)\r\nOwner: Metropolitan Museum, New York (Friedsam Collection)\r\nObject Number: 32.100.44",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346208",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Holy_Family__Donors_and_St__Paul_.webp",
  },
  {
    compositionName: "The Resurrection of Lazarus: The Smaller Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249878",
    dateCreated: "1642",
    imageUrl: "images/The_Resurrection_of_Lazarus__The_Smaller_Plate.webp",
  },
  {
    compositionName: "Ecce Homo Detail (Heads)",
    author: ["Dominique Vivant Denon", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249880",
    dateCreated: "18th-19th century",
    imageUrl: "images/Ecce_Homo_Detail__Heads_.webp",
  },
  {
    compositionName: "Little Bridge",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249887",
    dateCreated: "17th century",
    imageUrl: "images/Little_Bridge.webp",
  },
  {
    compositionName: "Two Peasants and Their Dog",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249889",
    dateCreated: "17th century",
    imageUrl: "images/Two_Peasants_and_Their_Dog.webp",
  },
  {
    compositionName: "Govert Flinck in Hunting Costume",
    author: ["Cornelis Ploos van Amstel", "After Govert Flinck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249908",
    dateCreated: "18th century",
    imageUrl: "images/Govert_Flinck_in_Hunting_Costume.webp",
  },
  {
    compositionName: "The Blind Fiddler",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249923",
    dateCreated: "1631",
    imageUrl: "images/The_Blind_Fiddler.webp",
  },
  {
    compositionName: "Three Oriental Figures",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249937",
    dateCreated: "1641",
    imageUrl: "images/Three_Oriental_Figures.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Young Lady"',
    author: [
      "Artist of original: Michiel Jansz. van Miereveld",
      "Artist of original: Also att. to School of Bartholomeus van der Helst",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head (X-ray stained)\r\n\r\nBurroughs Number: 2702\r\n\r\nX-Radiograph(s) of: \r\nArtist: Miereveld, Michiel Jansz. van, Dutch, 1567-1641\r\nArtist: Also att. to School of Bartholomeus van der Helst\r\nTitle: Portrait of a Young Lady\r\nDescription: Wood (cradle)\r\nOwner: Fogg Museum - Minturn Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346401",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Young_Lady_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Man "',
    author: [
      "Artist of original: Pieter Aertsen",
      "Artist of original: Or Jan van Scorel",
    ],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2704\r\n\r\nX-Radiograph(s) of: \r\nArtist: Aertsen, Pieter, Netherlandish, 1507 or 1508-1575\r\nArtist: Or van Scorel, Jan , Flemish, 1495-1562\r\nTitle: Portrait of a Man \r\nDate: 1544\r\nOwner: Fogg Museum - Minturn Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346403",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Man__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Youth"',
    author: ["Artist of original: Reynier van Gherwen"],
    tale: "X-Radiograph Description: X-Radiograph; Details : Head; Hand; ?\r\n\r\nBurroughs Number: 2709\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gherwen, Reynier van, Dutch, active 1640-ca.1660\r\nTitle: Portrait of a Youth\r\nDescription: Wood (cradle)\r\nOwner: Kunsthistorisches Museum, Vienna\r\nObject Number: 853",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346408",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Youth_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with a Fur Hat"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Central figure\r\n\r\nBurroughs Number: 2710\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man with a Fur Hat\r\nDate: ca.1655\r\nDescription: Canvas (stretcher)\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 828j",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346409",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_with_a_Fur_Hat_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Parable of Workers in the Vineyard"',
    author: [
      "Artist of original: Reynier van Gherwen",
      "Artist of original: Also att. to School of Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head of man with hand\r\n\r\nX-Radiograph Settings: 35 kv, 2.3 ma, 30 sec.\r\n\r\nBurroughs Number: 2711\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gherwen, Reynier van, Dutch, active 1640-ca.1660\r\nArtist: Also att. to School of Rembrandt\r\nTitle: Parable of Workers in the Vineyard\r\nDescription: Canvas (Stretcher)\r\nOwner: Stadel Museum, Frankfort\r\nObject Number: 986",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346410",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Parable_of_Workers_in_the_Vineyard_.webp",
  },
  {
    compositionName: "Albertinus Agnes a Nassau",
    author: ["Cornelis Visscher", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250003",
    dateCreated: "17th century",
    imageUrl: "images/Albertinus_Agnes_a_Nassau.webp",
  },
  {
    compositionName: "Madonna and Child with Tobias and the Angel",
    author: ["Cornelis Visscher", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250004",
    dateCreated: "17th century",
    imageUrl: "images/Madonna_and_Child_with_Tobias_and_the_Angel.webp",
  },
  {
    compositionName: "Maximilianus",
    author: ["Cornelis Visscher", "After Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250007",
    dateCreated: "17th century",
    imageUrl: "images/Maximilianus.webp",
  },
  {
    compositionName: "William of Nassau",
    author: ["Cornelis Visscher", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250008",
    dateCreated: "17th century",
    imageUrl: "images/William_of_Nassau.webp",
  },
  {
    compositionName: "Winder",
    author: ["Johannes Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250021",
    dateCreated: "17th century",
    imageUrl: "images/Winder.webp",
  },
  {
    compositionName: "Flemish Inn",
    author: ["J. Quartley", "After Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250033",
    dateCreated: "19th century",
    imageUrl: "images/Flemish_Inn.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "The Old Geographer"',
    author: ["Artist of original: Karel van der Pluym"],
    tale: "Burroughs Number: 2905\r\n\r\nX-Radiograph(s) of: \r\nArtist: Pluym, Karel van der, Dutch, 1625-1672\r\nTitle: The Old Geographer\r\nOwner: Cherster D. Tripp, Chicago\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346605",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__The_Old_Geographer_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Allegory-Morte non Timeo (Copy)"',
    author: ["Artist of original: Joos van Cleve"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2924\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Joos van, Netherlandish, ca. 1485-1541\r\nTitle: Allegory-Morte non Timeo (Copy)\r\nOwner: Karl Loevenich\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346612",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Allegory_Morte_non_Timeo__Copy__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Pieta (copy)"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2981\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Pieta (copy)\r\nOwner: Boston Museum of Fine Arts, MA (Herbert Sears)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346660",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Pieta__copy__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Party Landing from a Ship"',
    author: ["Artist of original: Hendrik van Minderhout"],
    tale: "Burroughs Number: 3038\r\n\r\nX-Radiograph(s) of: \r\nArtist: Minderhout, Hendrik van, Dutch, 1632-16\r\nTitle: Party Landing from a Ship\r\nOwner: Loan to Harvard University Art Museums from Nichols Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346713",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Party_Landing_from_a_Ship_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Francis"',
    author: ["Artist of original: Adriaen van Utrecht"],
    tale: "Burroughs Number: 3048\r\n\r\nX-Radiograph(s) of: \r\nArtist: Margaritone d'Arezzo, Italian, ca.1216-ca.1290\r\nTitle: St. Francis\r\nOwner: Vatican Museum, Rome\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346722",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Francis_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jan de Montfort"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3204\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Jan de Montfort\r\nDate: ca.1630\r\nOwner: Kunsthistorisches Museum, Vienna\r\nObject Number: 1048",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346840",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jan_de_Montfort_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Jerome"',
    author: ["Artist of original: Rogier van der Weyden"],
    tale: "Burroughs Number: 3302\r\n\r\nX-Radiograph(s) of: \r\nArtist: Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nTitle: St. Jerome\r\nOwner: Private Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346937",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Jerome_.webp",
  },
  {
    compositionName: "House in a Grove",
    author: ["Johannes Pieter van Wisselingh"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250343",
    dateCreated: "19th century",
    imageUrl: "images/House_in_a_Grove.webp",
  },
  {
    compositionName: "Man Seated at a Table",
    author: ["Giuseppe Zocchi", "After Gerbrand van den Eeckhout"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250356",
    dateCreated: "18th century",
    imageUrl: "images/Man_Seated_at_a_Table.webp",
  },
  {
    compositionName: "Pieter Cornelis Hooft",
    author: ["Anthony van Zyvelt", "After Joachim von Sandrart the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250358",
    dateCreated: "17th century",
    imageUrl: "images/Pieter_Cornelis_Hooft.webp",
  },
  {
    compositionName: "Scene from the story of Daniel",
    author: ["After Anonymous Netherlands 1599", "Willem van Haecht I"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250369",
    dateCreated: "16th century",
    imageUrl: "images/Scene_from_the_story_of_Daniel.webp",
  },
  {
    compositionName: "Hispanus",
    author: ["Hieronymus Wierix", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250373",
    dateCreated: "16th century",
    imageUrl: "images/Hispanus.webp",
  },
  {
    compositionName:
      "Helena Tromper Du Boys (wrongly called Helena Eleanora de Sieveri)",
    author: ["Cornelis Visscher", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250447",
    dateCreated: "17th century",
    imageUrl:
      "images/Helena_Tromper_Du_Boys__wrongly_called_Helena_Eleanora_de_Sieveri_.webp",
  },
  {
    compositionName: "Marauders Setting a House on Fire",
    author: ["Cornelis Visscher", "After Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250511",
    dateCreated: "17th century",
    imageUrl: "images/Marauders_Setting_a_House_on_Fire.webp",
  },
  {
    compositionName: "Thessalus",
    author: ["Hieronymus Wierix", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250735",
    dateCreated: "16th century",
    imageUrl: "images/Thessalus.webp",
  },
  {
    compositionName: "Mattathias Kills the Jew and the King's Officer",
    author: ["Johannes Wierix", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250741",
    dateCreated: "1574",
    imageUrl: "images/Mattathias_Kills_the_Jew_and_the_King_s_Officer.webp",
  },
  {
    compositionName: "Dr. Gachet",
    author: ["Vincent van Gogh"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250876",
    dateCreated: "1890",
    imageUrl: "images/Dr__Gachet.webp",
  },
  {
    compositionName: "Lion and Lioness",
    author: ["Evert Louis van Muyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/252929",
    dateCreated: "19th century",
    imageUrl: "images/Lion_and_Lioness.webp",
  },
  {
    compositionName: "Lion, Lying Down",
    author: ["Evert Louis van Muyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/252930",
    dateCreated: "19th century",
    imageUrl: "images/Lion__Lying_Down.webp",
  },
  {
    compositionName: "Bison and Calf",
    author: ["Evert Louis van Muyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/252941",
    dateCreated: "19th century",
    imageUrl: "images/Bison_and_Calf.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Young Man"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph \r\n\r\nBurroughs Number: 3656\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of a Young Man\r\nOwner: Wadsworth Athenaeum, Hartford, CT \r\nObject Number: TL11532",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347262",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Young_Man_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Self-Portrait for Gauguin"',
    author: ["Artist of original: Vincent van Gogh"],
    tale: "X-Radiograph Description: X-Radiograph  (head and shoulders)\r\n\r\nX-Radiograph Settings: 15 kv, 7 ma, 75 sec.; 15 kv, 7 ma, 8 min.; ; \r\n\r\nBurroughs Number: 3666\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gogh, Vincent van, Dutch, 1853-1890\r\nTitle: Self-Portrait for Gauguin\r\nDate: 1888\r\nOwner: Harvard University Art Museums (Wertheim Collection)\r\nObject Number: 1951.65",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347268",
    dateCreated: "July 10, 1956",
    imageUrl: "images/X_radiograph_s__of__Self_Portrait_for_Gauguin_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Wolfgang A. von Zweibrucken"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "Burroughs Number: 3674\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Wolfgang A. von Zweibrucken\r\nOwner: Private Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347275",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Wolfgang_A__von_Zweibrucken_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Three pairs of Shoes"',
    author: ["Artist of original: Vincent van Gogh"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3684\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gogh, Vincent van, Dutch, 1853-1890\r\nTitle: Three pairs of Shoes\r\nOwner: Harvard University Art Museums (Wertheim Collection)\r\nObject Number: 1951.66",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347284",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Three_pairs_of_Shoes_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Young Woman"',
    author: ["Artist of original: Bartholomeus van der Helst"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3701\r\n\r\nX-Radiograph(s) of: \r\nArtist: Helst, Bartholomeus van der, Dutch, 1613-1670\r\nTitle: Portrait of a Young Woman\r\nOwner: Harvard University Art Museums\r\nObject Number: 1969.62",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347301",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Young_Woman_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Bust of Christ"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph see #4820\r\n\r\nBurroughs Number: 3714\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Bust of Christ\r\nOwner: Harvard University Art Museums\r\nObject Number: 1964.172",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347313",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Bust_of_Christ_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Harbor Scene"',
    author: ["Artist of original: Jan van Goyen"],
    tale: "Burroughs Number: 3743\r\n\r\nX-Radiograph(s) of: \r\nArtist: Goyen, Jan van, Dutch, 1596-1656\r\nTitle: Harbor Scene\r\nOwner: Harvard University Art Museums\r\nObject Number: 1969.54",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347334",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Harbor_Scene_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Genre Scene"',
    author: [
      "Artist of original: Adriaen van Ostade",
      "Artist of original: Also att. to Pieter Jansz. Quast",
    ],
    tale: "Burroughs Number: 3745\r\n\r\nX-Radiograph(s) of: \r\nArtist: Ostade, Adriaen van, Dutch, 1610-1685\r\nArtist: Also att. to Quast, Pieter Jansz., Dutch, 1605 or 1606-1647\r\nTitle: Genre Scene\r\nOwner: Private Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347335",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Genre_Scene_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Two Negroes"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "Burroughs Number: 3771\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Two Negroes\r\nOwner: Owned by Dealer\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347360",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Two_Negroes_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Figures in Landscape with Ruins"',
    author: ["Artist of original: Adriaen van Nieulandt the Younger"],
    tale: "Burroughs Number: 3778\r\n\r\nX-Radiograph(s) of: \r\nArtist: Nieulandt, Adriaen van, the Younger, Dutch, 1587-1658\r\nTitle: Figures in Landscape with Ruins\r\nOwner: Private Collection\r\nObject Number: TL16211",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347365",
    dateCreated: "September 10, 1967",
    imageUrl:
      "images/X_radiograph_s__of__Figures_in_Landscape_with_Ruins_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Lady with Beads"',
    author: ["Artist of original: Joos van Cleve"],
    tale: "Burroughs Number: 3784\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Joos van, Netherlandish, ca. 1485-1541\r\nTitle: Portrait of a Lady with Beads\r\nOwner: Donald Scott Jr., Glenside, PA\r\nObject Number: TL16368.8",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347370",
    dateCreated: "November 14, 1967",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Lady_with_Beads_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of a Man (Horace)"',
    author: ["Artist of original: Michiel van Musscher"],
    tale: "Burroughs Number: 3814\r\n\r\nX-Radiograph(s) of: \r\nArtist: Musscher, Michiel van, Dutch, 1645-1705\r\nTitle: Portrait of a Man (Horace)\r\nOwner: J.J. Demorest\r\nObject Number: TL17921",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347401",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_a_Man__Horace__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "3 River Landscapes"',
    author: ["Artist of original: Aert van der Neer"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3870\r\n\r\nX-Radiograph(s) of: \r\nArtist: Neer, Aert van der, Dutch, 1603-1677\r\nTitle: 3 River Landscapes\r\nOwner: Harvard University Art Museums (Abbott Collection)\r\nObject Number: 1966.140-150",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347459",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__3_River_Landscapes_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Rest on the Flight"',
    author: ["Artist of original: Cornelis van Poelenburch"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3917\r\n\r\nX-Radiograph(s) of: \r\nArtist: Poelenburgh, Cornelis van, Dutch, 1594 or 1595-1667\r\nTitle: Rest on the Flight\r\nOwner: Harvard University Art Museums\r\nObject Number: 1965.523",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347490",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Rest_on_the_Flight_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Waterfall"',
    author: ["Artist of original: Jacob van Ruisdael"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3919\r\n\r\nX-Radiograph(s) of: \r\nArtist: Ruisdael, Jacob van, Dutch, 1628 or 1629-1682\r\nTitle: Waterfall\r\nOwner: Harvard University Art Museums\r\nObject Number: 1953.2",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347492",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Waterfall_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Peasant Scene"',
    author: ["Artist of original: Egbert van Heemskerck the Elder"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3921\r\n\r\nX-Radiograph(s) of: \r\nArtist: Heemskerck, Egbert van, Dutch, 1634/5-1704\r\nTitle: Peasant Scene\r\nOwner: Harvard University Art Museums\r\nObject Number: 1948.53",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347495",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Peasant_Scene_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "View of a River in Moonlight"',
    author: ["Artist of original: Aert van der Neer"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3922\r\n\r\nX-Radiograph(s) of: \r\nArtist: Neer, Aert van der, Dutch, 1603-1677\r\nTitle: View of a River in Moonlight\r\nOwner: Harvard University Art Museums\r\nObject Number: 1943.1356",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347496",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__View_of_a_River_in_Moonlight_.webp",
  },
  {
    compositionName: "Expulsion from Paradise",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254840",
    dateCreated: "1651",
    imageUrl: "images/Expulsion_from_Paradise.webp",
  },
  {
    compositionName: "The Peddler and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254841",
    dateCreated: "1651",
    imageUrl: "images/The_Peddler_and_Death.webp",
  },
  {
    compositionName: "The Wagoner and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254842",
    dateCreated: "1651",
    imageUrl: "images/The_Wagoner_and_Death.webp",
  },
  {
    compositionName: "The Old Man and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254843",
    dateCreated: "1651",
    imageUrl: "images/The_Old_Man_and_Death.webp",
  },
  {
    compositionName: "The Old Woman and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254844",
    dateCreated: "1651",
    imageUrl: "images/The_Old_Woman_and_Death.webp",
  },
  {
    compositionName: "The Child and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254845",
    dateCreated: "1651",
    imageUrl: "images/The_Child_and_Death.webp",
  },
  {
    compositionName: "Adam Ploughing",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254857",
    dateCreated: "1651",
    imageUrl: "images/Adam_Ploughing.webp",
  },
  {
    compositionName: "The Pope and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254858",
    dateCreated: "1651",
    imageUrl: "images/The_Pope_and_Death.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Old Woman"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: 5 ma, 40 kv, 60 sec. (4 1/2 taken, good); 5 ma, 40 kv, 60 sec. (3 retakes of top section); 5 ma, 40 kv, 60 sec. (3 retakes of bottom section); \r\n\r\nBurroughs Number: 3989\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Old Woman\r\nDescription: Canvas (wax lined)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347545",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Old_Woman_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of an Amsterdam Burger"',
    author: ["Artist of original: Attributed to Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: see also xray #4017\r\n\r\nX-Radiograph Settings: 5 ma, 45 kv, 80 sec.(almost entirely black); 4 ma, 20 kv, 2 min. (very good)\r\n\r\nBurroughs Number: 4031\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (att. to), Dutch, 1606-1669\r\nTitle: Portrait of an Amsterdam Burger\r\nOwner: Krannert Art Museum, University of Illinois\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347571",
    dateCreated: "October 31, 1980",
    imageUrl:
      "images/X_radiograph_s__of__Portrait_of_an_Amsterdam_Burger_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of ""Woodcutter" with lead white layer"',
    author: ["Artist of original: Vincent van Gogh"],
    tale: 'X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: 50 kv, 5 ma, 2 min.; 50 kv, 5 ma, 1 min.; 50 kv, 5 ma, 2 min.; 80 kv, 5 ma, 2 min. ; \r\n\r\nBurroughs Number: 4054\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gogh, Vincent van, Dutch, 1853-1890\r\nTitle: "Woodcutter" with lead white layer\r\nOwner: Brandeis University, Waltham, MA\r\n',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347583",
    dateCreated: "December 18, 1981",
    imageUrl:
      "images/X_radiograph_s__of___Woodcutter__with_lead_white_layer_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Blasted Elm"',
    author: ["Artist of original: Jacob van Ruisdael"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: Dupont Cronex NDT-55; 5 ma, 50 kv, 40 sec. (4)\r\n\r\nBurroughs Number: 4067\r\n\r\nX-Radiograph(s) of: \r\nArtist: Ruisdael, Jacob van, Dutch, 1628 or 1629-1682\r\nTitle: Blasted Elm\r\nOwner: Currier Gallery of Art, Manchester, NH\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347590",
    dateCreated: "April 7, 1982",
    imageUrl: "images/X_radiograph_s__of__Blasted_Elm_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Portrait of a Young Man in an Armchair"',
    author: ["Artist of original: Attributed to Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Settings: 5 ma, 47 kv, 60 sec (6 sheets)\r\n\r\nBurroughs Number: 4283\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (att. to), Dutch, 1606-1669\r\nTitle: Portrait of a Young Man in an Armchair\r\nDescription: Oil on canvas\r\nOwner: Rochester Memorial Art Gallery, NY\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347690",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Portrait_of_a_Young_Man_in_an_Armchair_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Woman at her Toilet"',
    author: ["Artist of original: Copyist Jan van Eyck"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: 5 ma, 50 kv, 60 sec.\r\n\r\nBurroughs Number: 4410\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van (Copyist) \r\nTitle: Woman at her Toilet\r\nOwner: Harvard University Art Museums\r\nObject Number: 1969.83",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347745",
    dateCreated: "February 8, 1996",
    imageUrl: "images/X_radiograph_s__of__Woman_at_her_Toilet_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Self-Portrait (copy after lost original?)"',
    author: ["Artist of original: Copy after Rembrandt Harmensz. van Rijn"],
    tale: "Burroughs Number: 4431\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (copy after), Dutch, 1606-1669\r\nTitle: Self-Portrait (copy after lost original?)\r\nOwner: Harvard University Art Museums\r\nObject Number: 1977.6",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347760",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Self_Portrait__copy_after_lost_original___.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Three Pairs of Shoes"',
    author: ["Artist of original: Vincent van Gogh"],
    tale: 'X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: 5 ma, 55 kv, 1 min., 58" from tube\r\n\r\nBurroughs Number: 4452\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gogh, Vincent van, Dutch, 1853-1890\r\nTitle: Three Pairs of Shoes\r\nOwner: Harvard University Art Museums\r\nObject Number: 1951.66',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347773",
    dateCreated: "November 18, 1997",
    imageUrl: "images/X_radiograph_s__of__Three_Pairs_of_Shoes_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Self-Portait"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph (4)\r\n\r\nX-Radiograph Settings: 5 ma, 40 kv, 1 min.\r\n\r\nBurroughs Number: 4541\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Self-Portait\r\nOwner: Harvard University Art Museums (Brontmann Collection)\r\nObject Number: 1977.6",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347786",
    dateCreated: "May 5, 1999",
    imageUrl: "images/X_radiograph_s__of__Self_Portait_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Jerome in His Study"',
    author: ["Artist of original: Joos van Cleve"],
    tale: 'X-Radiograph Description: X-Radiograph (9)\r\n\r\nX-Radiograph Settings: 5 ma, 60 kv, 40 sec. 75" from tube; #1: UL; #2: UC; #3: UR; #4: CL; #5: CC; #6: CR; #7: LL; #8: LC; #9: LR\r\n\r\nBurroughs Number: 4732\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Joos van, Netherlandish, ca. 1485-1541\r\nTitle: St. Jerome in His Study\r\nDescription: Thinned cradled oak panel\r\nOwner: Harvard University Art Museums\r\nObject Number: 1961.26',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347838",
    dateCreated: "August 25, 2004",
    imageUrl: "images/X_radiograph_s__of__St__Jerome_in_His_Study_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Magi (fragment)"',
    author: ["Artist of original: Joos van Cleve"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: Kodak M-1; 5 ma, 50 kv, 60 sec.\r\n\r\nBurroughs Number: 4734\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cleve, Joos van, Netherlandish, ca. 1485-1541\r\nTitle: Magi (fragment)\r\nDescription: Thin oak with masoninte\r\nOwner: Private Collection",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347840",
    dateCreated: "November 2, 2004",
    imageUrl: "images/X_radiograph_s__of__Magi__fragment__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Portrait of Man (Bredius 192)"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nX-Radiograph Settings: 45 KV, 5 mA, 1 minute, 30  seconds; Lorad, Kodak\r\n\r\nBurroughs Number: 4818\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Portrait of Man (Bredius 192)\r\nOwner: Detroit Art Institute, MI\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347881",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Portrait_of_Man__Bredius_192__.webp",
  },
  {
    compositionName: "The Queen and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254978",
    dateCreated: "1651",
    imageUrl: "images/The_Queen_and_Death.webp",
  },
  {
    compositionName: "The Bride and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254979",
    dateCreated: "1651",
    imageUrl: "images/The_Bride_and_Death.webp",
  },
  {
    compositionName: "Landscape with a Chapel on an Island",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255066",
    dateCreated: "1615",
    imageUrl: "images/Landscape_with_a_Chapel_on_an_Island.webp",
  },
  {
    compositionName: "June",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255084",
    dateCreated: "1618",
    imageUrl: "images/June.webp",
  },
  {
    compositionName: "Auricular Designs for a Table and a Pedestal",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350048",
    dateCreated: "1655",
    imageUrl: "images/Auricular_Designs_for_a_Table_and_a_Pedestal.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with Reptilian Wings at Top Flanking a Keyhole-like Aperture",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350049",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_Reptilian_Wings_at_Top_Flanking_a_Keyhole_like_Aperture.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with Six Putti Clasping Fruit Garlands at the Sides",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350050",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_Six_Putti_Clasping_Fruit_Garlands_at_the_Sides.webp",
  },
  {
    compositionName:
      "Auricular Designs for Two Tables, the Upper with Fruit Garlands, the Lower with Muscular Figures as Legs",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350052",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Designs_for_Two_Tables__the_Upper_with_Fruit_Garlands__the_Lower_with_Muscular_Figures_as_Legs.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with Two Compartments, Fruit Garlands at the Sides",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350234",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_Two_Compartments__Fruit_Garlands_at_the_Sides.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with Four Putti, Two with Wings, and Monstrous Female Figures Grasping Fruit Garlands",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350235",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_Four_Putti__Two_with_Wings__and_Monstrous_Female_Figures_Grasping_Fruit_Garlands.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with Two Winged Putti Holding Fruit Garlands with Ribbons",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350236",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_Two_Winged_Putti_Holding_Fruit_Garlands_with_Ribbons.webp",
  },
  {
    compositionName: "Snake with a Butterfly",
    author: ["Johannes Teyler", "After Otto Marseus van Schrieck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/352506",
    dateCreated: "after 1688",
    imageUrl: "images/Snake_with_a_Butterfly.webp",
  },
  {
    compositionName:
      "The Chaldeans Carrying Away the Pillars of the Temple of Jerusalem",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255438",
    dateCreated: "1569",
    imageUrl:
      "images/The_Chaldeans_Carrying_Away_the_Pillars_of_the_Temple_of_Jerusalem.webp",
  },
  {
    compositionName: "The Adoration of the Magi",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255439",
    dateCreated: "1569",
    imageUrl: "images/The_Adoration_of_the_Magi.webp",
  },
  {
    compositionName: "Giovanni Arnolfini",
    author: ["Albert Kr\u00fcger", "After Jan van Eyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255665",
    dateCreated: "19th century",
    imageUrl: "images/Giovanni_Arnolfini.webp",
  },
  {
    compositionName: "The Mocking of Noah",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255811",
    dateCreated: "1569",
    imageUrl: "images/The_Mocking_of_Noah.webp",
  },
  {
    compositionName: "The People of Israel Divided Between Tibni and Omri",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255813",
    dateCreated: "1569",
    imageUrl: "images/The_People_of_Israel_Divided_Between_Tibni_and_Omri.webp",
  },
  {
    compositionName: "The Chaldeans Carrying Away the Temple Treasures",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255814",
    dateCreated: "1569",
    imageUrl: "images/The_Chaldeans_Carrying_Away_the_Temple_Treasures.webp",
  },
  {
    compositionName: "Oriental Head",
    author: [
      "Leonard Leibowitz",
      "After Rembrandt Harmensz. van Rijn",
      "After Jan Lievens",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255857",
    dateCreated: "1992",
    imageUrl: "images/Oriental_Head.webp",
  },
  {
    compositionName: "Inigo Jones",
    author: ["Wenceslaus Hollar", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255859",
    dateCreated: "17th century",
    imageUrl: "images/Inigo_Jones.webp",
  },
  {
    compositionName: "Franciscus Junius the Younger",
    author: ["Wenceslaus Hollar", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255860",
    dateCreated: "1641",
    imageUrl: "images/Franciscus_Junius_the_Younger.webp",
  },
  {
    compositionName: "Henrietta Maria",
    author: ["Wenceslaus Hollar", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255862",
    dateCreated: "1641",
    imageUrl: "images/Henrietta_Maria.webp",
  },
  {
    compositionName: "Noah's Sacrifice",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255877",
    dateCreated: "1569",
    imageUrl: "images/Noah_s_Sacrifice.webp",
  },
  {
    compositionName: "Lot Making Love to His Daughter",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255878",
    dateCreated: "1569",
    imageUrl: "images/Lot_Making_Love_to_His_Daughter.webp",
  },
  {
    compositionName: "The Destruction of Jericho",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255879",
    dateCreated: "1569",
    imageUrl: "images/The_Destruction_of_Jericho.webp",
  },
  {
    compositionName: "The Destruction of Ai and the Stoning of Achan",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255880",
    dateCreated: "1569",
    imageUrl: "images/The_Destruction_of_Ai_and_the_Stoning_of_Achan.webp",
  },
  {
    compositionName:
      "The Corpse of the King of Ai Brought to the Gate of the City",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255985",
    dateCreated: "1569",
    imageUrl:
      "images/The_Corpse_of_the_King_of_Ai_Brought_to_the_Gate_of_the_City.webp",
  },
  {
    compositionName: "The King of Ai Hanged",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255996",
    dateCreated: "1569",
    imageUrl: "images/The_King_of_Ai_Hanged.webp",
  },
  {
    compositionName:
      "Samson Let Out of Prison and Destroying the Temple of the Philistines",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255997",
    dateCreated: "1569",
    imageUrl:
      "images/Samson_Let_Out_of_Prison_and_Destroying_the_Temple_of_the_Philistines.webp",
  },
  {
    compositionName: "The Burial of Samson",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255998",
    dateCreated: "1569",
    imageUrl: "images/The_Burial_of_Samson.webp",
  },
  {
    compositionName: "The Capture of Tirsah",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255999",
    dateCreated: "1569",
    imageUrl: "images/The_Capture_of_Tirsah.webp",
  },
  {
    compositionName: "Jehu Destroying the Temple and Statue of Baal",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256000",
    dateCreated: "1569",
    imageUrl: "images/Jehu_Destroying_the_Temple_and_Statue_of_Baal.webp",
  },
  {
    compositionName: "The Adoration of the Shepherds",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256008",
    dateCreated: "1569",
    imageUrl: "images/The_Adoration_of_the_Shepherds.webp",
  },
  {
    compositionName: "The Destruction of Jerusalem by Emperor Titus",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256009",
    dateCreated: "1569",
    imageUrl: "images/The_Destruction_of_Jerusalem_by_Emperor_Titus.webp",
  },
  {
    compositionName: "Horses",
    author: ["Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256030",
    dateCreated: "16th century",
    imageUrl: "images/Horses.webp",
  },
  {
    compositionName: "Gaspard Gevaerts",
    author: ["Elisha Kirkall", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256122",
    dateCreated: "c. 1725",
    imageUrl: "images/Gaspard_Gevaerts.webp",
  },
  {
    compositionName:
      "The Northern Facade of S. Giovanni in Laterano with the 'Aula Concilii'",
    author: [
      "A. Claude Philippe de Thubi\u00e8res comte de Caylus",
      "After Maarten van Heemskerck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256125",
    dateCreated: "18th century",
    imageUrl:
      "images/The_Northern_Facade_of_S__Giovanni_in_Laterano_with_the__Aula_Concilii_.webp",
  },
  {
    compositionName: "Untitled",
    author: ["David van der Kop"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256145",
    dateCreated: "1969",
    imageUrl: "images/Untitled.webp",
  },
  {
    compositionName: "Deserted Mill",
    author: ["Hendrik Dirk Kruseman van Elten"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256146",
    dateCreated: "1883",
    imageUrl: "images/Deserted_Mill.webp",
  },
  {
    compositionName:
      "Judith Approaching Holofernes' Encampment [Judith 10:11-15]",
    author: ["Lucas van Doetecum", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256259",
    dateCreated: "1562",
    imageUrl:
      "images/Judith_Approaching_Holofernes__Encampment__Judith_10_11_15_.webp",
  },
  {
    compositionName: "Mr. Algernon Sidney",
    author: ["John Baptist Jackson", "After Justus van Egmont"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256407",
    dateCreated: "18th century",
    imageUrl: "images/Mr__Algernon_Sidney.webp",
  },
  {
    compositionName: "Three Birds",
    author: ["Theo van Hoytema"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256408",
    dateCreated: "19th-20th century",
    imageUrl: "images/Three_Birds.webp",
  },
  {
    compositionName: "Two Birds",
    author: ["Theo van Hoytema"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256409",
    dateCreated: "19th-20th century",
    imageUrl: "images/Two_Birds.webp",
  },
  {
    compositionName: "Frederick, King of Bohemia",
    author: ["Pieter van Gunst", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256521",
    dateCreated: "17th-18th century",
    imageUrl: "images/Frederick__King_of_Bohemia.webp",
  },
  {
    compositionName: "Beggars",
    author: ["Gurdon Saltonstall Howe", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256562",
    dateCreated: "19th-20th century",
    imageUrl: "images/Beggars.webp",
  },
  {
    compositionName: "Title",
    author: ["Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256596",
    dateCreated: "17th century",
    imageUrl: "images/Title.webp",
  },
  {
    compositionName:
      "Bird's-eye View of a Town with Palaces and a Canal, from the Steps of a Building in the Right Foreground a Man is Greeting a Rider on Horseback (N.H.)",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256666",
    dateCreated: "1562",
    imageUrl:
      "images/Bird_s_eye_View_of_a_Town_with_Palaces_and_a_Canal__from_the_Steps_of_a_Building_in_the_Right_Foreground_a_Man_is_Greeting_a_Rider_on_Horseback__N_H__.webp",
  },
  {
    compositionName:
      "View into the Courtyard of a Palace with a Rivergod in the Center of a Rectangular Pond (N.H.)",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by At the Sign of the Four Winds",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256667",
    dateCreated: "1562",
    imageUrl:
      "images/View_into_the_Courtyard_of_a_Palace_with_a_Rivergod_in_the_Center_of_a_Rectangular_Pond__N_H__.webp",
  },
  {
    compositionName:
      "Man Sitting on an Auricular Mask, Supporting a Strapwork Frame in his Shoulders",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Frans Floris",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256669",
    dateCreated: "1557",
    imageUrl:
      "images/Man_Sitting_on_an_Auricular_Mask__Supporting_a_Strapwork_Frame_in_his_Shoulders.webp",
  },
  {
    compositionName: "Five Shells",
    author: ["Jan van Huysum I"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361362",
    dateCreated: "17th century",
    imageUrl: "images/Five_Shells.webp",
  },
  {
    compositionName: "Moth, Pupa, and Eggs",
    author: ["Attributed to Vincent Laurensz van der Vinne II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361374",
    dateCreated: "1670",
    imageUrl: "images/Moth__Pupa__and_Eggs.webp",
  },
  {
    compositionName: "Portrait of a Man Standing at a Desk",
    author: [
      "Cornelis Cornelisz. van Haarlem",
      "Previously attributed to Bartholomeus Spranger",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361385",
    dateCreated: "16th-17th century",
    imageUrl: "images/Portrait_of_a_Man_Standing_at_a_Desk.webp",
  },
  {
    compositionName: "Standing Peasant with a Jug",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361758",
    dateCreated: "17th century",
    imageUrl: "images/Standing_Peasant_with_a_Jug.webp",
  },
  {
    compositionName: "Herod Returning Christ to Pilate",
    author: ["Andries van Buysen", "After Bernard Picart"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362415",
    dateCreated: "18th century",
    imageUrl: "images/Herod_Returning_Christ_to_Pilate.webp",
  },
  {
    compositionName: "The Crafty Bird-Catcher",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Pieter Bruegel, the Elder",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362967",
    dateCreated: "c. 1555-1556",
    imageUrl: "images/The_Crafty_Bird_Catcher.webp",
  },
  {
    compositionName: "The Flight into Egypt",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Pieter Bruegel, the Elder",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362968",
    dateCreated: "c. 1555-1556",
    imageUrl: "images/The_Flight_into_Egypt.webp",
  },
  {
    compositionName: "Soldiers at Rest",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Pieter Bruegel, the Elder",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362969",
    dateCreated: "c. 1555-1556",
    imageUrl: "images/Soldiers_at_Rest.webp",
  },
  {
    compositionName: "Three Goats by the Water's Edge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256835",
    dateCreated: "17th century",
    imageUrl: "images/Three_Goats_by_the_Water_s_Edge.webp",
  },
  {
    compositionName: "Two Men on the Hill",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256836",
    dateCreated: "17th century",
    imageUrl: "images/Two_Men_on_the_Hill.webp",
  },
  {
    compositionName: "The Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256837",
    dateCreated: "17th century",
    imageUrl: "images/The_Rock.webp",
  },
  {
    compositionName:
      "View of a Castle with Tower and Entrance building, Placed in a Pond and Surrounded by a Garden; Archers in the Foreground (N. H.)",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256846",
    dateCreated: "1562",
    imageUrl:
      "images/View_of_a_Castle_with_Tower_and_Entrance_building__Placed_in_a_Pond_and_Surrounded_by_a_Garden__Archers_in_the_Foreground__N__H__.webp",
  },
  {
    compositionName: "James Graham, Marquis of Montrose",
    author: ["Jacobus Houbraken", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256905",
    dateCreated: "1740",
    imageUrl: "images/James_Graham__Marquis_of_Montrose.webp",
  },
  {
    compositionName: "Marchese Philippo Cattaneo",
    author: ["Timothy Cole", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256978",
    dateCreated: "19th-20th century",
    imageUrl: "images/Marchese_Philippo_Cattaneo.webp",
  },
  {
    compositionName: "Philemon and Baucis",
    author: ["Timothy Cole", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256981",
    dateCreated: "19th-20th century",
    imageUrl: "images/Philemon_and_Baucis.webp",
  },
  {
    compositionName:
      "Marchesa Elena Grimaldi, Wife of Marchese Nicola Cattaneo",
    author: ["Timothy Cole", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257002",
    dateCreated: "19th-20th century",
    imageUrl:
      "images/Marchesa_Elena_Grimaldi__Wife_of_Marchese_Nicola_Cattaneo.webp",
  },
  {
    compositionName: "Tomboctou Home",
    author: ["Ian van Coller"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/365370",
    dateCreated: "1998",
    imageUrl: "images/Tomboctou_Home.webp",
  },
  {
    compositionName:
      "An Old Bearded Man Kneeling in Prayer before a Bed, Approached by a Younger Man",
    author: ["Circle of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/369362",
    dateCreated: "c. 1650",
    imageUrl:
      "images/An_Old_Bearded_Man_Kneeling_in_Prayer_before_a_Bed__Approached_by_a_Younger_Man.webp",
  },
  {
    compositionName: "The Return from the Flight into Egypt",
    author: ["Jacques de Gheyn II", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370233",
    dateCreated: "c. 1592",
    imageUrl: "images/The_Return_from_the_Flight_into_Egypt.webp",
  },
  {
    compositionName: "Dog on a Chain",
    author: ["Pauwels van Hillegaert I"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370255",
    dateCreated: "1654",
    imageUrl: "images/Dog_on_a_Chain.webp",
  },
  {
    compositionName:
      "Hirah the Adullamite with the Kid, Inquiring for the Harlot",
    author: ["Dirck Volkertsz. Coornhert", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370277",
    dateCreated: "c. 1549",
    imageUrl:
      "images/Hirah_the_Adullamite_with_the_Kid__Inquiring_for_the_Harlot.webp",
  },
  {
    compositionName: "Abraham Dismissing Hagar",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370289",
    dateCreated: "1516",
    imageUrl: "images/Abraham_Dismissing_Hagar.webp",
  },
  {
    compositionName: "Head of an Old Man in a High Fur Cap",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370312",
    dateCreated: "c. 1629",
    imageUrl: "images/Head_of_an_Old_Man_in_a_High_Fur_Cap.webp",
  },
  {
    compositionName: "Charles I",
    author: [
      "Jonas Suyderhoef",
      "border by Pieter Soutman",
      "After Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370330",
    dateCreated: "c. 1650",
    imageUrl: "images/Charles_I.webp",
  },
  {
    compositionName: "Goat",
    author: ["Govaert van der Leeuw"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370346",
    dateCreated: "17th century",
    imageUrl: "images/Goat.webp",
  },
  {
    compositionName: "Nicolas Chrystin",
    author: ["Jean Morin", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370497",
    dateCreated: "17th century",
    imageUrl: "images/Nicolas_Chrystin.webp",
  },
  {
    compositionName:
      "Count Wilhelm IV grants Amsterdam Great Privilege in 1342",
    author: ["Pieter van Abeele"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370544",
    dateCreated: "c. 1650",
    imageUrl:
      "images/Count_Wilhelm_IV_grants_Amsterdam_Great_Privilege_in_1342.webp",
  },
  {
    compositionName:
      "Frederick Henry, Prince of Orange (1584-1647); reverse: Victorious Captures and Sieges",
    author: ["Anthonis Pietersz. van der Willighe"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370548",
    dateCreated: "1631",
    imageUrl:
      "images/Frederick_Henry__Prince_of_Orange__1584_1647___reverse__Victorious_Captures_and_Sieges.webp",
  },
  {
    compositionName: "Maarten Harpertszoon Tromp, Death",
    author: ["Pieter van Abeele"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370556",
    dateCreated: "1653",
    imageUrl: "images/Maarten_Harpertszoon_Tromp__Death.webp",
  },
  {
    compositionName: "Marriage / Birth medal",
    author: ["Pieter van Abeele"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370557",
    dateCreated: "c. 1655",
    imageUrl: "images/Marriage___Birth_medal.webp",
  },
  {
    compositionName: "Marriage Medal with Love (Venus) and Marriage (Juno)",
    author: ["Pieter van Abeele"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370559",
    dateCreated: "c. 1655",
    imageUrl:
      "images/Marriage_Medal_with_Love__Venus__and_Marriage__Juno_.webp",
  },
  {
    compositionName: "Maurice, Prince of Orange; reverse: Siege of Grave",
    author: ["Gerhard van Bylaer", "Designed by Conrad Bloc"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370563",
    dateCreated: "1602",
    imageUrl: "images/Maurice__Prince_of_Orange__reverse__Siege_of_Grave.webp",
  },
  {
    compositionName: "Siege of Grave",
    author: ["C. van der Vogelaar"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370573",
    dateCreated: "1602",
    imageUrl: "images/Siege_of_Grave.webp",
  },
  {
    compositionName: "Siege of Leiden",
    author: ["Gerhard van Bylaer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370574",
    dateCreated: "1574",
    imageUrl: "images/Siege_of_Leiden.webp",
  },
  {
    compositionName:
      "The Granting of a Crown for the Arms of Amsterdam by the Emperor Maximilian in 1488",
    author: ["Pieter van Abeele"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370576",
    dateCreated: "c. 1650",
    imageUrl:
      "images/The_Granting_of_a_Crown_for_the_Arms_of_Amsterdam_by_the_Emperor_Maximilian_in_1488.webp",
  },
  {
    compositionName: "William II's Siege of Amsterdam",
    author: ["Dirk van Ryswyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370581",
    dateCreated: "1650",
    imageUrl: "images/William_II_s_Siege_of_Amsterdam.webp",
  },
  {
    compositionName: "Trees in an Autumn Landscape",
    author: ["Theo van Hoytema"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370602",
    dateCreated: "19th-20th century",
    imageUrl: "images/Trees_in_an_Autumn_Landscape.webp",
  },
  {
    compositionName: "Large Farm with Draw Well",
    author: [
      "Joannes van Doetecum",
      "and Lucas van Doetecum",
      "After Master of the Small Landscapes",
      "Published by Philips Galle",
      "Or published by Theodoor Galle",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370648",
    dateCreated: "c. 1559-1561; printed 1601 or c. 1612",
    imageUrl: "images/Large_Farm_with_Draw_Well.webp",
  },
  {
    compositionName: "Donkey",
    author: ["Govaert van der Leeuw"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370885",
    dateCreated: "17th century",
    imageUrl: "images/Donkey.webp",
  },
  {
    compositionName: "Ram",
    author: ["Govaert van der Leeuw"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370886",
    dateCreated: "17th century",
    imageUrl: "images/Ram.webp",
  },
  {
    compositionName: "A Cooper",
    author: ["Jacob van Strij"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/4931",
    dateCreated: "c. 1795-1800?",
    imageUrl: "images/A_Cooper.webp",
  },
  {
    compositionName: "The Triumph of the World",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/5328",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_the_World.webp",
  },
  {
    compositionName:
      'Title page for the portfolio "New European Graphics, Portfolio III: German Artists"',
    author: [
      "Various Artists",
      "Rudolf Bauer",
      "Heinrich Campendonk",
      "Jacoba B. van Heemskerck van Beest",
      "Johannes Molzahn",
      "Fritz Stuckenberg",
      "William Wauer",
      "August Macke",
      "Kurt Schwitters",
      "Bernhard Hoetger",
      "Walter Dexel",
      "Oskar Fischer",
      "Arnold Topp",
      "Willi Baumeister",
      "Franz Marc",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/19919",
    dateCreated: "1921",
    imageUrl:
      "images/Title_page_for_the_portfolio__New_European_Graphics__Portfolio_III__German_Artists_.webp",
  },
  {
    compositionName:
      'Composition, from the portfolio "New European Graphics, Portfolio III: German Artists"',
    author: ["Jacoba B. van Heemskerck van Beest"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/20197",
    dateCreated: "c. 1921",
    imageUrl:
      "images/Composition__from_the_portfolio__New_European_Graphics__Portfolio_III__German_Artists_.webp",
  },
  {
    compositionName: "The Triumph of Pride",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29404",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_Pride.webp",
  },
  {
    compositionName: "The Last Judgment",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29703",
    dateCreated: "1564",
    imageUrl: "images/The_Last_Judgment.webp",
  },
  {
    compositionName: "The Triumph of Peace",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29704",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_Peace.webp",
  },
  {
    compositionName: "The Triumph of Humility",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29705",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_Humility.webp",
  },
  {
    compositionName: "The Triumph of Envy",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29706",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_Envy.webp",
  },
  {
    compositionName: "The Triumph of Riches",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29787",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_Riches.webp",
  },
  {
    compositionName: "The Triumph of Want",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29812",
    dateCreated: "1564",
    imageUrl: "images/The_Triumph_of_Want.webp",
  },
  {
    compositionName: "The Triumph of War",
    author: ["Cornelis Cort", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29813",
    dateCreated: "1565",
    imageUrl: "images/The_Triumph_of_War.webp",
  },
  {
    compositionName: "We're Concerned, Are You?",
    author: ["Marguerite Van Cook"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30598",
    dateCreated: "1993",
    imageUrl: "images/We_re_Concerned__Are_You_.webp",
  },
  {
    compositionName: "Head of Adam van N------, after Van Dyck",
    author: ["Unidentified Artist", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30956",
    dateCreated: "19th century",
    imageUrl: "images/Head_of_Adam_van_N________after_Van_Dyck.webp",
  },
  {
    compositionName:
      "Blank; verso: Rhythmic Scheme of the Portinari Altarpiece, after Hugo van der Goes",
    author: ["Lewis W. Rubenstein", "After Hugo van der Goes"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/47971",
    dateCreated: "1931 - 1932",
    imageUrl:
      "images/Blank__verso__Rhythmic_Scheme_of_the_Portinari_Altarpiece__after_Hugo_van_der_Goes.webp",
  },
  {
    compositionName: "Dance of Death (Mortalium nobilitas, first edition)",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/48204",
    dateCreated: "17th century",
    imageUrl: "images/Dance_of_Death__Mortalium_nobilitas__first_edition_.webp",
  },
  {
    compositionName:
      "Right Panel of the Portinari Altarpiece, after Hugo van der Goes",
    author: ["Lewis W. Rubenstein", "After Hugo van der Goes"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/49072",
    dateCreated: "1931 - 1932",
    imageUrl:
      "images/Right_Panel_of_the_Portinari_Altarpiece__after_Hugo_van_der_Goes.webp",
  },
  {
    compositionName:
      "Steel-tube Furniture after Designs by Ludwig van der Rohe and Marcel Breuer",
    author: [
      "Unidentified Artist",
      "Chairs: Ludwig Mies van der Rohe",
      "Table and stool: Marcel Breuer",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/51996",
    dateCreated: "c. 1978",
    imageUrl:
      "images/Steel_tube_Furniture_after_Designs_by_Ludwig_van_der_Rohe_and_Marcel_Breuer.webp",
  },
  {
    compositionName:
      "Steel-Tube Furniture after Designs by Ludwig Mies van der Rohe and Marcel Breuer",
    author: ["Unidentified Artist", "Designer: Ludwig Mies van der Rohe"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/52417",
    dateCreated: "c. 1927",
    imageUrl:
      "images/Steel_Tube_Furniture_after_Designs_by_Ludwig_Mies_van_der_Rohe_and_Marcel_Breuer.webp",
  },
  {
    compositionName: "Album of 16th-century Netherlandish Prints and Drawings",
    author: [
      "Adriaen Collaert",
      "Joannes van Doetecum",
      "Philips Galle",
      "Lucas van Doetecum",
      "Jan Sadeler, the Younger",
      "Hans Bol",
      "Johann Sadeler I",
      "Hans Collaert the Elder",
      "Hans Collaert the Younger",
      "Various Artists",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/54451",
    dateCreated: "16th century",
    imageUrl:
      "images/Album_of_16th_century_Netherlandish_Prints_and_Drawings.webp",
  },
  {
    compositionName: "The Way of the Flesh",
    author: ["Workshop of Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/54946",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Way_of_the_Flesh.webp",
  },
  {
    compositionName: "The Way of Christ",
    author: ["Workshop of Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/54947",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Way_of_Christ.webp",
  },
  {
    compositionName: "Carolus Scribanus",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/54967",
    dateCreated: "1629",
    imageUrl: "images/Carolus_Scribanus.webp",
  },
  {
    compositionName: "The Way of the World",
    author: ["Workshop of Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/54973",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Way_of_the_World.webp",
  },
  {
    compositionName: "The Way of the Devil",
    author: ["Workshop of Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/54974",
    dateCreated: "c. 1573",
    imageUrl: "images/The_Way_of_the_Devil.webp",
  },
  {
    compositionName: "Eqvile Ioannis Avstriaci Caroli V",
    author: [
      "Hieronymus Wierix",
      "Adriaen Collaert",
      "Philips Galle",
      "After Jan van der Straet",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55073",
    dateCreated: "16th-17th century",
    imageUrl: "images/Eqvile_Ioannis_Avstriaci_Caroli_V.webp",
  },
  {
    compositionName: "Topographical View of Unidentified Belgian Town",
    author: ["Adam Frans van der Meulen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55128",
    dateCreated: "17th century",
    imageUrl: "images/Topographical_View_of_Unidentified_Belgian_Town.webp",
  },
  {
    compositionName: "Rembrandt at the Age of About Sixty",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259707",
    dateCreated: "18th century",
    imageUrl: "images/Rembrandt_at_the_Age_of_About_Sixty.webp",
  },
  {
    compositionName: "An Elderly Woman",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259708",
    dateCreated: "18th century",
    imageUrl: "images/An_Elderly_Woman.webp",
  },
  {
    compositionName: "Two Boors Drinking and Smoking",
    author: ["Georg Friedrich Schmidt", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259740",
    dateCreated: "18th century",
    imageUrl: "images/Two_Boors_Drinking_and_Smoking.webp",
  },
  {
    compositionName: "The Fianc\u00e9e's Father Arranging Her Dowry",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259742",
    dateCreated: "18th century",
    imageUrl: "images/The_Fiancee_s_Father_Arranging_Her_Dowry.webp",
  },
  {
    compositionName: "The Jewesh Fianc\u00e9e",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259855",
    dateCreated: "18th century",
    imageUrl: "images/The_Jewesh_Fiancee.webp",
  },
  {
    compositionName: "The Descent from the Cross, by Torchlight",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259969",
    dateCreated: "1654",
    imageUrl: "images/The_Descent_from_the_Cross__by_Torchlight.webp",
  },
  {
    compositionName: "Pharoah Summons Joseph before Him",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259971",
    dateCreated: "1646",
    imageUrl: "images/Pharoah_Summons_Joseph_before_Him.webp",
  },
  {
    compositionName: "The Mocking of Christ",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259972",
    dateCreated: "1648",
    imageUrl: "images/The_Mocking_of_Christ.webp",
  },
  {
    compositionName: "The Flagellation",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259974",
    dateCreated: "1648",
    imageUrl: "images/The_Flagellation.webp",
  },
  {
    compositionName: "The Corpse of Christ",
    author: ["Ferdinand Piloty", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260033",
    dateCreated: "19th century",
    imageUrl: "images/The_Corpse_of_Christ.webp",
  },
  {
    compositionName: "The Holy Family",
    author: ["Ferdinand Piloty", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260034",
    dateCreated: "19th century",
    imageUrl: "images/The_Holy_Family.webp",
  },
  {
    compositionName: "William, Count of Nassau, Prince of Orange",
    author: ["Christoffel van Sichem I", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/58375",
    dateCreated: "16th century",
    imageUrl: "images/William__Count_of_Nassau__Prince_of_Orange.webp",
  },
  {
    compositionName: "Naphthali",
    author: ["Jacques de Gheyn II", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/58755",
    dateCreated: "ca. 1589",
    imageUrl: "images/Naphthali.webp",
  },
  {
    compositionName: "Benjamin",
    author: ["Jacques de Gheyn II", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/58788",
    dateCreated: "ca. 1589",
    imageUrl: "images/Benjamin.webp",
  },
  {
    compositionName: "Issacher",
    author: ["Jacques de Gheyn II", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/59038",
    dateCreated: "ca. 1589",
    imageUrl: "images/Issacher.webp",
  },
  {
    compositionName: "Zebulon",
    author: ["Jacques de Gheyn II", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/59054",
    dateCreated: "ca. 1589",
    imageUrl: "images/Zebulon.webp",
  },
  {
    compositionName: "Ruben",
    author: ["Jacques de Gheyn II", "After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/59080",
    dateCreated: "ca. 1589",
    imageUrl: "images/Ruben.webp",
  },
  {
    compositionName: "Edward Sackville, Earl of Dorset",
    author: ["George Vertue", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69924",
    dateCreated: "18th century",
    imageUrl: "images/Edward_Sackville__Earl_of_Dorset.webp",
  },
  {
    compositionName: "The Diligent Worker United with Christ after Death",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69927",
    dateCreated: "1572",
    imageUrl: "images/The_Diligent_Worker_United_with_Christ_after_Death.webp",
  },
  {
    compositionName: "Labor and Diligence Enjoying Their Simple Meal",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69928",
    dateCreated: "1572",
    imageUrl: "images/Labor_and_Diligence_Enjoying_Their_Simple_Meal.webp",
  },
  {
    compositionName: "The Temple of Diana at Ephesus",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69930",
    dateCreated: "1572",
    imageUrl: "images/The_Temple_of_Diana_at_Ephesus.webp",
  },
  {
    compositionName: "Man Born to Toil",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69951",
    dateCreated: "1572",
    imageUrl: "images/Man_Born_to_Toil.webp",
  },
  {
    compositionName:
      "The Diligent Worker Aspiring to the Righteousness of the Lord",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69952",
    dateCreated: "1572",
    imageUrl:
      "images/The_Diligent_Worker_Aspiring_to_the_Righteousness_of_the_Lord.webp",
  },
  {
    compositionName: "The Colosseum at Rome",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69955",
    dateCreated: "1572",
    imageUrl: "images/The_Colosseum_at_Rome.webp",
  },
  {
    compositionName: "The Marriage of Labor and Diligence",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69962",
    dateCreated: "1572",
    imageUrl: "images/The_Marriage_of_Labor_and_Diligence.webp",
  },
  {
    compositionName:
      "The Lord Endowing the Diligent Worker with Food and Clothing",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69963",
    dateCreated: "1572",
    imageUrl:
      "images/The_Lord_Endowing_the_Diligent_Worker_with_Food_and_Clothing.webp",
  },
  {
    compositionName: "The Pyramids of Egypt",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69964",
    dateCreated: "1572",
    imageUrl: "images/The_Pyramids_of_Egypt.webp",
  },
  {
    compositionName: "The Walls of Babylon",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69965",
    dateCreated: "1572",
    imageUrl: "images/The_Walls_of_Babylon.webp",
  },
  {
    compositionName: "The Statue of Jupiter at Olympia",
    author: ["Copy after Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69992",
    dateCreated: "1572",
    imageUrl: "images/The_Statue_of_Jupiter_at_Olympia.webp",
  },
  {
    compositionName: "The Mausoleum at Halicarnassus",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/69993",
    dateCreated: "1572",
    imageUrl: "images/The_Mausoleum_at_Halicarnassus.webp",
  },
  {
    compositionName: "The Lighthouse at Alexandria",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/70327",
    dateCreated: "1572",
    imageUrl: "images/The_Lighthouse_at_Alexandria.webp",
  },
  {
    compositionName: "The Colossus of Rhodes",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/70328",
    dateCreated: "1572",
    imageUrl: "images/The_Colossus_of_Rhodes.webp",
  },
  {
    compositionName: "The Turbaned Soldier on Horseback",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/72026",
    dateCreated: "c. 1632",
    imageUrl: "images/The_Turbaned_Soldier_on_Horseback.webp",
  },
  {
    compositionName: "Christ",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260447",
    dateCreated: "16th century",
    imageUrl: "images/Christ.webp",
  },
  {
    compositionName: "James the Elder",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260448",
    dateCreated: "16th century",
    imageUrl: "images/James_the_Elder.webp",
  },
  {
    compositionName: "Thomas",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260449",
    dateCreated: "16th century",
    imageUrl: "images/Thomas.webp",
  },
  {
    compositionName: "Emperor Maximilian I",
    author: [
      "Tentatively attributed to Jan M\u00fcller",
      "After Lucas van Leyden",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260450",
    dateCreated: "20th century",
    imageUrl: "images/Emperor_Maximilian_I.webp",
  },
  {
    compositionName:
      "The Three Christian Worthies: King Arthur, Charlemagne, Godefroy de Bouillon",
    author: ["Harmen Jansz. M\u00fcller", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260520",
    dateCreated: "c. 1567",
    imageUrl:
      "images/The_Three_Christian_Worthies__King_Arthur__Charlemagne__Godefroy_de_Bouillon.webp",
  },
  {
    compositionName: "And Seth Fathered Enosh",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260718",
    dateCreated: "1646",
    imageUrl: "images/And_Seth_Fathered_Enosh.webp",
  },
  {
    compositionName: "The Rape of Thamar",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260719",
    dateCreated: "1646",
    imageUrl: "images/The_Rape_of_Thamar.webp",
  },
  {
    compositionName: "The Betrayal of Christ",
    author: ["Christoffel van Sichem II", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260720",
    dateCreated: "1646",
    imageUrl: "images/The_Betrayal_of_Christ.webp",
  },
  {
    compositionName: "The Crowning with Thorns",
    author: ["Christoffel van Sichem II", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260721",
    dateCreated: "1646",
    imageUrl: "images/The_Crowning_with_Thorns.webp",
  },
  {
    compositionName: "Ecce Homo",
    author: ["Christoffel van Sichem II", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260722",
    dateCreated: "1646",
    imageUrl: "images/Ecce_Homo.webp",
  },
  {
    compositionName: "Christ Carrying the Cross",
    author: ["Christoffel van Sichem II", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260723",
    dateCreated: "1646",
    imageUrl: "images/Christ_Carrying_the_Cross.webp",
  },
  {
    compositionName: "The Temptation of Christ",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260726",
    dateCreated: "1657",
    imageUrl: "images/The_Temptation_of_Christ.webp",
  },
  {
    compositionName: "Two Men Engaged in Conversation",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260758",
    dateCreated: "1646",
    imageUrl: "images/Two_Men_Engaged_in_Conversation.webp",
  },
  {
    compositionName: "The Resurrection",
    author: ["Christoffel van Sichem II", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260759",
    dateCreated: "1646",
    imageUrl: "images/The_Resurrection.webp",
  },
  {
    compositionName: "The Taking of Christ in the Garden",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260760",
    dateCreated: "1648",
    imageUrl: "images/The_Taking_of_Christ_in_the_Garden.webp",
  },
  {
    compositionName: "Christ is Beaten",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260761",
    dateCreated: "1648",
    imageUrl: "images/Christ_is_Beaten.webp",
  },
  {
    compositionName: "Christ Blesses Veronica while Bearing the Cross",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260762",
    dateCreated: "1648",
    imageUrl: "images/Christ_Blesses_Veronica_while_Bearing_the_Cross.webp",
  },
  {
    compositionName: "May",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/95456",
    dateCreated: "1616",
    imageUrl: "images/May.webp",
  },
  {
    compositionName: "March",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/95477",
    dateCreated: "1616",
    imageUrl: "images/March.webp",
  },
  {
    compositionName: "Landscape with Ruins, Animals Grazing in the Foreground",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/97570",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_Ruins__Animals_Grazing_in_the_Foreground.webp",
  },
  {
    compositionName:
      "Landscape with a Road Leading through Rocks into a Valley",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/97571",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_a_Road_Leading_through_Rocks_into_a_Valley.webp",
  },
  {
    compositionName: "Landscape with a River, a Road and a Cliff to the Left",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/97572",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_a_River__a_Road_and_a_Cliff_to_the_Left.webp",
  },
  {
    compositionName:
      "Landscape with a Broad River and a Rider in the Foreground",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/97573",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_a_Broad_River_and_a_Rider_in_the_Foreground.webp",
  },
  {
    compositionName: "Landscape with a Wooden Bridge, a Traveler at the Right",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/97602",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_a_Wooden_Bridge__a_Traveler_at_the_Right.webp",
  },
  {
    compositionName: "Landscape with Two Churches in the Distance",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/99703",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Two_Churches_in_the_Distance.webp",
  },
  {
    compositionName: "Landscape with Hunters Chasing a Deer",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/99704",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Hunters_Chasing_a_Deer.webp",
  },
  {
    compositionName: "Landscape with Wayfarers Pointing Toward a Horseman",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/99931",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Wayfarers_Pointing_Toward_a_Horseman.webp",
  },
  {
    compositionName:
      "Landscape with a Wooden Bridge, a Village in the Distance",
    author: ["Jan van Aken"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/99945",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_a_Wooden_Bridge__a_Village_in_the_Distance.webp",
  },
  {
    compositionName:
      "Two Wooden Houses in the Goudsbloemstraat, Burned December 25, 1682",
    author: ["Jan van der Heyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/100021",
    dateCreated: "1682",
    imageUrl:
      "images/Two_Wooden_Houses_in_the_Goudsbloemstraat__Burned_December_25__1682.webp",
  },
  {
    compositionName: "Joshua, David, and Judas Maccabeus",
    author: ["Harmen Jansz. M\u00fcller", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/143738",
    dateCreated: "c. 1567",
    imageUrl: "images/Joshua__David__and_Judas_Maccabeus.webp",
  },
  {
    compositionName:
      "Hector of Troy, Alexander of Macedonia, and Julius Caesar",
    author: ["Harmen Jansz. M\u00fcller", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/143997",
    dateCreated: "c. 1567",
    imageUrl:
      "images/Hector_of_Troy__Alexander_of_Macedonia__and_Julius_Caesar.webp",
  },
  {
    compositionName: "King Arthur, Charlemange, and Godfrey of Bouillon",
    author: ["Harmen Jansz. M\u00fcller", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/143998",
    dateCreated: "c. 1567",
    imageUrl: "images/King_Arthur__Charlemange__and_Godfrey_of_Bouillon.webp",
  },
  {
    compositionName: "Pentecost",
    author: ["Bernard van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/144755",
    dateCreated: "c. 1520-30",
    imageUrl: "images/Pentecost.webp",
  },
  {
    compositionName: "Willard Van Orman Quine (1908-2000)",
    author: ["Dragan Radenovi\u0107", "Willard Van Orman Quine"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/148374",
    dateCreated: "20th century",
    imageUrl: "images/Willard_Van_Orman_Quine__1908_2000_.webp",
  },
  {
    compositionName: "Untitled (bride and bridegroom)",
    author: ["James Augustus Joseph Van Der Zee"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/155451",
    dateCreated: "c. 1926",
    imageUrl: "images/Untitled__bride_and_bridegroom_.webp",
  },
  {
    compositionName: "Untitled (portrait of wedding party, New York)",
    author: ["James Augustus Joseph Van Der Zee"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/155991",
    dateCreated: "1923",
    imageUrl: "images/Untitled__portrait_of_wedding_party__New_York_.webp",
  },
  {
    compositionName: "View of Rhynfels",
    author: ["Circle of Jan van Call I", "Circle of Johannes Teyler"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/165310",
    dateCreated: "c. 1685",
    imageUrl: "images/View_of_Rhynfels.webp",
  },
  {
    compositionName: "Ireland",
    author: ["Willard Van Dyke"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/166660",
    dateCreated: "1979",
    imageUrl: "images/Ireland.webp",
  },
  {
    compositionName: "A Man Seated at a Table Holding a Pipe",
    author: ["Jacob van Strij"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/169985",
    dateCreated: "18th-19th century",
    imageUrl: "images/A_Man_Seated_at_a_Table_Holding_a_Pipe.webp",
  },
  {
    compositionName: "Judith with the Head of Holofernes",
    author: ["Christoffel van Sichem I", "After Hendrick Goltzius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261990",
    dateCreated: "16th-17th century",
    imageUrl: "images/Judith_with_the_Head_of_Holofernes.webp",
  },
  {
    compositionName: "Christ Crucified between the Two Thieves: Oval Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262064",
    dateCreated: "c. 1641",
    imageUrl:
      "images/Christ_Crucified_between_the_Two_Thieves__Oval_Plate.webp",
  },
  {
    compositionName: "Self-Portrait with Raised Sabre",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262075",
    dateCreated: "1634",
    imageUrl: "images/Self_Portrait_with_Raised_Sabre.webp",
  },
  {
    compositionName: "Christ and the Woman of Samaria: An Arched Print",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262078",
    dateCreated: "1658",
    imageUrl: "images/Christ_and_the_Woman_of_Samaria__An_Arched_Print.webp",
  },
  {
    compositionName: "Self-Portrait Leaning on a Stone Sill",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262113",
    dateCreated: "1639",
    imageUrl: "images/Self_Portrait_Leaning_on_a_Stone_Sill.webp",
  },
  {
    compositionName: "Self-Portrait Etching at a Window",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262114",
    dateCreated: "1648",
    imageUrl: "images/Self_Portrait_Etching_at_a_Window.webp",
  },
  {
    compositionName: "Self-Portrait in a Fur Cap: Bust",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262115",
    dateCreated: "1630",
    imageUrl: "images/Self_Portrait_in_a_Fur_Cap__Bust.webp",
  },
  {
    compositionName: "The Angel Appearing to the Shepherds",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262117",
    dateCreated: "1634",
    imageUrl: "images/The_Angel_Appearing_to_the_Shepherds.webp",
  },
  {
    compositionName: "The Hundred Guilder Print",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262118",
    dateCreated: "c. 1649",
    imageUrl: "images/The_Hundred_Guilder_Print.webp",
  },
  {
    compositionName: "Crucifixion: Small Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262144",
    dateCreated: "c. 1634",
    imageUrl: "images/Crucifixion__Small_Plate.webp",
  },
  {
    compositionName: "The Entombment",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262158",
    dateCreated: "c. 1654",
    imageUrl: "images/The_Entombment.webp",
  },
  {
    compositionName: "Christ at Emmaus: the Larger Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262159",
    dateCreated: "c. 1654",
    imageUrl: "images/Christ_at_Emmaus__the_Larger_Plate.webp",
  },
  {
    compositionName: "Christ Presented to the People: Oblong Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262202",
    dateCreated: "1655",
    imageUrl: "images/Christ_Presented_to_the_People__Oblong_Plate.webp",
  },
  {
    compositionName: "Adoration of the Shepherds (with the Lamp)",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262217",
    dateCreated: "c. 1654",
    imageUrl: "images/Adoration_of_the_Shepherds__with_the_Lamp_.webp",
  },
  {
    compositionName: "Quacksalver",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262219",
    dateCreated: "1635",
    imageUrl: "images/Quacksalver.webp",
  },
  {
    compositionName: "Cottage with a White Paling",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262236",
    dateCreated: "1648",
    imageUrl: "images/Cottage_with_a_White_Paling.webp",
  },
  {
    compositionName: "Jan Lutma, Goldsmith",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262237",
    dateCreated: "1656",
    imageUrl: "images/Jan_Lutma__Goldsmith.webp",
  },
  {
    compositionName: "Beggar in a High Cap, Standing and Leaning on a Stick",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262239",
    dateCreated: "17th century",
    imageUrl:
      "images/Beggar_in_a_High_Cap__Standing_and_Leaning_on_a_Stick.webp",
  },
  {
    compositionName:
      'Landscape with a Farm Building and the "House with the Tower"',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262251",
    dateCreated: "c. 1651",
    imageUrl:
      "images/Landscape_with_a_Farm_Building_and_the__House_with_the_Tower_.webp",
  },
  {
    compositionName: "Landscape with Cottages and a Hay Barn: Oblong",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262252",
    dateCreated: "1641",
    imageUrl: "images/Landscape_with_Cottages_and_a_Hay_Barn__Oblong.webp",
  },
  {
    compositionName: 'Study for a Statue in "Joseph and Potiphar\'s Wife"',
    author: ["Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/194451",
    dateCreated: "1716-1722",
    imageUrl: "images/Study_for_a_Statue_in__Joseph_and_Potiphar_s_Wife_.webp",
  },
  {
    compositionName: "Winter",
    author: ["Pieter van der Heyden", "After Hans Bol"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/195472",
    dateCreated: "1570",
    imageUrl: "images/Winter.webp",
  },
  {
    compositionName: "Herdsman with His Flock",
    author: ["Jan van Brosterhuisen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/195473",
    dateCreated: "17th century",
    imageUrl: "images/Herdsman_with_His_Flock.webp",
  },
  {
    compositionName: "River Landscape with a Castle",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198089",
    dateCreated: "1615",
    imageUrl: "images/River_Landscape_with_a_Castle.webp",
  },
  {
    compositionName: "Chapel near a Pond",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198090",
    dateCreated: "1615",
    imageUrl: "images/Chapel_near_a_Pond.webp",
  },
  {
    compositionName: "Brederode Castle",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198091",
    dateCreated: "1615",
    imageUrl: "images/Brederode_Castle.webp",
  },
  {
    compositionName: "A Man Netting Birds",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198092",
    dateCreated: "1615",
    imageUrl: "images/A_Man_Netting_Birds.webp",
  },
  {
    compositionName: "Huntsmen with Hounds near a Farm",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198093",
    dateCreated: "1615",
    imageUrl: "images/Huntsmen_with_Hounds_near_a_Farm.webp",
  },
  {
    compositionName: "Titlepage",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198143",
    dateCreated: "1616",
    imageUrl: "images/Titlepage.webp",
  },
  {
    compositionName: "Draw-well among Trees",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/198144",
    dateCreated: "1616",
    imageUrl: "images/Draw_well_among_Trees.webp",
  },
  {
    compositionName: "Locksmith",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262392",
    dateCreated: "1635",
    imageUrl: "images/Locksmith.webp",
  },
  {
    compositionName: "Stretcher of Cloth",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262393",
    dateCreated: "1635",
    imageUrl: "images/Stretcher_of_Cloth.webp",
  },
  {
    compositionName: "Bust of an Old Man",
    author: ["Jan Joris van Vliet", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262416",
    dateCreated: "17th century",
    imageUrl: "images/Bust_of_an_Old_Man.webp",
  },
  {
    compositionName: "Sculptor",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262482",
    dateCreated: "1635",
    imageUrl: "images/Sculptor.webp",
  },
  {
    compositionName: "Broom-Maker",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262483",
    dateCreated: "1635",
    imageUrl: "images/Broom_Maker.webp",
  },
  {
    compositionName: "Shoemaker",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262484",
    dateCreated: "1635",
    imageUrl: "images/Shoemaker.webp",
  },
  {
    compositionName: "Turner",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262547",
    dateCreated: "1635",
    imageUrl: "images/Turner.webp",
  },
  {
    compositionName: "Baker",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262548",
    dateCreated: "1635",
    imageUrl: "images/Baker.webp",
  },
  {
    compositionName: "Cooper",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262549",
    dateCreated: "1635",
    imageUrl: "images/Cooper.webp",
  },
  {
    compositionName: "Weaver",
    author: ["Jan Joris van Vliet", "Published by Cornelis Danckerts I"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262550",
    dateCreated: "1635",
    imageUrl: "images/Weaver.webp",
  },
  {
    compositionName: "Tinsmith",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262568",
    dateCreated: "1635",
    imageUrl: "images/Tinsmith.webp",
  },
  {
    compositionName: "Tailor",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262569",
    dateCreated: "1635",
    imageUrl: "images/Tailor.webp",
  },
  {
    compositionName: "Mason",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262587",
    dateCreated: "1635",
    imageUrl: "images/Mason.webp",
  },
  {
    compositionName: "Carpenter",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262588",
    dateCreated: "1635",
    imageUrl: "images/Carpenter.webp",
  },
  {
    compositionName: "Hatter",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262589",
    dateCreated: "1635",
    imageUrl: "images/Hatter.webp",
  },
  {
    compositionName: "Glazier",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262590",
    dateCreated: "1635",
    imageUrl: "images/Glazier.webp",
  },
  {
    compositionName: "Home, Family, Work, Community",
    author: ["Anton van Dalen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262675",
    dateCreated: "1993",
    imageUrl: "images/Home__Family__Work__Community.webp",
  },
  {
    compositionName: "The Angel Departing from the Family of Tobias",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262681",
    dateCreated: "1641",
    imageUrl: "images/The_Angel_Departing_from_the_Family_of_Tobias.webp",
  },
  {
    compositionName: 'Christ Preaching ("La Petite Tombe")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262682",
    dateCreated: "c. 1652",
    imageUrl: "images/Christ_Preaching___La_Petite_Tombe__.webp",
  },
  {
    compositionName: "The Blindness of Tobit: The Larger Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262702",
    dateCreated: "1651",
    imageUrl: "images/The_Blindness_of_Tobit__The_Larger_Plate.webp",
  },
  {
    compositionName: "Sail-maker",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262980",
    dateCreated: "1635",
    imageUrl: "images/Sail_maker.webp",
  },
  {
    compositionName: "A Stroll in the Haarlem Woods",
    author: ["Jan van der Vinne"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262991",
    dateCreated: "17th-18th century",
    imageUrl: "images/A_Stroll_in_the_Haarlem_Woods.webp",
  },
  {
    compositionName: "Basket-Maker",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263000",
    dateCreated: "1635",
    imageUrl: "images/Basket_Maker.webp",
  },
  {
    compositionName: "Jacques de Cachiopin",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263020",
    dateCreated: "17th century",
    imageUrl: "images/Jacques_de_Cachiopin.webp",
  },
  {
    compositionName: "Joachim and Anna at the Golden Gate",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263057",
    dateCreated: "1520",
    imageUrl: "images/Joachim_and_Anna_at_the_Golden_Gate.webp",
  },
  {
    compositionName: "Saint Peter",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263241",
    dateCreated: "c. 1510",
    imageUrl: "images/Saint_Peter.webp",
  },
  {
    compositionName: "Judas Thaddeus",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263242",
    dateCreated: "c. 1510",
    imageUrl: "images/Judas_Thaddeus.webp",
  },
  {
    compositionName: "Saint Thomas",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263243",
    dateCreated: "c. 1510",
    imageUrl: "images/Saint_Thomas.webp",
  },
  {
    compositionName: "Saint James the Greater",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263244",
    dateCreated: "c. 1510",
    imageUrl: "images/Saint_James_the_Greater.webp",
  },
  {
    compositionName: "Philip",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263314",
    dateCreated: "c. 1510",
    imageUrl: "images/Philip.webp",
  },
  {
    compositionName: "Bartholomew",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263315",
    dateCreated: "c. 1510",
    imageUrl: "images/Bartholomew.webp",
  },
  {
    compositionName: "John",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263537",
    dateCreated: "c. 1510",
    imageUrl: "images/John.webp",
  },
  {
    compositionName: "Saint Andrew",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263538",
    dateCreated: "c. 1510",
    imageUrl: "images/Saint_Andrew.webp",
  },
  {
    compositionName: "The Crossing of the Rhine",
    author: [
      "Pierre Louis Henri Laurent",
      "Jean Duplessis-Bertaux",
      "After Adam Frans van der Meulen",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/263600",
    dateCreated: "19th century",
    imageUrl: "images/The_Crossing_of_the_Rhine.webp",
  },
  {
    compositionName: "Flower Piece",
    author: ["Richard Earlom", "After Jan van Huysum II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/264851",
    dateCreated: "1778",
    imageUrl: "images/Flower_Piece.webp",
  },
  {
    compositionName: "Man with a Pink",
    author: ["Ferdinand Gaillard", "After Jan van Eyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265147",
    dateCreated: "19th century",
    imageUrl: "images/Man_with_a_Pink.webp",
  },
  {
    compositionName: "Interior",
    author: ["Charles-\u00c9mile Jacque", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265412",
    dateCreated: "19th century",
    imageUrl: "images/Interior.webp",
  },
  {
    compositionName: "Man With a Turban",
    author: ["Felix Jazinski", "After Jan van Eyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265445",
    dateCreated: "19th-20th century",
    imageUrl: "images/Man_With_a_Turban.webp",
  },
  {
    compositionName: "Jacob van Vien",
    author: ["Jules Ferdinand Jacquemart", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265455",
    dateCreated: "1871",
    imageUrl: "images/Jacob_van_Vien.webp",
  },
  {
    compositionName: "Marine",
    author: ["Jules Ferdinand Jacquemart", "After Jan van de Capelle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265456",
    dateCreated: "19th century",
    imageUrl: "images/Marine.webp",
  },
  {
    compositionName: "Edge of the Meuse",
    author: ["Jules Ferdinand Jacquemart", "After Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265457",
    dateCreated: "19th century",
    imageUrl: "images/Edge_of_the_Meuse.webp",
  },
  {
    compositionName: "Death Appearing to a Wedded Couple",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273665",
    dateCreated: "1639",
    imageUrl: "images/Death_Appearing_to_a_Wedded_Couple.webp",
  },
  {
    compositionName: "Wild Men Climbing to the Flower of Love",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273689",
    dateCreated: "15th-16th century",
    imageUrl: "images/Wild_Men_Climbing_to_the_Flower_of_Love.webp",
  },
  {
    compositionName: "Saint Martin",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273815",
    dateCreated: "15th century",
    imageUrl: "images/Saint_Martin.webp",
  },
  {
    compositionName: "The Beggar",
    author: [
      "Wenceslaus Hollar",
      "After Jacques d'Arthois",
      "Published by Peeter van Avont",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273840",
    dateCreated: "1649",
    imageUrl: "images/The_Beggar.webp",
  },
  {
    compositionName:
      "The Artist's Mother in a Cloth Headdress, Looking Down: Head Only",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273844",
    dateCreated: "1633",
    imageUrl:
      "images/The_Artist_s_Mother_in_a_Cloth_Headdress__Looking_Down__Head_Only.webp",
  },
  {
    compositionName: "Anatomic Demonstration",
    author: ["Jan Pieter de Frey", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273895",
    dateCreated: "18th-19th century",
    imageUrl: "images/Anatomic_Demonstration.webp",
  },
  {
    compositionName: "Snydics de la halle aux draps",
    author: ["Jan Pieter de Frey", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273896",
    dateCreated: "18th-19th century",
    imageUrl: "images/Snydics_de_la_halle_aux_draps.webp",
  },
  {
    compositionName: "The Israelites Finding Achior Tied to a Tree",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273911",
    dateCreated: "1564",
    imageUrl: "images/The_Israelites_Finding_Achior_Tied_to_a_Tree.webp",
  },
  {
    compositionName: "Hermit Reading in the Wilderness",
    author: ["Jan Pieter de Frey", "After Quiringh Gerritsz van Brekelenkam"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273993",
    dateCreated: "18th-19th century",
    imageUrl: "images/Hermit_Reading_in_the_Wilderness.webp",
  },
  {
    compositionName: "Charity",
    author: ["Cornelis van Caukercken", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273999",
    dateCreated: "17th century",
    imageUrl: "images/Charity.webp",
  },
  {
    compositionName: "John Lesley, \u00e9veque de Ross",
    author: ["Pieter van Gunst", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274736",
    dateCreated: "18th century",
    imageUrl: "images/John_Lesley__eveque_de_Ross.webp",
  },
  {
    compositionName: "Jan Pietersz Zomer",
    author: ["Arnoud van Halen", "After Adriaen van Bloemen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274737",
    dateCreated: "1717",
    imageUrl: "images/Jan_Pietersz_Zomer.webp",
  },
  {
    compositionName: "Simon Episcopius",
    author: ["Pieter van Gunst", "After Hendrik Martensz. Sorgh"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274768",
    dateCreated: "18th century",
    imageUrl: "images/Simon_Episcopius.webp",
  },
  {
    compositionName: "Jan van den Honert",
    author: ["Jacobus Houbraken", "After Hieronymus van der Mij"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274807",
    dateCreated: "18th century",
    imageUrl: "images/Jan_van_den_Honert.webp",
  },
  {
    compositionName: "Theodor van Thulden",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274821",
    dateCreated: "17th century",
    imageUrl: "images/Theodor_van_Thulden.webp",
  },
  {
    compositionName: "Albert de Wallenstein, Duke of Friedland",
    author: ["Pieter de Jode, the Younger", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274822",
    dateCreated: "17th century",
    imageUrl: "images/Albert_de_Wallenstein__Duke_of_Friedland.webp",
  },
  {
    compositionName: "Branch of a Tree",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274823",
    dateCreated: "17th century",
    imageUrl: "images/Branch_of_a_Tree.webp",
  },
  {
    compositionName: "Spotted Bull and Three Sheep",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232876",
    dateCreated: "1670",
    imageUrl: "images/Spotted_Bull_and_Three_Sheep.webp",
  },
  {
    compositionName: "The Pantheon (S. Maria Rotunda)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232885",
    dateCreated: "16th century",
    imageUrl: "images/The_Pantheon__S__Maria_Rotunda_.webp",
  },
  {
    compositionName: "Forum of the Holy Apostles (Forum SS. Apostolorum)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232886",
    dateCreated: "16th century",
    imageUrl: "images/Forum_of_the_Holy_Apostles__Forum_SS__Apostolorum_.webp",
  },
  {
    compositionName: "Bridge over the Tiber (Pons quatuor capitum)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232887",
    dateCreated: "16th century",
    imageUrl: "images/Bridge_over_the_Tiber__Pons_quatuor_capitum_.webp",
  },
  {
    compositionName: "Ostia, Rome (Hostia)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232888",
    dateCreated: "16th century",
    imageUrl: "images/Ostia__Rome__Hostia_.webp",
  },
  {
    compositionName: "November",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232894",
    dateCreated: "1618",
    imageUrl: "images/November.webp",
  },
  {
    compositionName: "Lacus Nemorensis, sive Ariciae",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232904",
    dateCreated: "16th century",
    imageUrl: "images/Lacus_Nemorensis__sive_Ariciae.webp",
  },
  {
    compositionName:
      "The House of Loreto (Loreti opidi, Divae Mariae sacri, effigies)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232905",
    dateCreated: "16th century",
    imageUrl:
      "images/The_House_of_Loreto__Loreti_opidi__Divae_Mariae_sacri__effigies_.webp",
  },
  {
    compositionName:
      "An Imaginary View by Hendrick van Cleve (Inventio pictoria, Henrici Cliventis)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232926",
    dateCreated: "16th century",
    imageUrl:
      "images/An_Imaginary_View_by_Hendrick_van_Cleve__Inventio_pictoria__Henrici_Cliventis_.webp",
  },
  {
    compositionName: "Joseph Relating his Dreams",
    author: ["Dominique Vivant Denon", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233068",
    dateCreated: "c. 1790",
    imageUrl: "images/Joseph_Relating_his_Dreams.webp",
  },
  {
    compositionName: "Skulls",
    author: ["Antoon Philippus Derkzen van Angeren"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233072",
    dateCreated: "1907",
    imageUrl: "images/Skulls.webp",
  },
  {
    compositionName: "Grain Field at the Edge of a Wood",
    author: ["Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233073",
    dateCreated: "1648",
    imageUrl: "images/Grain_Field_at_the_Edge_of_a_Wood.webp",
  },
  {
    compositionName: "Amerigo Vespucci on His Ship",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233090",
    dateCreated: "c. 1595",
    imageUrl: "images/Amerigo_Vespucci_on_His_Ship.webp",
  },
  {
    compositionName: "Two Floating Joists",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275004",
    dateCreated: "17th century",
    imageUrl: "images/Two_Floating_Joists.webp",
  },
  {
    compositionName: "Big Tree",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275005",
    dateCreated: "17th century",
    imageUrl: "images/Big_Tree.webp",
  },
  {
    compositionName: "Remnants of the Fence",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275006",
    dateCreated: "17th century",
    imageUrl: "images/Remnants_of_the_Fence.webp",
  },
  {
    compositionName: "Dilapidated Hut",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275007",
    dateCreated: "17th century",
    imageUrl: "images/Dilapidated_Hut.webp",
  },
  {
    compositionName: "Man at the Entrance of the Dilapidated Fence",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275008",
    dateCreated: "17th century",
    imageUrl: "images/Man_at_the_Entrance_of_the_Dilapidated_Fence.webp",
  },
  {
    compositionName: "Two Men on the Elevated Terrace",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275009",
    dateCreated: "17th century",
    imageUrl: "images/Two_Men_on_the_Elevated_Terrace.webp",
  },
  {
    compositionName: "Marine View Seen through a Hollow of a Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275010",
    dateCreated: "17th century",
    imageUrl: "images/Marine_View_Seen_through_a_Hollow_of_a_Rock.webp",
  },
  {
    compositionName: "Pines in a Ravine",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275012",
    dateCreated: "17th century",
    imageUrl: "images/Pines_in_a_Ravine.webp",
  },
  {
    compositionName: "Watermill at the Foot of a Mountain, an Artist Sketching",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275014",
    dateCreated: "17th century",
    imageUrl:
      "images/Watermill_at_the_Foot_of_a_Mountain__an_Artist_Sketching.webp",
  },
  {
    compositionName: "Wheel under a Movable Thatched Roof",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275015",
    dateCreated: "17th century",
    imageUrl: "images/Wheel_under_a_Movable_Thatched_Roof.webp",
  },
  {
    compositionName: "Mill under the Waterfall",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275016",
    dateCreated: "17th century",
    imageUrl: "images/Mill_under_the_Waterfall.webp",
  },
  {
    compositionName: "Landscape with Three Men Carrying Burdens",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275017",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Three_Men_Carrying_Burdens.webp",
  },
  {
    compositionName: "Shepherd",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275018",
    dateCreated: "17th century",
    imageUrl: "images/Shepherd.webp",
  },
  {
    compositionName: "Reynard is hung from tree at Lion's Court",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275019",
    dateCreated: "17th century",
    imageUrl: "images/Reynard_is_hung_from_tree_at_Lion_s_Court.webp",
  },
  {
    compositionName: "August",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233329",
    dateCreated: "1618",
    imageUrl: "images/August.webp",
  },
  {
    compositionName: "December",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233330",
    dateCreated: "1618",
    imageUrl: "images/December.webp",
  },
  {
    compositionName: "October",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233350",
    dateCreated: "1618",
    imageUrl: "images/October.webp",
  },
  {
    compositionName: "The Sportsman with Seven Dogs",
    author: ["Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/234678",
    dateCreated: "17th century",
    imageUrl: "images/The_Sportsman_with_Seven_Dogs.webp",
  },
  {
    compositionName: "Bear appears before Lion's Court, his back to viewer",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275047",
    dateCreated: "17th century",
    imageUrl:
      "images/Bear_appears_before_Lion_s_Court__his_back_to_viewer.webp",
  },
  {
    compositionName: "Reynard leads wolf into Lion's Court, wolf bows",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275052",
    dateCreated: "17th century",
    imageUrl: "images/Reynard_leads_wolf_into_Lion_s_Court__wolf_bows.webp",
  },
  {
    compositionName: "Rabbit meets Reynard in field",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275053",
    dateCreated: "17th century",
    imageUrl: "images/Rabbit_meets_Reynard_in_field.webp",
  },
  {
    compositionName: "Farmers surround bear",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275054",
    dateCreated: "17th century",
    imageUrl: "images/Farmers_surround_bear.webp",
  },
  {
    compositionName: "Reynard and animals gather in forest, addressed by Lion",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275055",
    dateCreated: "17th century",
    imageUrl:
      "images/Reynard_and_animals_gather_in_forest__addressed_by_Lion.webp",
  },
  {
    compositionName: "Jan van Zuren",
    author: ["Hendrick Goltzius", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275068",
    dateCreated: "1590",
    imageUrl: "images/Jan_van_Zuren.webp",
  },
  {
    compositionName: "Reynard captures two birds",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275072",
    dateCreated: "17th century",
    imageUrl: "images/Reynard_captures_two_birds.webp",
  },
  {
    compositionName: "Horses fend off wolf attack",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275073",
    dateCreated: "17th century",
    imageUrl: "images/Horses_fend_off_wolf_attack.webp",
  },
  {
    compositionName: "Lion addresses animals, cock and badgers in foreground",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275074",
    dateCreated: "17th century",
    imageUrl:
      "images/Lion_addresses_animals__cock_and_badgers_in_foreground.webp",
  },
  {
    compositionName: "Bear is spoken to by Lion and Wolf",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275075",
    dateCreated: "17th century",
    imageUrl: "images/Bear_is_spoken_to_by_Lion_and_Wolf.webp",
  },
  {
    compositionName: "Bust of An Old Man",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235536",
    dateCreated: "17th century",
    imageUrl: "images/Bust_of_An_Old_Man.webp",
  },
  {
    compositionName: "Ruins of the Coloseum",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235537",
    dateCreated: "17th century",
    imageUrl: "images/Ruins_of_the_Coloseum.webp",
  },
  {
    compositionName: "Various Ruins and Views ... (a book of 37 plates)",
    author: ["Hendrick van Cleve III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235577",
    dateCreated: "16th century",
    imageUrl: "images/Various_Ruins_and_Views______a_book_of_37_plates_.webp",
  },
  {
    compositionName: "The Legendary Prester John",
    author: [
      "Luca Ciamberlano",
      "After Agostino Carracci",
      "After Karel van Mander",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235663",
    dateCreated: "c. 1599",
    imageUrl: "images/The_Legendary_Prester_John.webp",
  },
  {
    compositionName: "The Seated Cowherd",
    author: ["Jean Morin", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235759",
    dateCreated: "17th century",
    imageUrl: "images/The_Seated_Cowherd.webp",
  },
  {
    compositionName: '"La Cafarelle"',
    author: ["Jean Morin", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235760",
    dateCreated: "17th century",
    imageUrl: "images/_La_Cafarelle_.webp",
  },
  {
    compositionName: "Mercury Accuses Battus",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235766",
    dateCreated: "17th century",
    imageUrl: "images/Mercury_Accuses_Battus.webp",
  },
  {
    compositionName: "Bacchus and Ariadne",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235767",
    dateCreated: "17th century",
    imageUrl: "images/Bacchus_and_Ariadne.webp",
  },
  {
    compositionName: "A Woman Bathing Seen from Behind",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235768",
    dateCreated: "17th century",
    imageUrl: "images/A_Woman_Bathing_Seen_from_Behind.webp",
  },
  {
    compositionName: "Marriage of the Virgin",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235811",
    dateCreated: "17th-18th century",
    imageUrl: "images/Marriage_of_the_Virgin.webp",
  },
  {
    compositionName: "Christ on the Cross",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235814",
    dateCreated: "17th-18th century",
    imageUrl: "images/Christ_on_the_Cross.webp",
  },
  {
    compositionName: "The Nativity",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235831",
    dateCreated: "17th-18th century",
    imageUrl: "images/The_Nativity.webp",
  },
  {
    compositionName: "The Dream of Joseph",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235832",
    dateCreated: "17th-18th century",
    imageUrl: "images/The_Dream_of_Joseph.webp",
  },
  {
    compositionName: "The Agony in the Garden",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235833",
    dateCreated: "17th-18th century",
    imageUrl: "images/The_Agony_in_the_Garden.webp",
  },
  {
    compositionName: "The Death of Saint Joseph",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235852",
    dateCreated: "17th-18th century",
    imageUrl: "images/The_Death_of_Saint_Joseph.webp",
  },
  {
    compositionName: "The Walls of Ancient Rome",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235908",
    dateCreated: "17th century",
    imageUrl: "images/The_Walls_of_Ancient_Rome.webp",
  },
  {
    compositionName: "The Triumphal Arch of Constantine",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235909",
    dateCreated: "17th century",
    imageUrl: "images/The_Triumphal_Arch_of_Constantine.webp",
  },
  {
    compositionName: "Cottage Near a Pond",
    author: ["Jan van Brosterhuisen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235910",
    dateCreated: "17th century",
    imageUrl: "images/Cottage_Near_a_Pond.webp",
  },
  {
    compositionName: "Roman Ruins",
    author: ["Jan Gerritsz. van Bronchorst", "After Cornelis van Poelenburch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235944",
    dateCreated: "17th century",
    imageUrl: "images/Roman_Ruins.webp",
  },
  {
    compositionName: "Winding River",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275172",
    dateCreated: "17th century",
    imageUrl: "images/Winding_River.webp",
  },
  {
    compositionName: "Rock Rising from the Water",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275173",
    dateCreated: "17th century",
    imageUrl: "images/Rock_Rising_from_the_Water.webp",
  },
  {
    compositionName: "Titian and His Mistress",
    author: ["Anthony van Dyck", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275192",
    dateCreated: "17th century",
    imageUrl: "images/Titian_and_His_Mistress.webp",
  },
  {
    compositionName: "Four Fathers of the Church",
    author: ["Cornelis van Dalen, the Younger", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275236",
    dateCreated: "17th century",
    imageUrl: "images/Four_Fathers_of_the_Church.webp",
  },
  {
    compositionName: "Pietro Aretino",
    author: [
      "Cornelis van Dalen, the Younger",
      "After Titian (Tiziano Vecellio)",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275237",
    dateCreated: "17th century",
    imageUrl: "images/Pietro_Aretino.webp",
  },
  {
    compositionName: "Small Oval Landscape, Upright",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275243",
    dateCreated: "17th century",
    imageUrl: "images/Small_Oval_Landscape__Upright.webp",
  },
  {
    compositionName: "First Small Oval Landscape, Oblong",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275244",
    dateCreated: "17th century",
    imageUrl: "images/First_Small_Oval_Landscape__Oblong.webp",
  },
  {
    compositionName: "Man on the Wooden Bridge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275245",
    dateCreated: "17th century",
    imageUrl: "images/Man_on_the_Wooden_Bridge.webp",
  },
  {
    compositionName: "Hamlet on a Hilly Ground",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275247",
    dateCreated: "17th century",
    imageUrl: "images/Hamlet_on_a_Hilly_Ground.webp",
  },
  {
    compositionName: "Horseman on the Stone Bridge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275325",
    dateCreated: "17th century",
    imageUrl: "images/Horseman_on_the_Stone_Bridge.webp",
  },
  {
    compositionName: "The Unloading of the Barge",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275337",
    dateCreated: "17th century",
    imageUrl: "images/The_Unloading_of_the_Barge.webp",
  },
  {
    compositionName: "Goatherd on the Hill",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275338",
    dateCreated: "17th century",
    imageUrl: "images/Goatherd_on_the_Hill.webp",
  },
  {
    compositionName: "Hamlet on the Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275339",
    dateCreated: "17th century",
    imageUrl: "images/Hamlet_on_the_Rock.webp",
  },
  {
    compositionName: "Three Figures on the Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275340",
    dateCreated: "17th century",
    imageUrl: "images/Three_Figures_on_the_Rock.webp",
  },
  {
    compositionName: "House with the Pointed Turret",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275341",
    dateCreated: "17th century",
    imageUrl: "images/House_with_the_Pointed_Turret.webp",
  },
  {
    compositionName: "Hut Seen From Behind",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275342",
    dateCreated: "17th century",
    imageUrl: "images/Hut_Seen_From_Behind.webp",
  },
  {
    compositionName: "Jacobus Triglandius",
    author: ["Cornelis van Dalen, the Elder", "After Jan van Teylingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275373",
    dateCreated: "17th century",
    imageUrl: "images/Jacobus_Triglandius.webp",
  },
  {
    compositionName: "Great Church on the Hill",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275440",
    dateCreated: "17th century",
    imageUrl: "images/Great_Church_on_the_Hill.webp",
  },
  {
    compositionName: "Hamlet on the Declivity of a Hill",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275441",
    dateCreated: "17th century",
    imageUrl: "images/Hamlet_on_the_Declivity_of_a_Hill.webp",
  },
  {
    compositionName: "The Large Rock",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275442",
    dateCreated: "17th century",
    imageUrl: "images/The_Large_Rock.webp",
  },
  {
    compositionName: "Herd of Swine",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275452",
    dateCreated: "17th century",
    imageUrl: "images/Herd_of_Swine.webp",
  },
  {
    compositionName: "Jan de Wael",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275456",
    dateCreated: "17th century",
    imageUrl: "images/Jan_de_Wael.webp",
  },
  {
    compositionName: "The Couple Walking",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236492",
    dateCreated: "c. 1638",
    imageUrl: "images/The_Couple_Walking.webp",
  },
  {
    compositionName: "The Woman Spinning",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236493",
    dateCreated: "1652",
    imageUrl: "images/The_Woman_Spinning.webp",
  },
  {
    compositionName: "The Woman Winding upon a Reel",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236511",
    dateCreated: "c. 1684",
    imageUrl: "images/The_Woman_Winding_upon_a_Reel.webp",
  },
  {
    compositionName: "Antoine Triest",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275997",
    dateCreated: "17th century",
    imageUrl: "images/Antoine_Triest.webp",
  },
  {
    compositionName: "Lucas Vorsterman, the Elder",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275998",
    dateCreated: "17th century",
    imageUrl: "images/Lucas_Vorsterman__the_Elder.webp",
  },
  {
    compositionName: "Frans Francken, the Younger",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275999",
    dateCreated: "17th century",
    imageUrl: "images/Frans_Francken__the_Younger.webp",
  },
  {
    compositionName: "Bathsheba Bringing Abishag to David",
    author: ["Richard Earlom", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276006",
    dateCreated: "18th-19th century",
    imageUrl: "images/Bathsheba_Bringing_Abishag_to_David.webp",
  },
  {
    compositionName: "Coppenol",
    author: [
      "Pierre Fran\u00e7ois Basan",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276037",
    dateCreated: "18th century",
    imageUrl: "images/Coppenol.webp",
  },
  {
    compositionName: "Penitent Saint Jerome",
    author: [
      "Nicolas-Dauphin de Beauvais",
      "After Charles-Fran\u00e7ois Hutin",
      "After Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276042",
    dateCreated: "c. 1755",
    imageUrl: "images/Penitent_Saint_Jerome.webp",
  },
  {
    compositionName: "Jacob Blessing the Sons of Joseph",
    author: ["Lambert Antoine Claessens", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276069",
    dateCreated: "18th-19th century",
    imageUrl: "images/Jacob_Blessing_the_Sons_of_Joseph.webp",
  },
  {
    compositionName: "Elevation of the Cross",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276086",
    dateCreated: "17th century",
    imageUrl: "images/Elevation_of_the_Cross.webp",
  },
  {
    compositionName: "The Country Wedding",
    author: ["Johannes Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237198",
    dateCreated: "17th century",
    imageUrl: "images/The_Country_Wedding.webp",
  },
  {
    compositionName: "Seaport with a Large Round Tower",
    author: ["Matthijs van Plattenberg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237201",
    dateCreated: "17th century",
    imageUrl: "images/Seaport_with_a_Large_Round_Tower.webp",
  },
  {
    compositionName: "Road on the Edge of a Wood",
    author: ["Matthijs van Plattenberg"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237202",
    dateCreated: "17th century",
    imageUrl: "images/Road_on_the_Edge_of_a_Wood.webp",
  },
  {
    compositionName: "Grazing Cow with Two Sheep",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237207",
    dateCreated: "1670",
    imageUrl: "images/Grazing_Cow_with_Two_Sheep.webp",
  },
  {
    compositionName: "Three Peasants Around a Bench in an Interior",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237216",
    dateCreated: "17th century",
    imageUrl: "images/Three_Peasants_Around_a_Bench_in_an_Interior.webp",
  },
  {
    compositionName: "Interior with Dancing Couple",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237217",
    dateCreated: "17th century",
    imageUrl: "images/Interior_with_Dancing_Couple.webp",
  },
  {
    compositionName: "Story of Tobias: Tobias and the Angel",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237227",
    dateCreated: "17th century",
    imageUrl: "images/Story_of_Tobias__Tobias_and_the_Angel.webp",
  },
  {
    compositionName: "Windmill",
    author: ["Adriaan van Stalbemt"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237230",
    dateCreated: "16th-17th century",
    imageUrl: "images/Windmill.webp",
  },
  {
    compositionName: "Abraham and Isaac",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237231",
    dateCreated: "1645",
    imageUrl: "images/Abraham_and_Isaac.webp",
  },
  {
    compositionName: "Abraham Preparing to Sacrifice Isaac",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237239",
    dateCreated: "17th century",
    imageUrl: "images/Abraham_Preparing_to_Sacrifice_Isaac.webp",
  },
  {
    compositionName: "Mercury Lulls Argus to Sleep",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237245",
    dateCreated: "17th century",
    imageUrl: "images/Mercury_Lulls_Argus_to_Sleep.webp",
  },
  {
    compositionName: "Peasants about to Brawl",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237246",
    dateCreated: "17th century",
    imageUrl: "images/Peasants_about_to_Brawl.webp",
  },
  {
    compositionName: "Story of Tobias: Tobias Catching the Fish",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237261",
    dateCreated: "17th century",
    imageUrl: "images/Story_of_Tobias__Tobias_Catching_the_Fish.webp",
  },
  {
    compositionName:
      "Story of Tobias: The Angel Departing From Tobit and Tobias",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237262",
    dateCreated: "17th century",
    imageUrl:
      "images/Story_of_Tobias__The_Angel_Departing_From_Tobit_and_Tobias.webp",
  },
  {
    compositionName: "Return of the Holy Family from Egypt",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237265",
    dateCreated: "17th century",
    imageUrl: "images/Return_of_the_Holy_Family_from_Egypt.webp",
  },
  {
    compositionName: "Story of Tobias: Tobias Blessed By the Blind Tobit",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237267",
    dateCreated: "17th century",
    imageUrl: "images/Story_of_Tobias__Tobias_Blessed_By_the_Blind_Tobit.webp",
  },
  {
    compositionName: "Bridge Over a Waterfall Near a Domed Rotunda",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237300",
    dateCreated: "17th century",
    imageUrl: "images/Bridge_Over_a_Waterfall_Near_a_Domed_Rotunda.webp",
  },
  {
    compositionName: "Skaters",
    author: ["Copy after Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237301",
    dateCreated: "17th century",
    imageUrl: "images/Skaters.webp",
  },
  {
    compositionName: "Cloister",
    author: ["Johann Friedrich Franz Bruder", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277135",
    dateCreated: "19th century",
    imageUrl: "images/Cloister.webp",
  },
  {
    compositionName: "Henry Danvers, earl of Danby",
    author: ["Valentine Green", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277201",
    dateCreated: "18th-19th century",
    imageUrl: "images/Henry_Danvers__earl_of_Danby.webp",
  },
  {
    compositionName: "Diego Felipe de Guzman, Marques de Leganes",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277205",
    dateCreated: "17th century",
    imageUrl: "images/Diego_Felipe_de_Guzman__Marques_de_Leganes.webp",
  },
  {
    compositionName: "Gustavus Adolphus, King of Sweden",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277206",
    dateCreated: "17th century",
    imageUrl: "images/Gustavus_Adolphus__King_of_Sweden.webp",
  },
  {
    compositionName: "Two Men, One Smoking",
    author: ["Frans van der Steen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237351",
    dateCreated: "17th century",
    imageUrl: "images/Two_Men__One_Smoking.webp",
  },
  {
    compositionName: "Hagar's Departure",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237381",
    dateCreated: "c. 1620",
    imageUrl: "images/Hagar_s_Departure.webp",
  },
  {
    compositionName: "Tobit Delivering His Son Tobias to the Angel",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237382",
    dateCreated: "17th century",
    imageUrl: "images/Tobit_Delivering_His_Son_Tobias_to_the_Angel.webp",
  },
  {
    compositionName: "Winter Landscape with Skaters along a Town Wall",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237734",
    dateCreated: "17th century",
    imageUrl: "images/Winter_Landscape_with_Skaters_along_a_Town_Wall.webp",
  },
  {
    compositionName: "Night",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237752",
    dateCreated: "17th century",
    imageUrl: "images/Night.webp",
  },
  {
    compositionName: "Arcadian Landscape",
    author: ["Moyses Matheusz van Uyttenbroeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237755",
    dateCreated: "17th century",
    imageUrl: "images/Arcadian_Landscape.webp",
  },
  {
    compositionName: "Copper Plate: \u201cSaint Barbara\u201d",
    author: ["After Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237761",
    dateCreated: "18th century",
    imageUrl: "images/Copper_Plate___Saint_Barbara_.webp",
  },
  {
    compositionName: "Fields and a Village Road, with a Post Mill",
    author: [
      "Joannes van Doetecum",
      "and Lucas van Doetecum",
      "After Master of the Small Landscapes",
      "Published by Theodoor Galle",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237769",
    dateCreated: "1559-1561; printed c. 1612",
    imageUrl: "images/Fields_and_a_Village_Road__with_a_Post_Mill.webp",
  },
  {
    compositionName: "David Ryckaert",
    author: ["Carl Gottlieb Rasp", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278288",
    dateCreated: "18th century",
    imageUrl: "images/David_Ryckaert.webp",
  },
  {
    compositionName: "Hermit in a Grotto near a Burning City",
    author: ["Georg Friedrich Schmidt", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278329",
    dateCreated: "18th century",
    imageUrl: "images/Hermit_in_a_Grotto_near_a_Burning_City.webp",
  },
  {
    compositionName: "Light Breeze",
    author: ["Pierre Charles Canot", "After Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237828",
    dateCreated: "1773",
    imageUrl: "images/Light_Breeze.webp",
  },
  {
    compositionName:
      "King Cyrus Rescues Daniel from the Lion's Den (Dan.14:39-40)",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237829",
    dateCreated: "1565",
    imageUrl:
      "images/King_Cyrus_Rescues_Daniel_from_the_Lion_s_Den__Dan_14_39_40_.webp",
  },
  {
    compositionName: "Daniel Denies to King Cyrus that Baal is a Living God",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/237840",
    dateCreated: "1565",
    imageUrl:
      "images/Daniel_Denies_to_King_Cyrus_that_Baal_is_a_Living_God.webp",
  },
  {
    compositionName: "Portrait",
    author: ["Alphonse Charles Masson", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278595",
    dateCreated: "19th century",
    imageUrl: "images/Portrait.webp",
  },
  {
    compositionName:
      "Louis-Michel van Loo Working on the Portrait of His Deceased Father, Jean-Baptiste van Loo",
    author: ["Simon Charles Miger", "After Louis-Michel van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278624",
    dateCreated: "1781",
    imageUrl:
      "images/Louis_Michel_van_Loo_Working_on_the_Portrait_of_His_Deceased_Father__Jean_Baptiste_van_Loo.webp",
  },
  {
    compositionName: "Michel Le Blon",
    author: ["Theodor Matham", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278663",
    dateCreated: "17th century",
    imageUrl: "images/Michel_Le_Blon.webp",
  },
  {
    compositionName: "The Lucky Hunter",
    author: ["Jacques Philippe Le Bas", "After Carel van Falens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238238",
    dateCreated: "1740",
    imageUrl: "images/The_Lucky_Hunter.webp",
  },
  {
    compositionName: "The Fates",
    author: ["Pieter Jalhea Furnius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238281",
    dateCreated: "16th-17th century",
    imageUrl: "images/The_Fates.webp",
  },
  {
    compositionName: "Choice Between Virtue and Shame",
    author: ["Pieter Jalhea Furnius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238282",
    dateCreated: "16th-17th century",
    imageUrl: "images/Choice_Between_Virtue_and_Shame.webp",
  },
  {
    compositionName: "End of the Way to Shame",
    author: ["Pieter Jalhea Furnius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238283",
    dateCreated: "16th-17th century",
    imageUrl: "images/End_of_the_Way_to_Shame.webp",
  },
  {
    compositionName: "Way to Virtue",
    author: ["Pieter Jalhea Furnius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238284",
    dateCreated: "16th-17th century",
    imageUrl: "images/Way_to_Virtue.webp",
  },
  {
    compositionName: "End of the Way to Virtue",
    author: ["Pieter Jalhea Furnius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238285",
    dateCreated: "16th-17th century",
    imageUrl: "images/End_of_the_Way_to_Virtue.webp",
  },
  {
    compositionName: "The Second View of the Beach at Scheveningen",
    author: [
      "Abraham Jacobsz. Hulk",
      "After Jacques-Francois-Joseph Swebach",
      "After Adriaen van de Velde",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238495",
    dateCreated: "18th century",
    imageUrl: "images/The_Second_View_of_the_Beach_at_Scheveningen.webp",
  },
  {
    compositionName: "Martin Day",
    author: ["L\u00e9opold Flameng", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238511",
    dateCreated: "19th century",
    imageUrl: "images/Martin_Day.webp",
  },
  {
    compositionName: "Woman Cutting Her Mistress's Nails",
    author: ["Follower of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279231",
    dateCreated: "17th century",
    imageUrl: "images/Woman_Cutting_Her_Mistress_s_Nails.webp",
  },
  {
    compositionName: "Man Drawing from a Cast",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279232",
    dateCreated: "c. 1641",
    imageUrl: "images/Man_Drawing_from_a_Cast.webp",
  },
  {
    compositionName: "The Card Player",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279233",
    dateCreated: "1641",
    imageUrl: "images/The_Card_Player.webp",
  },
  {
    compositionName:
      "Study from the Nude: Man Seated on the Ground with One Leg Extended",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279236",
    dateCreated: "1646",
    imageUrl:
      "images/Study_from_the_Nude__Man_Seated_on_the_Ground_with_One_Leg_Extended.webp",
  },
  {
    compositionName: "Landscape with Cottages and a Haybarn: Oblong",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279237",
    dateCreated: "1641",
    imageUrl: "images/Landscape_with_Cottages_and_a_Haybarn__Oblong.webp",
  },
  {
    compositionName: "Nicolas Gabriel de la Reynie, King's Councillor",
    author: ["Pieter van Schuppen", "After Pierre Mignard"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279241",
    dateCreated: "1665",
    imageUrl: "images/Nicolas_Gabriel_de_la_Reynie__King_s_Councillor.webp",
  },
  {
    compositionName: "Self-Portrait with Long Bushy Hair: Head Only",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279244",
    dateCreated: "c.1631",
    imageUrl: "images/Self_Portrait_with_Long_Bushy_Hair__Head_Only.webp",
  },
  {
    compositionName: "The First Oriental Head",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279260",
    dateCreated: "1635",
    imageUrl: "images/The_First_Oriental_Head.webp",
  },
  {
    compositionName:
      "Bust of a Man Wearing a High Cap, Three-Quarters Right: the Artist's Father",
    author: ["James Bretherton", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279261",
    dateCreated: "1630",
    imageUrl:
      "images/Bust_of_a_Man_Wearing_a_High_Cap__Three_Quarters_Right__the_Artist_s_Father____.webp",
  },
  {
    compositionName: "Bald Man in a Fur Coat: Bust",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279262",
    dateCreated: "1631",
    imageUrl: "images/Bald_Man_in_a_Fur_Coat__Bust.webp",
  },
  {
    compositionName: "Ephraim Bonus, Jewish Physician",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279353",
    dateCreated: "1647",
    imageUrl: "images/Ephraim_Bonus__Jewish_Physician.webp",
  },
  {
    compositionName: "Man and Woman Drinking",
    author: ["John Smith", "After Egbert van Heemskerck the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279371",
    dateCreated: "1706-1707",
    imageUrl: "images/Man_and_Woman_Drinking.webp",
  },
  {
    compositionName: "Big Broom",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279424",
    dateCreated: "17th century",
    imageUrl: "images/Big_Broom.webp",
  },
  {
    compositionName: "Van Dyck and the Earl of Bristol",
    author: ["Fernando Selma", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279468",
    dateCreated: "18th century",
    imageUrl: "images/Van_Dyck_and_the_Earl_of_Bristol.webp",
  },
  {
    compositionName: "Self-Portrait in a Slant Fur Cap: Bust",
    author: [
      "Circle of Rembrandt Harmensz. van Rijn",
      "Previously attributed to Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279483",
    dateCreated: "1631",
    imageUrl: "images/Self_Portrait_in_a_Slant_Fur_Cap__Bust.webp",
  },
  {
    compositionName: "Angels Playing Musical Instruments and Cherubs Dancing",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239416",
    dateCreated: "c.1589",
    imageUrl:
      "images/Angels_Playing_Musical_Instruments_and_Cherubs_Dancing.webp",
  },
  {
    compositionName: "The Samaritan",
    author: ["Dominique Vivant Denon", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239423",
    dateCreated: "18th century",
    imageUrl: "images/The_Samaritan.webp",
  },
  {
    compositionName: "Jan van Ravesteyn",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279523",
    dateCreated: "17th century",
    imageUrl: "images/Jan_van_Ravesteyn.webp",
  },
  {
    compositionName: "Theodor Rombouts",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279525",
    dateCreated: "17th century",
    imageUrl: "images/Theodor_Rombouts.webp",
  },
  {
    compositionName: "Two Lower, Embossed Parts of Columns and Three Consoles",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279526",
    dateCreated: "1578",
    imageUrl:
      "images/Two_Lower__Embossed_Parts_of_Columns_and_Three_Consoles.webp",
  },
  {
    compositionName: "Entablature, Capital and Two Consoles",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279527",
    dateCreated: "1578",
    imageUrl: "images/Entablature__Capital_and_Two_Consoles.webp",
  },
  {
    compositionName: "Balthasar Gerbier",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279557",
    dateCreated: "17th century",
    imageUrl: "images/Balthasar_Gerbier.webp",
  },
  {
    compositionName: "Adam and Eve Weeping over Abel",
    author: ["Carlo Antonio Porporati", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279559",
    dateCreated: "18th century",
    imageUrl: "images/Adam_and_Eve_Weeping_over_Abel.webp",
  },
  {
    compositionName: "Marie de Barban\u00e7on, Wife of Albert, Duc d'Arenberg",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279568",
    dateCreated: "17th century",
    imageUrl: "images/Marie_de_Barbancon__Wife_of_Albert__Duc_d_Arenberg.webp",
  },
  {
    compositionName: "Bedtime",
    author: ["Carlo Antonio Porporati", "After Jacob van Loo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279570",
    dateCreated: "18th century",
    imageUrl: "images/Bedtime.webp",
  },
  {
    compositionName: "Plate 36: Seven Draped Female Statues",
    author: ["Jan de Bisschop", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279574",
    dateCreated: "17th century",
    imageUrl: "images/Plate_36__Seven_Draped_Female_Statues.webp",
  },
  {
    compositionName: "Virgin and Child",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279592",
    dateCreated: "17th century",
    imageUrl: "images/Virgin_and_Child.webp",
  },
  {
    compositionName: "Adoration of the Shepherds: A Night Piece",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279608",
    dateCreated: "c. 1656",
    imageUrl: "images/Adoration_of_the_Shepherds__A_Night_Piece.webp",
  },
  {
    compositionName: "Presentation in the Temple, with the Angel: Small Plate",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279609",
    dateCreated: "1630",
    imageUrl:
      "images/Presentation_in_the_Temple__with_the_Angel__Small_Plate.webp",
  },
  {
    compositionName: "Christ and His Parents Returning from the Temple",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279610",
    dateCreated: "1654",
    imageUrl: "images/Christ_and_His_Parents_Returning_from_the_Temple.webp",
  },
  {
    compositionName: "Self-Portrait with Plumed Cap and Lowered Sabre",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279613",
    dateCreated: "1634",
    imageUrl: "images/Self_Portrait_____with_Plumed_Cap_and_Lowered_Sabre.webp",
  },
  {
    compositionName: "Abraham Casting Out Hagar and Ishmael",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279614",
    dateCreated: "1637",
    imageUrl: "images/Abraham_Casting_Out_Hagar_and_Ishmael.webp",
  },
  {
    compositionName: "Abraham Caressing Isaac",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279615",
    dateCreated: "c. 1637",
    imageUrl: "images/Abraham_Caressing_Isaac.webp",
  },
  {
    compositionName: "Joseph's Coat Brought to Jacob",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279616",
    dateCreated: "c. 1633",
    imageUrl: "images/Joseph_s_Coat_Brought_to_Jacob.webp",
  },
  {
    compositionName: "The Rest on the Flight into Egypt, Lightly Etched",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279617",
    dateCreated: "1645",
    imageUrl: "images/The_Rest_on_the_Flight_into_Egypt__Lightly_Etched.webp",
  },
  {
    compositionName: "Plate III",
    author: ["Hermanus van Brussel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239875",
    dateCreated: "18th-19th century",
    imageUrl: "images/Plate_III.webp",
  },
  {
    compositionName: "Plate IV",
    author: ["Hermanus van Brussel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239876",
    dateCreated: "18th-19th century",
    imageUrl: "images/Plate_IV.webp",
  },
  {
    compositionName: "Plate V",
    author: ["Hermanus van Brussel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239877",
    dateCreated: "18th-19th century",
    imageUrl: "images/Plate_V.webp",
  },
  {
    compositionName: "Bird-hunting by Night",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239941",
    dateCreated: "16th-17th century",
    imageUrl: "images/Bird_hunting_by_Night.webp",
  },
  {
    compositionName: "Plate I",
    author: ["Hermanus van Brussel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239961",
    dateCreated: "18th-19th century",
    imageUrl: "images/Plate_I.webp",
  },
  {
    compositionName: "Plate II",
    author: ["Hermanus van Brussel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239962",
    dateCreated: "18th-19th century",
    imageUrl: "images/Plate_II.webp",
  },
  {
    compositionName: "Mill with Ferryboat on the Left",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239966",
    dateCreated: "1774",
    imageUrl: "images/Mill_with_Ferryboat_on_the_Left.webp",
  },
  {
    compositionName: "Fishing in a Stream",
    author: ["Adriaen Collaert", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239979",
    dateCreated: "16th-17th century",
    imageUrl: "images/Fishing_in_a_Stream.webp",
  },
  {
    compositionName: "The Burgomaster",
    author: ["Jacques Firmin Beauvarlet", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240003",
    dateCreated: "18th century",
    imageUrl: "images/The_Burgomaster.webp",
  },
  {
    compositionName: "A Game of Backgammon",
    author: ["Jacques Firmin Beauvarlet", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240004",
    dateCreated: "18th century",
    imageUrl: "images/A_Game_of_Backgammon.webp",
  },
  {
    compositionName: "Blowing Bubbles",
    author: ["Jean Bein", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240007",
    dateCreated: "19th century",
    imageUrl: "images/Blowing_Bubbles.webp",
  },
  {
    compositionName: "Prudence and Justice",
    author: ["Cornelis Bos", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240025",
    dateCreated: "1537",
    imageUrl: "images/Prudence_and_Justice.webp",
  },
  {
    compositionName: "Shepherd and Shepherdess Driving Cows",
    author: ["Jean-Jacques de Boissieu", "After Adriaan van der Cabel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240048",
    dateCreated: "1773",
    imageUrl: "images/Shepherd_and_Shepherdess_Driving_Cows.webp",
  },
  {
    compositionName: "A Wheat Field",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240058",
    dateCreated: "1772",
    imageUrl: "images/A_Wheat_Field.webp",
  },
  {
    compositionName: "Mill with Two Draughtsmen on the Right",
    author: ["Jean-Jacques de Boissieu", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240069",
    dateCreated: "1782",
    imageUrl: "images/Mill_with_Two_Draughtsmen_on_the_Right.webp",
  },
  {
    compositionName: "The Ballad Writer",
    author: ["Alexis Chataigner", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240078",
    dateCreated: "19th century",
    imageUrl: "images/The_Ballad_Writer.webp",
  },
  {
    compositionName: "Christ before Pilate: Large Plate",
    author: [
      "Rembrandt Harmensz. van Rijn",
      "Etched and engraved basis for the composition by Jan Joris van Vliet",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279720",
    dateCreated: "1636",
    imageUrl: "images/Christ_before_Pilate__Large_Plate.webp",
  },
  {
    compositionName: "The Descent from the Cross: A Sketch",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279721",
    dateCreated: "1642",
    imageUrl: "images/The_Descent_from_the_Cross__A_Sketch.webp",
  },
  {
    compositionName:
      'The Incredulity of Thomas ("Christ Appearing to the Apostles")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279722",
    dateCreated: "1656",
    imageUrl:
      "images/The_Incredulity_of_Thomas___Christ_Appearing_to_the_Apostles__.webp",
  },
  {
    compositionName:
      "Peter and John Healing the Cripple at the Gate of the Temple",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279723",
    dateCreated: "1659",
    imageUrl:
      "images/Peter_and_John_Healing_the_Cripple_at_the_Gate_of_the_Temple.webp",
  },
  {
    compositionName: "Saint Jerome Reading",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279724",
    dateCreated: "1634",
    imageUrl: "images/Saint_Jerome_Reading.webp",
  },
  {
    compositionName:
      'A Hurdy-Gurdy Player Followed by Children at the Door of a House ("The Schoolmaster")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279725",
    dateCreated: "1641",
    imageUrl:
      "images/A_Hurdy_Gurdy_Player_Followed_by_Children_at_the_Door_of_a_House___The_Schoolmaster__.webp",
  },
  {
    compositionName: "The Persian",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279726",
    dateCreated: "1632",
    imageUrl: "images/The_Persian.webp",
  },
  {
    compositionName: "Landscape with Sportsman and Dogs",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279727",
    dateCreated: "c. 1645-1648",
    imageUrl: "images/Landscape_with_Sportsman_and_Dogs.webp",
  },
  {
    compositionName: "Janus opening the door of the year",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240165",
    dateCreated: "17th-18th century",
    imageUrl: "images/Janus_opening_the_door_of_the_year.webp",
  },
  {
    compositionName: "Saint Philippus Nerus",
    author: ["Robert van Auden-Aerd", "After Carlo Maratti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240166",
    dateCreated: "17th-18th century",
    imageUrl: "images/Saint_Philippus_Nerus.webp",
  },
  {
    compositionName: "Hendrik Du Boys",
    author: ["Cornelis Visscher", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279783",
    dateCreated: "17th century",
    imageUrl: "images/Hendrik_Du_Boys.webp",
  },
  {
    compositionName: "Petrus Paulus Rubens",
    author: ["Johannes Visscher", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279785",
    dateCreated: "17th century",
    imageUrl: "images/Petrus_Paulus_Rubens.webp",
  },
  {
    compositionName: "Sir Kenelm Digby",
    author: ["Robert van Voerst", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279789",
    dateCreated: "17th century",
    imageUrl: "images/Sir_Kenelm_Digby.webp",
  },
  {
    compositionName: "Robert van Voerst",
    author: ["Robert van Voerst", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279806",
    dateCreated: "17th century",
    imageUrl: "images/Robert_van_Voerst.webp",
  },
  {
    compositionName: "Simon Vouet",
    author: ["Robert van Voerst", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279807",
    dateCreated: "17th century",
    imageUrl: "images/Simon_Vouet.webp",
  },
  {
    compositionName: "Jacob's Ladder",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279836",
    dateCreated: "1655",
    imageUrl: "images/Jacob_s_Ladder.webp",
  },
  {
    compositionName: "Ambrogio, marquis de Spinola",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279854",
    dateCreated: "17th century",
    imageUrl: "images/Ambrogio__marquis_de_Spinola.webp",
  },
  {
    compositionName: "Pieter Stevens",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279855",
    dateCreated: "17th century",
    imageUrl: "images/Pieter_Stevens.webp",
  },
  {
    compositionName: "Cornelis de Vos",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279856",
    dateCreated: "17th century",
    imageUrl: "images/Cornelis_de_Vos.webp",
  },
  {
    compositionName: "Cornelis Saftleven",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279865",
    dateCreated: "17th century",
    imageUrl: "images/Cornelis_Saftleven.webp",
  },
  {
    compositionName: "Cornelis Schut",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279866",
    dateCreated: "17th century",
    imageUrl: "images/Cornelis_Schut.webp",
  },
  {
    compositionName: "Lord Chief Baron Wandesford",
    author: ["James Watson", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279868",
    dateCreated: "18th century",
    imageUrl: "images/Lord_Chief_Baron_Wandesford.webp",
  },
  {
    compositionName: "Interior with a Company at a Fire-place in an Inn",
    author: ["Cornelis Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279895",
    dateCreated: "17th century",
    imageUrl: "images/Interior_with_a_Company_at_a_Fire_place_in_an_Inn.webp",
  },
  {
    compositionName: "Daniel's Vision of the Four Beasts",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279908",
    dateCreated: "1655",
    imageUrl: "images/Daniel_s_Vision_of_the_Four_Beasts.webp",
  },
  {
    compositionName: "Plate 37: Six Male Statues",
    author: ["Jan de Bisschop", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279914",
    dateCreated: "17th century",
    imageUrl: "images/Plate_37__Six_Male_Statues.webp",
  },
  {
    compositionName: "William I, Prince of Orange",
    author: ["Gerard Valck", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279930",
    dateCreated: "17th century",
    imageUrl: "images/William_I__Prince_of_Orange.webp",
  },
  {
    compositionName: "Jan van Mildert",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279943",
    dateCreated: "17th century",
    imageUrl: "images/Jan_van_Mildert.webp",
  },
  {
    compositionName: "Thomas Howard, 26th Earl of Arundel",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279944",
    dateCreated: "17th century",
    imageUrl: "images/Thomas_Howard__26th_Earl_of_Arundel.webp",
  },
  {
    compositionName: "Wenceslas Coeberger",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279945",
    dateCreated: "17th century",
    imageUrl: "images/Wenceslas_Coeberger.webp",
  },
  {
    compositionName: "Aubert LeMire",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279947",
    dateCreated: "17th century",
    imageUrl: "images/Aubert_LeMire.webp",
  },
  {
    compositionName: "Theodor van Loon",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279949",
    dateCreated: "17th century",
    imageUrl: "images/Theodor_van_Loon.webp",
  },
  {
    compositionName: "Two Embossed Pedestals and Five Consoles",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279952",
    dateCreated: "1578",
    imageUrl: "images/Two_Embossed_Pedestals_and_Five_Consoles.webp",
  },
  {
    compositionName: "Two Embossed Pedestals and Two Consoles",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279953",
    dateCreated: "1578",
    imageUrl: "images/Two_Embossed_Pedestals_and_Two_Consoles.webp",
  },
  {
    compositionName:
      "Rusticated Entrance Portal with Variant for the Right Half",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279954",
    dateCreated: "1578",
    imageUrl:
      "images/Rusticated_Entrance_Portal_with_Variant_for_the_Right_Half.webp",
  },
  {
    compositionName: "Two Rusticated Portals, Left with a Side View",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279955",
    dateCreated: "1578",
    imageUrl: "images/Two_Rusticated_Portals__Left_with_a_Side_View.webp",
  },
  {
    compositionName: "Two Lower, Embossed Parts of Columns and Two Consoles",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Volcxken Diericx",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279958",
    dateCreated: "1578",
    imageUrl:
      "images/Two_Lower__Embossed_Parts_of_Columns_and_Two_Consoles.webp",
  },
  {
    compositionName: "The Sbiro",
    author: ["Victor Pillement", "After Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240676",
    dateCreated: "18th-19th century",
    imageUrl: "images/The_Sbiro.webp",
  },
  {
    compositionName: "Dispar animarun aeternitas",
    author: ["Carel van Mallery"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240716",
    dateCreated: "17th century",
    imageUrl: "images/Dispar_animarun_aeternitas.webp",
  },
  {
    compositionName: "S. Margarita",
    author: [
      "Carel van Mallery",
      "After Giuseppe Cesari (called Cavaliere d'Arpino)",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240717",
    dateCreated: "17th century",
    imageUrl: "images/S__Margarita.webp",
  },
  {
    compositionName: "Jean Baptiste Franck",
    author: ["Jean Joseph Mougeot", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240781",
    dateCreated: "19th century",
    imageUrl: "images/Jean_Baptiste_Franck.webp",
  },
  {
    compositionName: "Last judgment",
    author: ["Carel van Mallery"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240867",
    dateCreated: "17th century",
    imageUrl: "images/Last_judgment.webp",
  },
  {
    compositionName: "Old man with Beard and Cap",
    author: ["Antoine Marcenay de Ghuy", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240885",
    dateCreated: "1755",
    imageUrl: "images/Old_man_with_Beard_and_Cap.webp",
  },
  {
    compositionName: "The Beginning of the Storm",
    author: ["Antoine Marcenay de Ghuy", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240888",
    dateCreated: "1758",
    imageUrl: "images/The_Beginning_of_the_Storm.webp",
  },
  {
    compositionName: "The Anger of the Drunkards",
    author: ["Jean Pelletier", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240898",
    dateCreated: "18th century",
    imageUrl: "images/The_Anger_of_the_Drunkards.webp",
  },
  {
    compositionName: "Robbery of the Wagons",
    author: ["Cornelis Visscher", "After Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280203",
    dateCreated: "17th century",
    imageUrl: "images/Robbery_of_the_Wagons.webp",
  },
  {
    compositionName: "Petrus Pro\u00eblius",
    author: ["Johannes Visscher", "After Joannes van Noordt"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280204",
    dateCreated: "c. 1661",
    imageUrl: "images/Petrus_Proelius.webp",
  },
  {
    compositionName: "Philip Herbert, 4th Earl of Pembroke",
    author: ["Robert van Voerst", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280213",
    dateCreated: "17th century",
    imageUrl: "images/Philip_Herbert__4th_Earl_of_Pembroke.webp",
  },
  {
    compositionName: "David and Goliath",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280245",
    dateCreated: "1655",
    imageUrl: "images/David_and_Goliath.webp",
  },
  {
    compositionName: "Fire-light",
    author: ["John Wood", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280274",
    dateCreated: "18th century",
    imageUrl: "images/Fire_light.webp",
  },
  {
    compositionName: "The Windmill",
    author: ["Fran\u00e7ois Vivares", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280283",
    dateCreated: "18th century",
    imageUrl: "images/The_Windmill.webp",
  },
  {
    compositionName: "Smokers and Drinkers",
    author: ["Johannes Visscher", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/280311",
    dateCreated: "17th century",
    imageUrl: "images/Smokers_and_Drinkers.webp",
  },
  {
    compositionName: "Chief Lee",
    author: ["James Augustus Joseph Van Der Zee"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/281171",
    dateCreated: "1924",
    imageUrl: "images/Chief_Lee.webp",
  },
  {
    compositionName: "Peasants Drinking in an Inn",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/292452",
    dateCreated: "c. 1640-1643",
    imageUrl: "images/Peasants_Drinking_in_an_Inn.webp",
  },
  {
    compositionName: "Wolf Hunt with Traps and Arquebus",
    author: ["Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/292454",
    dateCreated: "1578-1580",
    imageUrl: "images/Wolf_Hunt_with_Traps_and_Arquebus.webp",
  },
  {
    compositionName: "Tric Trac Players under an Arbor",
    author: ["Adriaen van Ostade", "Cornelis Dusart"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/292670",
    dateCreated: "1673",
    imageUrl: "images/Tric_Trac_Players_under_an_Arbor.webp",
  },
  {
    compositionName: "Landscape with an Inn and a Bastion",
    author: ["Circle of Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293651",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_an_Inn_and_a_Bastion.webp",
  },
  {
    compositionName: "A Village Street in Primolano",
    author: ["Paulus van Vianen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293681",
    dateCreated: "1607",
    imageUrl: "images/A_Village_Street_in_Primolano.webp",
  },
  {
    compositionName: "A Suit of Armor",
    author: ["Attributed to Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293702",
    dateCreated: "17th century",
    imageUrl: "images/A_Suit_of_Armor.webp",
  },
  {
    compositionName: "Holy Family in the Carpenter's Shop",
    author: [
      "Rembrandt Harmensz. van Rijn",
      "Previously attributed to Nicolaes Maes",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293809",
    dateCreated: "17th century",
    imageUrl: "images/Holy_Family_in_the_Carpenter_s_Shop.webp",
  },
  {
    compositionName: "The Prodigal Son",
    author: ["Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293925",
    dateCreated: "16th century",
    imageUrl: "images/The_Prodigal_Son.webp",
  },
  {
    compositionName: "Cottages on Road by Edge of a Wood",
    author: ["Jan van Kessel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293964",
    dateCreated: "c. 1665-c. 1669",
    imageUrl: "images/Cottages_on_Road_by_Edge_of_a_Wood.webp",
  },
  {
    compositionName: "Peasant Slaughtering a Pig",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/293970",
    dateCreated: "17th century",
    imageUrl: "images/Peasant_Slaughtering_a_Pig.webp",
  },
  {
    compositionName: "Portrait of Woman, after Anthony van Dyck",
    author: ["Hilaire-Germain-Edgar Degas", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294084",
    dateCreated: "c. 1860",
    imageUrl: "images/Portrait_of_Woman__after_Anthony_van_Dyck.webp",
  },
  {
    compositionName: "Portrait of Baldassare Peruzzi",
    author: ["Willem Rutgaart van der Wall"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294219",
    dateCreated: "1809",
    imageUrl: "images/Portrait_of_Baldassare_Peruzzi.webp",
  },
  {
    compositionName: "The Crucifixion",
    author: ["Jan van Scorel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294221",
    dateCreated: "16th century",
    imageUrl: "images/The_Crucifixion.webp",
  },
  {
    compositionName: "Landscape with Buildings and Windmills",
    author: ["Attributed to Cornelis Claesz. van Wieringen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294418",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Buildings_and_Windmills.webp",
  },
  {
    compositionName: "The Creation of Adam",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241535",
    dateCreated: "16th-17th century",
    imageUrl: "images/The_Creation_of_Adam.webp",
  },
  {
    compositionName: "Cardinal d'Este",
    author: ["Pieter van Schuppen", "After Simon Vouet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241652",
    dateCreated: "17th-18th century",
    imageUrl: "images/Cardinal_d_Este.webp",
  },
  {
    compositionName: "Jean Baptiste Christyn, Baron of Meerbeck",
    author: ["Pieter van Schuppen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241653",
    dateCreated: "17th-18th century",
    imageUrl: "images/Jean_Baptiste_Christyn__Baron_of_Meerbeck.webp",
  },
  {
    compositionName: "Joachim de Seigliere",
    author: ["Pieter van Schuppen", "After Alexandre du Buisson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241654",
    dateCreated: "1674",
    imageUrl: "images/Joachim_de_Seigliere.webp",
  },
  {
    compositionName: "Israelites Leaving Egypt",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241657",
    dateCreated: "16th-17th century",
    imageUrl: "images/Israelites_Leaving_Egypt.webp",
  },
  {
    compositionName: "Israelites Gathering Manna",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241658",
    dateCreated: "16th-17th century",
    imageUrl: "images/Israelites_Gathering_Manna.webp",
  },
  {
    compositionName: "Moses Striking the Rock",
    author: ["Johann Sadeler I", "After Chrispijn van den Broeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241659",
    dateCreated: "16th-17th century",
    imageUrl: "images/Moses_Striking_the_Rock.webp",
  },
  {
    compositionName: "Charles de Hovel, Baron de Morainville",
    author: ["Pieter van Schuppen", "After Pieter van Mol"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241695",
    dateCreated: "17th-18th century",
    imageUrl: "images/Charles_de_Hovel__Baron_de_Morainville.webp",
  },
  {
    compositionName: "Adam Fran\u00e7ois van der Meulen",
    author: ["Pieter van Schuppen", "After Nicolas de Largilli\u00e8re"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241696",
    dateCreated: "17th-18th century",
    imageUrl: "images/Adam_Francois_van_der_Meulen.webp",
  },
  {
    compositionName: "Louis, Dauphin of France",
    author: ["Pieter van Schuppen", "After Fran\u00e7ois de Troy"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241697",
    dateCreated: "17th-18th century",
    imageUrl: "images/Louis__Dauphin_of_France.webp",
  },
  {
    compositionName: "Fran\u00e7ois Pithou",
    author: ["Pieter van Schuppen", "After Simon Vouet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241706",
    dateCreated: "17th-18th century",
    imageUrl: "images/Francois_Pithou.webp",
  },
  {
    compositionName: "Pope Alexander VII",
    author: ["Pieter van Schuppen", "After Pierre Mignard"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241707",
    dateCreated: "17th-18th century",
    imageUrl: "images/Pope_Alexander_VII.webp",
  },
  {
    compositionName: "Madonna of the Chair",
    author: ["Pieter van Schuppen", "After Raphael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241708",
    dateCreated: "17th-18th century",
    imageUrl: "images/Madonna_of_the_Chair.webp",
  },
  {
    compositionName: "Joannes, Count of Nassau-Siegen",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241722",
    dateCreated: "17th century",
    imageUrl: "images/Joannes__Count_of_Nassau_Siegen.webp",
  },
  {
    compositionName: "Palamedes Palamedesz",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241723",
    dateCreated: "17th century",
    imageUrl: "images/Palamedes_Palamedesz.webp",
  },
  {
    compositionName: "Robert Van Voerst",
    author: ["Thomas Chambars", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241728",
    dateCreated: "18th century",
    imageUrl: "images/Robert_Van_Voerst.webp",
  },
  {
    compositionName: "Henricus Comes van den Berghe",
    author: ["Paulus Pontius", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241736",
    dateCreated: "17th century",
    imageUrl: "images/Henricus_Comes_van_den_Berghe.webp",
  },
  {
    compositionName: "Wolfgang Wilhelm, Count Palatine of the Rhine",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241749",
    dateCreated: "17th century",
    imageUrl: "images/Wolfgang_Wilhelm__Count_Palatine_of_the_Rhine.webp",
  },
  {
    compositionName: "Corn Field",
    author: ["Heliodore Joseph Pisan", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/241776",
    dateCreated: "19th century",
    imageUrl: "images/Corn_Field.webp",
  },
  {
    compositionName: "Three Heroes of the Old Testament",
    author: ["Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296618",
    dateCreated: "1567",
    imageUrl: "images/Three_Heroes_of_the_Old_Testament.webp",
  },
  {
    compositionName:
      "Head of a Horse; verso: Sheep's Head and Study of a Sheep",
    author: ["Attributed to Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296622",
    dateCreated: "17th century",
    imageUrl:
      "images/Head_of_a_Horse__verso__Sheep_s_Head_and_Study_of_a_Sheep____.webp",
  },
  {
    compositionName: "Le D\u00e9jeuner de Fanfan (Lunch for the Precious One)",
    author: ["Henri Nicolas van Gorp"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296649",
    dateCreated: "18th-19th century",
    imageUrl: "images/Le_Dejeuner_de_Fanfan__Lunch_for_the_Precious_One_.webp",
  },
  {
    compositionName: "Saint Sebastian",
    author: [
      "Giovanni Antonio Licinio, call Il Pordenone",
      "Attributed to Anthony van Dyck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296754",
    dateCreated: "16th century",
    imageUrl: "images/Saint_Sebastian.webp",
  },
  {
    compositionName: "Studies of Five Figures",
    author: ["Willem van de Velde the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296829",
    dateCreated: "17th century",
    imageUrl: "images/Studies_of_Five_Figures.webp",
  },
  {
    compositionName: "Portrait of Don Carlos Coloma",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296830",
    dateCreated: "17th century",
    imageUrl: "images/Portrait_of_Don_Carlos_Coloma.webp",
  },
  {
    compositionName: "A Woman in Bed with a Child",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296970",
    dateCreated: "c. 1636-1639",
    imageUrl: "images/A_Woman_in_Bed_with_a_Child.webp",
  },
  {
    compositionName: "Four Ships",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296978",
    dateCreated: "17th-18th century",
    imageUrl: "images/Four_Ships.webp",
  },
  {
    compositionName: "Boar Hunt along the Banks of the Tiber at Fiano",
    author: ["Gaspar van Wittel (called Vanvitelli)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296985",
    dateCreated: "17th-18th century",
    imageUrl: "images/Boar_Hunt_along_the_Banks_of_the_Tiber_at_Fiano.webp",
  },
  {
    compositionName: "Three Studies of a Cow",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297023",
    dateCreated: "c. 1650",
    imageUrl: "images/Three_Studies_of_a_Cow.webp",
  },
  {
    compositionName: "Landscape with Cottages and Figures",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297024",
    dateCreated: "c. 1650",
    imageUrl: "images/Landscape_with_Cottages_and_Figures.webp",
  },
  {
    compositionName: "Seated Soldier; verso: slight sketches",
    author: ["Jan Philipsz. van Bouckhorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297048",
    dateCreated: "17th century",
    imageUrl: "images/Seated_Soldier__verso__slight_sketches.webp",
  },
  {
    compositionName: "View of Mariakerk in Utrecht from the South",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297050",
    dateCreated: "c. 1652",
    imageUrl: "images/View_of_Mariakerk_in_Utrecht_from_the_South.webp",
  },
  {
    compositionName: "Jacques Callot",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242099",
    dateCreated: "17th century",
    imageUrl: "images/Jacques_Callot.webp",
  },
  {
    compositionName: "Gaston de France, duc d'Orl\u00e9ans",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242100",
    dateCreated: "17th century",
    imageUrl: "images/Gaston_de_France__duc_d_Orleans.webp",
  },
  {
    compositionName: "Nicolas Claude Fabri de Peiresc",
    author: ["Lucas Vorsterman, I", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242101",
    dateCreated: "17th century",
    imageUrl: "images/Nicolas_Claude_Fabri_de_Peiresc.webp",
  },
  {
    compositionName: "Peaked Roof Building",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298593",
    dateCreated: "17th century",
    imageUrl: "images/Peaked_Roof_Building.webp",
  },
  {
    compositionName: "Man Swinging a Flail",
    author: ["Imitator of Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298661",
    dateCreated: "17th century",
    imageUrl: "images/Man_Swinging_a_Flail.webp",
  },
  {
    compositionName: "Jonah Cast on Shore by the Fish",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243346",
    dateCreated: "1566",
    imageUrl: "images/Jonah_Cast_on_Shore_by_the_Fish.webp",
  },
  {
    compositionName:
      "The Return of the Apostles from Mount Olivet and the Election of Matthias as Apostle (Acts I:9-26)",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243361",
    dateCreated: "1575-1582",
    imageUrl:
      "images/The_Return_of_the_Apostles_from_Mount_Olivet_and_the_Election_of_Matthias_as_Apostle__Acts_I_9_26_.webp",
  },
  {
    compositionName: "Descent of the Holy Ghost (Acts 2:1-6)",
    author: ["Philips Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243362",
    dateCreated: "1575-1582",
    imageUrl: "images/Descent_of_the_Holy_Ghost__Acts_2_1_6_.webp",
  },
  {
    compositionName: "Girl with Flute",
    author: ["Jan Joost van Cossiau"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299254",
    dateCreated: "18th century",
    imageUrl: "images/Girl_with_Flute.webp",
  },
  {
    compositionName: "The Rat Catcher, after Rembrandt",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299284",
    dateCreated: "18th century",
    imageUrl: "images/The_Rat_Catcher__after_Rembrandt.webp",
  },
  {
    compositionName:
      "The Seed Falling by the Way Side [Matt. 13-19]  Negligence and Inertia accompanying a sleeping traveller robbed of the word sown in his heart by the devil.",
    author: ["Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243808",
    dateCreated: "1574",
    imageUrl:
      "images/The_Seed_Falling_by_the_Way_Side__Matt__13_19___Negligence_and_Inertia_accompanying_a_sleeping_traveller_robbed_of_the_word_sown_in_his_heart_by_the_devil_.webp",
  },
  {
    compositionName:
      "The Seed Received into Stony Places [Matt. 13:20-21] a man turning away from religious Persecution, accompanied by Fear and Weakness",
    author: ["After Philips Galle", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243809",
    dateCreated: "1574",
    imageUrl:
      "images/The_Seed_Received_into_Stony_Places__Matt__13_20_21__a_man_turning_away_from_religious_Persecution__accompanied_by_Fear_and_Weakness.webp",
  },
  {
    compositionName: "Stefano della Bella",
    author: [
      "Wenceslaus Hollar",
      "After Nicolaes van Helt Stockade",
      "Published by Johannes Meyssens",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243825",
    dateCreated: "1649",
    imageUrl: "images/Stefano_della_Bella.webp",
  },
  {
    compositionName: "Three Ages of Man",
    author: ["Copy after Jan Philipsz. van Bouckhorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/312428",
    dateCreated: "16th-17th century",
    imageUrl: "images/Three_Ages_of_Man.webp",
  },
  {
    compositionName: "A Scene in a Camp",
    author: ["Justus van Huysum the Younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/312469",
    dateCreated: "17th-18th century",
    imageUrl: "images/A_Scene_in_a_Camp.webp",
  },
  {
    compositionName: "Luke (from series of the four evangelists)",
    author: ["Crispijn de Passe I", "After Lucas van Leyden"],
    tale: "Luke (from series of the four evangelists)",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316015",
    dateCreated: "16th-17th century",
    imageUrl: "images/Luke__from_series_of_the_four_evangelists_.webp",
  },
  {
    compositionName: "The Dying Hour",
    author: ["Philips Galle", "after Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316021",
    dateCreated: "1569",
    imageUrl: "images/The_Dying_Hour.webp",
  },
  {
    compositionName: "Hell",
    author: ["Philips Galle", "after Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316023",
    dateCreated: "1569",
    imageUrl: "images/Hell.webp",
  },
  {
    compositionName: "Heaven",
    author: ["Philips Galle", "after Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316024",
    dateCreated: "1569",
    imageUrl: "images/Heaven.webp",
  },
  {
    compositionName: "Matthew (from series of the four evangelists)",
    author: ["Crispijn de Passe I", "After Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316031",
    dateCreated: "16th-17th century",
    imageUrl: "images/Matthew__from_series_of_the_four_evangelists_.webp",
  },
  {
    compositionName: "Mark (from series of the four evangelists)",
    author: ["Crispijn de Passe I", "After Lucas van Leyden"],
    tale: "Mark (from series of the four evangelists)",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316032",
    dateCreated: "16th-17th century",
    imageUrl: "images/Mark__from_series_of_the_four_evangelists_.webp",
  },
  {
    compositionName: "John (from series of the four evangelists)",
    author: ["Crispijn de Passe I", "After Lucas van Leyden"],
    tale: "John (from series of the four evangelists)",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/316033",
    dateCreated: "16th-17th century",
    imageUrl: "images/John__from_series_of_the_four_evangelists_.webp",
  },
  {
    compositionName:
      "Saint Peter and Saint John Dismissed with Threats [Acts 4:18-21]",
    author: [
      "Philips Galle",
      "After Maarten van Heemskerck",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243873",
    dateCreated: "1558",
    imageUrl:
      "images/Saint_Peter_and_Saint_John_Dismissed_with_Threats__Acts_4_18_21_.webp",
  },
  {
    compositionName:
      "Saint Peter Healing the Lame at the Beautiful Gate  [Acts 3:1-8]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243874",
    dateCreated: "1575-1582",
    imageUrl:
      "images/Saint_Peter_Healing_the_Lame_at_the_Beautiful_Gate___Acts_3_1_8_.webp",
  },
  {
    compositionName: "Death of Sapphira [Acts 5:6-10]",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243875",
    dateCreated: "1575-1582",
    imageUrl: "images/Death_of_Sapphira__Acts_5_6_10_.webp",
  },
  {
    compositionName: "The Road to Calvary",
    author: ["After Karel van Mander"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/323234",
    dateCreated: "1596-1598",
    imageUrl: "images/The_Road_to_Calvary.webp",
  },
  {
    compositionName: "The Arrest",
    author: [
      "Zacharias Dolendo",
      "After Karel van Mander",
      "Published by Jacques de Gheyn II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/323238",
    dateCreated: "1596-1598",
    imageUrl: "images/The_Arrest.webp",
  },
  {
    compositionName: "Christ before Caiaphas",
    author: [
      "Zacharias Dolendo",
      "After Karel van Mander",
      "Published by Jacques de Gheyn II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/323239",
    dateCreated: "1596-1598",
    imageUrl: "images/Christ_before_Caiaphas.webp",
  },
  {
    compositionName: "Christ led away from Pilate",
    author: [
      "Zacharias Dolendo",
      "After Karel van Mander",
      "Published by Jacques de Gheyn II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/323240",
    dateCreated: "1596-1598",
    imageUrl: "images/Christ_led_away_from_Pilate.webp",
  },
  {
    compositionName: "Self-Portrait",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/323716",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Self_Portrait.webp",
  },
  {
    compositionName: "Jan Brueghel the Elder",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324146",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Jan_Brueghel_the_Elder.webp",
  },
  {
    compositionName: "Pieter Brueghel the Younger",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324147",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Pieter_Brueghel_the_Younger.webp",
  },
  {
    compositionName: "Erasmus of Rotterdam",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324148",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Erasmus_of_Rotterdam.webp",
  },
  {
    compositionName: "Frans Francken the Elder",
    author: ["Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/324149",
    dateCreated: "c. 1626-1633",
    imageUrl: "images/Frans_Francken_the_Elder.webp",
  },
  {
    compositionName: "Elizabeth and Philadelphia Wharton",
    author: ["Pieter van Gunst", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244259",
    dateCreated: "18th century",
    imageUrl: "images/Elizabeth_and_Philadelphia_Wharton.webp",
  },
  {
    compositionName: "Freight Wagon",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244297",
    dateCreated: "17th century",
    imageUrl: "images/Freight_Wagon.webp",
  },
  {
    compositionName:
      "The Christ Child with the Infant John the Baptist and St. Elizabeth",
    author: ["Hendrick Goltzius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244323",
    dateCreated: "c. 1578",
    imageUrl:
      "images/The_Christ_Child_with_the_Infant_John_the_Baptist_and_St__Elizabeth.webp",
  },
  {
    compositionName: "The Death of Giovanni de' Medici",
    author: ["Hendrick Goltzius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244324",
    dateCreated: "c. 1578",
    imageUrl: "images/The_Death_of_Giovanni_de__Medici.webp",
  },
  {
    compositionName: "Ralph Snow",
    author: ["Alexander van Haeken", "After Isaac Whood"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244355",
    dateCreated: "18th century",
    imageUrl: "images/Ralph_Snow.webp",
  },
  {
    compositionName: "Hugh Latimer, Bishop of Worcester",
    author: ["Pieter van Gunst", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244383",
    dateCreated: "18th century",
    imageUrl: "images/Hugh_Latimer__Bishop_of_Worcester.webp",
  },
  {
    compositionName: "Hadrianus Relandus",
    author: ["Pieter van Gunst", "After Johan George Colasius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244384",
    dateCreated: "18th century",
    imageUrl: "images/Hadrianus_Relandus.webp",
  },
  {
    compositionName: "Nicholas Ridley",
    author: ["Pieter van Gunst", "After Adriaen van der Werff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244385",
    dateCreated: "18th century",
    imageUrl: "images/Nicholas_Ridley.webp",
  },
  {
    compositionName: "Heinrich Winckler",
    author: ["Pieter van Gunst", "After Johann Heinrich Am Ende"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244386",
    dateCreated: "18th century",
    imageUrl: "images/Heinrich_Winckler.webp",
  },
  {
    compositionName: "Nicholas Sanderson",
    author: ["Jan Faber the Younger", "After John van der Banck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244649",
    dateCreated: "18th century",
    imageUrl: "images/Nicholas_Sanderson.webp",
  },
  {
    compositionName: "Giovanni de' Medici in a Duel",
    author: ["Hendrick Goltzius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244723",
    dateCreated: "c. 1578",
    imageUrl: "images/Giovanni_de__Medici_in_a_Duel.webp",
  },
  {
    compositionName: "Giovanni de' Medici Sends Back the Swiss Mercenaries",
    author: ["Hendrick Goltzius", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244724",
    dateCreated: "c. 1578",
    imageUrl:
      "images/Giovanni_de__Medici_Sends_Back_the_Swiss_Mercenaries.webp",
  },
  {
    compositionName: "Laughing Smoker",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244735",
    dateCreated: "18th-19th century",
    imageUrl: "images/Laughing_Smoker.webp",
  },
  {
    compositionName: "Family Group",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "This print is after A. van Ostade (etching B. 49) with variations",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244742",
    dateCreated: "18th-19th century",
    imageUrl: "images/Family_Group.webp",
  },
  {
    compositionName: "Half-length figure of a man",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244746",
    dateCreated: "18th-19th century",
    imageUrl: "images/Half_length_figure_of_a_man.webp",
  },
  {
    compositionName: "Man under a Trellis",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244762",
    dateCreated: "18th-19th century",
    imageUrl: "images/Man_under_a_Trellis.webp",
  },
  {
    compositionName:
      "Small Landscape with Sailboat and a Windmill on the Right; verso: fragment of a harbor scene with sailboat",
    author: ["Anthonie van Borssom"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/73712",
    dateCreated: "17th century",
    imageUrl:
      "images/Small_Landscape_with_Sailboat_and_a_Windmill_on_the_Right__verso__fragment_of_a_harbor_scene_with_sailboat.webp",
  },
  {
    compositionName: "A Farmhouse in the Trees",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/76987",
    dateCreated: "c. 1620",
    imageUrl: "images/A_Farmhouse_in_the_Trees.webp",
  },
  {
    compositionName: "Jehan Polyander de Kerckhoven",
    author: ["Cornelis van Dalen, the Elder", "After David Baudringien"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245036",
    dateCreated: "17th century",
    imageUrl: "images/Jehan_Polyander_de_Kerckhoven.webp",
  },
  {
    compositionName: "Giorgione da Castelfranco",
    author: ["Cornelis van Dalen, the Younger", "After Lorenzo Lotto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245038",
    dateCreated: "17th century",
    imageUrl: "images/Giorgione_da_Castelfranco.webp",
  },
  {
    compositionName: "Beheading of Saint John the Baptist",
    author: ["David Deuchar", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245043",
    dateCreated: "18th-19th century",
    imageUrl: "images/Beheading_of_Saint_John_the_Baptist.webp",
  },
  {
    compositionName: "Peasant Smoking",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245049",
    dateCreated: "18th-19th century",
    imageUrl: "images/Peasant_Smoking.webp",
  },
  {
    compositionName: "Peasants Drinking before a House",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245050",
    dateCreated: "18th-19th century",
    imageUrl: "images/Peasants_Drinking_before_a_House.webp",
  },
  {
    compositionName: "Peddlar Sitting at Foot of a Tree",
    author: ["David Deuchar", "After Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245054",
    dateCreated: "18th-19th century",
    imageUrl: "images/Peddlar_Sitting_at_Foot_of_a_Tree.webp",
  },
  {
    compositionName: "Angler",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245055",
    dateCreated: "18th-19th century",
    imageUrl: "images/Angler.webp",
  },
  {
    compositionName: "Angler (Second Plate)",
    author: ["David Deuchar", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245085",
    dateCreated: "18th-19th century",
    imageUrl: "images/Angler__Second_Plate_.webp",
  },
  {
    compositionName: "Adrian Stalbent",
    author: ["John Corner", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245115",
    dateCreated: "18th-19th century",
    imageUrl: "images/Adrian_Stalbent.webp",
  },
  {
    compositionName: "Marcantonio de Dominis, Archbishop of Spalatro",
    author: ["Willem Jacobszoon Delff", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245131",
    dateCreated: "1617",
    imageUrl: "images/Marcantonio_de_Dominis__Archbishop_of_Spalatro.webp",
  },
  {
    compositionName: "Festus Hommius",
    author: ["Cornelis van Dalen, the Elder", "After David Bailly"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245132",
    dateCreated: "17th century",
    imageUrl: "images/Festus_Hommius.webp",
  },
  {
    compositionName: "Night Watch (Detail)",
    author: ["Timothy Cole", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245415",
    dateCreated: "19th-20th century",
    imageUrl: "images/Night_Watch__Detail_.webp",
  },
  {
    compositionName: "Fourth View of Ruins on the Palatine",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182058",
    dateCreated: "1561",
    imageUrl: "images/Fourth_View_of_Ruins_on_the_Palatine.webp",
  },
  {
    compositionName: "New St. Peter\u2019s under Construction",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182059",
    dateCreated: "1561",
    imageUrl: "images/New_St__Peter_s_under_Construction.webp",
  },
  {
    compositionName: "View of the Colosseum, From the Palatine",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182062",
    dateCreated: "1561",
    imageUrl: "images/View_of_the_Colosseum__From_the_Palatine.webp",
  },
  {
    compositionName: "First View of Ruins on the Palatine",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182063",
    dateCreated: "1561",
    imageUrl: "images/First_View_of_Ruins_on_the_Palatine.webp",
  },
  {
    compositionName: "Second View of Ruins on the Palatine",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182064",
    dateCreated: "1561",
    imageUrl: "images/Second_View_of_Ruins_on_the_Palatine.webp",
  },
  {
    compositionName: "View of the Baths of Diocletian",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182065",
    dateCreated: "1561",
    imageUrl: "images/View_of_the_Baths_of_Diocletian.webp",
  },
  {
    compositionName: "View of a Sculpture Garden",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182066",
    dateCreated: "1561",
    imageUrl: "images/View_of_a_Sculpture_Garden.webp",
  },
  {
    compositionName: "Second View of the Baths of Diocletian",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182067",
    dateCreated: "1561",
    imageUrl: "images/Second_View_of_the_Baths_of_Diocletian.webp",
  },
  {
    compositionName: "View of an Amphitheater, Probably the Colosseum",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182154",
    dateCreated: "1561",
    imageUrl: "images/View_of_an_Amphitheater__Probably_the_Colosseum.webp",
  },
  {
    compositionName: "Third View of Ruins on the Palatine",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182155",
    dateCreated: "1561",
    imageUrl: "images/Third_View_of_Ruins_on_the_Palatine.webp",
  },
  {
    compositionName: "Jan Baptist Barb\u00e9",
    author: ["Schelte Adamsz. Bolswert", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245669",
    dateCreated: "17th century",
    imageUrl: "images/Jan_Baptist_Barbe.webp",
  },
  {
    compositionName: "Dead Christ on the Lap of His Mother",
    author: ["Schelte Adamsz. Bolswert", "After Abraham van Diepenbeeck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245670",
    dateCreated: "17th century",
    imageUrl: "images/Dead_Christ_on_the_Lap_of_His_Mother.webp",
  },
  {
    compositionName: "Peasant Eating a Piece of Ham",
    author: ["Cornelis Bloemaert", "After Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245749",
    dateCreated: "1625",
    imageUrl: "images/Peasant_Eating_a_Piece_of_Ham.webp",
  },
  {
    compositionName: "The Cat",
    author: ["John Burnet", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245755",
    dateCreated: "19th century",
    imageUrl: "images/The_Cat.webp",
  },
  {
    compositionName: "The Artist in His Studio",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184043",
    dateCreated: "17th century",
    imageUrl: "images/The_Artist_in_His_Studio.webp",
  },
  {
    compositionName: "The Blind Tobit Admonishing Anna",
    author: [
      "Justus de Gelder",
      "Previously attributed to Rembrandt Harmensz. van Rijn",
      "Previously attributed to Nicolaes Maes",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184045",
    dateCreated: "17th century",
    imageUrl: "images/The_Blind_Tobit_Admonishing_Anna.webp",
  },
  {
    compositionName: "Dancing Man; verso: Standing Man, right arm bent",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184055",
    dateCreated: "17th century",
    imageUrl: "images/Dancing_Man__verso__Standing_Man__right_arm_bent.webp",
  },
  {
    compositionName: "Elderly Couple",
    author: ["Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184057",
    dateCreated: "17th century",
    imageUrl: "images/Elderly_Couple.webp",
  },
  {
    compositionName: "Man and Woman at Table",
    author: ["Isaac van Ostade", "Cornelis Dusart"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184058",
    dateCreated: "17th century",
    imageUrl: "images/Man_and_Woman_at_Table.webp",
  },
  {
    compositionName: "Christ Brought Before Pilate",
    author: ["Samuel van Hoogstraten"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184099",
    dateCreated: "c. 1649",
    imageUrl: "images/Christ_Brought_Before_Pilate.webp",
  },
  {
    compositionName:
      "Three Peasants at Table; verso:  remains of black chalk sketch",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/184117",
    dateCreated: "17th century",
    imageUrl:
      "images/Three_Peasants_at_Table__verso___remains_of_black_chalk_sketch.webp",
  },
  {
    compositionName: "S. Norbert Preaching Against the Heretic Tankelin",
    author: ["Ignaz Bergmann", "After Bernard van Orley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246751",
    dateCreated: "19th century",
    imageUrl: "images/S__Norbert_Preaching_Against_the_Heretic_Tankelin.webp",
  },
  {
    compositionName: "Ornament with Man Seen from Back, Holding a Falcon",
    author: ["Bartholomaeus van Lochom", "Hans Janssen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246777",
    dateCreated: "17th century",
    imageUrl: "images/Ornament_with_Man_Seen_from_Back__Holding_a_Falcon.webp",
  },
  {
    compositionName: "Ornament with Man Facing Left Holding a Falcon",
    author: ["Bartholomaeus van Lochom", "Hans Janssen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246778",
    dateCreated: "17th century",
    imageUrl: "images/Ornament_with_Man_Facing_Left_Holding_a_Falcon.webp",
  },
  {
    compositionName:
      "Duke Adolphus of Gueldres Threatening His Imprisoned Father",
    author: ["Daniel Berger", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246794",
    dateCreated: "1767",
    imageUrl:
      "images/Duke_Adolphus_of_Gueldres_Threatening_His_Imprisoned_Father.webp",
  },
  {
    compositionName: "Rembrandt with a Sabre",
    author: ["Henry Duff Linton", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246808",
    dateCreated: "19th century",
    imageUrl: "images/Rembrandt_with_a_Sabre.webp",
  },
  {
    compositionName: "Ten Roundels for Trenchers (on five sheets)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55212",
    dateCreated: "c. 1570",
    imageUrl: "images/Ten_Roundels_for_Trenchers__on_five_sheets_.webp",
  },
  {
    compositionName: "Printing Block: David Playing His Harp before Saul",
    author: ["After Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55374",
    dateCreated: "1950",
    imageUrl: "images/Printing_Block__David_Playing_His_Harp_before_Saul.webp",
  },
  {
    compositionName: "Has He fingered My Bagpipe Well? (Bagpipers)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55566",
    dateCreated: "c. 1570",
    imageUrl: "images/Has_He_fingered_My_Bagpipe_Well___Bagpipers_.webp",
  },
  {
    compositionName:
      "Little Hans He Kisses Me as You See (Boor and Seamstress)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55599",
    dateCreated: "c. 1570",
    imageUrl:
      "images/Little_Hans_He_Kisses_Me_as_You_See__Boor_and_Seamstress_.webp",
  },
  {
    compositionName: "Farm with Gateway",
    author: [
      "Joannes van Doetecum",
      "and Lucas van Doetecum",
      "After Master of the Small Landscapes",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55630",
    dateCreated: "1559",
    imageUrl: "images/Farm_with_Gateway.webp",
  },
  {
    compositionName: "The King Drinks (Twelfth-Night King and Wife)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55631",
    dateCreated: "c. 1570",
    imageUrl: "images/The_King_Drinks__Twelfth_Night_King_and_Wife_.webp",
  },
  {
    compositionName:
      "That by Itself, Theissgen, Will Hardly Stuff It (Sausage Makers)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55632",
    dateCreated: "c. 1570",
    imageUrl:
      "images/That_by_Itself__Theissgen__Will_Hardly_Stuff_It__Sausage_Makers_.webp",
  },
  {
    compositionName: "Oh Rombert, I Have to Cry (Soldier and Wife)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55641",
    dateCreated: "c. 1570",
    imageUrl: "images/Oh_Rombert__I_Have_to_Cry__Soldier_and_Wife_.webp",
  },
  {
    compositionName: "Dear Heart, My Arrow Is All Worn Down (Archer and Wife)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55820",
    dateCreated: "c. 1570",
    imageUrl:
      "images/Dear_Heart__My_Arrow_Is_All_Worn_Down__Archer_and_Wife_.webp",
  },
  {
    compositionName: "Stuff It Down Quickly, Nelis (Milkmaid and Husband)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55833",
    dateCreated: "c. 1570",
    imageUrl: "images/Stuff_It_Down_Quickly__Nelis__Milkmaid_and_Husband_.webp",
  },
  {
    compositionName: "That Really Is a Big Deal (Spinstress and Poulterer)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55834",
    dateCreated: "c. 1570",
    imageUrl:
      "images/That_Really_Is_a_Big_Deal__Spinstress_and_Poulterer_.webp",
  },
  {
    compositionName:
      "What Are You Up To, My Fine Lass (Gallant and Fisherwoman)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55895",
    dateCreated: "c. 1570",
    imageUrl:
      "images/What_Are_You_Up_To__My_Fine_Lass__Gallant_and_Fisherwoman_.webp",
  },
  {
    compositionName:
      "Little Barbara Holds Her Jug Steady (Couple with Jug and Owl)",
    author: ["After Maarten van Cleve"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55896",
    dateCreated: "c. 1570",
    imageUrl:
      "images/Little_Barbara_Holds_Her_Jug_Steady__Couple_with_Jug_and_Owl_.webp",
  },
  {
    compositionName: 'A Scholar in His Study ("Faust")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/56589",
    dateCreated: "c. 1652",
    imageUrl: "images/A_Scholar_in_His_Study___Faust__.webp",
  },
  {
    compositionName: "The Large Rock at the River",
    author: ["Allart van Everdingen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/57575",
    dateCreated: "17th century",
    imageUrl: "images/The_Large_Rock_at_the_River.webp",
  },
  {
    compositionName: "Florentina, a Courtesan, and the Hermit",
    author: [
      "Various Artists",
      "Ferdinand Bol",
      "Previously attributed to Rembrandt Harmensz. van Rijn",
    ],
    tale: "An illustration in a bound letterpress book, p. 11",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/57800",
    dateCreated: "1644",
    imageUrl: "images/Florentina__a_Courtesan__and_the_Hermit.webp",
  },
  {
    compositionName: "Floral Still Life with Hollyhock and Marigold",
    author: ["Jan van Huysum II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342182",
    dateCreated: "c. 1718",
    imageUrl: "images/Floral_Still_Life_with_Hollyhock_and_Marigold.webp",
  },
  {
    compositionName: "An English Galliot at Sea Running before a Strong Wind",
    author: ["Willem van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342197",
    dateCreated: "c. 1690",
    imageUrl:
      "images/An_English_Galliot_at_Sea_Running_before_a_Strong_Wind.webp",
  },
  {
    compositionName: "The Age of Ten",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342295",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Ten.webp",
  },
  {
    compositionName: "The Age of Twenty",
    author: ["Gerard van Groeningen", "Published by Philips Galle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342297",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Age_of_Twenty.webp",
  },
  {
    compositionName: "The Temptation",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342314",
    dateCreated: "1575",
    imageUrl: "images/The_Temptation.webp",
  },
  {
    compositionName: "Adam and Eve Hiding Themselves",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342315",
    dateCreated: "1575",
    imageUrl: "images/Adam_and_Eve_Hiding_Themselves.webp",
  },
  {
    compositionName: "The Expulsion from Paradise",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342316",
    dateCreated: "1575",
    imageUrl: "images/The_Expulsion_from_Paradise.webp",
  },
  {
    compositionName: "The Life of the First Parents",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342317",
    dateCreated: "1575",
    imageUrl: "images/The_Life_of_the_First_Parents.webp",
  },
  {
    compositionName:
      "Hamor and Shechem Asking Jacob for Dinah's Hand in Marriage",
    author: [
      "Jan Harmensz. Muller",
      "After Maarten van Heemskerck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342335",
    dateCreated: "c. 1569",
    imageUrl:
      "images/Hamor_and_Shechem_Asking_Jacob_for_Dinah_s_Hand_in_Marriage.webp",
  },
  {
    compositionName: "Dinah Taken Home by Simeon and Levi",
    author: [
      "Jan Harmensz. Muller",
      "After Maarten van Heemskerck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342336",
    dateCreated: "c. 1569",
    imageUrl: "images/Dinah_Taken_Home_by_Simeon_and_Levi.webp",
  },
  {
    compositionName: "Ruben and Simeon",
    author: [
      "Johann Sadeler I",
      "Previously attributed to Jan Harmensz. Muller",
      "After Maarten van Heemskerck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342337",
    dateCreated: "c. 1575",
    imageUrl: "images/Ruben_and_Simeon.webp",
  },
  {
    compositionName: "Levi and Juda",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342338",
    dateCreated: "c. 1575",
    imageUrl: "images/Levi_and_Juda.webp",
  },
  {
    compositionName: "Zabulon and Issachar",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342339",
    dateCreated: "c. 1575",
    imageUrl: "images/Zabulon_and_Issachar.webp",
  },
  {
    compositionName: "Dan and Gad",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342340",
    dateCreated: "c. 1575",
    imageUrl: "images/Dan_and_Gad.webp",
  },
  {
    compositionName: "Aser and Nehphtali",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342341",
    dateCreated: "c. 1575",
    imageUrl: "images/Aser_and_Nehphtali.webp",
  },
  {
    compositionName: "Joseph and Benjamin",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342342",
    dateCreated: "c. 1575",
    imageUrl: "images/Joseph_and_Benjamin.webp",
  },
  {
    compositionName: "God  Appearing to Moses",
    author: [
      "Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342350",
    dateCreated: "c. 1579",
    imageUrl: "images/God__Appearing_to_Moses.webp",
  },
  {
    compositionName: "Moses and Aaron before the Pharaoh",
    author: [
      "Johannes Wierix",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342351",
    dateCreated: "c. 1579",
    imageUrl: "images/Moses_and_Aaron_before_the_Pharaoh.webp",
  },
  {
    compositionName: "The Taskmasters of the Pharaoh Beating the Israelites",
    author: [
      "Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342352",
    dateCreated: "c. 1579",
    imageUrl:
      "images/The_Taskmasters_of_the_Pharaoh_Beating_the_Israelites.webp",
  },
  {
    compositionName: "The Invasion of the Frogs",
    author: [
      "Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342353",
    dateCreated: "c. 1579",
    imageUrl: "images/The_Invasion_of_the_Frogs.webp",
  },
  {
    compositionName: "The Preparation for Passover",
    author: [
      "Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342354",
    dateCreated: "c. 1579",
    imageUrl: "images/The_Preparation_for_Passover.webp",
  },
  {
    compositionName: "The Exodus from Egypt",
    author: [
      "Johann Sadeler I",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342355",
    dateCreated: "c. 1579",
    imageUrl: "images/The_Exodus_from_Egypt.webp",
  },
  {
    compositionName: "The Crossing of the Red Sea",
    author: [
      "Johannes Wierix",
      "After Maarten van Cleve",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342356",
    dateCreated: "c. 1579",
    imageUrl: "images/The_Crossing_of_the_Red_Sea.webp",
  },
  {
    compositionName: "Moses Showing the Tables of the Law",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342357",
    dateCreated: "c. 1579",
    imageUrl: "images/Moses_Showing_the_Tables_of_the_Law.webp",
  },
  {
    compositionName: "Gathering of the Manna",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342358",
    dateCreated: "c. 1579",
    imageUrl: "images/Gathering_of_the_Manna.webp",
  },
  {
    compositionName: "Moses Striking Water from the Rock",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342359",
    dateCreated: "c. 1579",
    imageUrl: "images/Moses_Striking_Water_from_the_Rock.webp",
  },
  {
    compositionName: "The Brazen Serpent",
    author: [
      "Johann Sadeler I",
      "After Chrispijn van den Broeck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342360",
    dateCreated: "c. 1579",
    imageUrl: "images/The_Brazen_Serpent.webp",
  },
  {
    compositionName: "Saint Catherine",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248577",
    dateCreated: "1520",
    imageUrl: "images/Saint_Catherine.webp",
  },
  {
    compositionName: "Old Man with a Cane",
    author: ["Pieter Tanj\u00e9", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248578",
    dateCreated: "18th century",
    imageUrl: "images/Old_Man_with_a_Cane.webp",
  },
  {
    compositionName: "Two Gossips",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248592",
    dateCreated: "c. 1642",
    imageUrl: "images/Two_Gossips.webp",
  },
  {
    compositionName: "Dance in the Tavern",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248595",
    dateCreated: "1652",
    imageUrl: "images/Dance_in_the_Tavern.webp",
  },
  {
    compositionName: "Clothing the Naked",
    author: ["Pieter Nagel", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248605",
    dateCreated: "c. 1571",
    imageUrl: "images/Clothing_the_Naked.webp",
  },
  {
    compositionName: "Feeding the Hungry",
    author: ["Pieter Nagel", "After Gerard van Groeningen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248606",
    dateCreated: "c. 1571",
    imageUrl: "images/Feeding_the_Hungry.webp",
  },
  {
    compositionName: "Jehoiada Anointing Joash",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Maarten van Heemskerck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342435",
    dateCreated: "c. 1567",
    imageUrl: "images/Jehoiada_Anointing_Joash.webp",
  },
  {
    compositionName: "The Destruction of the House of Baal",
    author: [
      "Harmen Jansz. M\u00fcller",
      "After Maarten van Heemskerck",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342436",
    dateCreated: "c. 1567",
    imageUrl: "images/The_Destruction_of_the_House_of_Baal.webp",
  },
  {
    compositionName: "King Nebukadnessar Receives Daniel",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342481",
    dateCreated: "before 1576",
    imageUrl: "images/King_Nebukadnessar_Receives_Daniel.webp",
  },
  {
    compositionName: "The Dream of Nebukadnessar",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342482",
    dateCreated: "before 1576",
    imageUrl: "images/The_Dream_of_Nebukadnessar.webp",
  },
  {
    compositionName: "King Nebukadnessar and the Worship of the Golden Statue",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342483",
    dateCreated: "before 1576",
    imageUrl:
      "images/King_Nebukadnessar_and_the_Worship_of_the_Golden_Statue.webp",
  },
  {
    compositionName: "The Magi on Their Way to Bethlehem",
    author: [
      "Johann Sadeler I",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342517",
    dateCreated: "1585",
    imageUrl: "images/The_Magi_on_Their_Way_to_Bethlehem.webp",
  },
  {
    compositionName: "The Magi Visiting Herod",
    author: [
      "Johann Sadeler I",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342518",
    dateCreated: "1585",
    imageUrl: "images/The_Magi_Visiting_Herod.webp",
  },
  {
    compositionName: "The Magi Warned in a Dream not to Return to Herod",
    author: [
      "Johann Sadeler I",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342520",
    dateCreated: "1585",
    imageUrl: "images/The_Magi_Warned_in_a_Dream_not_to_Return_to_Herod.webp",
  },
  {
    compositionName: "The Massacre of the Innocents",
    author: [
      "Johann Sadeler I",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342522",
    dateCreated: "1585",
    imageUrl: "images/The_Massacre_of_the_Innocents.webp",
  },
  {
    compositionName: "Samuel Coster, Physician",
    author: ["Reinier van Persyn", "After Joachim von Sandrart the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248883",
    dateCreated: "17th century",
    imageUrl: "images/Samuel_Coster__Physician.webp",
  },
  {
    compositionName: "Franciscus Plante",
    author: ["Jonas Suyderhoef", "After Dirck Dirckszoon van Santvoort"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248885",
    dateCreated: "17th century",
    imageUrl: "images/Franciscus_Plante.webp",
  },
  {
    compositionName: "Ariosto",
    author: ["Reinier van Persyn", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248970",
    dateCreated: "17th century",
    imageUrl: "images/Ariosto____.webp",
  },
  {
    compositionName: "Boy and Girl With a Sparrow",
    author: ["Pietro Peiroleri", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248988",
    dateCreated: "18th century",
    imageUrl: "images/Boy_and_Girl_With_a_Sparrow.webp",
  },
  {
    compositionName: "Orators, or Minstrels of Haarlem",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249006",
    dateCreated: "1667",
    imageUrl: "images/Orators__or_Minstrels_of_Haarlem.webp",
  },
  {
    compositionName: "Christ and the Woman taken in Adultery",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342585",
    dateCreated: "c. 1572",
    imageUrl: "images/Christ_and_the_Woman_taken_in_Adultery.webp",
  },
  {
    compositionName: "The Jews Throwing Stones at Christ",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342586",
    dateCreated: "c. 1572",
    imageUrl: "images/The_Jews_Throwing_Stones_at_Christ.webp",
  },
  {
    compositionName: "Christ in the Temple in Solomon's Porch",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Gerard van Groeningen",
      "Published by Gerard de Jode",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342587",
    dateCreated: "c. 1572",
    imageUrl: "images/Christ_in_the_Temple_in_Solomon_s_Porch.webp",
  },
  {
    compositionName: "Jupiter and Io",
    author: ["Frans van der Steen", "After Correggio (Antonio Allegri)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249245",
    dateCreated: "17th century",
    imageUrl: "images/Jupiter_and_Io.webp",
  },
  {
    compositionName: "Flight into Egypt",
    author: ["William James Smith", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249275",
    dateCreated: "19th century",
    imageUrl: "images/Flight_into_Egypt.webp",
  },
  {
    compositionName: "Virgin Mourning the Death of Jesus",
    author: ["William James Smith", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249281",
    dateCreated: "19th century",
    imageUrl: "images/Virgin_Mourning_the_Death_of_Jesus.webp",
  },
  {
    compositionName: "Blind Man",
    author: ["William James Smith", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249282",
    dateCreated: "19th century",
    imageUrl: "images/Blind_Man.webp",
  },
  {
    compositionName: "Bust of a Man in Profile, Bearded",
    author: ["William James Smith", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249283",
    dateCreated: "19th century",
    imageUrl: "images/Bust_of_a_Man_in_Profile__Bearded.webp",
  },
  {
    compositionName: "Family of Satyrs",
    author: ["Jonas Suyderhoef", "After Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249291",
    dateCreated: "17th century",
    imageUrl: "images/Family_of_Satyrs.webp",
  },
  {
    compositionName: "Rembrandt as an Officer",
    author: ["Francesco Rosaspina", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249310",
    dateCreated: "18th century",
    imageUrl: "images/Rembrandt_as_an_Officer.webp",
  },
  {
    compositionName: "Daniel Heinsius",
    author: ["Jonas Suyderhoef", "After Jacob Fransz. van der Merck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249353",
    dateCreated: "17th century",
    imageUrl: "images/Daniel_Heinsius.webp",
  },
  {
    compositionName: "Maximilian I, Emperor of Germany",
    author: ["Jonas Suyderhoef", "After Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249358",
    dateCreated: "17th century",
    imageUrl: "images/Maximilian_I__Emperor_of_Germany.webp",
  },
  {
    compositionName: "Burchard",
    author: ["Mathys van Somer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249378",
    dateCreated: "17th century",
    imageUrl: "images/Burchard.webp",
  },
  {
    compositionName: "Peter Engelhardt Dietherr",
    author: ["Mathys van Somer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249379",
    dateCreated: "17th century",
    imageUrl: "images/Peter_Engelhardt_Dietherr.webp",
  },
  {
    compositionName: "Johannes Krull",
    author: ["Mathys van Somer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249380",
    dateCreated: "17th century",
    imageUrl: "images/Johannes_Krull.webp",
  },
  {
    compositionName: "Boors Dancing",
    author: ["Jonas Suyderhoef", "After Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249383",
    dateCreated: "17th century",
    imageUrl: "images/Boors_Dancing.webp",
  },
  {
    compositionName:
      "Lieven Willemz. van Coppenol, Writing Master: The Smaller Plate",
    author: [
      "Pierre Fran\u00e7ois Basan",
      "After Rembrandt Harmensz. van Rijn",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249392",
    dateCreated: "17th century",
    imageUrl:
      "images/Lieven_Willemz__van_Coppenol__Writing_Master__The_Smaller_Plate.webp",
  },
  {
    compositionName: "Wooded Landscape with a Herdsman",
    author: ["Cornelis Ploos van Amstel", "After Jan Both"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249421",
    dateCreated: "18th century",
    imageUrl: "images/Wooded_Landscape_with_a_Herdsman.webp",
  },
  {
    compositionName: "Drunken Man Asleep in a Tavern",
    author: ["Cornelis Ploos van Amstel", "After Adriaen Brouwer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249422",
    dateCreated: "18th century",
    imageUrl: "images/Drunken_Man_Asleep_in_a_Tavern.webp",
  },
  {
    compositionName: "Flock of Goats near a Ruin",
    author: ["Cornelis Ploos van Amstel", "After Simon van der Does"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249423",
    dateCreated: "18th century",
    imageUrl: "images/Flock_of_Goats_near_a_Ruin.webp",
  },
  {
    compositionName: "River near a Town",
    author: ["Cornelis Ploos van Amstel", "After Jacob Esselens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249424",
    dateCreated: "18th century",
    imageUrl: "images/River_near_a_Town.webp",
  },
  {
    compositionName: "Woman Playing a Guitar",
    author: ["Cornelis Ploos van Amstel", "After Caspar Netscher"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249425",
    dateCreated: "18th century",
    imageUrl: "images/Woman_Playing_a_Guitar.webp",
  },
  {
    compositionName: "Landscape with a Watermill",
    author: ["Cornelis Ploos van Amstel", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249426",
    dateCreated: "18th century",
    imageUrl: "images/Landscape_with_a_Watermill.webp",
  },
  {
    compositionName: "Ruins",
    author: ["Cornelis Ploos van Amstel", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249427",
    dateCreated: "18th century",
    imageUrl: "images/Ruins.webp",
  },
  {
    compositionName: "Farm in Ruin",
    author: ["Cornelis Ploos van Amstel", "After Jacob van Ruisdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249428",
    dateCreated: "18th century",
    imageUrl: "images/Farm_in_Ruin.webp",
  },
  {
    compositionName: "Roman Bridge",
    author: ["Cornelis Ploos van Amstel", "After Jacob van der Ulft"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249429",
    dateCreated: "18th century",
    imageUrl: "images/Roman_Bridge.webp",
  },
  {
    compositionName: "Warship Firing a Cannon Shot",
    author: [
      "Cornelis Ploos van Amstel",
      "After Willem van de Velde the Elder",
      "After Willem van de Velde II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249430",
    dateCreated: "18th century",
    imageUrl: "images/Warship_Firing_a_Cannon_Shot.webp",
  },
  {
    compositionName: "Warship and Several Boats",
    author: [
      "Cornelis Ploos van Amstel",
      "After Willem van de Velde the Elder",
      "After Willem van de Velde II",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249431",
    dateCreated: "18th century",
    imageUrl: "images/Warship_and_Several_Boats.webp",
  },
  {
    compositionName: 'Illustration to "Emblemata ex Horatio Flacco"',
    author: ["Gysbrecht van Veen", "After Otto van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249432",
    dateCreated: "16th-17th century",
    imageUrl: "images/Illustration_to__Emblemata_ex_Horatio_Flacco_.webp",
  },
  {
    compositionName: "Bernard Picart",
    author: ["Jacob van der Schley", "After Matth\u00e4us des Angles"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249449",
    dateCreated: "18th century",
    imageUrl: "images/Bernard_Picart.webp",
  },
  {
    compositionName: "Rembrandt's Marriage",
    author: ["Samuel William Reynolds I", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249453",
    dateCreated: "19th century",
    imageUrl: "images/Rembrandt_s_Marriage.webp",
  },
  {
    compositionName: "Flight into Egypt: Holy Family Crossing a Rill",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249455",
    dateCreated: "1654",
    imageUrl: "images/Flight_into_Egypt__Holy_Family_Crossing_a_Rill.webp",
  },
  {
    compositionName: "Christ's Body Carried to the Tomb",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249457",
    dateCreated: "c. 1645",
    imageUrl: "images/Christ_s_Body_Carried_to_the_Tomb.webp",
  },
  {
    compositionName: "Three Oriental Figures (Jacob and Laban)",
    author: [
      "Unidentified Artist",
      "After Rembrandt Harmensz. van Rijn",
      "Published by Johann Georg Hertel",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249458",
    dateCreated: "17th century",
    imageUrl: "images/Three_Oriental_Figures__Jacob_and_Laban_.webp",
  },
  {
    compositionName: "Bust of a Young Man with a Feather Cap",
    author: ["Christoffel van Sichem I", "After Jacob Matham"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249667",
    dateCreated: "1613",
    imageUrl: "images/Bust_of_a_Young_Man_with_a_Feather_Cap.webp",
  },
  {
    compositionName: "Roadside Inn",
    author: ["J. Quartley", "After Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249677",
    dateCreated: "19th century",
    imageUrl: "images/Roadside_Inn.webp",
  },
  {
    compositionName: "Street in Meissen",
    author: ["J. Quartley", "After Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249678",
    dateCreated: "19th century",
    imageUrl: "images/Street_in_Meissen.webp",
  },
  {
    compositionName: "Lady with a Fan",
    author: ["J.P. Quilley", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249680",
    dateCreated: "19th century",
    imageUrl: "images/Lady_with_a_Fan.webp",
  },
  {
    compositionName: "Madonna and Child in a Garland of Roses",
    author: ["Cornelis Ploos van Amstel", "After Abraham Bloemaert"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249690",
    dateCreated: "1769",
    imageUrl: "images/Madonna_and_Child_in_a_Garland_of_Roses.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Madonna and Child with St. Catherine"',
    author: ["Artist of original: Follower of Anthony van Dyck"],
    tale: "X-Radiograph Description: X-radiograph; Detail : Child and St Catherine\r\n\r\nBurroughs Number: 608\r\n\r\nX-Radiograph(s) of: \r\nArtist: Follower of Anthony van Dyck, Flemish\r\nTitle: Madonna and Child with St. Catherine\r\nDescription: Canvas\r\nOwner: Private Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344318",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Madonna_and_Child_with_St__Catherine_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Madonna, Child and St. Catherine"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 610\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nTitle: Madonna, Child and St. Catherine\r\nOwner: Chicago Art Institute, IL\r\nObject Number: 1915.12",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344320",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Madonna__Child_and_St__Catherine_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Madonna and Child with Donor"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : donator; Detail :\r\n\r\nBurroughs Number: 611\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nTitle: Madonna and Child with Donor\r\nDescription: Canvas\r\nOwner: Fogg Museum - Minturn Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344321",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Madonna_and_Child_with_Donor_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Mourning Magdalen (copy ?)"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 612\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Mourning Magdalen (copy ?)\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 672",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344322",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Mourning_Magdalen__copy____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Magdalen"',
    author: [
      "Artist of original: Anthony van Dyck",
      "Artist of original: Also att. to Jacques Jordaens",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 613\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nArtist: Also att. to Jordaens, Jacob, Flemish, 1593-1678\r\nTitle: Magdalen\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 670",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344323",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Magdalen_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Marriage of St. Catherine"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 614\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nTitle: Marriage of St. Catherine\r\nOwner: Williams or Thorne\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344324",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Marriage_of_St__Catherine_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Martin Pepijn"',
    author: [
      "Artist of original: Abraham van Diepenbeeck",
      "Artist of original: Also att. to Anthony van Dyck",
    ],
    tale: "X-Radiograph Description: Print\r\n\r\nBurroughs Number: 615\r\n\r\nX-Radiograph(s) of: \r\nArtist: Diepenbeeck, Abraham Jansz. van, Flemish, 1596-1675\r\nArtist: Also att. to Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Martin Pepijn\r\nOwner: Royal Museum of Fine Arts, Antwerp\r\nObject Number: 793",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344325",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Martin_Pepijn_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "James Stuart, Duke of Lennox"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 616\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: James Stuart, Duke of Lennox\r\nDate: 1632-41\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 89.15.16",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344326",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__James_Stuart__Duke_of_Lennox_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Della Faille"',
    author: ["Artist of original: Anthony van Dyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 617\r\n\r\nX-Radiograph(s) of: \r\nArtist: Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Della Faille\r\nOwner: Royal Museum of Fine Arts, Brussels, Belgium\r\nObject Number: 162",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344327",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Della_Faille_.webp",
  },
  {
    compositionName: "A Rabbi",
    author: ["J.P. Quilley", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249757",
    dateCreated: "19th century",
    imageUrl: "images/A_Rabbi.webp",
  },
  {
    compositionName: "Shipbuilder and his Wife",
    author: ["J.P. Quilley", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249758",
    dateCreated: "19th century",
    imageUrl: "images/Shipbuilder_and_his_Wife.webp",
  },
  {
    compositionName: "Saint Nicholas, Bishop",
    author: ["Daniel Veelward", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249761",
    dateCreated: "19th century",
    imageUrl: "images/Saint_Nicholas__Bishop.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Madonna and Angels"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: X-radiograph; 3 Details : little shows, seam visible\r\n\r\nBurroughs Number: 633\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nTitle: Madonna and Angels\r\nDescription: Canvas\r\nOwner: Stuart Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344343",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Madonna_and_Angels_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Garden of Love"',
    author: ["Artist of original: Gerbrand van den Eeckhout"],
    tale: "X-Radiograph Description: X-Radiograph; Central figures\r\n\r\nBurroughs Number: 637\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eeckhout, Gerbrand van den, Dutch, 1621-1674\r\nTitle: Garden of Love\r\nDate: 1652\r\nDescription: Canvas, lined (stretcher); 21 1/8 x 25 3/16, actual\r\nOwner: Worcester Art Museum, MA\r\nObject Number: 1922.208",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344347",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Garden_of_Love_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Raising of Jairi\'s Daughter"',
    author: ["Artist of original: Gerbrand van den Eeckhout"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 638\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eeckhout, Gerbrand van den, Dutch, 1621-1674\r\nTitle: Raising of Jairi's Daughter\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 804",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344348",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Raising_of_Jairi_s_Daughter_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Destruction of Sodom"',
    author: ["Artist of original: Gerbrand van den Eeckhout"],
    tale: "X-Radiograph Description: Negative; X-radiograph; Dark\r\n\r\nBurroughs Number: 639\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eeckhout, Gerbrand van den, Dutch, 1621-1674\r\nTitle: Destruction of Sodom\r\nDescription: Wood\r\nOwner: Metropolitan Museum, New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344349",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Destruction_of_Sodom_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Girl with a Falcon"',
    author: ["Artist of original: Willem van der Vliet"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : girl\r\n\r\nBurroughs Number: 648\r\n\r\nX-Radiograph(s) of: \r\nArtist: Vliet, Willem Willemsz. van der, Dutch, ca.1584-1642\r\nArtist: Also att. to English School\r\nTitle: Girl with a Falcon\r\nDescription: Wood\r\nOwner: Cincinnati Art Museum, OH\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344358",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Girl_with_a_Falcon_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Adoration of the Lamb, Singing Angels"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 657\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Adoration of the Lamb, Singing Angels\r\nDate: 1432\r\nOwner: St. Bavon, Ghent\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344367",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Adoration_of_the_Lamb__Singing_Angels_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Adoration of the Lamb, Angel Musicians"',
    author: ["Artist of original: Jan van Eyck"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 658\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Jan van, Netherlandish, ca.1390-1441\r\nTitle: Adoration of the Lamb, Angel Musicians\r\nDate: 1432\r\nOwner: St. Bavon, Ghent\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344368",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Adoration_of_the_Lamb__Angel_Musicians_.webp",
  },
  {
    compositionName: "Fight with Pistols",
    author: ["Cornelis Visscher", "After Pieter van Laer"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249955",
    dateCreated: "17th century",
    imageUrl: "images/Fight_with_Pistols.webp",
  },
  {
    compositionName: "Landscape with Judith and Tamar",
    author: ["Claes Jansz. Visscher", "After Gillis van Coninxloo III"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249966",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_Judith_and_Tamar.webp",
  },
  {
    compositionName: "Tinman",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249970",
    dateCreated: "17th century",
    imageUrl: "images/Tinman.webp",
  },
  {
    compositionName: "Peddler Seated at the Foot of a Tree",
    author: ["Jan Joris van Vliet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249971",
    dateCreated: "17th century",
    imageUrl: "images/Peddler_Seated_at_the_Foot_of_a_Tree.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Titus Reading or Singing"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 683\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Titus Reading or Singing\r\nDate: ca.1656-8\r\nOwner: Kunsthistorisches Museum, Vienna\r\nObject Number: 1269",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344393",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Titus_____Reading_or_Singing_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with Gold Chain (the Laborer ?)"',
    author: [
      "Artist of original: Willem Drost",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
      "Artist of original: Also att. to Carel Fabritius",
    ],
    tale: "X-Radiograph Description: X-radiograph; Negative; Overall ; Detail : head; \r\n\r\nBurroughs Number: 689\r\n\r\nX-Radiograph(s) of: \r\nArtist: Drost, Willem, Dutch, 1630-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nArtist: Also att. to Fabritius, Carel, Dutch, 1622-1654\r\nTitle: Man with Gold Chain (the Laborer ?)\r\nDate: ca.1648\r\nDescription: Canvas (stretcher)\r\nOwner: Formerly Ehrich Gallery\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344399",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Man_with_Gold_Chain__the_Laborer____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Daniel\'s Vision"',
    author: [
      "Artist of original: Willem Drost",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 690\r\n\r\nX-Radiograph(s) of: \r\nArtist: Drost, Willem, Dutch, 1630-1680\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Daniel's Vision\r\nDate: ca.1650\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 828 F",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344400",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Daniel_s_Vision_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Adoration of the Kings"',
    author: ["Artist of original: Hendrik van Balen"],
    tale: "X-Radiograph Description: Print, X-radiograph; Detail : Central figures; X-ray in poor condition\r\n\r\nBurroughs Number: 699\r\n\r\nX-Radiograph(s) of: \r\nArtist: Balen, Hendrick van\r\nTitle: Adoration of the Kings\r\nDescription: Wood (cradle)\r\nOwner: Bowdoin College Museum of Art, Brunswick, ME\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344410",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Adoration_of_the_Kings_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Adoration"',
    author: ["Artist of original: Follower of Hugo van der Goes"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 711\r\n\r\nX-Radiograph(s) of: \r\nArtist: Follower of Hugo van der Goes\r\nArtist: Also att. to Flemish School (Ghent)\r\nTitle: Adoration\r\nOwner: Metropolitan Museum, New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344422",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Adoration_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Presentation in the Temple"',
    author: ["Artist of original: Also att. to Goswijn van der Weyden"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 726\r\n\r\nX-Radiograph(s) of: \r\nArtist: Master of Hoogstraeten, Early Netherlandish, 15th-16th centuries\r\nArtist: Also att. to Weyden, Goswijn van der, Flemish, ca. 1465-after 1538\r\nTitle: Presentation in the Temple\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 370",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344437",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Presentation_in_the_Temple_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Woman Reading"',
    author: ["Artist of original: Also att. to Follower of Bernard van Orley"],
    tale: "Burroughs Number: 749\r\n\r\nX-Radiograph(s) of: \r\nArtist: Master of the Female Half-Lengths, Early Netherlandish, act.ca.1500-1533\r\nArtist: Also att. to Follower of Bernaert van Orley\r\nTitle: Woman Reading\r\nOwner: Louvre, Paris\r\nObject Number: 2641",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344460",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Woman_Reading_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Woman at Clavicord (Eleanor of Toledo ?)"',
    author: ["Artist of original: Jan van Hemessen"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head and torso\r\n\r\nBurroughs Number: 752\r\n\r\nX-Radiograph(s) of: \r\nArtist: Hemessen, Jan van, Netherlandish, ca. 1500-ca. 1575\r\nTitle: Woman at Clavicord (Eleanor of Toledo ?)\r\nDescription: Wood (oak) (cradle) 26 7/16 x 21 13 /16 (67.2 x 55.4)\r\nOwner: Worcester Art Museum, MA\r\nObject Number: 1920.88",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344463",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Woman_at_Clavicord__Eleanor_of_Toledo____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Circumcision"',
    author: [
      "Artist of original: Arent de Gelder",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-radiograph; Negative; Detail : central figures\r\n\r\nBurroughs Number: 825\r\n\r\nX-Radiograph(s) of: \r\nArtist: Gelder, Aert de, Dutch, 1645-1727\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Circumcision\r\nDate: 1661\r\nDescription: Oil on canvas, 56.5 x 75 cm (22 1/4 x 29 1/2 in.) \r\nOwner: National Gallery (Widener Collection), Washington, DC \r\nObject Number: 1942.9.60",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344535",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Circumcision_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Death of the Virgin"',
    author: ["Artist of original: Hugo van der Goes"],
    tale: "X-Radiograph Description: Negative (2 details)\r\n\r\nBurroughs Number: 914\r\n\r\nX-Radiograph(s) of: \r\nArtist: Goes, Hugo van der, Netherlandish, ca.1440-1482\r\nTitle: Death of the Virgin\r\nDate: late\r\nOwner: Bruges Museum, Netherlands\r\nObject Number: 7",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344624",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Death_of_the_Virgin_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Virgin and Child"',
    author: ["Artist of original: Hugo van der Goes"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 916\r\n\r\nX-Radiograph(s) of: \r\nArtist: Goes, Hugo van der, Netherlandish, ca.1440-1482\r\nTitle: Virgin and Child\r\nOwner: Royal Museum of Fine Arts, Brussels, Belgium\r\nObject Number: 957",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344626",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Virgin_and_Child_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Saint-Anthony"',
    author: [
      "Artist of original: Lucas Cornelisz.",
      "Artist of original: Also att. to Lucas van Leyden",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1254\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cornelisz. de Kok, Lucas, Netherlandish, ca. 1493-1552\r\nArtist: Also att. to Lucas van Leyden, Netherlandish, ca. 1494-1533\r\nTitle: Saint-Anthony\r\nDate: 1511\r\nDescription: (under Jan de Cock)\r\nOwner: Royal Museum of Fine Arts, Brussels, Belgium\r\nObject Number: 780",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344960",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Saint_Anthony_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Slaughtered Ox (old copy after Rembrandt)"',
    author: [
      "Artist of original: Nicolaes Maes",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1281\r\n\r\nX-Radiograph(s) of: \r\nArtist: Maes, Nicolaes, Dutch, 1634-1693\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Slaughtered Ox (old copy after Rembrandt)\r\nDate: 1637\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 475",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344987",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Slaughtered_Ox__old_copy_after_Rembrandt__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Jacob van Dael"',
    author: ["Artist of original: Michiel Jansz. van Miereveld"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 1391\r\n\r\nX-Radiograph(s) of: \r\nArtist: Miereveld, Michiel Jansz. van, Dutch, 1567-1641\r\nTitle: Jacob van Dael\r\nDate: 1640\r\nDescription: Oil on wood (cradle); 27 1/2 x 23 in. (69.9 x 58.4 cm)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 25.110.13",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345096",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Jacob_van_Dael_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Virgin and Angels"',
    author: ["Artist of original: Bernard van Orley"],
    tale: "Burroughs Number: 1467\r\n\r\nX-Radiograph(s) of: \r\nArtist: Orley, Bernaert van, Flemish, ca.1492-ca.1541\r\nTitle: Virgin and Angels\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 14.60.632",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345172",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Virgin_and_Angels_.webp",
  },
  {
    compositionName: "Titlepage, Nova Reperta",
    author: ["Theodoor Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253769",
    dateCreated: "16th century",
    imageUrl: "images/Titlepage__Nova_Reperta.webp",
  },
  {
    compositionName: "Cornelis Ploos van Amstel",
    author: ["Cornelis Ploos van Amstel", "After George van der Myn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253775",
    dateCreated: "18th century",
    imageUrl: "images/Cornelis_Ploos_van_Amstel.webp",
  },
  {
    compositionName: "The Bath",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253920",
    dateCreated: "15th century",
    imageUrl: "images/The_Bath.webp",
  },
  {
    compositionName: "Christ before Pilate",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253981",
    dateCreated: "15th century",
    imageUrl: "images/Christ_before_Pilate.webp",
  },
  {
    compositionName: "Christ Appearing to His Disciples",
    author: ["Israhel van Meckenem the younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253982",
    dateCreated: "15th century",
    imageUrl: "images/Christ_Appearing_to_His_Disciples.webp",
  },
  {
    compositionName: "Portrait of a Seated Gentleman",
    author: ["Cornelis Ploos van Amstel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254135",
    dateCreated: "1771",
    imageUrl: "images/Portrait_of_a_Seated_Gentleman.webp",
  },
  {
    compositionName: "Lamentation",
    author: ["Luigi Schiavonetti", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254154",
    dateCreated: "18th-19th century",
    imageUrl: "images/Lamentation.webp",
  },
  {
    compositionName: "Portrait of a Young Man with a Skull",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254308",
    dateCreated: "c. 1519",
    imageUrl: "images/Portrait_of_a_Young_Man_with_a_Skull.webp",
  },
  {
    compositionName: "Star of the Kings",
    author: ["Jan van de Velde II", "After Pieter de Molijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254336",
    dateCreated: "17th century",
    imageUrl: "images/Star_of_the_Kings.webp",
  },
  {
    compositionName: "Nude Man Seated on the Ground with One Leg Extended",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254397",
    dateCreated: "1646",
    imageUrl: "images/Nude_Man_Seated_on_the_Ground_with_One_Leg_Extended.webp",
  },
  {
    compositionName: "The Dragon Devouring the Companions of Cadmus",
    author: ["Hendrick Goltzius", "After Cornelis Cornelisz. van Haarlem"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254473",
    dateCreated: "1588",
    imageUrl: "images/The_Dragon_Devouring_the_Companions_of_Cadmus.webp",
  },
  {
    compositionName:
      'A  Brook with a Grotto and a Boat House ("Het Spelonkje")',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254506",
    dateCreated: "1645",
    imageUrl:
      "images/A__Brook_with_a_Grotto_and_a_Boat_House___Het_Spelonkje__.webp",
  },
  {
    compositionName: "Landscape with Ruins of a Tower and a Bridge",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254682",
    dateCreated: "1615",
    imageUrl: "images/Landscape_with_Ruins_of_a_Tower_and_a_Bridge.webp",
  },
  {
    compositionName: "Figure Carrying Building",
    author: ["Anton van Dalen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254730",
    dateCreated: "1993",
    imageUrl: "images/Figure_Carrying_Building.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Toilet of Bathsheba"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1630\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Toilet of Bathsheba\r\nDate: 1643\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 14.40.651",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345335",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Toilet_of_Bathsheba_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Margaretta von Bilderbeecq"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Print, X-Radiograph copy of the same print \r\n\r\nX-Radiograph Settings: 35 kv, 2.2 ma, 50 sec (Whelte)\r\n\r\nBurroughs Number: 1631\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Margaretta von Bilderbeecq\r\nDate: 1633\r\nOwner: Stadel Museum, Frankfort\r\nObject Number: 912",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345336",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Margaretta_von_Bilderbeecq_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Christ at Emmaus"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-radiograph; Negative; Detail : Christ and \r\n\r\nBurroughs Number: 1633\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Christ at Emmaus\r\nDescription: Wood, H 0.68 m; W 0.65 m\r\nOwner: Louvre, Paris\r\nObject Number: 1739",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345338",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Christ_at_Emmaus_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "David before Saul"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nX-Radiograph Settings: 35 kv, 2.2 ma, 50 sec. (Whelte)\r\n\r\nBurroughs Number: 1634\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: David before Saul\r\nDate: ca.1630-1\r\nOwner: Stadel Museum, Frankfort\r\nObject Number: 498",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345339",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__David_before_Saul_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Elizabeth van Rijn"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-radiograph; Print; Negative; Details of X-Ray : half top and half bottom; Details of negative : head\r\n\r\nBurroughs Number: 1635\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Elizabeth van Rijn\r\nDate: 1632\r\nDescription: Wood\r\nOwner: Boston Museum of Fine Arts, MA (R.T. Paine Collection)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345340",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Elizabeth_van_Rijn_____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Herman Doomer"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; details : Head; Hand\r\n\r\nBurroughs Number: 1636\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Herman Doomer\r\nDate: 1640\r\nDescription: Oil on wood; 29 5/8 x 21 3/4 in. (75.2 x 55.2 cm)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 29.100.1",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345341",
    dateCreated: "January 16, 1964",
    imageUrl: "images/X_radiograph_s__of__Herman_Doomer_.webp",
  },
  {
    compositionName: "The Cardinal and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254859",
    dateCreated: "1651",
    imageUrl: "images/The_Cardinal_and_Death.webp",
  },
  {
    compositionName: "The Duke and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254860",
    dateCreated: "1651",
    imageUrl: "images/The_Duke_and_Death.webp",
  },
  {
    compositionName: "The Count and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254861",
    dateCreated: "1651",
    imageUrl: "images/The_Count_and_Death.webp",
  },
  {
    compositionName: "The Knight and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254862",
    dateCreated: "1651",
    imageUrl: "images/The_Knight_and_Death.webp",
  },
  {
    compositionName: "The Advocate and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254909",
    dateCreated: "1651",
    imageUrl: "images/The_Advocate_and_Death.webp",
  },
  {
    compositionName: "The Merchant and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254910",
    dateCreated: "1651",
    imageUrl: "images/The_Merchant_and_Death.webp",
  },
  {
    compositionName: "The Rich Man and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254911",
    dateCreated: "1651",
    imageUrl: "images/The_Rich_Man_and_Death.webp",
  },
  {
    compositionName: "The Gamblers and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254912",
    dateCreated: "1651",
    imageUrl: "images/The_Gamblers_and_Death.webp",
  },
  {
    compositionName: "The Bishop and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254956",
    dateCreated: "1651",
    imageUrl: "images/The_Bishop_and_Death.webp",
  },
  {
    compositionName: "The Monk and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254957",
    dateCreated: "1651",
    imageUrl: "images/The_Monk_and_Death.webp",
  },
  {
    compositionName: "The Abbot and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254958",
    dateCreated: "1651",
    imageUrl: "images/The_Abbot_and_Death.webp",
  },
  {
    compositionName: "The Abbess and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254959",
    dateCreated: "1651",
    imageUrl: "images/The_Abbess_and_Death.webp",
  },
  {
    compositionName: "The Preacher and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254960",
    dateCreated: "1651",
    imageUrl: "images/The_Preacher_and_Death.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Woman Bathing"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1659\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Woman Bathing\r\nDate: 1654\r\nOwner: National Gallery, London\r\nObject Number: 54",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345364",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Woman_Bathing_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Auctioneer (so-called)"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1660\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Auctioneer (so-called)\r\nDate: 1658\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 14.40.624",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345365",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Auctioneer__so_called__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Lady with a Fan"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1661\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Lady with a Fan\r\nDate: 1639\r\nOwner: Rijksmuseum, Amsterdam\r\nObject Number: 2022",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345366",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Lady_with_a_Fan_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with a Glove"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-radiograph; Negative; Detail : head\r\n\r\nBurroughs Number: 1665\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man with a Glove\r\nDate: ca. 1660-8\r\nDescription: Oil on canvas transferred to canvas, 99.5 x 82.5 cm (39 1/8 x 32 1/2 in.) \r\nOwner: National Gallery (Widener Collection), Washington, DC \r\nObject Number: 1942.9.67",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345370",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_with_a_Glove_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with a Glass"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1667\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Man with a Glass\r\nDate: ca.1662-8\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 14.40.621",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345372",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_with_a_Glass_.webp",
  },
  {
    compositionName: "The Bridal Pair and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "Borders after Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255351",
    dateCreated: "1651",
    imageUrl: "images/The_Bridal_Pair_and_Death.webp",
  },
  {
    compositionName: "The Nun and Death",
    author: [
      "Wenceslaus Hollar",
      "After Hans Holbein the Younger",
      "After Abraham van Diepenbeeck",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255352",
    dateCreated: "1651",
    imageUrl: "images/The_Nun_and_Death.webp",
  },
  {
    compositionName: "Madame Duchess of Richemont",
    author: ["Johann van der Bruggen", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255424",
    dateCreated: "1682",
    imageUrl: "images/Madame_Duchess_of_Richemont.webp",
  },
  {
    compositionName: "Title Page from Disasters of the Jewish Nation",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255431",
    dateCreated: "1569",
    imageUrl: "images/Title_Page_from_Disasters_of_the_Jewish_Nation.webp",
  },
  {
    compositionName: "The Tower of Babel",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255432",
    dateCreated: "1569",
    imageUrl: "images/The_Tower_of_Babel.webp",
  },
  {
    compositionName:
      "The Destruction of the Tower of Babel and The Dispersion of Peoples",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255433",
    dateCreated: "1569",
    imageUrl:
      "images/The_Destruction_of_the_Tower_of_Babel_and_The_Dispersion_of_Peoples.webp",
  },
  {
    compositionName: "Lot and His Family Leaving the Burning Sodom",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255434",
    dateCreated: "1569",
    imageUrl: "images/Lot_and_His_Family_Leaving_the_Burning_Sodom.webp",
  },
  {
    compositionName: "Jehu Adoring the Golden Calves",
    author: ["Philips Galle", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255437",
    dateCreated: "1569",
    imageUrl: "images/Jehu_Adoring_the_Golden_Calves.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Raising of Lazarus"',
    author: ["Artist of original: Copy after Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1689\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (copy after), Dutch, 1606-1669\r\nTitle: Raising of Lazarus\r\nDate: ca.1630\r\nOwner: Chicago Art Institute, IL\r\nObject Number: 2363.231",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345394",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Raising_of_Lazarus_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Good Samaritan"',
    author: ["Artist of original: School of Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1690\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Rembrandt\r\nTitle: Good Samaritan\r\nOwner: Shirley Falcke's Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345395",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Good_Samaritan_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Old Jew"',
    author: ["Artist of original: Copy after Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1691\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (copy after), Dutch, 1606-1669\r\nTitle: Old Jew\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 477",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345396",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Old_Jew_.webp",
  },
  {
    compositionName: "Christ Taken by the Jews",
    author: ["Jacob Cornelisz. van Oostsanen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257184",
    dateCreated: "1651",
    imageUrl: "images/Christ_Taken_by_the_Jews.webp",
  },
  {
    compositionName:
      "View from a Canal of the Gate Bridge with Shutters of a Fortified Town, Street Facade on the Right (N. H.)",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by At the Sign of the Four Winds",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257193",
    dateCreated: "1562",
    imageUrl:
      "images/View_from_a_Canal_of_the_Gate_Bridge_with_Shutters_of_a_Fortified_Town__Street_Facade_on_the_Right__N__H__.webp",
  },
  {
    compositionName: "City Street with Lone Tree",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257194",
    dateCreated: "1562",
    imageUrl: "images/City_Street_with_Lone_Tree.webp",
  },
  {
    compositionName: "City Street Rising to a Portico Building with Two Towers",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257195",
    dateCreated: "1562",
    imageUrl:
      "images/City_Street_Rising_to_a_Portico_Building_with_Two_Towers.webp",
  },
  {
    compositionName: "View into a Palace Courtyard with Ducks in a Pond (N.H.)",
    author: [
      "Joannes van Doetecum",
      "Lucas van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by At the Sign of the Four Winds",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257198",
    dateCreated: "1562",
    imageUrl:
      "images/View_into_a_Palace_Courtyard_with_Ducks_in_a_Pond__N_H__.webp",
  },
  {
    compositionName:
      "Town Square with Fountain, in the Centre Background a Temple (N.H.)",
    author: [
      "Lucas van Doetecum",
      "Joannes van Doetecum",
      "After Hans Vredeman de Vries",
      "Published by At the Sign of the Four Winds",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257199",
    dateCreated: "1562",
    imageUrl:
      "images/Town_Square_with_Fountain__in_the_Centre_Background_a_Temple__N_H__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Annunciation (copy)"',
    author: [
      "Artist of original: Master of Fl\u00e9malle",
      "Artist of original: Also att. to Rogier van der Weyden",
      "Artist of original: Also att. to School of Rogier van der Weyden",
    ],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2189\r\n\r\nX-Radiograph(s) of: \r\nArtist: Campin, Robert, Flemish, Born ca. 1375-1379, Died 1444\r\nArtist: Also att. to Weyden, Rogier van der, Flemish, ca. 1399-1464\r\nArtist: Also att. to School of Rogier van der Weyden\r\nTitle: Annunciation (copy)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 2",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345887",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Annunciation__copy__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Margaret de Vos"',
    author: [
      "Artist of original: Gaspar de Crayer",
      "Artist of original: Also att. to Anthony van Dyck",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2239\r\n\r\nX-Radiograph(s) of: \r\nArtist: Crayer, Gaspar de, Flemish, 1584-1669\r\nArtist: Also att. to Dyck, Anthony van, Flemish, 1599-1641\r\nTitle: Margaret de Vos\r\nDescription: Canvas (stetcher)\r\nOwner: Boston Museum of Fine Arts, MA\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345937",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Margaret_de_Vos_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Tobias and the Angel"',
    author: [
      "Artist of original: Barent Fabritius",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 2245\r\n\r\nX-Radiograph(s) of: \r\nArtist: Fabritius, Barent (called Bernard Fabritius), Dutch, 1624-1673\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Tobias and the Angel\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 828 N ",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345943",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Tobias_and_the_Angel_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Diptych of The Crucifixion and The Last Judgment"',
    author: ["Artist of original: Hubert van Eyck"],
    tale: "X-Radiograph Description: X-Radiograph; Details : (little shows); Crucifixion, top ; Crucifixion, bottom; Last Judgment, top; Last Judgment, bottom\r\n\r\nBurroughs Number: 2247\r\n\r\nX-Radiograph(s) of: \r\nArtist: Eyck, Hubert van, Netherlandish, died 1426\r\nTitle: Diptych of The Crucifixion and The Last Judgment\r\nDate: ca. 1430\r\nDescription: Oil on canvas, transferred from wood; Each 22 1/4 x 7 2/3 in. (56.5 x 19.7 cm)\r\nOwner: Metropolitan Museum, New York\r\nObject Number: 33.92ab",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/345945",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Diptych_of_The_Crucifixion_and_The_Last_Judgment_.webp",
  },
  {
    compositionName: "Third View of the Baths of Diocletian",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182156",
    dateCreated: "1561",
    imageUrl: "images/Third_View_of_the_Baths_of_Diocletian.webp",
  },
  {
    compositionName: "View of Massive Ruins, Possibly the Baths of Caracalla",
    author: ["Hieronymus Cock", "Joannes van Doetecum"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/182157",
    dateCreated: "1561",
    imageUrl:
      "images/View_of_Massive_Ruins__Possibly_the_Baths_of_Caracalla.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Christ at the Well"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Little shows\r\n\r\nBurroughs Number: 2435\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Christ at the Well\r\nDate: 1655\r\nDescription: Wood\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 811b",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346133",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Christ_at_the_Well_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "head of Christ"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2436\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: head of Christ\r\nOwner: Gemaldegalerie, Berlin\r\nObject Number: 811c",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346134",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__head_of_Christ_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Harmen van Rijn"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2437\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Harmen van Rijn\r\nDate: ca.1630-1\r\nDescription: Wood\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 230",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346135",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Harmen_van_Rijn_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Bellona"',
    author: [
      "Artist of original: Jacob Adriaensz. Backer",
      "Artist of original: Also att. to Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2439\r\n\r\nX-Radiograph(s) of: \r\nArtist: Backer, Jacob Adriaensz, Dutch, 1608-1651\r\nArtist: Also att. to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Bellona\r\nDate: 1633\r\nDescription: Oil on canvas; 50 x 38 3/8 in. (127 x 97.5 cm)\r\nOwner: Metropolitan Museum, New York (Friedsam Collection)\r\nObject Number: 32.100.23",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346137",
    dateCreated: "January 15, 1964",
    imageUrl: "images/X_radiograph_s__of__Bellona_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Harmen van Rijn"',
    author: ["Artist of original: Imitation from Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Overall (little shows)\r\n\r\nBurroughs Number: 2441\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (Imitation from), Dutch, 1606-1669\r\nTitle: Harmen van Rijn\r\nDescription: Wood\r\nOwner: Metropolitan Museum, New York (Friedsam Collection)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346139",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Harmen_van_Rijn_____.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Lieven van Coppenol"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Detail : head\r\n\r\nBurroughs Number: 2443\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Lieven van Coppenol\r\nDate: ca.1632\r\nDescription: Canvas (stretcher)\r\nOwner: Staatliche Museen Kassel, Germany\r\nObject Number: 234",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346141",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Lieven_van_Coppenol_.webp",
  },
  {
    compositionName: "Cardinal Charles de Bourbon, Archbishop of Lyons",
    author: ["Johann Nepomuk Strixner", "After Jan van Eyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259638",
    dateCreated: "1821-1834",
    imageUrl: "images/Cardinal_Charles_de_Bourbon__Archbishop_of_Lyons.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Male Portrait (Landscape underneath)"',
    author: ["Artist of original: Attributed to Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Overall (nothing shows)\r\n\r\nBurroughs Number: 2667\r\n\r\nX-Radiograph(s) of: \r\nArtist: Forgery\r\nArtist: Attributed to Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Male Portrait (Landscape underneath)\r\nDescription: Wood\r\nOwner: Brinckerhoff\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346366",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Male_Portrait__Landscape_underneath__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man with a White Collar"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: X-Radiorgaph; Overall\r\n\r\nBurroughs Number: 2668\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nArtist: Also att. to Forgeries\r\nTitle: Man with a White Collar\r\nDescription: Canvas (stretcher)\r\nOwner: Metropolitan Museum, New York  (Davis Collection)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346367",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_with_a_White_Collar_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Diptych : The Crucifixion of Saint Peter with a Donor; The Legend of Saint Anthony Abbot with a Donor; The Annunciation, wings of an altarpiece"',
    author: [
      "Artist of original: Also att. to School of Rogier van der Weyden",
    ],
    tale: "X-Radiograph Description: X-Radiograph; Details : (X-rays stained); Donoress on right wing; Left side of left wing\r\n\r\nBurroughs Number: 2832\r\n\r\nX-Radiograph(s) of: \r\nArtist: French School (Picardy)\r\nArtist: Also att. to School of Rogier van der Weyden\r\nTitle: Diptych : The Crucifixion of Saint Peter with a Donor; The Legend of Saint Anthony Abbot with a Donor; The Annunciation, wings of an altarpiece\r\nDate: 1451\r\nDescription: Oil on wood; Each 45 x 31 in. (114.3 x 78.7 cm)\r\nOwner: Metropolitan Museum, New York (Friedsam Collection)\r\nObject Number: 32.100.108?11",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346532",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Diptych___The_Crucifixion_of_Saint_Peter_with_a_Donor__The_Legend_of_Saint_Anthony_Abbot_with_a_Donor__The_Annunciation__wings_of_an_altarpiece_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Head of a Man"',
    author: ["Artist of original: Follower of Jan van Eyck"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2847\r\n\r\nX-Radiograph(s) of: \r\nArtist: Follower of Jan van Eyck\r\nTitle: Head of a Man\r\nOwner: Brooklyn Museum (Friedsam Collection), New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346547",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Head_of_a_Man_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Baby Stuart"',
    author: ["Artist of original: School of Anthony van Dyck"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2851\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Anthony van Dyck\r\nArtist: Or Copy\r\nTitle: Baby Stuart\r\nOwner: Henri W. Belknap, Salem\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346551",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Baby_Stuart_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "St. Ignatius"',
    author: [
      "Artist of original: Abraham van Diepenbeeck",
      "Artist of original: Also att. to Peter Paul Rubens",
    ],
    tale: "X-Radiograph Description: 1 X-Radiograph, 1 print, Negative\r\n\r\nBurroughs Number: 2860\r\n\r\nX-Radiograph(s) of: \r\nArtist: Diepenbeeck, Abraham Jansz. van, Flemish, 1596-1675\r\nArtist: Also att. to Rubens, Peter Paul, Flemish, 1577-1640\r\nTitle: St. Ignatius\r\nOwner: Berkshire Museum, Pittsfield, MA\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346560",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__St__Ignatius_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "High Priest"',
    author: [
      "Artist of original: Imitation from Rembrandt Harmensz. van Rijn",
    ],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2863\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (Imitation from ?), Dutch, 1606-1669\r\nTitle: High Priest\r\nDate: 1637\r\nOwner: Worcester Art Museum, MA (loan from Bottenweiser)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346563",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__High_Priest_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Aristotle with Bust of Homer"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph (2 details)\r\n\r\nBurroughs Number: 2901\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Aristotle with Bust of Homer\r\nDate: 1653\r\nOwner: Through Duveen Brothers\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346601",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Aristotle_with_Bust_of_Homer_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Lucrecia"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph (2 details)\r\n\r\nBurroughs Number: 2902\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Lucrecia\r\nDate: 1666\r\nOwner: Minneapolis Institute of Arts, MN\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346602",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Lucrecia_.webp",
  },
  {
    compositionName: "The Virgin, Saint Anne, and Infant Jesus",
    author: [
      "Johann Nepomuk Strixner",
      "After Jan Joest van Calcar",
      "Previously attributed to after Jan Stephan von Calcar",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260170",
    dateCreated: "1821-1834",
    imageUrl: "images/The_Virgin__Saint_Anne__and_Infant_Jesus.webp",
  },
  {
    compositionName: "The Sorrowing Mother",
    author: [
      "Johann Nepomuk Strixner",
      "After Jan Joest van Calcar",
      "Previously attributed to after Jan Stephan von Calcar",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260171",
    dateCreated: "1821-1834",
    imageUrl: "images/The_Sorrowing_Mother.webp",
  },
  {
    compositionName: "Two Boys with a Helmet and a Standard",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260207",
    dateCreated: "1527",
    imageUrl: "images/Two_Boys_with_a_Helmet_and_a_Standard.webp",
  },
  {
    compositionName: "Meeting of Joachim and Anna",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260229",
    dateCreated: "1520",
    imageUrl: "images/Meeting_of_Joachim_and_Anna.webp",
  },
  {
    compositionName: "Two Couples in the Forest",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260233",
    dateCreated: "c. 1509",
    imageUrl: "images/Two_Couples_in_the_Forest.webp",
  },
  {
    compositionName: "Madonna and Child with Two Angels",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260240",
    dateCreated: "1523",
    imageUrl: "images/Madonna_and_Child_with_Two_Angels.webp",
  },
  {
    compositionName: "Old Beggar Bent Over",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260259",
    dateCreated: "c. 1675",
    imageUrl: "images/Old_Beggar_Bent_Over.webp",
  },
  {
    compositionName: "Peter",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260267",
    dateCreated: "16th century",
    imageUrl: "images/Peter.webp",
  },
  {
    compositionName: "Paul",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260268",
    dateCreated: "16th century",
    imageUrl: "images/Paul.webp",
  },
  {
    compositionName: "Saint Philip",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260269",
    dateCreated: "16th century",
    imageUrl: "images/Saint_Philip.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Self-Portrait (after Louvre portrait of 1637)"',
    author: ["Artist of original: Copy after Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3538\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (copy after), Dutch, 1606-1669\r\nTitle: Self-Portrait (after Louvre portrait of 1637)\r\nOwner: Private Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347152",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Self_Portrait__after_Louvre_portrait_of_1637__.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Man in a Beret"',
    author: ["Artist of original: Imitation from Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3539\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (Imitation from), Dutch, 1606-1669\r\nTitle: Man in a Beret\r\nOwner: Private Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347153",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Man_in_a_Beret_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Angel"',
    author: ["Artist of original: Lucas van Leyden"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3540\r\n\r\nX-Radiograph(s) of: \r\nArtist: Lucas van Leyden, Netherlandish, ca. 1494-1533\r\nTitle: Angel\r\nDate: Early\r\nOwner: Harvard University Art Museums\r\nObject Number: 1943.98",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347154",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Angel_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Abraham\'s Sacrifice"',
    author: ["Artist of original: Imitation from Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3544\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn (Imitation from), Dutch, 1606-1669\r\nTitle: Abraham's Sacrifice\r\nOwner: Sigismund Rothschild Jr., New York\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347157",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Abraham_s_Sacrifice_.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Self-Portrait with a Bandaged Ear and Pipe"',
    author: ["Artist of original: After Vincent van Gogh"],
    tale: "X-Radiograph Description: X-Radiograph (2) Portion of picture covered: 100%; \r\n\r\nBurroughs Number: 3557\r\n\r\nX-Radiograph(s) of: \r\nArtist: Forgery\r\nArtist: After Gogh, Vincent van, Dutch, 1853-1890\r\nTitle: Self-Portrait with a Bandaged Ear and Pipe\r\nDescription: oil on canvas, high impasto\r\nOwner: Harvard University Art Museums\r\nObject Number: 1934.35",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347170",
    dateCreated: "",
    imageUrl:
      "images/X_radiograph_s__of__Self_Portrait_with_a_Bandaged_Ear_and_Pipe_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "H. Stoeffels at Window"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Portion of Picture covered: 50%\r\n\r\nBurroughs Number: 3592\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: H. Stoeffels at Window\r\nOwner: Walters Art Museum, Baltimore, MD\r\nObject Number: TL8103",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347199",
    dateCreated: "June 15, 1948",
    imageUrl: "images/X_radiograph_s__of__H__Stoeffels_at_Window_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Rabbi in a Red Hat"',
    author: ["Artist of original: Rembrandt Harmensz. van Rijn"],
    tale: "X-Radiograph Description: X-Radiograph; Portion of picture covered: 50 %\r\n\r\nBurroughs Number: 3596\r\n\r\nX-Radiograph(s) of: \r\nArtist: Rembrandt van Rijn, Dutch, 1606-1669\r\nTitle: Rabbi in a Red Hat\r\nDate: 1657\r\nOwner: Palace of the Legion of Honor, San Francisco, CA\r\nObject Number: TL8209",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347203",
    dateCreated: "November 29, 1948",
    imageUrl: "images/X_radiograph_s__of__Rabbi_in_a_Red_Hat_.webp",
  },
  {
    compositionName: "Surgeon",
    author: ["Copy after Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260390",
    dateCreated: "16th century",
    imageUrl: "images/Surgeon.webp",
  },
  {
    compositionName: "Algernon Percy, Earl of Northumberland",
    author: ["Jacobus Houbraken", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260426",
    dateCreated: "1738",
    imageUrl: "images/Algernon_Percy__Earl_of_Northumberland.webp",
  },
  {
    compositionName: "Presentation of Christ before Herod",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261116",
    dateCreated: "1648",
    imageUrl: "images/Presentation_of_Christ_before_Herod.webp",
  },
  {
    compositionName: "Christ Denounced by the People and Led Away by Soldiers",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261117",
    dateCreated: "1648",
    imageUrl:
      "images/Christ_Denounced_by_the_People_and_Led_Away_by_Soldiers.webp",
  },
  {
    compositionName: "Christ is Led Away as Pilate Washes His Hands",
    author: ["Christoffel van Sichem II", "After Maarten van Heemskerck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261118",
    dateCreated: "1648",
    imageUrl: "images/Christ_is_Led_Away_as_Pilate_Washes_His_Hands.webp",
  },
  {
    compositionName: "John the Baptist",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261120",
    dateCreated: "1657?",
    imageUrl: "images/John_the_Baptist.webp",
  },
  {
    compositionName: "Saint Ann and the Virgin and Child",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261121",
    dateCreated: "1648",
    imageUrl: "images/Saint_Ann_and_the_Virgin_and_Child.webp",
  },
  {
    compositionName: "Gaston d'Orleans",
    author: ["Pieter van Sompel", "After Anthony van Dyck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261165",
    dateCreated: "17th century",
    imageUrl: "images/Gaston_d_Orleans.webp",
  },
  {
    compositionName: "Nude Man Seated before a Curtain",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261184",
    dateCreated: "1646",
    imageUrl: "images/Nude_Man_Seated_before_a_Curtain.webp",
  },
  {
    compositionName: "Landscape with a Cow Drinking",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261185",
    dateCreated: "c. 1650-1651",
    imageUrl: "images/Landscape_with_a_Cow_Drinking.webp",
  },
  {
    compositionName: "Initial",
    author: ["Jan van Vianen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261190",
    dateCreated: "1701",
    imageUrl: "images/Initial.webp",
  },
  {
    compositionName: "Church Tower of Katwyk",
    author: ["Charles Storm van's Gravesande"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261456",
    dateCreated: "19th-20th century",
    imageUrl: "images/Church_Tower_of_Katwyk.webp",
  },
  {
    compositionName: "Saint Jerome beside a Pollard Willow",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261490",
    dateCreated: "1648",
    imageUrl: "images/Saint_Jerome_beside_a_Pollard_Willow.webp",
  },
  {
    compositionName: "Beggar Man and Beggar Woman Conversing",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261505",
    dateCreated: "1630",
    imageUrl: "images/Beggar_Man_and_Beggar_Woman_Conversing.webp",
  },
  {
    compositionName: "Boats on a River",
    author: ["Charles Storm van's Gravesande"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261638",
    dateCreated: "19th-20th century",
    imageUrl: "images/Boats_on_a_River.webp",
  },
  {
    compositionName: "Gillis de Glarges",
    author: ["Jonas Suyderhoef", "After Michiel Jansz. van Miereveld"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261667",
    dateCreated: "17th century",
    imageUrl: "images/Gillis_de_Glarges.webp",
  },
  {
    compositionName: "Pepin, First Duke of Brabant, and His Daughter, Bega",
    author: ["Frans van der Steen", "After Peter Paul Rubens"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261710",
    dateCreated: "17th century",
    imageUrl:
      "images/Pepin__First_Duke_of_Brabant__and_His_Daughter__Bega.webp",
  },
  {
    compositionName: "Expulsion from the Garden",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261755",
    dateCreated: "1631/1646",
    imageUrl: "images/Expulsion_from_the_Garden.webp",
  },
  {
    compositionName:
      "Laban gives a banquet for Jacob upon his intended marriage to Rachel",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261756",
    dateCreated: "1646",
    imageUrl:
      "images/Laban_gives_a_banquet_for_Jacob_upon_his_intended_marriage_to_Rachel.webp",
  },
  {
    compositionName: "David receives the news of the death of Absalom",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261757",
    dateCreated: "1646",
    imageUrl: "images/David_receives_the_news_of_the_death_of_Absalom.webp",
  },
  {
    compositionName: "Sampson and the Lion",
    author: ["Christoffel van Sichem II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261758",
    dateCreated: "1646",
    imageUrl: "images/Sampson_and_the_Lion.webp",
  },
  {
    compositionName: "Jan Six",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261770",
    dateCreated: "1647",
    imageUrl: "images/Jan_Six.webp",
  },
  {
    compositionName: "Man Wearing a Close Cap: Bust (The Artist's Father?)",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261771",
    dateCreated: "1630",
    imageUrl:
      "images/Man_Wearing_a_Close_Cap__Bust__The_Artist_s_Father__.webp",
  },
  {
    compositionName: "Studies of the Head of Saskia and Others",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261772",
    dateCreated: "1636",
    imageUrl: "images/Studies_of_the_Head_of_Saskia_and_Others.webp",
  },
  {
    compositionName: "Bust of an Old Man with Flowing Beard and White Sleeve",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261779",
    dateCreated: "c. 1630",
    imageUrl:
      "images/Bust_of_an_Old_Man_with_Flowing_Beard_and_White_Sleeve.webp",
  },
  {
    compositionName: "Sheet of Studies with a Woman Lying Ill in Bed",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261780",
    dateCreated: "c. 1639",
    imageUrl: "images/Sheet_of_Studies_with_a_Woman_Lying_Ill_in_Bed.webp",
  },
  {
    compositionName: "Man Leading a Camel",
    author: ["Unidentified Artist", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261891",
    dateCreated: "19th century",
    imageUrl: "images/Man_Leading_a_Camel.webp",
  },
  {
    compositionName: "Joseph Telling His Dreams",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261960",
    dateCreated: "1638",
    imageUrl: "images/Joseph_Telling_His_Dreams.webp",
  },
  {
    compositionName: "Cartouche in Auricular Style with Six Compartments",
    author: [
      "Michiel Mosijn",
      "After Gerbrand van den Eeckhout",
      "Published by Cornelis Danckerts I",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/349729",
    dateCreated: "17th century",
    imageUrl: "images/Cartouche_in_Auricular_Style_with_Six_Compartments.webp",
  },
  {
    compositionName: "The Invention of Book Printing",
    author: ["Theodoor Galle", "After Jan van der Straet"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/349745",
    dateCreated: "c. 1591",
    imageUrl: "images/The_Invention_of_Book_Printing.webp",
  },
  {
    compositionName: "Portrait of Frans van Mieris",
    author: ["Carel de Moor", "After Frans van Mieris the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/349751",
    dateCreated: "c. 1690",
    imageUrl: "images/Portrait_of_Frans_van_Mieris.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with a Bat-like Form at Top Center, with Four Winged Putti Clasping Fruit Garlands at the Sides",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350045",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_a_Bat_like_Form_at_Top_Center__with_Four_Winged_Putti_Clasping_Fruit_Garlands_at_the_Sides.webp",
  },
  {
    compositionName:
      "Auricular Cartouche with Fruit Garlands and a Winged Monster with Clawed Paws",
    author: [
      "Pieter Hendricksz. Schut",
      "After Gerbrand van den Eeckhout",
      "Published by Nicolaes Visscher",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/350046",
    dateCreated: "1655",
    imageUrl:
      "images/Auricular_Cartouche_with_Fruit_Garlands_and_a_Winged_Monster_with_Clawed_Paws.webp",
  },
  {
    compositionName: "Portrait of a Man Holding a Sword",
    author: ["Willem van Mieris"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/354251",
    dateCreated: "1686",
    imageUrl: "images/Portrait_of_a_Man_Holding_a_Sword.webp",
  },
  {
    compositionName: "Susannah and the Elders",
    author: ["Willem van Mieris"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/354736",
    dateCreated: "1691",
    imageUrl: "images/Susannah_and_the_Elders.webp",
  },
  {
    compositionName: "The Adoration of the Christ Child",
    author: ["Bart Anthony van der Leck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/355102",
    dateCreated: "1905-1906",
    imageUrl: "images/The_Adoration_of_the_Christ_Child.webp",
  },
  {
    compositionName: "Landscape with Farmhouse",
    author: ["Jan van der Heyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/356426",
    dateCreated: "1668",
    imageUrl: "images/Landscape_with_Farmhouse.webp",
  },
  {
    compositionName:
      "Cottages and a Hay Barn on the Diemerdijk with a Flock of Sheep",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262281",
    dateCreated: "1650",
    imageUrl:
      "images/Cottages_and_a_Hay_Barn_on_the_Diemerdijk_with_a_Flock_of_Sheep.webp",
  },
  {
    compositionName: "Cornelis Claesz Anslo",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262282",
    dateCreated: "1641",
    imageUrl: "images/Cornelis_Claesz_Anslo.webp",
  },
  {
    compositionName: 'Jan Uytenbogaert, "The Goldweigher"',
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262331",
    dateCreated: "1639",
    imageUrl: "images/Jan_Uytenbogaert___The_Goldweigher_.webp",
  },
  {
    compositionName:
      "Bald-headed Man in Profile Right: Small Bust, the Artist's Father",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262362",
    dateCreated: "1630",
    imageUrl:
      "images/Bald_headed_Man_in_Profile_Right__Small_Bust__the_Artist_s_Father____.webp",
  },
  {
    compositionName: "Illustration",
    author: ["Jan van Vianen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262363",
    dateCreated: "17th-18th century",
    imageUrl: "images/Illustration.webp",
  },
  {
    compositionName: "The Great Jewish Bride",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262373",
    dateCreated: "1635",
    imageUrl: "images/The_Great_Jewish_Bride.webp",
  },
  {
    compositionName:
      "Rembrandt's Mother Seated at a Table, Looking Right: Three-Quarter Length",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/262374",
    dateCreated: "c. 1631",
    imageUrl:
      "images/Rembrandt_s_Mother_Seated_at_a_Table__Looking_Right__Three_Quarter_Length.webp",
  },
  {
    compositionName:
      "A Bouquet of Flowers; verso: Sketch of a bouquet and grapes",
    author: ["Jan van Huysum II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360056",
    dateCreated: "18th century",
    imageUrl:
      "images/A_Bouquet_of_Flowers__verso__Sketch_of_a_bouquet_and_grapes.webp",
  },
  {
    compositionName: "The Peasant Father",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360058",
    dateCreated: "17th century",
    imageUrl: "images/The_Peasant_Father.webp",
  },
  {
    compositionName: "Kneeling Actor; verso: Sketch of a Figure",
    author: ["Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360059",
    dateCreated: "17th century",
    imageUrl: "images/Kneeling_Actor__verso__Sketch_of_a_Figure.webp",
  },
  {
    compositionName: "Landscape with a Fence and House",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360559",
    dateCreated: "17th century",
    imageUrl: "images/Landscape_with_a_Fence_and_House.webp",
  },
  {
    compositionName: "Skating Scene",
    author: ["Esaias van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360560",
    dateCreated: "17th century",
    imageUrl: "images/Skating_Scene.webp",
  },
  {
    compositionName: "Italianate Landscape with a River",
    author: ["Jacob van der Ulft"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360563",
    dateCreated: "17th century",
    imageUrl: "images/Italianate_Landscape_with_a_River.webp",
  },
  {
    compositionName: "Peasants in a Barn Slaughtering a Pig",
    author: ["Follower of Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360566",
    dateCreated: "17th century",
    imageUrl: "images/Peasants_in_a_Barn_Slaughtering_a_Pig.webp",
  },
  {
    compositionName: "Landscape with Travelers on a Hill overlooking a River",
    author: ["Corneliz Symonsz. van der Schalcke"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360576",
    dateCreated: "17th century",
    imageUrl:
      "images/Landscape_with_Travelers_on_a_Hill_overlooking_a_River.webp",
  },
  {
    compositionName: "A Sparrow",
    author: ["Gerardus van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360591",
    dateCreated: "1678",
    imageUrl: "images/A_Sparrow.webp",
  },
  {
    compositionName: "Peasant Interior with Butchering",
    author: ["Isaac van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360602",
    dateCreated: "17th century",
    imageUrl: "images/Peasant_Interior_with_Butchering.webp",
  },
  {
    compositionName: "Village Street with Travelers Resting",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360603",
    dateCreated: "17th century",
    imageUrl: "images/Village_Street_with_Travelers_Resting.webp",
  },
  {
    compositionName: "Castle with a View to a Church",
    author: ["Jan van Goyen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360604",
    dateCreated: "1653",
    imageUrl: "images/Castle_with_a_View_to_a_Church.webp",
  },
  {
    compositionName: "A Branch of White Plums",
    author: ["Jacob van Eynden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360606",
    dateCreated: "18th century",
    imageUrl: "images/A_Branch_of_White_Plums.webp",
  },
  {
    compositionName: "Nasturtium Indicum",
    author: ["Balthasar van der Ast"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360611",
    dateCreated: "c. 1620-40",
    imageUrl: "images/Nasturtium_Indicum.webp",
  },
  {
    compositionName: "A Goat",
    author: ["Adriaen van de Velde"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360619",
    dateCreated: "17th century",
    imageUrl: "images/A_Goat.webp",
  },
  {
    compositionName:
      "Portrait of an Elegant Lady; verso: Two Portraits of an Elegant Lady",
    author: ["Gerrit van Honthorst"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/360639",
    dateCreated: "17th century",
    imageUrl:
      "images/Portrait_of_an_Elegant_Lady__verso__Two_Portraits_of_an_Elegant_Lady.webp",
  },
  {
    compositionName: "Harbor Scene",
    author: [
      "Cornelis Claesz. van Wieringen",
      "Previously attributed to Abraham de Verwer",
      "Previously attributed to Aert van der Neer",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361318",
    dateCreated: "17th century",
    imageUrl: "images/Harbor_Scene.webp",
  },
  {
    compositionName: "Turnips",
    author: ["Rocho van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361328",
    dateCreated: "17th century",
    imageUrl: "images/Turnips.webp",
  },
  {
    compositionName: "Peasants in an Interior",
    author: ["Adriaen van Ostade"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361330",
    dateCreated: "17th century",
    imageUrl: "images/Peasants_in_an_Interior.webp",
  },
  {
    compositionName: "Ships in a Harbor",
    author: ["Willem van de Velde the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361332",
    dateCreated: "17th century",
    imageUrl: "images/Ships_in_a_Harbor.webp",
  },
  {
    compositionName: "Dead Bird",
    author: ["Gerardus van Veen"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361338",
    dateCreated: "1675",
    imageUrl: "images/Dead_Bird.webp",
  },
  {
    compositionName: "Seven Peasants in an Interior",
    author: [
      "School of Adriaen van Ostade",
      "Previously attributed to Cornelis Dusart",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361344",
    dateCreated: "17th century",
    imageUrl: "images/Seven_Peasants_in_an_Interior.webp",
  },
  {
    compositionName: "Head of a Man",
    author: ["Jan van de Velde II"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361357",
    dateCreated: "1639",
    imageUrl: "images/Head_of_a_Man.webp",
  },
  {
    compositionName: "Cottages by a River; verso: Cottage by a Tree",
    author: ["Salomon van Ruysdael"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/361358",
    dateCreated: "17th century",
    imageUrl: "images/Cottages_by_a_River__verso__Cottage_by_a_Tree.webp",
  },
  {
    compositionName: "The Big Fish Eat the Little Fish",
    author: [
      "Pieter van der Heyden",
      "After Pieter Bruegel, the Elder",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362972",
    dateCreated: "1557",
    imageUrl: "images/The_Big_Fish_Eat_the_Little_Fish.webp",
  },
  {
    compositionName: "Peasant Wedding Dance",
    author: [
      "Pieter van der Heyden",
      "After Pieter Bruegel, the Elder",
      "Published by At the Sign of the Four Winds",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362973",
    dateCreated: "after 1570",
    imageUrl: "images/Peasant_Wedding_Dance.webp",
  },
  {
    compositionName: "The Wedding of Mopsus and Nisa",
    author: [
      "Pieter van der Heyden",
      "After Pieter Bruegel, the Elder",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362974",
    dateCreated: "1570",
    imageUrl: "images/The_Wedding_of_Mopsus_and_Nisa.webp",
  },
  {
    compositionName: "The Blue Boat",
    author: [
      "Pieter van der Heyden",
      "Manner of Hieronymus Bosch",
      "Published by Hieronymus Cock",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362975",
    dateCreated: "1559",
    imageUrl: "images/The_Blue_Boat.webp",
  },
  {
    compositionName: "The Eaters of Sausages and Fat",
    author: [
      "Attributed to Joannes van Doetecum",
      "Attributed to Lucas van Doetecum",
      "Published by Hieronymus Cock",
      "Manner of Hieronymus Bosch",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362976",
    dateCreated: "16th century",
    imageUrl: "images/The_Eaters_of_Sausages_and_Fat.webp",
  },
  {
    compositionName: "The Judgment of Paris",
    author: [
      "Nicolaas Verkolje",
      "After Cornelis Cornelisz. van Haarlem",
      "Previously attributed to Cornelis Cornelisz. van Haarlem",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/363238",
    dateCreated: "18th century",
    imageUrl: "images/The_Judgment_of_Paris.webp",
  },
  {
    compositionName: "The Baptism of Christ in the Jordan",
    author: ["Lucas van Leyden"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/364387",
    dateCreated: "c. 1510",
    imageUrl: "images/The_Baptism_of_Christ_in_the_Jordan.webp",
  },
  {
    compositionName: "Concert Hall of the Felix Meritis Society in Amsterdam",
    author: [
      "Reinier Vinkeles",
      "Noach van der Meer the Younger",
      "After Jacques Kuyper",
      "Published by C. S. Roos",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/364510",
    dateCreated: "1791",
    imageUrl:
      "images/Concert_Hall_of_the_Felix_Meritis_Society_in_Amsterdam.webp",
  },
  {
    compositionName: "Djenne Market and Mosque",
    author: ["Ian van Coller"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/365369",
    dateCreated: "1998",
    imageUrl: "images/Djenne_Market_and_Mosque.webp",
  },
  {
    compositionName:
      "Medici Chapel, after Michelangelo; verso: Egyptian Heads; Miscellaneous Sketches",
    author: ["John Singer Sargent", "After Michelangelo Buonarroti"],
    tale: 'The sketch was made on Royal Academy letterhead; in red, it is printed "Royal Academy of Arts / London, W. / 190__"  The side that is folded in is more finished and thus was considered during cataloguing to be the recto.',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/194765",
    dateCreated: "1906 - 1913",
    imageUrl:
      "images/Medici_Chapel__after_Michelangelo__verso__Egyptian_Heads__Miscellaneous_Sketches.webp",
  },
  {
    compositionName: "Blank page; verso: Head of Brutus, after Michelangelo",
    author: ["John Singer Sargent", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/197630",
    dateCreated: "c. 1884 - 1889",
    imageUrl:
      "images/Blank_page__verso__Head_of_Brutus__after_Michelangelo.webp",
  },
  {
    compositionName: "Battle of Lapiths and Centaurs, after Michelangelo",
    author: ["Attributed to Jacques Jordaens", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/199089",
    dateCreated: "17th century",
    imageUrl: "images/Battle_of_Lapiths_and_Centaurs__after_Michelangelo.webp",
  },
  {
    compositionName: "Countess Matilda of Tuscany",
    author: [
      "After a model by Gian Lorenzo Bernini",
      "Previously attributed to Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/213392",
    dateCreated: "c. 1633-1634 (model)",
    imageUrl: "images/Countess_Matilda_of_Tuscany.webp",
  },
  {
    compositionName: "The Persian Sibyl",
    author: ["Giorgio Ghisi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/226294",
    dateCreated: "early 1570s",
    imageUrl: "images/The_Persian_Sibyl.webp",
  },
  {
    compositionName: "Night, after Michelangelo",
    author: ["Unidentified Artist", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/226693",
    dateCreated: "1895",
    imageUrl: "images/Night__after_Michelangelo.webp",
  },
  {
    compositionName: "Day, after Michelangelo",
    author: ["Unidentified Artist", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/226694",
    dateCreated: "1895",
    imageUrl: "images/Day__after_Michelangelo.webp",
  },
  {
    compositionName:
      "The Cardsharps (after the painting in the Kimbell Art Museum)",
    author: ["Unidentified Artist", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228614",
    dateCreated: "18th-19th century",
    imageUrl:
      "images/The_Cardsharps__after_the_painting_in_the_Kimbell_Art_Museum_.webp",
  },
  {
    compositionName: "The Entombment of Christ",
    author: ["After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231344",
    dateCreated: "17th century",
    imageUrl: "images/The_Entombment_of_Christ.webp",
  },
  {
    compositionName: "The Card Players",
    author: ["Follower of Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231633",
    dateCreated: "17th century",
    imageUrl: "images/The_Card_Players.webp",
  },
  {
    compositionName: "The Martyrdom of Saint Sebastian",
    author: [
      "Giovanni Battista Caracciolo",
      "Previously attributed to school of Michelangelo Merisi da Caravaggio",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/231737",
    dateCreated: "c. 1625",
    imageUrl: "images/The_Martyrdom_of_Saint_Sebastian.webp",
  },
  {
    compositionName: "The Denial of Saint Peter",
    author: ["Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233683",
    dateCreated: "1603",
    imageUrl: "images/The_Denial_of_Saint_Peter.webp",
  },
  {
    compositionName: "Christ Before the Whipping",
    author: ["J. L. Benoist", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238089",
    dateCreated: "19th century",
    imageUrl: "images/Christ_Before_the_Whipping.webp",
  },
  {
    compositionName: "Last Judgment",
    author: ["L\u00e9onard Gaultier", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238425",
    dateCreated: "16th century",
    imageUrl: "images/Last_Judgment.webp",
  },
  {
    compositionName: "Michel-Ange Bonarroti",
    author: ["Alphonse Fran\u00e7ois", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238427",
    dateCreated: "19th century",
    imageUrl: "images/Michel_Ange_Bonarroti.webp",
  },
  {
    compositionName: "The Virgin of Manchester, painting by Michelangelo",
    author: ["Alphonse Fran\u00e7ois", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238428",
    dateCreated: "19th century",
    imageUrl: "images/The_Virgin_of_Manchester__painting_by_Michelangelo.webp",
  },
  {
    compositionName:
      "Portrait of Alof de Wignacourt, Grand Master of the Order of Malta",
    author: [
      "Nicolas Larmessin the Younger",
      "After Michelangelo Merisi da Caravaggio",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238921",
    dateCreated: "c. 1729",
    imageUrl:
      "images/Portrait_of_Alof_de_Wignacourt__Grand_Master_of_the_Order_of_Malta.webp",
  },
  {
    compositionName: "The Creation of Eve",
    author: ["Joseph Coiny", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239673",
    dateCreated: "19th century",
    imageUrl: "images/The_Creation_of_Eve.webp",
  },
  {
    compositionName: "Zechariah",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275222",
    dateCreated: "18th century",
    imageUrl: "images/Zechariah.webp",
  },
  {
    compositionName: "Isaiah",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275223",
    dateCreated: "18th century",
    imageUrl: "images/Isaiah.webp",
  },
  {
    compositionName: "Achim and Amminadab",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275224",
    dateCreated: "18th century",
    imageUrl: "images/Achim_and_Amminadab.webp",
  },
  {
    compositionName: "Asa",
    author: [
      "Domenico Cunego",
      "Pietro Savorelli",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275225",
    dateCreated: "18th century",
    imageUrl: "images/Asa.webp",
  },
  {
    compositionName: "Judith With the Head of Holofernes",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275226",
    dateCreated: "18th century",
    imageUrl: "images/Judith_With_the_Head_of_Holofernes.webp",
  },
  {
    compositionName: "Outline of the Last Judgment",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275227",
    dateCreated: "18th century",
    imageUrl: "images/Outline_of_the_Last_Judgment.webp",
  },
  {
    compositionName: "Sibylla Erythraea",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275228",
    dateCreated: "18th century",
    imageUrl: "images/Sibylla_Erythraea.webp",
  },
  {
    compositionName: "Sibylla Libica",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275229",
    dateCreated: "18th century",
    imageUrl: "images/Sibylla_Libica.webp",
  },
  {
    compositionName: "The Brazen Serpent",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275234",
    dateCreated: "18th century",
    imageUrl: "images/The_Brazen_Serpent.webp",
  },
  {
    compositionName: "Jeremiah",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275235",
    dateCreated: "18th century",
    imageUrl: "images/Jeremiah.webp",
  },
  {
    compositionName: "Plate 25: La Notte (Night)",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243200",
    dateCreated: "17th century",
    imageUrl: "images/Plate_25__La_Notte__Night_.webp",
  },
  {
    compositionName: "Plate 26: Three Male Torsos",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243201",
    dateCreated: "17th century",
    imageUrl: "images/Plate_26__Three_Male_Torsos.webp",
  },
  {
    compositionName: "Plate 53: Bacchus with Satyr",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243210",
    dateCreated: "17th century",
    imageUrl: "images/Plate_53__Bacchus_with_Satyr.webp",
  },
  {
    compositionName: "Plate 52: Bacchus with Satyr",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243229",
    dateCreated: "17th century",
    imageUrl: "images/Plate_52__Bacchus_with_Satyr.webp",
  },
  {
    compositionName: "Plate 28: Five Male Figures",
    author: [
      "Jan de Bisschop",
      "After Michelangelo Buonarroti",
      "After Raphael",
      "After Annibale Carracci",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243281",
    dateCreated: "17th century",
    imageUrl: "images/Plate_28__Five_Male_Figures.webp",
  },
  {
    compositionName:
      "Plate 12: Male Nude, Lying on his Left Side, Seen from the Back, His Hand on a Tiller",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243413",
    dateCreated: "17th century",
    imageUrl:
      "images/Plate_12__Male_Nude__Lying_on_his_Left_Side__Seen_from_the_Back__His_Hand_on_a_Tiller.webp",
  },
  {
    compositionName: "Plate 23: Aurora (Dawn)",
    author: [
      "Jan de Bisschop",
      "After Michelangelo Buonarroti",
      "After Francesco Salviati",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243414",
    dateCreated: "17th century",
    imageUrl: "images/Plate_23__Aurora__Dawn_.webp",
  },
  {
    compositionName: "Plate 17: Struggle of Two of the Damned",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243801",
    dateCreated: "17th century",
    imageUrl: "images/Plate_17__Struggle_of_Two_of_the_Damned.webp",
  },
  {
    compositionName: "Christ and the Samarian Woman",
    author: [
      "After Nicolas Beatrizet the Younger",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243882",
    dateCreated: "16th century",
    imageUrl: "images/Christ_and_the_Samarian_Woman.webp",
  },
  {
    compositionName: "Concert",
    author: ["Thomas Chambars", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244095",
    dateCreated: "18th century",
    imageUrl: "images/Concert.webp",
  },
  {
    compositionName: "Michelangelo",
    author: ["Giorgio Ghisi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275449",
    dateCreated: "c. 1574",
    imageUrl: "images/Michelangelo.webp",
  },
  {
    compositionName: "Ezekiel",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275677",
    dateCreated: "18th century",
    imageUrl: "images/Ezekiel.webp",
  },
  {
    compositionName: "Joel",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275678",
    dateCreated: "18th century",
    imageUrl: "images/Joel.webp",
  },
  {
    compositionName: "Azor and Nahshon",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275679",
    dateCreated: "18th century",
    imageUrl: "images/Azor_and_Nahshon.webp",
  },
  {
    compositionName: "David and Goliath",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275680",
    dateCreated: "18th century",
    imageUrl: "images/David_and_Goliath.webp",
  },
  {
    compositionName: "Eleazar and Matthan",
    author: [
      "Domenico Cunego",
      "Aloisio Cunego",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275681",
    dateCreated: "18th century",
    imageUrl: "images/Eleazar_and_Matthan.webp",
  },
  {
    compositionName: "Haman Hanged",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275682",
    dateCreated: "18th century",
    imageUrl: "images/Haman_Hanged.webp",
  },
  {
    compositionName: "Hezekiah",
    author: [
      "Domenico Cunego",
      "Pietro Savorelli",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275683",
    dateCreated: "18th century",
    imageUrl: "images/Hezekiah.webp",
  },
  {
    compositionName: "Jacob and Joseph",
    author: [
      "Domenico Cunego",
      "Aloisio Cunego",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275684",
    dateCreated: "18th century",
    imageUrl: "images/Jacob_and_Joseph.webp",
  },
  {
    compositionName: "Jesse",
    author: [
      "Domenico Cunego",
      "Pietro Savorelli",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275685",
    dateCreated: "18th century",
    imageUrl: "images/Jesse.webp",
  },
  {
    compositionName: "Virgin and Dead Christ (Mater Dolorosa)",
    author: ["Caterina Piotti-Pirola", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248344",
    dateCreated: "19th century",
    imageUrl: "images/Virgin_and_Dead_Christ__Mater_Dolorosa_.webp",
  },
  {
    compositionName: "Climbers",
    author: ["Marcantonio Raimondi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/248400",
    dateCreated: "1510",
    imageUrl: "images/Climbers.webp",
  },
  {
    compositionName: "Plate 15: Moses",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249062",
    dateCreated: "17th century",
    imageUrl: "images/Plate_15__Moses.webp",
  },
  {
    compositionName: "Persian Sibyl",
    author: ["John Skippe", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249149",
    dateCreated: "1782",
    imageUrl: "images/Persian_Sibyl.webp",
  },
  {
    compositionName: "Holy Family",
    author: ["Philippe de Soye", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249381",
    dateCreated: "1566",
    imageUrl: "images/Holy_Family.webp",
  },
  {
    compositionName: "Evil",
    author: ["William Sharp", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249593",
    dateCreated: "18th century",
    imageUrl: "images/Evil.webp",
  },
  {
    compositionName: "Last Judgement",
    author: ["Tommaso Piroli", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249997",
    dateCreated: "18th century",
    imageUrl: "images/Last_Judgement.webp",
  },
  {
    compositionName: "Outline of Twelve of the Frescoes Wanting in No. I",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275850",
    dateCreated: "18th century",
    imageUrl: "images/Outline_of_Twelve_of_the_Frescoes_Wanting_in_No__I.webp",
  },
  {
    compositionName: "Tomb of Giulio de'Medici",
    author: ["Cornelis Cort", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275862",
    dateCreated: "1570",
    imageUrl: "images/Tomb_of_Giulio_de_Medici.webp",
  },
  {
    compositionName: "Temptation and Expulsion",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275884",
    dateCreated: "18th century",
    imageUrl: "images/Temptation_and_Expulsion.webp",
  },
  {
    compositionName: "The Deluge",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275885",
    dateCreated: "18th century",
    imageUrl: "images/The_Deluge.webp",
  },
  {
    compositionName: "Noah's Sacrifice",
    author: [
      "Domenico Cunego",
      "Girolamo Carattoni",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275886",
    dateCreated: "18th century",
    imageUrl: "images/Noah_s_Sacrifice.webp",
  },
  {
    compositionName: "Resurrection",
    author: ["Francesco Bartolozzi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276023",
    dateCreated: "18th century",
    imageUrl: "images/Resurrection.webp",
  },
  {
    compositionName: "The Fall of Phaeton",
    author: ["Nicolas Beatrizet the Younger", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276093",
    dateCreated: "1540-1566",
    imageUrl: "images/The_Fall_of_Phaeton.webp",
  },
  {
    compositionName: "Tityus Gnawed by the Vulture",
    author: ["Nicolas Beatrizet the Younger", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276094",
    dateCreated: "16th century",
    imageUrl: "images/Tityus_Gnawed_by_the_Vulture.webp",
  },
  {
    compositionName: "Vegetation and Sun and Moon",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276144",
    dateCreated: "18th century",
    imageUrl: "images/Vegetation_and_Sun_and_Moon.webp",
  },
  {
    compositionName: "Creation of Animals",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276145",
    dateCreated: "18th century",
    imageUrl: "images/Creation_of_Animals.webp",
  },
  {
    compositionName: "Creation of Man",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276146",
    dateCreated: "18th century",
    imageUrl: "images/Creation_of_Man.webp",
  },
  {
    compositionName: "Creation of Woman",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276293",
    dateCreated: "18th century",
    imageUrl: "images/Creation_of_Woman.webp",
  },
  {
    compositionName: "Christ Carried to the Tomb",
    author: ["Pierre Audouin", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276349",
    dateCreated: "19th century",
    imageUrl: "images/Christ_Carried_to_the_Tomb.webp",
  },
  {
    compositionName: "Archers Shooting at a Herm",
    author: ["Nicolas Beatrizet the Younger", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276535",
    dateCreated: "16th century",
    imageUrl: "images/Archers_Shooting_at_a_Herm.webp",
  },
  {
    compositionName: "Soldiers Bathing in the Arno",
    author: ["Agostino Veneziano", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276862",
    dateCreated: "16th century",
    imageUrl: "images/Soldiers_Bathing_in_the_Arno.webp",
  },
  {
    compositionName: "Children's Bacchanal",
    author: ["Anonymous Italy 1553", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277072",
    dateCreated: "16th century",
    imageUrl: "images/Children_s_Bacchanal.webp",
  },
  {
    compositionName: "Michelangelo Buonarroti",
    author: ["Giuseppe Longhi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277433",
    dateCreated: "19th century",
    imageUrl: "images/Michelangelo_Buonarroti.webp",
  },
  {
    compositionName: "Madonna and Child and the Infant S. John",
    author: ["Moritz Steinla", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277641",
    dateCreated: "19th century",
    imageUrl: "images/Madonna_and_Child_and_the_Infant_S__John.webp",
  },
  {
    compositionName: "Ceiling of the Sistine Chapel",
    author: ["Ludwig Gruner", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277909",
    dateCreated: "19th century",
    imageUrl: "images/Ceiling_of_the_Sistine_Chapel.webp",
  },
  {
    compositionName: "Two naked men",
    author: ["Marcantonio Raimondi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278226",
    dateCreated: "16th century",
    imageUrl: "images/Two_naked_men.webp",
  },
  {
    compositionName: "Card Players",
    author: ["Pieter Tanj\u00e9", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279027",
    dateCreated: "18th century",
    imageUrl: "images/Card_Players.webp",
  },
  {
    compositionName: "La Fortuna",
    author: ["Davide Testi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279213",
    dateCreated: "19th century",
    imageUrl: "images/La_Fortuna.webp",
  },
  {
    compositionName: "Cartoon of Pisa",
    author: ["Luigi Schiavonetti", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279254",
    dateCreated: "18th-19th century",
    imageUrl: "images/Cartoon_of_Pisa.webp",
  },
  {
    compositionName: "Entombment",
    author: ["Jonas Suyderhoef", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279422",
    dateCreated: "17th century",
    imageUrl: "images/Entombment.webp",
  },
  {
    compositionName: "Sibylla Cumaea",
    author: ["Giovanni Volpato", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279814",
    dateCreated: "18th century",
    imageUrl: "images/Sibylla_Cumaea.webp",
  },
  {
    compositionName: "Sibylla Delphica",
    author: ["Giovanni Volpato", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279815",
    dateCreated: "18th century",
    imageUrl: "images/Sibylla_Delphica.webp",
  },
  {
    compositionName: "Death of the Virgin",
    author: ["Simon Vall\u00e9e", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279976",
    dateCreated: "1729",
    imageUrl: "images/Death_of_the_Virgin.webp",
  },
  {
    compositionName: "Christ among the Doctors",
    author: ["Parmigianino", "Previously attributed to Michelangelo Anselmi"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/294847",
    dateCreated: "1524-1525",
    imageUrl: "images/Christ_among_the_Doctors.webp",
  },
  {
    compositionName: "Head of Ariadne",
    author: ["Michelangelo Mercoli"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295135",
    dateCreated: "18th century",
    imageUrl: "images/Head_of_Ariadne.webp",
  },
  {
    compositionName: "Kneeling Male Nude",
    author: ["Michelangelo Mercoli"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295136",
    dateCreated: "18th century",
    imageUrl: "images/Kneeling_Male_Nude.webp",
  },
  {
    compositionName: "Study of Two Women and Child",
    author: ["Michelangelo Mercoli"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295315",
    dateCreated: "18th century",
    imageUrl: "images/Study_of_Two_Women_and_Child.webp",
  },
  {
    compositionName: "Hercules and Antaeus (recto and verso)",
    author: ["Michelangelo Anselmi"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/295795",
    dateCreated: "16th century",
    imageUrl: "images/Hercules_and_Antaeus__recto_and_verso_.webp",
  },
  {
    compositionName: "Sadoc",
    author: [
      "Jean-Robert Ango",
      "After Michelangelo Buonarroti",
      "Previously attributed to Jean-Honor\u00e9 Fragonard",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296140",
    dateCreated: "18th century",
    imageUrl: "images/Sadoc.webp",
  },
  {
    compositionName: "Eliud",
    author: [
      "Jean-Robert Ango",
      "After Michelangelo Buonarroti",
      "Previously attributed to Jean-Honor\u00e9 Fragonard",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296179",
    dateCreated: "18th century",
    imageUrl: "images/Eliud.webp",
  },
  {
    compositionName: "Seated Nude",
    author: ["Follower of Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296314",
    dateCreated: "16th century",
    imageUrl: "images/Seated_Nude.webp",
  },
  {
    compositionName: "Ganymede",
    author: ["Copy after Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297213",
    dateCreated: "16th century",
    imageUrl: "images/Ganymede.webp",
  },
  {
    compositionName:
      "Portrait of a Woman in Profile and Sketch of a Bearded Man",
    author: ["Copy after Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297283",
    dateCreated: "16th century",
    imageUrl:
      "images/Portrait_of_a_Woman_in_Profile_and_Sketch_of_a_Bearded_Man.webp",
  },
  {
    compositionName: "Soldiers Playing Cards",
    author: ["School of Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298278",
    dateCreated: "16th century",
    imageUrl: "images/Soldiers_Playing_Cards.webp",
  },
  {
    compositionName: "God the Father and the Prophet Joel",
    author: ["Jean-Honor\u00e9 Fragonard", "After Michelangelo Buonarroti"],
    tale: "At the top of the page is God the Father creating the sun and moon, copied from Michelangelo's fresco in the Sistine Chapel; at the bottom of the page is the Prophet Joel, also copied from the frescoes of the Sistine Chapel.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298359",
    dateCreated: "1761",
    imageUrl: "images/God_the_Father_and_the_Prophet_Joel.webp",
  },
  {
    compositionName: "Seated Woman",
    author: ["Follower of Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298507",
    dateCreated: "16th century",
    imageUrl: "images/Seated_Woman.webp",
  },
  {
    compositionName: "Head of a Bearded Man",
    author: ["Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298520",
    dateCreated: "15th-16th century",
    imageUrl: "images/Head_of_a_Bearded_Man.webp",
  },
  {
    compositionName: "Profile Head of a Young Man",
    author: ["Attributed to Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298521",
    dateCreated: "16th century",
    imageUrl: "images/Profile_Head_of_a_Young_Man.webp",
  },
  {
    compositionName:
      "Cloaked Figure; verso: Half-Length figure with Bound Hands",
    author: ["Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298698",
    dateCreated: "16th century",
    imageUrl:
      "images/Cloaked_Figure__verso__Half_Length_figure_with_Bound_Hands.webp",
  },
  {
    compositionName: "Studies of Men's Heads",
    author: [
      "? Michelangelo Buonarroti",
      "Previously attributed to follower of Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298714",
    dateCreated: "16th century",
    imageUrl: "images/Studies_of_Men_s_Heads.webp",
  },
  {
    compositionName: "Reclining Nude; verso: Drapery study",
    author: ["Follower of Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298916",
    dateCreated: "16th century",
    imageUrl: "images/Reclining_Nude__verso__Drapery_study.webp",
  },
  {
    compositionName: "Profile Head of a Woman",
    author: ["Follower of Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298978",
    dateCreated: "16th century",
    imageUrl: "images/Profile_Head_of_a_Woman.webp",
  },
  {
    compositionName: "A Fantastic Animal",
    author: ["Follower of Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298982",
    dateCreated: "16th century",
    imageUrl: "images/A_Fantastic_Animal.webp",
  },
  {
    compositionName: "Plate 22: Sybil",
    author: [
      "Jan de Bisschop",
      "After Michelangelo Buonarroti",
      "After Francesco Salviati",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274061",
    dateCreated: "17th century",
    imageUrl: "images/Plate_22__Sybil.webp",
  },
  {
    compositionName: "Noah Drunken",
    author: [
      "Domenico Cunego",
      "Girolamo Carattoni",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275221",
    dateCreated: "18th century",
    imageUrl: "images/Noah_Drunken.webp",
  },
  {
    compositionName: "Sibylla Persica",
    author: ["Giorgio Ghisi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275326",
    dateCreated: "16th century",
    imageUrl: "images/Sibylla_Persica.webp",
  },
  {
    compositionName: "Daniel",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275365",
    dateCreated: "18th century",
    imageUrl: "images/Daniel.webp",
  },
  {
    compositionName: "Jonah",
    author: ["Domenico Cunego", "Luigi Fabri", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275366",
    dateCreated: "18th century",
    imageUrl: "images/Jonah.webp",
  },
  {
    compositionName: "Jeremias",
    author: ["Giorgio Ghisi", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275446",
    dateCreated: "16th century",
    imageUrl: "images/Jeremias.webp",
  },
  {
    compositionName: "Josiah",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275686",
    dateCreated: "18th century",
    imageUrl: "images/Josiah.webp",
  },
  {
    compositionName: "Rehoboam",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275687",
    dateCreated: "18th century",
    imageUrl: "images/Rehoboam.webp",
  },
  {
    compositionName: "Salmon",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275688",
    dateCreated: "18th century",
    imageUrl: "images/Salmon.webp",
  },
  {
    compositionName: "Uzziah",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275689",
    dateCreated: "18th century",
    imageUrl: "images/Uzziah.webp",
  },
  {
    compositionName: "Zerubbabel",
    author: [
      "Domenico Cunego",
      "Pietro Savorelli",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275690",
    dateCreated: "18th century",
    imageUrl: "images/Zerubbabel.webp",
  },
  {
    compositionName: "God Dividing Light from Darkness",
    author: ["Domenico Cunego", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275742",
    dateCreated: "18th century",
    imageUrl: "images/God_Dividing_Light_from_Darkness.webp",
  },
  {
    compositionName: "Delphian Sibyl",
    author: ["Timothy Cole", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275759",
    dateCreated: "19th-20th century",
    imageUrl: "images/Delphian_Sibyl.webp",
  },
  {
    compositionName: "Ecce Homo",
    author: [
      "Pierre Fran\u00e7ois Basan",
      "After Michelangelo Merisi da Caravaggio",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240334",
    dateCreated: "18th century",
    imageUrl: "images/Ecce_Homo.webp",
  },
  {
    compositionName: "Michelangelo Merisi da Caravaggio",
    author: ["Etienne Baudet", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240353",
    dateCreated: "17th century",
    imageUrl: "images/Michelangelo_Merisi_da_Caravaggio.webp",
  },
  {
    compositionName: "The Rape of Ganymede",
    author: ["Philippe Thomassin", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/240941",
    dateCreated: "16th-17th century",
    imageUrl: "images/The_Rape_of_Ganymede.webp",
  },
  {
    compositionName:
      "Madonna and Child, with Saint Domimic Distributing Rosaries",
    author: ["Lucas Vorsterman, I", "After Michelangelo Merisi da Caravaggio"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242048",
    dateCreated: "17th century",
    imageUrl:
      "images/Madonna_and_Child__with_Saint_Domimic_Distributing_Rosaries.webp",
  },
  {
    compositionName: "Creation of Eve",
    author: ["Antonio Capellan", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242495",
    dateCreated: "18th century",
    imageUrl: "images/Creation_of_Eve.webp",
  },
  {
    compositionName: "Plate 14: Polyphemus",
    author: [
      "Jan de Bisschop",
      "After Daniele da Volterra",
      "After Michelangelo Buonarroti",
      "After Pellegrino Tibaldi",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244281",
    dateCreated: "17th century",
    imageUrl: "images/Plate_14__Polyphemus.webp",
  },
  {
    compositionName: "Plate 15: Christ with the Cross",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244657",
    dateCreated: "17th century",
    imageUrl: "images/Plate_15__Christ_with_the_Cross.webp",
  },
  {
    compositionName: "Plate 13: Two Male Nudes Lying on their Backs",
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244800",
    dateCreated: "17th century",
    imageUrl: "images/Plate_13__Two_Male_Nudes_Lying_on_their_Backs.webp",
  },
  {
    compositionName: 'Plate 11: "The Dream"',
    author: ["Jan de Bisschop", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244889",
    dateCreated: "17th century",
    imageUrl: "images/Plate_11___The_Dream_.webp",
  },
  {
    compositionName: "Tomb of Lorenzo de Medici",
    author: ["Cornelis Cort", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245129",
    dateCreated: "1570",
    imageUrl: "images/Tomb_of_Lorenzo_de_Medici.webp",
  },
  {
    compositionName: "The Prophet Jeremiah",
    author: [
      "William James Linton",
      "Drawn by William Harvey",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/246825",
    dateCreated: "19th century",
    imageUrl: "images/The_Prophet_Jeremiah.webp",
  },
  {
    compositionName: "The Three Apostles",
    author: [
      "Johann Friedrich Bause",
      "After Michelangelo Merisi da Caravaggio",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/247027",
    dateCreated: "18th-19th century",
    imageUrl: "images/The_Three_Apostles.webp",
  },
  {
    compositionName:
      "Prophet Daniel and Eritrean Sibyl from the Sistine Ceiling",
    author: [
      "Jean-Claude Richard, Abb\u00e9 de Saint-Non",
      "After Jean-Honor\u00e9 Fragonard",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/175973",
    dateCreated: "c. 1770",
    imageUrl:
      "images/Prophet_Daniel_and_Eritrean_Sibyl_from_the_Sistine_Ceiling.webp",
  },
  {
    compositionName:
      'Two Studies of "Night\'s" Leg, after Michelangelo; verso: Banner',
    author: ["Edward Burne-Jones", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/177615",
    dateCreated: "19th century",
    imageUrl:
      "images/Two_Studies_of__Night_s__Leg__after_Michelangelo__verso__Banner.webp",
  },
  {
    compositionName:
      'Study of "Night\'s" Leg, after Michelangelo; verso: Study of "Night," after Michelangelo',
    author: ["Edward Burne-Jones", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/177616",
    dateCreated: "19th century",
    imageUrl:
      "images/Study_of__Night_s__Leg__after_Michelangelo__verso__Study_of__Night___after_Michelangelo.webp",
  },
  {
    compositionName: 'Study of "Dawn," after Michelangelo; verso: blank',
    author: ["Edward Burne-Jones", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/177617",
    dateCreated: "19th century",
    imageUrl: "images/Study_of__Dawn___after_Michelangelo__verso__blank.webp",
  },
  {
    compositionName:
      'Two Studies of "Night\'s" Arm, after Michelangelo; verso: Study of "Night\'s" Arm, after Michelangelo',
    author: ["Edward Burne-Jones", "Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/177687",
    dateCreated: "19th century",
    imageUrl:
      "images/Two_Studies_of__Night_s__Arm__after_Michelangelo__verso__Study_of__Night_s__Arm__after_Michelangelo.webp",
  },
  {
    compositionName: "Female Nude, after Michelangelo; verso: blank",
    author: ["Edward Burne-Jones", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/178200",
    dateCreated: "19th century",
    imageUrl: "images/Female_Nude__after_Michelangelo_____verso__blank.webp",
  },
  {
    compositionName: "The Prophet Isaiah, after Michelangelo",
    author: ["Attributed to August Temmel", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30613",
    dateCreated: "19th century",
    imageUrl: "images/The_Prophet_Isaiah__after_Michelangelo.webp",
  },
  {
    compositionName: "The Libyan Sibyl, after Michelangelo",
    author: ["Attributed to August Temmel", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30651",
    dateCreated: "19th century",
    imageUrl: "images/The_Libyan_Sibyl__after_Michelangelo.webp",
  },
  {
    compositionName: "Eve Taking the Forbidden Fruit, after Michelangelo",
    author: ["Attributed to August Temmel", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30886",
    dateCreated: "19th century",
    imageUrl: "images/Eve_Taking_the_Forbidden_Fruit__after_Michelangelo.webp",
  },
  {
    compositionName: "The Delphic Sibyl, after Michelangelo",
    author: ["Attributed to August Temmel", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30887",
    dateCreated: "19th century",
    imageUrl: "images/The_Delphic_Sibyl__after_Michelangelo.webp",
  },
  {
    compositionName: "Adam, after Michelangelo",
    author: ["Attributed to August Temmel", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30958",
    dateCreated: "19th century",
    imageUrl: "images/Adam__after_Michelangelo.webp",
  },
  {
    compositionName: "The Prophet Joel, after Michelangelo",
    author: ["Attributed to August Temmel", "After Michelangelo Buonarroti"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/30959",
    dateCreated: "19th century",
    imageUrl: "images/The_Prophet_Joel__after_Michelangelo.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Card Players"',
    author: ["Artist of original: Michelangelo Merisi da Caravaggio"],
    tale: "X-Radiograph Description: Detail : One player\r\n\r\nBurroughs Number: 347\r\n\r\nX-Radiograph(s) of: \r\nArtist: Caravaggio, Michelangelo Merisi da (called Caravaggio), Italian, 1571-1610\r\nTitle: Card Players\r\nDescription: Oil on canvas, 94.2 cm x 119.2 cm\r\nOwner: Harvard University Art Museums\r\nObject Number: 1929.253",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344057",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Card_Players_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Boy and Girl"',
    author: ["Artist of original: School of Michelangelo Merisi da Caravaggio"],
    tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 348\r\n\r\nX-Radiograph(s) of: \r\nArtist: School of Caravaggio\r\nTitle: Boy and Girl\r\nOwner: Findley Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/344058",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Boy_and_Girl_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Young Boy"',
    author: ["Artist of original: Michelangelo Merisi da Caravaggio"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2850\r\n\r\nX-Radiograph(s) of: \r\nArtist: Caravaggio, Michelangelo Merisi da (called Caravaggio), Italian, 1571-1610\r\nTitle: Young Boy\r\nOwner: Hartford Museum, CT (Wildenstein Collection)\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346550",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Young_Boy_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Pipe Smocker"',
    author: [
      "Artist of original: Jan Janssens",
      "Artist of original: Also att. to Follower of Michelangelo Merisi da Caravaggio",
    ],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3016\r\n\r\nX-Radiograph(s) of: \r\nArtist: Janssens, Jan, Jan , active early 17th century\r\nArtist: Also att. to Follower of Caravaggio \r\nTitle: Pipe Smocker\r\nOwner: Roger A. Heard Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346693",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Pipe_Smocker_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Deposition"',
    author: ["Artist of original: Michelangelo Merisi da Caravaggio"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3078\r\n\r\nX-Radiograph(s) of: \r\nArtist: Caravaggio, Michelangelo Merisi da (called Caravaggio), Italian, 1571-1610\r\nTitle: Deposition\r\nDate: 1595\r\nOwner: Vatican Museum, Rome\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346747",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Deposition_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Holy Family"',
    author: ["Artist of original: Michelangelo Buonarroti"],
    tale: "Burroughs Number: 3125\r\n\r\nX-Radiograph(s) of: \r\nArtist: Buonarroti, Michelangelo, Italian, 1475-1564\r\nTitle: Holy Family\r\nOwner: Galleria degli Uffizi, Florence\r\nObject Number: 1456",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346770",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Holy_Family_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Pieta"',
    author: [
      "Artist of original: Michelangelo Buonarroti",
      "Artist of original: Also att. to Marcello Venusti",
    ],
    tale: "Burroughs Number: 3163\r\n\r\nX-Radiograph(s) of: \r\nArtist: Buonarroti, Michelangelo, Italian, 1475-1564\r\nArtist: Also att. to Venusti, Marcello, Italian, ca. 1512-1579\r\nTitle: Pieta\r\nOwner: Charles F. Carr Collection\r\n",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/346804",
    dateCreated: "",
    imageUrl: "images/X_radiograph_s__of__Pieta_.webp",
  },
  {
    compositionName: "Three Female Figures after Caravaggio and Raphael",
    author: [
      "Jean-Claude Richard, Abb\u00e9 de Saint-Non",
      "After Jean-Honor\u00e9 Fragonard",
      "After Michelangelo Merisi da Caravaggio",
      "After Raphael",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/265899",
    dateCreated: "1772",
    imageUrl: "images/Three_Female_Figures_after_Caravaggio_and_Raphael.webp",
  },
  {
    compositionName:
      "Detail of Michelangelo's Sistine Ceiling Featuring God the Creator And a Prophet",
    author: [
      "Jean-Claude Richard, Abb\u00e9 de Saint-Non",
      "After Jean-Honor\u00e9 Fragonard",
      "After Michelangelo Buonarroti",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/266332",
    dateCreated: "1770",
    imageUrl:
      "images/Detail_of_Michelangelo_s_Sistine_Ceiling_Featuring_God_the_Creator_And_a_Prophet.webp",
  },
  {
    compositionName: "Honeyboy Edwards",
    author: ["Jeff Dunas"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/190563",
    dateCreated: "1995",
    imageUrl: "images/Honeyboy_Edwards.webp",
  },
  {
    compositionName: "Untitled",
    author: ["Jeff Weiss"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/284600",
    dateCreated: "1976",
    imageUrl: "images/Untitled.webp",
  },
  {
    compositionName: "Freshly Painted Houses",
    author: ["Jeff Brouws"],
    tale: "Printed by the artist; Artist Proof in an edition of 9.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/319231",
    dateCreated: "1991, printed 2007",
    imageUrl: "images/Freshly_Painted_Houses.webp",
  },
  {
    compositionName:
      "Former Enka Rayon Plant, Hominy Creek, Enka, North Carolina",
    author: ["Jeff Rich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370028",
    dateCreated: "2006",
    imageUrl:
      "images/Former_Enka_Rayon_Plant__Hominy_Creek__Enka__North_Carolina.webp",
  },
  {
    compositionName:
      "River Clean-up, Swannanoa River, Asheville, North Carolina",
    author: ["Jeff Rich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370037",
    dateCreated: "2007",
    imageUrl:
      "images/River_Clean_up__Swannanoa_River__Asheville__North_Carolina.webp",
  },
  {
    compositionName:
      "White Oak Lake, Oak Ridge National Laboratory, Oak Ridge, Tennessee",
    author: ["Jeff Rich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370038",
    dateCreated: "2015",
    imageUrl:
      "images/White_Oak_Lake__Oak_Ridge_National_Laboratory__Oak_Ridge__Tennessee.webp",
  },
  {
    compositionName:
      "Mary, Esther, and Ellis, members of the Organization Black Belt Citizens Fighting for Health and Justice, Uniontown, Alabama",
    author: ["Jeff Rich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370039",
    dateCreated: "2014",
    imageUrl:
      "images/Mary__Esther__and_Ellis__members_of_the_Organization_Black_Belt_Citizens_Fighting_for_Health_and_Justice__Uniontown__Alabama.webp",
  },
  {
    compositionName: "Steve\u2019s Chair",
    author: ["Jeff Rich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370040",
    dateCreated: "2011",
    imageUrl: "images/Steve_s_Chair.webp",
  },
  {
    compositionName: "Monitoring Wells, Paducah",
    author: ["Jeff Rich"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370041",
    dateCreated: "2011",
    imageUrl: "images/Monitoring_Wells__Paducah.webp",
  },
  {
    compositionName: "Fluxfest",
    author: ["Ida Griffin", "Larry Baldwin", "Jeff Berner"],
    tale: 'The Fogg owns one Maciunas-published Fluxus edition by Ben Berner (M26383), the "director" of the Fluxfest advertised on this poster.',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/5853",
    dateCreated: "1967",
    imageUrl: "images/Fluxfest.webp",
  },
  {
    compositionName: "Fluxbook",
    author: [
      "Jeff Berner",
      "Designed by George Maciunas",
      "Published by Fluxus",
    ],
    tale: "Transparent plastic box containing printed pages from a small bible encased in epoxy, with offset printed label designed by George Maciunas.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/29699",
    dateCreated: "late 1960s",
    imageUrl: "images/Fluxbook.webp",
  },
  {
    compositionName: "Plan for My Coffin for Changing Direction",
    author: ["Jeff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71846",
    dateCreated: "20th century",
    imageUrl: "images/Plan_for_My_Coffin_for_Changing_Direction.webp",
  },
  {
    compositionName:
      "Plan for Hitler's Coffin with Section Removed with Emasculated Body Parts",
    author: ["Jeff"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71860",
    dateCreated: "20th century",
    imageUrl:
      "images/Plan_for_Hitler_s_Coffin_with_Section_Removed_with_Emasculated_Body_Parts.webp",
  },
  {
    compositionName: "Beaker",
    author: ["Andrew Gregory"],
    tale: "Plain circular with slightly flaring sides and applied horizontal ribs at the base.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227324",
    dateCreated: "1696-1697",
    imageUrl: "images/Beaker.webp",
  },
  {
    compositionName: "Chocolate pot",
    author: ["Andrew Raven"],
    tale: "Of tapering cylindrical form on cast stepped base, with wood scroll side handle and tapering curved spout with hinged cap, the hinged high domed cover with cast corkscrew thumb-piece and stirrer aperture and removable cap with baluster finial; the side engraved with a lozenge of arms within a foliate scroll fish-scale and shell cartouche.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/229275",
    dateCreated: "1706-1707",
    imageUrl: "images/Chocolate_pot.webp",
  },
  {
    compositionName: "Portrait of John Jay",
    author: ["Joseph Andrews", "After Gilbert Stuart"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242131",
    dateCreated: "19th century",
    imageUrl: "images/Portrait_of_John_Jay.webp",
  },
  {
    compositionName: "Martin Luther",
    author: ["Andrew Duncan", "After Hans Holbein the Younger"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245084",
    dateCreated: "19th century",
    imageUrl: "images/Martin_Luther.webp",
  },
  {
    compositionName: "The Only Daughter",
    author: ["Joseph Andrews", "After Gilbert Stuart Newton"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245548",
    dateCreated: "19th century",
    imageUrl: "images/The_Only_Daughter.webp",
  },
  {
    compositionName: "Francesco Maria Rovere, duke of Urbino",
    author: ["Joseph Andrews", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/245549",
    dateCreated: "19th century",
    imageUrl: "images/Francesco_Maria_Rovere__duke_of_Urbino.webp",
  },
  {
    compositionName: "Untitled Portrait",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273277",
    dateCreated: "19th century",
    imageUrl: "images/Untitled_Portrait.webp",
  },
  {
    compositionName: "Jefferson",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273546",
    dateCreated: "19th century",
    imageUrl: "images/Jefferson.webp",
  },
  {
    compositionName: "Witch of Endor",
    author: [
      "Charles Edward Wagstaff",
      "Joseph Andrews",
      "After Washington Allston",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275723",
    dateCreated: "1852",
    imageUrl: "images/Witch_of_Endor.webp",
  },
  {
    compositionName: "Washington",
    author: ["Joseph Andrews", "After Gilbert Stuart"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276303",
    dateCreated: "19th century",
    imageUrl: "images/Washington.webp",
  },
  {
    compositionName: "Children Knock",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276320",
    dateCreated: "19th century",
    imageUrl: "images/Children_Knock.webp",
  },
  {
    compositionName: "Early in the Morning",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276322",
    dateCreated: "19th century",
    imageUrl: "images/Early_in_the_Morning.webp",
  },
  {
    compositionName: "First Tooth",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276323",
    dateCreated: "19th century",
    imageUrl: "images/First_Tooth.webp",
  },
  {
    compositionName: "Goose Girl",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276324",
    dateCreated: "19th century",
    imageUrl: "images/Goose_Girl.webp",
  },
  {
    compositionName: "Plymouth Rock, 1620",
    author: ["Joseph Andrews", "After Peter Frederick Rothermel"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276337",
    dateCreated: "1869",
    imageUrl: "images/Plymouth_Rock__1620.webp",
  },
  {
    compositionName: "Hanapepe Valley",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276364",
    dateCreated: "19th century",
    imageUrl: "images/Hanapepe_Valley.webp",
  },
  {
    compositionName: "Man Addressing Old Man who is Seated in a Chair",
    author: ["Joseph Andrews", "After Felix Octavius Carr Darley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276365",
    dateCreated: "19th century",
    imageUrl: "images/Man_Addressing_Old_Man_who_is_Seated_in_a_Chair.webp",
  },
  {
    compositionName: "Untitled",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276373",
    dateCreated: "19th century",
    imageUrl: "images/Untitled.webp",
  },
  {
    compositionName: "Henry Clay",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276377",
    dateCreated: "19th century",
    imageUrl: "images/Henry_Clay.webp",
  },
  {
    compositionName: "Thomas Dawes",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276378",
    dateCreated: "19th century",
    imageUrl: "images/Thomas_Dawes.webp",
  },
  {
    compositionName: "Mount St. Michael",
    author: ["Andrew F. Affleck"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/257942",
    dateCreated: "20th century",
    imageUrl: "images/Mount_St__Michael.webp",
  },
  {
    compositionName: "James Graham",
    author: ["Joseph Andrews", "After George Peter Alexander Healy"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276483",
    dateCreated: "19th century",
    imageUrl: "images/James_Graham.webp",
  },
  {
    compositionName: "Emily C. Judson",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276494",
    dateCreated: "19th century",
    imageUrl: "images/Emily_C__Judson.webp",
  },
  {
    compositionName: "S.R. Spaulding",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276578",
    dateCreated: "19th century",
    imageUrl: "images/S_R__Spaulding.webp",
  },
  {
    compositionName: "William B. Tappan",
    author: ["Joseph Andrews", "After John Neagle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276579",
    dateCreated: "19th century",
    imageUrl: "images/William_B__Tappan.webp",
  },
  {
    compositionName: "Raising of Lazarus",
    author: ["Joseph Andrews", "After Sebastiano del Piombo"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276723",
    dateCreated: "19th century",
    imageUrl: "images/Raising_of_Lazarus.webp",
  },
  {
    compositionName: "Old Woman Reclining at Foot of Tree",
    author: ["Joseph Andrews", "After Felix Octavius Carr Darley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276724",
    dateCreated: "19th century",
    imageUrl: "images/Old_Woman_Reclining_at_Foot_of_Tree.webp",
  },
  {
    compositionName: "Parson Wells and his Wife",
    author: ["Joseph Andrews", "After Felix Octavius Carr Darley"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276725",
    dateCreated: "19th century",
    imageUrl: "images/Parson_Wells_and_his_Wife.webp",
  },
  {
    compositionName: "Charles Brickett Haddock",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276427",
    dateCreated: "19th century",
    imageUrl: "images/Charles_Brickett_Haddock.webp",
  },
  {
    compositionName: "John H. Clifford",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276453",
    dateCreated: "19th century",
    imageUrl: "images/John_H__Clifford.webp",
  },
  {
    compositionName: "Fourier, socialist",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276454",
    dateCreated: "19th century",
    imageUrl: "images/Fourier__socialist.webp",
  },
  {
    compositionName: "Lincoln",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276455",
    dateCreated: "19th century",
    imageUrl: "images/Lincoln.webp",
  },
  {
    compositionName: "Oliver Wolcott",
    author: ["Joseph Andrews", "After John Trumbull"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276456",
    dateCreated: "19th century",
    imageUrl: "images/Oliver_Wolcott.webp",
  },
  {
    compositionName: "Andrew William Mellon (1855-1937),after Birley",
    author: [
      "Casimir Gregory Stapko",
      "Copy after Oswald Birley",
      "Andrew William Mellon",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304925",
    dateCreated: "1950",
    imageUrl: "images/Andrew_William_Mellon__1855_1937__after_Birley.webp",
  },
  {
    compositionName: "Andrew Preston Peabody (1811-1893)",
    author: ["David M. French", "Andrew Preston Peabody"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305487",
    dateCreated: "1859",
    imageUrl: "images/Andrew_Preston_Peabody__1811_1893_.webp",
  },
  {
    compositionName: "Teel's House",
    author: ["Andrew Wyeth"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/308768",
    dateCreated: "1954",
    imageUrl: "images/Teel_s_House.webp",
  },
  {
    compositionName: "Study of Beech Trunk",
    author: ["Andrew Wyeth"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/308946",
    dateCreated: "20th century",
    imageUrl: "images/Study_of_Beech_Trunk.webp",
  },
  {
    compositionName: 'Lightning Rod, for "Northern Point"',
    author: ["Andrew Wyeth"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/309194",
    dateCreated: "1950",
    imageUrl: "images/Lightning_Rod__for__Northern_Point_.webp",
  },
  {
    compositionName: "Mother and Son",
    author: ["Sybil Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/317241",
    dateCreated: "1932",
    imageUrl: "images/Mother_and_Son.webp",
  },
  {
    compositionName:
      "Commissary Department, Alexandria, Slave Pen, Fort Ellsworth, Seminary Hospital, Camps &c., in distance, No. 119",
    author: ["Andrew Joseph Russell"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362540",
    dateCreated: "c. 1861-1865",
    imageUrl:
      "images/Commissary_Department__Alexandria__Slave_Pen__Fort_Ellsworth__Seminary_Hospital__Camps__c___in_distance__No__119.webp",
  },
  {
    compositionName:
      "Andersonville Prison, Ga., August 17, 1864. South View of Stockade",
    author: ["Andrew Jackson Riddle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362541",
    dateCreated: "1864; printed c. 1870-1889",
    imageUrl:
      "images/Andersonville_Prison__Ga___August_17__1864__South_View_of_Stockade.webp",
  },
  {
    compositionName: "Leaf Cutter Ants",
    author: ["Andrew Freeman"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370150",
    dateCreated: "2007",
    imageUrl: "images/Leaf_Cutter_Ants.webp",
  },
  {
    compositionName: "Bomb Cage / Eagle Sanctuary",
    author: ["Andrew Freeman"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/370151",
    dateCreated: "2007",
    imageUrl: "images/Bomb_Cage___Eagle_Sanctuary.webp",
  },
  {
    compositionName: "Model T Headquarters, Highland Park, Detroit",
    author: ["Andrew Moore"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/371415",
    dateCreated: "2009",
    imageUrl: "images/Model_T_Headquarters__Highland_Park__Detroit.webp",
  },
  {
    compositionName: "Engravings",
    author: ["Joseph Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55253",
    dateCreated: "19th century",
    imageUrl: "images/Engravings.webp",
  },
  {
    compositionName: "Suit Shopping: An Engraved Narrative (triptych)",
    author: ["Andrew Raftery"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/93125",
    dateCreated: "2002",
    imageUrl: "images/Suit_Shopping__An_Engraved_Narrative__triptych_.webp",
  },
  {
    compositionName: "Suit Shopping: An Engraved Narrative (diptych)",
    author: ["Andrew Raftery"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/93303",
    dateCreated: "2002",
    imageUrl: "images/Suit_Shopping__An_Engraved_Narrative__diptych_.webp",
  },
  {
    compositionName: "Sculls",
    author: ["Sybil Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/100552",
    dateCreated: "1930",
    imageUrl: "images/Sculls.webp",
  },
  {
    compositionName:
      "Health, General: United States. U.S. Department of Agriculture. Composition of Food Materials: Chart 2. Eggs and Cheese.: Whole Egg. Egg White and Yolk. Cream Cheese. Cottage Cheese",
    author: ["Andrew B. Graham Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/152202",
    dateCreated: "c. 1903",
    imageUrl:
      "images/Health__General__United_States__U_S__Department_of_Agriculture__Composition_of_Food_Materials__Chart_2__Eggs_and_Cheese___Whole_Egg__Egg_White_and_Yolk__Cream_Cheese__Cottage_Cheese.webp",
  },
  {
    compositionName:
      "Health, General: United States. U.S. Department of Agriculture. Composition of Food Materials: Chart 3. Meat Fresh and Cured",
    author: ["Andrew B. Graham Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/152203",
    dateCreated: "c. 1916",
    imageUrl:
      "images/Health__General__United_States__U_S__Department_of_Agriculture__Composition_of_Food_Materials__Chart_3__Meat_Fresh_and_Cured.webp",
  },
  {
    compositionName:
      "Health, General: United States. U.S. Department of Agriculture. Composition of Food Materials: Chart 11. Fresh and Dried Fruit.: Apple. Dried Fig. Strawberry. Banana",
    author: ["Andrew B. Graham Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/152207",
    dateCreated: "c. 1903",
    imageUrl:
      "images/Health__General__United_States__U_S__Department_of_Agriculture__Composition_of_Food_Materials__Chart_11__Fresh_and_Dried_Fruit___Apple__Dried_Fig__Strawberry__Banana.webp",
  },
  {
    compositionName:
      "Health, General: United States. U.S. Department of Agriculture. Composition of Food Materials: Chart 6. Cereal Grains.: Corn. Wheat. Buckwheat. Oat. Rice. Rye",
    author: ["Andrew B. Graham Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/152221",
    dateCreated: "c. 1903",
    imageUrl:
      "images/Health__General__United_States__U_S__Department_of_Agriculture__Composition_of_Food_Materials__Chart_6__Cereal_Grains___Corn__Wheat__Buckwheat__Oat__Rice__Rye.webp",
  },
  {
    compositionName:
      "Health, General: United States. U.S. Department of Agriculture. Composition of Food Materials: Chart 13. Nuts and Nut Products.: Walnut. Chestnut. Peanut. Peanut Butter. Cocoanut",
    author: ["Andrew B. Graham Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/152253",
    dateCreated: "c. 1903",
    imageUrl:
      "images/Health__General__United_States__U_S__Department_of_Agriculture__Composition_of_Food_Materials__Chart_13__Nuts_and_Nut_Products___Walnut__Chestnut__Peanut__Peanut_Butter__Cocoanut.webp",
  },
  {
    compositionName:
      "Untitled (The ceremony for the driving of the golden spike at Promontory Summit, Utah)",
    author: ["Andrew Joseph Russell"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/157199",
    dateCreated: "May 10, 1869",
    imageUrl:
      "images/Untitled__The_ceremony_for_the_driving_of_the_golden_spike_at_Promontory_Summit__Utah_.webp",
  },
  {
    compositionName:
      "Health: United States: U.S. Department of Agriculture, Composition of Food Materials: Chart 9. Roots and Succulent Vegetables.: Parsnip. Onion. Potato. Celery",
    author: ["Andrew B. Graham Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159287",
    dateCreated: "c. 1903",
    imageUrl:
      "images/Health__United_States__U_S__Department_of_Agriculture__Composition_of_Food_Materials__Chart_9__Roots_and_Succulent_Vegetables___Parsnip__Onion__Potato__Celery.webp",
  },
  {
    compositionName: "The Diggers Movement - 1649",
    author: ["Andrew Castrucci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250390",
    dateCreated: "1993",
    imageUrl: "images/The_Diggers_Movement___1649.webp",
  },
  {
    compositionName: "Logging Team",
    author: ["Sybil Andrews"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250649",
    dateCreated: "1952",
    imageUrl: "images/Logging_Team.webp",
  },
  {
    compositionName: "Barrington Pope Blanchford",
    author: ["Andrew Geddes"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250658",
    dateCreated: "1815",
    imageUrl: "images/Barrington_Pope_Blanchford.webp",
  },
  {
    compositionName: "Fishook",
    author: ["Andrew Castrucci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/250698",
    dateCreated: "1993",
    imageUrl: "images/Fishook.webp",
  },
  {
    compositionName: "Redundant Constellation Series:  Conditioned Responses",
    author: ["Andrew Rubin"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253751",
    dateCreated: "1990",
    imageUrl:
      "images/Redundant_Constellation_Series___Conditioned_Responses.webp",
  },
  {
    compositionName:
      'Hindoo and Mohamedan Buildings, Frontispiece to "Fisher\'s Drawing Room Scrap-Book"',
    author: [
      "George Baxter",
      "Edited and published by Fisher, Son, & Jackson",
      "After David Roberts",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/192580",
    dateCreated: "1832",
    imageUrl:
      "images/Hindoo_and_Mohamedan_Buildings__Frontispiece_to__Fisher_s_Drawing_Room_Scrap_Book_.webp",
  },
  {
    compositionName:
      "Housing Development, Dessau-T\u00f6rten, interior color scheme, building type 4, isometric from below",
    author: ["Werner Jackson (b. Isaacsohn)", "Walter Gropius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/220905",
    dateCreated: "1928",
    imageUrl:
      "images/Housing_Development__Dessau_Torten__interior_color_scheme__building_type_4__isometric_from_below.webp",
  },
  {
    compositionName: "Untitled student exercise from Newcomb College",
    author: ["Ad\u00e8le Jackson Kaars-Sypesteyn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/225377",
    dateCreated: "1942-1949",
    imageUrl: "images/Untitled_student_exercise_from_Newcomb_College.webp",
  },
  {
    compositionName: "Portrait of a Man",
    author: ["John Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228023",
    dateCreated: "c. 1820-1825",
    imageUrl: "images/Portrait_of_a_Man.webp",
  },
  {
    compositionName: "Cruxifixion (Three Plates)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232399",
    dateCreated: "1741",
    imageUrl: "images/Cruxifixion__Three_Plates_.webp",
  },
  {
    compositionName: "Descent from the Cross",
    author: ["John Baptist Jackson", "After Rembrandt Harmensz. van Rijn"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/233044",
    dateCreated: "1738",
    imageUrl: "images/Descent_from_the_Cross.webp",
  },
  {
    compositionName: "Massacre of the Innocents",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243944",
    dateCreated: "18th century",
    imageUrl: "images/Massacre_of_the_Innocents.webp",
  },
  {
    compositionName: "Holy Family with Four Saints",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243945",
    dateCreated: "18th century",
    imageUrl: "images/Holy_Family_with_Four_Saints.webp",
  },
  {
    compositionName: "Brook in Delaford Park, near Iver Buckinghamshire",
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243946",
    dateCreated: "19th century",
    imageUrl: "images/Brook_in_Delaford_Park__near_Iver_Buckinghamshire.webp",
  },
  {
    compositionName: "Mission of Santa Barbara, the Corridor",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/285127",
    dateCreated: "1870s-1890s",
    imageUrl: "images/Mission_of_Santa_Barbara__the_Corridor.webp",
  },
  {
    compositionName: "No. 2",
    author: ["Jackson Pollock"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299931",
    dateCreated: "1950",
    imageUrl: "images/No__2.webp",
  },
  {
    compositionName: "Jackson Pollock (1912-1956)",
    author: ["Hans Namuth", "Jackson Pollock"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/303635",
    dateCreated: "1950",
    imageUrl: "images/Jackson_Pollock__1912_1956_.webp",
  },
  {
    compositionName: "Charles Loring Jackson (1847-1935)",
    author: ["Lilla Cabot Perry", "Charles Loring Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304785",
    dateCreated: "1930",
    imageUrl: "images/Charles_Loring_Jackson__1847_1935_.webp",
  },
  {
    compositionName: "William Eustis Russell (1857-1896)",
    author: ["William Morton Jackson Rice", "William Eustis Russell"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/304949",
    dateCreated: "1898",
    imageUrl: "images/William_Eustis_Russell__1857_1896_.webp",
  },
  {
    compositionName: "Walter Jackson Bate (1918-1999)",
    author: ["Marcella Com\u00e8s", "Walter Jackson Bate"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305048",
    dateCreated: "20th century",
    imageUrl: "images/Walter_Jackson_Bate__1918_1999_.webp",
  },
  {
    compositionName: "John Barnard Swett Jackson (1806-1879)",
    author: ["Edward L. Custer", "John Barnard Swett Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305153",
    dateCreated: "1879",
    imageUrl: "images/John_Barnard_Swett_Jackson__1806_1879_.webp",
  },
  {
    compositionName: "Benjamin Waterhouse (1754-1846)",
    author: ["John Adams Jackson", "Benjamin Waterhouse"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305258",
    dateCreated: "1858",
    imageUrl: "images/Benjamin_Waterhouse__1754_1846_.webp",
  },
  {
    compositionName: "William Jackson Hooker (1785-1865)",
    author: ["Unidentified Artist", "William Jackson Hooker"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305289",
    dateCreated: "1859",
    imageUrl: "images/William_Jackson_Hooker__1785_1865_.webp",
  },
  {
    compositionName: "Jean Louis Rodolphe Agassiz (1807-1873)",
    author: ["John Adams Jackson", "Jean Louis Rodolphe Agassiz"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305341",
    dateCreated: "1874",
    imageUrl: "images/Jean_Louis_Rodolphe_Agassiz__1807_1873_.webp",
  },
  {
    compositionName: "James Jackson (1777-1867)",
    author: [
      "Copied under the direction of Bela Lyon Pratt",
      "James Jackson",
      "After Shobal Vail Clevenger",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305374",
    dateCreated: "19th-20th century",
    imageUrl: "images/James_Jackson__1777_1867_.webp",
  },
  {
    compositionName: "John Bernard Swett Jackson (1806-1879)",
    author: ["Bela Lyon Pratt", "John Barnard Swett Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305387",
    dateCreated: "19th-20th century",
    imageUrl: "images/John_Bernard_Swett_Jackson__1806_1879_.webp",
  },
  {
    compositionName: "Edward Hammond Clarke (1820-1877)",
    author: ["By or copy after John Adams Jackson", "Edward Hammond Clarke"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/305451",
    dateCreated: "19th century",
    imageUrl: "images/Edward_Hammond_Clarke__1820_1877_.webp",
  },
  {
    compositionName: "Untitled",
    author: ["Jackson Pollock"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/309322",
    dateCreated: "1939-1940",
    imageUrl: "images/Untitled.webp",
  },
  {
    compositionName: "Marriage at Cana (left)",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/314861",
    dateCreated: "1740",
    imageUrl: "images/Marriage_at_Cana__left_.webp",
  },
  {
    compositionName: "Marriage at Cana (right)",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/314862",
    dateCreated: "1740",
    imageUrl: "images/Marriage_at_Cana__right_.webp",
  },
  {
    compositionName: "Cruxifixion (one of three sheets, left)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/314863",
    dateCreated: "1741",
    imageUrl: "images/Cruxifixion__one_of_three_sheets__left_.webp",
  },
  {
    compositionName: "Cruxifixion (one of three sheets, center)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/314864",
    dateCreated: "1741",
    imageUrl: "images/Cruxifixion__one_of_three_sheets__center_.webp",
  },
  {
    compositionName: "Cruxifixion (one of three sheets, right)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/314865",
    dateCreated: "1741",
    imageUrl: "images/Cruxifixion__one_of_three_sheets__right_.webp",
  },
  {
    compositionName: "Merrill Staunton Gaunt (1892-1916)",
    author: [
      "Hazel Brill Jackson",
      "Foundry: T. F. McCann & Sons Co.",
      "Portrait of Merrill Staunton Gaunt",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/317358",
    dateCreated: "1917",
    imageUrl: "images/Merrill_Staunton_Gaunt__1892_1916_.webp",
  },
  {
    compositionName: "Tea",
    author: ["Thomas Rowlandson", "Published by Elizabeth Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/356968",
    dateCreated: "May 15, 1786",
    imageUrl: "images/Tea.webp",
  },
  {
    compositionName: "The Dance on Dun-Can",
    author: [
      "Thomas Rowlandson",
      "After Samuel Collings",
      "Published by Elizabeth Jackson",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/356969",
    dateCreated: "May 15, 1786",
    imageUrl: "images/The_Dance_on_Dun_Can.webp",
  },
  {
    compositionName:
      "Andersonville Prison, Ga., August 17, 1864. South View of Stockade",
    author: ["Andrew Jackson Riddle"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362541",
    dateCreated: "1864; printed c. 1870-1889",
    imageUrl:
      "images/Andersonville_Prison__Ga___August_17__1864__South_View_of_Stockade.webp",
  },
  {
    compositionName: "William Street at Exchange Place, about 1831",
    author: ["Walter M. Aikman", "After Alexander Jackson Davis"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/254066",
    dateCreated: "1914",
    imageUrl: "images/William_Street_at_Exchange_Place__about_1831.webp",
  },
  {
    compositionName: "Death of Saint Peter Martyr",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/255719",
    dateCreated: "1739",
    imageUrl: "images/Death_of_Saint_Peter_Martyr.webp",
  },
  {
    compositionName: "Cruxifixion (three plates)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256088",
    dateCreated: "1741",
    imageUrl: "images/Cruxifixion__three_plates_.webp",
  },
  {
    compositionName: "Presentation of the Virgin in the Temple (three plates)",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256089",
    dateCreated: "1742",
    imageUrl:
      "images/Presentation_of_the_Virgin_in_the_Temple__three_plates_.webp",
  },
  {
    compositionName: "Virgin and Child Appearing to Six Saints",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256090",
    dateCreated: "1742",
    imageUrl: "images/Virgin_and_Child_Appearing_to_Six_Saints.webp",
  },
  {
    compositionName: "Entombment",
    author: ["John Baptist Jackson", "After Jacopo Bassano the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256140",
    dateCreated: "1739",
    imageUrl: "images/Entombment.webp",
  },
  {
    compositionName: "Marriage at Cana",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256141",
    dateCreated: "1740",
    imageUrl: "images/Marriage_at_Cana.webp",
  },
  {
    compositionName: "Finding of Moses",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256142",
    dateCreated: "1741",
    imageUrl: "images/Finding_of_Moses.webp",
  },
  {
    compositionName: "Massacare of the Innocents",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256386",
    dateCreated: "18th century",
    imageUrl: "images/Massacare_of_the_Innocents.webp",
  },
  {
    compositionName: "Christ on the Mount of Olives",
    author: ["John Baptist Jackson", "After Jacopo Bassano the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256387",
    dateCreated: "18th century",
    imageUrl: "images/Christ_on_the_Mount_of_Olives.webp",
  },
  {
    compositionName: "The Rich Man and Lazarus (left half)",
    author: ["John Baptist Jackson", "After Jacopo Bassano the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256388",
    dateCreated: "18th century",
    imageUrl: "images/The_Rich_Man_and_Lazarus__left_half_.webp",
  },
  {
    compositionName: "Presentation in the Temple",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256403",
    dateCreated: "1739",
    imageUrl: "images/Presentation_in_the_Temple.webp",
  },
  {
    compositionName:
      "Presentation of the Virgin in the Temple (center portion)",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256404",
    dateCreated: "18th century",
    imageUrl:
      "images/Presentation_of_the_Virgin_in_the_Temple__center_portion_.webp",
  },
  {
    compositionName: "Raising of Lazarus",
    author: ["John Baptist Jackson", "After Leandro Bassano"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256405",
    dateCreated: "18th century",
    imageUrl: "images/Raising_of_Lazarus.webp",
  },
  {
    compositionName: "Rich Man and Lazarus (two plates)",
    author: ["John Baptist Jackson", "After Jacopo Bassano the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256406",
    dateCreated: "18th century",
    imageUrl: "images/Rich_Man_and_Lazarus__two_plates_.webp",
  },
  {
    compositionName: "Mr. Algernon Sidney",
    author: ["John Baptist Jackson", "After Justus van Egmont"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256407",
    dateCreated: "18th century",
    imageUrl: "images/Mr__Algernon_Sidney.webp",
  },
  {
    compositionName: "The Massacre of the Innocents",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256415",
    dateCreated: "18th century",
    imageUrl: "images/The_Massacre_of_the_Innocents.webp",
  },
  {
    compositionName: "Holy Family and Four Saints",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256416",
    dateCreated: "18th century",
    imageUrl: "images/Holy_Family_and_Four_Saints.webp",
  },
  {
    compositionName: "Marriage of Saint Catherine",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/256417",
    dateCreated: "18th century",
    imageUrl: "images/Marriage_of_Saint_Catherine.webp",
  },
  {
    compositionName:
      "Details of Main Entrance of Art Palace, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71426",
    dateCreated: "1894",
    imageUrl:
      "images/Details_of_Main_Entrance_of_Art_Palace__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Panorama of State Buildings, from North East, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71427",
    dateCreated: "1894",
    imageUrl:
      "images/Panorama_of_State_Buildings__from_North_East__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Midway Plaisance, Looking West, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71428",
    dateCreated: "1894",
    imageUrl:
      "images/Midway_Plaisance__Looking_West__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Court of Honor, Looking East, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71429",
    dateCreated: "1894",
    imageUrl:
      "images/Court_of_Honor__Looking_East__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "German Government Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71430",
    dateCreated: "1894",
    imageUrl:
      "images/German_Government_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Interior of Electricity Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77565",
    dateCreated: "1894",
    imageUrl:
      "images/Interior_of_Electricity_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Looking North Between Mines and Electricity Buildings, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77566",
    dateCreated: "1894",
    imageUrl:
      "images/Looking_North_Between_Mines_and_Electricity_Buildings__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Northwest Corner Agricultural Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77567",
    dateCreated: "1894",
    imageUrl:
      "images/Northwest_Corner_Agricultural_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "North Front of Agricultural Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77568",
    dateCreated: "1894",
    imageUrl:
      "images/North_Front_of_Agricultural_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "Statue of Liberty, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77569",
    dateCreated: "1894",
    imageUrl: "images/Statue_of_Liberty__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "Statue of the Republic, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77595",
    dateCreated: "1894",
    imageUrl:
      "images/Statue_of_the_Republic__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "The Water Gate, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77596",
    dateCreated: "1894",
    imageUrl: "images/The_Water_Gate__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Mining and Electricity Buildings, from Transportation Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77597",
    dateCreated: "1894",
    imageUrl:
      "images/Mining_and_Electricity_Buildings__from_Transportation_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Administration Building, from Agricultural Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77598",
    dateCreated: "1894",
    imageUrl:
      "images/Administration_Building__from_Agricultural_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "East Entrance Horticultural Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77599",
    dateCreated: "1894",
    imageUrl:
      "images/East_Entrance_Horticultural_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "View North from Colonnade, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77600",
    dateCreated: "1894",
    imageUrl:
      "images/View_North_from_Colonnade__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "North Facade of Mining Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77601",
    dateCreated: "1894",
    imageUrl:
      "images/North_Facade_of_Mining_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Administration Building, Looking North East, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77648",
    dateCreated: "1894",
    imageUrl:
      "images/Administration_Building__Looking_North_East__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "South Colonnade, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77649",
    dateCreated: "1894",
    imageUrl: "images/South_Colonnade__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Lake Front, from Manufactures Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77650",
    dateCreated: "1894",
    imageUrl:
      "images/Lake_Front__from_Manufactures_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Statue of Columbus, East Entrance Administration Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71135",
    dateCreated: "1894",
    imageUrl:
      "images/Statue_of_Columbus__East_Entrance_Administration_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Manufactures and Electricity Buildings, from Squatters Hut, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71309",
    dateCreated: "1894",
    imageUrl:
      "images/Manufactures_and_Electricity_Buildings__from_Squatters_Hut__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Bird's Eye View of State Buildings at the White City, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71310",
    dateCreated: "1894",
    imageUrl:
      "images/Bird_s_Eye_View_of_State_Buildings_at_the_White_City__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "The Immense Crowd, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71311",
    dateCreated: "1894",
    imageUrl: "images/The_Immense_Crowd__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "Statue of Cowboy, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71312",
    dateCreated: "1894",
    imageUrl: "images/Statue_of_Cowboy__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "Statue of Plenty, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71327",
    dateCreated: "1894",
    imageUrl: "images/Statue_of_Plenty__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Group of Statuary, Transportation Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71328",
    dateCreated: "1894",
    imageUrl:
      "images/Group_of_Statuary__Transportation_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Rear View of MacMonnies Fountain, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71329",
    dateCreated: "1894",
    imageUrl:
      "images/Rear_View_of_MacMonnies_Fountain__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "MacMonnies Fountain, From Grand Plaza, World's Columbian Exposition",
    author: ["William Henry Jackson", "A. Zeese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/71331",
    dateCreated: "1894",
    imageUrl:
      "images/MacMonnies_Fountain__From_Grand_Plaza__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "Pikes Peak from the Garden of the Gods",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158148",
    dateCreated: "1870s",
    imageUrl: "images/Pikes_Peak_from_the_Garden_of_the_Gods.webp",
  },
  {
    compositionName: "Lake San Miguel, Colorado",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158189",
    dateCreated: "1870s",
    imageUrl: "images/Lake_San_Miguel__Colorado.webp",
  },
  {
    compositionName: "Echo City, from Witch Rocks, U.P.P.R., Utah",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158217",
    dateCreated: "1870s",
    imageUrl: "images/Echo_City__from_Witch_Rocks__U_P_P_R___Utah.webp",
  },
  {
    compositionName: "Head of Evans Gulch, Mosquito Pass",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158474",
    dateCreated: "1870s",
    imageUrl: "images/Head_of_Evans_Gulch__Mosquito_Pass.webp",
  },
  {
    compositionName: "Spanish Peaks from Veta Mountain",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158475",
    dateCreated: "1870s",
    imageUrl: "images/Spanish_Peaks_from_Veta_Mountain.webp",
  },
  {
    compositionName: "Badlands on the Wind River, Wyoming",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158605",
    dateCreated: "1860s",
    imageUrl: "images/Badlands_on_the_Wind_River__Wyoming.webp",
  },
  {
    compositionName: "Summit of Marshall Pass",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158690",
    dateCreated: "1870s",
    imageUrl: "images/Summit_of_Marshall_Pass.webp",
  },
  {
    compositionName: "Summit of Gray's Peak",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158691",
    dateCreated: "1870s",
    imageUrl: "images/Summit_of_Gray_s_Peak.webp",
  },
  {
    compositionName: "The Arkansas Valley at Salida, South",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158692",
    dateCreated: "1870s",
    imageUrl: "images/The_Arkansas_Valley_at_Salida__South.webp",
  },
  {
    compositionName: "Mosquito Pass, Head of Evans Gulch",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158693",
    dateCreated: "1870s",
    imageUrl: "images/Mosquito_Pass__Head_of_Evans_Gulch.webp",
  },
  {
    compositionName: "The White City at Midnight, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77579",
    dateCreated: "1894",
    imageUrl:
      "images/The_White_City_at_Midnight__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Electricity Building and Fountain, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77580",
    dateCreated: "1894",
    imageUrl:
      "images/Electricity_Building_and_Fountain__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "Chicago Day, World's Columbian Exposition",
    author: ["William Henry Jackson", "A. Zeese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77592",
    dateCreated: "1894",
    imageUrl: "images/Chicago_Day__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "View North, Between Manufactures and Electricity Buildings, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77593",
    dateCreated: "1894",
    imageUrl:
      "images/View_North__Between_Manufactures_and_Electricity_Buildings__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Manufactures Building, from Horticultural Hall, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77594",
    dateCreated: "1894",
    imageUrl:
      "images/Manufactures_Building__from_Horticultural_Hall__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "View North West, from Manufactures Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77651",
    dateCreated: "1894",
    imageUrl:
      "images/View_North_West__from_Manufactures_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName: "South Facade of Art Palace, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77652",
    dateCreated: "1894",
    imageUrl:
      "images/South_Facade_of_Art_Palace__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "North Lagoon, from Mining Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77653",
    dateCreated: "1894",
    imageUrl:
      "images/North_Lagoon__from_Mining_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "View of North Lagoon, Art Palace and State Buildings, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77654",
    dateCreated: "1894",
    imageUrl:
      "images/View_of_North_Lagoon__Art_Palace_and_State_Buildings__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Administration Building at Night, from Electricity Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77655",
    dateCreated: "1894",
    imageUrl:
      "images/Administration_Building_at_Night__from_Electricity_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Main North Entrance of Agricultural Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77656",
    dateCreated: "1894",
    imageUrl:
      "images/Main_North_Entrance_of_Agricultural_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "South Entrance Mining Building, World's Columbian Exposition",
    author: ["William Henry Jackson", "Franklin Co."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/77657",
    dateCreated: "1894",
    imageUrl:
      "images/South_Entrance_Mining_Building__World_s_Columbian_Exposition.webp",
  },
  {
    compositionName:
      "Lake George reached by the N. Y. Central and Hudson River R.R.",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/156154",
    dateCreated: "1890",
    imageUrl:
      "images/Lake_George_reached_by_the_N__Y__Central_and_Hudson_River_R_R_.webp",
  },
  {
    compositionName:
      "The Palisades, from Dobbs Ferry on the New York Central and Hudson River Railroad",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/156155",
    dateCreated: "1890",
    imageUrl:
      "images/The_Palisades__from_Dobbs_Ferry_on_the_New_York_Central_and_Hudson_River_Railroad.webp",
  },
  {
    compositionName: "Ogden, Utah",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/156189",
    dateCreated: "1880s",
    imageUrl: "images/Ogden__Utah.webp",
  },
  {
    compositionName:
      "West Point as Seen from N. Y. Central and Hudson River RR",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/156206",
    dateCreated: "1880s",
    imageUrl:
      "images/West_Point_as_Seen_from_N__Y__Central_and_Hudson_River_RR.webp",
  },
  {
    compositionName: "Ca\u00f1on of Grand River, Utah",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/157425",
    dateCreated: "c. 1890",
    imageUrl: "images/Canon_of_Grand_River__Utah.webp",
  },
  {
    compositionName: "The Seven Castles, Red Canon, Colorado, Midland R. R.",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158107",
    dateCreated: "1870s",
    imageUrl:
      "images/The_Seven_Castles__Red_Canon__Colorado__Midland_R__R_.webp",
  },
  {
    compositionName: 'View Down the Blackwater from the "Old Dobbins House"',
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158108",
    dateCreated: "c. 1890",
    imageUrl:
      "images/View_Down_the_Blackwater_from_the__Old_Dobbins_House_.webp",
  },
  {
    compositionName: "Up the Potomac from Loudoun Heights",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158109",
    dateCreated: "c. 1892",
    imageUrl: "images/Up_the_Potomac_from_Loudoun_Heights.webp",
  },
  {
    compositionName: "Mouth of Indian Creek",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158123",
    dateCreated: "1870s",
    imageUrl: "images/Mouth_of_Indian_Creek.webp",
  },
  {
    compositionName: "Trout Creek Canon, U.P. RY",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158124",
    dateCreated: "1870s",
    imageUrl: "images/Trout_Creek_Canon__U_P__RY.webp",
  },
  {
    compositionName:
      'Casa Grande of the "Seven Castles" of Red Canon, Colorado, Midland R.R.',
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158125",
    dateCreated: "1870s",
    imageUrl:
      "images/Casa_Grande_of_the__Seven_Castles__of_Red_Canon__Colorado__Midland_R_R_.webp",
  },
  {
    compositionName: "Georgetown, Colorado",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158126",
    dateCreated: "c. 1873",
    imageUrl: "images/Georgetown__Colorado.webp",
  },
  {
    compositionName: "View on Lake Fork, Looking up Snake Creek, Colorado",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/158147",
    dateCreated: "1870s",
    imageUrl: "images/View_on_Lake_Fork__Looking_up_Snake_Creek__Colorado.webp",
  },
  {
    compositionName: '"The Curate of Glevering": Glevering Green',
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243947",
    dateCreated: "19th century",
    imageUrl: "images/_The_Curate_of_Glevering___Glevering_Green.webp",
  },
  {
    compositionName: "Marriage at Cana (two plates)",
    author: ["John Baptist Jackson", "After Paolo Caliari, called Veronese"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243972",
    dateCreated: "1740",
    imageUrl: "images/Marriage_at_Cana__two_plates_.webp",
  },
  {
    compositionName: "Madonna and Child With Six Saints",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243973",
    dateCreated: "1742",
    imageUrl: "images/Madonna_and_Child_With_Six_Saints.webp",
  },
  {
    compositionName: "Saint Peter Martyr",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/243991",
    dateCreated: "1739",
    imageUrl: "images/Saint_Peter_Martyr.webp",
  },
  {
    compositionName: "First Christmas from Home",
    author: ["Mason Jackson", "After Alfred William Hunt"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244027",
    dateCreated: "19th century",
    imageUrl: "images/First_Christmas_from_Home.webp",
  },
  {
    compositionName: "Return Home",
    author: ["Mason Jackson", "After Myles Birket Foster"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244028",
    dateCreated: "19th century",
    imageUrl: "images/Return_Home.webp",
  },
  {
    compositionName: "Miracle of Saint Mark (left plate)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244059",
    dateCreated: "18th century",
    imageUrl: "images/Miracle_of_Saint_Mark__left_plate_.webp",
  },
  {
    compositionName:
      "Presentation of the Young Virgin in the Temple (left plate of three plates)",
    author: ["John Baptist Jackson", "After Titian (Tiziano Vecellio)"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244060",
    dateCreated: "18th century",
    imageUrl:
      "images/Presentation_of_the_Young_Virgin_in_the_Temple__left_plate_of_three_plates_.webp",
  },
  {
    compositionName: "Berncastle on the Moselle",
    author: ["Mason Jackson", "After James Duffield Harding"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244061",
    dateCreated: "19th century",
    imageUrl: "images/Berncastle_on_the_Moselle.webp",
  },
  {
    compositionName: "Cold Without",
    author: ["Mason Jackson", "After Samuel Read"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244069",
    dateCreated: "19th century",
    imageUrl: "images/Cold_Without.webp",
  },
  {
    compositionName: "Julian: A Legend of Ravenhurst",
    author: ["Mason Jackson", "After Richard Principal Leitch"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244070",
    dateCreated: "19th century",
    imageUrl: "images/Julian__A_Legend_of_Ravenhurst.webp",
  },
  {
    compositionName: "Over the Brook",
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244071",
    dateCreated: "19th century",
    imageUrl: "images/Over_the_Brook.webp",
  },
  {
    compositionName: "Return from Milking",
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244072",
    dateCreated: "19th century",
    imageUrl: "images/Return_from_Milking.webp",
  },
  {
    compositionName: "Sprites' Hall",
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244073",
    dateCreated: "19th century",
    imageUrl: "images/Sprites__Hall.webp",
  },
  {
    compositionName: "Killiecrankie, Scotland",
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244082",
    dateCreated: "19th century",
    imageUrl: "images/Killiecrankie__Scotland.webp",
  },
  {
    compositionName: "Old Bridge at Angers",
    author: ["Mason Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244083",
    dateCreated: "19th century",
    imageUrl: "images/Old_Bridge_at_Angers.webp",
  },
  {
    compositionName: "Patience",
    author: ["Mason Jackson", "After Heinrich Carl Anton M\u00fccke"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/244084",
    dateCreated: "1850",
    imageUrl: "images/Patience.webp",
  },
  {
    compositionName: "John Wesley",
    author: ["James Thomson", "After John Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/249064",
    dateCreated: "19th century",
    imageUrl: "images/John_Wesley.webp",
  },
  {
    compositionName: "Miracle of Saint Mark (two plates)",
    author: ["John Baptist Jackson", "After Jacopo Tintoretto"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253451",
    dateCreated: "before 1745",
    imageUrl: "images/Miracle_of_Saint_Mark__two_plates_.webp",
  },
  {
    compositionName: "Marshall Pass, Mt. Ouray",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159085",
    dateCreated: "1870s",
    imageUrl: "images/Marshall_Pass__Mt__Ouray.webp",
  },
  {
    compositionName: "Mount Massive, From Iron Hill",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159086",
    dateCreated: "1870s",
    imageUrl: "images/Mount_Massive__From_Iron_Hill.webp",
  },
  {
    compositionName: "Untitled (waterfall)",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159087",
    dateCreated: "1870s",
    imageUrl: "images/Untitled__waterfall_.webp",
  },
  {
    compositionName: "Panorama of Mexico, the Palace from the Cathedral",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159088",
    dateCreated: "1870s",
    imageUrl: "images/Panorama_of_Mexico__the_Palace_from_the_Cathedral.webp",
  },
  {
    compositionName: "Spanish Peaks from Nunda's",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159118",
    dateCreated: "1870s",
    imageUrl: "images/Spanish_Peaks_from_Nunda_s.webp",
  },
  {
    compositionName: "Mystic Lake, Montana",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159172",
    dateCreated: "c. 1870",
    imageUrl: "images/Mystic_Lake__Montana.webp",
  },
  {
    compositionName: "Mt. Harvard, Sawatch Range, View South on Arkansas River",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159173",
    dateCreated: "c. 1870",
    imageUrl:
      "images/Mt__Harvard__Sawatch_Range__View_South_on_Arkansas_River.webp",
  },
  {
    compositionName: "Mt. Hayden, or the Great Teton",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159174",
    dateCreated: "c. 1870",
    imageUrl: "images/Mt__Hayden__or_the_Great_Teton.webp",
  },
  {
    compositionName: "Cascades from Mt. Blackmore, Montana",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159242",
    dateCreated: "c. 1870",
    imageUrl: "images/Cascades_from_Mt__Blackmore__Montana.webp",
  },
  {
    compositionName: "Middle Creek Near Mt. Blackmore, Montana",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159243",
    dateCreated: "c. 1870",
    imageUrl: "images/Middle_Creek_Near_Mt__Blackmore__Montana.webp",
  },
  {
    compositionName:
      "Moraines on Clear Creek, Valley of the Arkansas, Colorado",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159244",
    dateCreated: "c. 1870",
    imageUrl:
      "images/Moraines_on_Clear_Creek__Valley_of_the_Arkansas__Colorado.webp",
  },
  {
    compositionName: "Three Tetons",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159245",
    dateCreated: "c. 1870",
    imageUrl: "images/Three_Tetons.webp",
  },
  {
    compositionName: "The Three Tetons, Mt. Hayden",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159246",
    dateCreated: "c. 1870",
    imageUrl: "images/The_Three_Tetons__Mt__Hayden.webp",
  },
  {
    compositionName:
      "Quandary Peak, Blue River Range in Distance, North from the Summit of Mt. Lincoln",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159247",
    dateCreated: "c. 1870",
    imageUrl:
      "images/Quandary_Peak__Blue_River_Range_in_Distance__North_from_the_Summit_of_Mt__Lincoln.webp",
  },
  {
    compositionName: "Tower Falls, 115 Feet",
    author: ["William Henry Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/159248",
    dateCreated: "c. 1870",
    imageUrl: "images/Tower_Falls__115_Feet.webp",
  },
  {
    compositionName:
      "Housing Development, Dessau-T\u00f6rten, 1926-1928: Color scheme for walls and ceilings",
    author: ["Werner Jackson (b. Isaacsohn)", "Walter Gropius"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/176285",
    dateCreated: "1926-1928",
    imageUrl:
      "images/Housing_Development__Dessau_Torten__1926_1928__Color_scheme_for_walls_and_ceilings.webp",
  },
  {
    compositionName: "Boys Playing with Crabs",
    author: ["Thomas Pollock Anshutz"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/20475",
    dateCreated: "c. 1894",
    imageUrl: "images/Boys_Playing_with_Crabs.webp",
  },
  {
    compositionName: "Eileen Southern (1920-2002 )",
    author: ["Stephen E. Coit", "Eileen Jackson Southern"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/49409",
    dateCreated: "2005",
    imageUrl: "images/Eileen_Southern__1920_2002__.webp",
  },
  {
    compositionName:
      "Selected Works by John Baptist Jackston after Titian, Veronese, Tintoretto and others",
    author: ["John Baptist Jackson"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/55668",
    dateCreated: "1739",
    imageUrl:
      "images/Selected_Works_by_John_Baptist_Jackston_after_Titian__Veronese__Tintoretto_and_others.webp",
  },
  {
    compositionName: "Untitled (Greeting Card for 1944: front image)",
    author: ["Jackson Pollock"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/56738",
    dateCreated: "c. 1943",
    imageUrl: "images/Untitled__Greeting_Card_for_1944__front_image_.webp",
  },
  {
    compositionName: "The Virgin of the Rocks",
    author: [
      "Auguste Gaspard Louis Boucher Desnoyers",
      "After Leonardo da Vinci",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/268678",
    dateCreated: "19th century",
    imageUrl: "images/The_Virgin_of_the_Rocks.webp",
  },
  {
    compositionName: "Modesta e Vanit\u00e0 (Modesty and Vanity)",
    author: ["Angelo Campanella", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273073",
    dateCreated: "19th century",
    imageUrl: "images/Modesta_e_Vanita__Modesty_and_Vanity_.webp",
  },
  {
    compositionName: "S. Anna colla B. Vergine ed il divino Infante",
    author: ["Giuseppe Benaglia", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273658",
    dateCreated: "19th century",
    imageUrl: "images/S__Anna_colla_B__Vergine_ed_il_divino_Infante.webp",
  },
  {
    compositionName: "Bacchus",
    author: ["Fran\u00e7ois Garnier", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273893",
    dateCreated: "19th century",
    imageUrl: "images/Bacchus.webp",
  },
  {
    compositionName: "Leda",
    author: ["Jean Marie Leroux", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273907",
    dateCreated: "1835",
    imageUrl: "images/Leda.webp",
  },
  {
    compositionName: "The Virgin with Balances",
    author: ["Fran\u00e7ois Garnier", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273952",
    dateCreated: "19th century",
    imageUrl: "images/The_Virgin_with_Balances.webp",
  },
  {
    compositionName: "Madonna with a Flower",
    author: ["Joseph Franck", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/273953",
    dateCreated: "19th century",
    imageUrl: "images/Madonna_with_a_Flower.webp",
  },
  {
    compositionName: "Virgin and Child, Both Holding Flowers",
    author: ["Joseph Juster", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274494",
    dateCreated: "16th century",
    imageUrl: "images/Virgin_and_Child__Both_Holding_Flowers.webp",
  },
  {
    compositionName: 'Detail from "Adoration of the Magi"',
    author: ["Timothy Cole", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274533",
    dateCreated: "19th-20th century",
    imageUrl: "images/Detail_from__Adoration_of_the_Magi_.webp",
  },
  {
    compositionName: "Mater Dolorosa",
    author: ["George Jakob Felsing", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274798",
    dateCreated: "19th century",
    imageUrl: "images/Mater_Dolorosa.webp",
  },
  {
    compositionName: "The Virgin in Bas-relief",
    author: ["Fran\u00e7ois Forster", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/215607",
    dateCreated: "1835",
    imageUrl: "images/The_Virgin_in_Bas_relief.webp",
  },
  {
    compositionName: "Last Supper",
    author: ["Unidentified Artist", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228767",
    dateCreated: "",
    imageUrl: "images/Last_Supper.webp",
  },
  {
    compositionName: "Head of Christ",
    author: ["William Baxter Closson", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/235716",
    dateCreated: "19th century",
    imageUrl: "images/Head_of_Christ.webp",
  },
  {
    compositionName: "Madonna and Child with Saint Anne",
    author: ["Jean Nicholas Laugier", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/238757",
    dateCreated: "1831",
    imageUrl: "images/Madonna_and_Child_with_Saint_Anne.webp",
  },
  {
    compositionName: "The Savior of the World",
    author: ["Mathieu Erin Corr", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239642",
    dateCreated: "19th century",
    imageUrl: "images/The_Savior_of_the_World.webp",
  },
  {
    compositionName: "La Belle Ferronni\u00e8re",
    author: [
      "Fran\u00e7ois Eug\u00e8ne Augustin Bridoux",
      "After Leonardo da Vinci",
    ],
    tale: "A Ferronni\u00e8re\r\nA Ferronni\u00e8re\r\nA ferronni\u00e8re is a forehead ornament worn by ladies in the Renaissance.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/239967",
    dateCreated: "19th century",
    imageUrl: "images/La_Belle_Ferronniere.webp",
  },
  {
    compositionName: "Head of a Woman",
    author: ["Girolamo Mantelli", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242046",
    dateCreated: "18th century",
    imageUrl: "images/Head_of_a_Woman.webp",
  },
  {
    compositionName: "Leonardo da Vinci",
    author: ["Giovacchino Cantini", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/242350",
    dateCreated: "19th century",
    imageUrl: "images/Leonardo_da_Vinci.webp",
  },
  {
    compositionName: "Mona Lisa",
    author: ["Timothy Cole", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274850",
    dateCreated: "19th-20th century",
    imageUrl: "images/Mona_Lisa.webp",
  },
  {
    compositionName: "Goldsmith",
    author: ["Timothy Cole", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/274851",
    dateCreated: "19th-20th century",
    imageUrl: "images/Goldsmith.webp",
  },
  {
    compositionName: "The Battle of Anghiari",
    author: ["G\u00e9rard Edelinck", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/275315",
    dateCreated: "1657-1666",
    imageUrl: "images/The_Battle_of_Anghiari.webp",
  },
  {
    compositionName: "Virgin and Child Who Holds a Pigeon in One Hand",
    author: ["Jacopo Bernardi", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276217",
    dateCreated: "19th century",
    imageUrl: "images/Virgin_and_Child_Who_Holds_a_Pigeon_in_One_Hand.webp",
  },
  {
    compositionName: "Vanity",
    author: ["Maurice Blot", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276225",
    dateCreated: "18th-19th century",
    imageUrl: "images/Vanity.webp",
  },
  {
    compositionName: "The Beautiful Feronniere",
    author: [
      "Fran\u00e7ois Eug\u00e8ne Augustin Bridoux",
      "After Leonardo da Vinci",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276243",
    dateCreated: "19th century",
    imageUrl: "images/The_Beautiful_Feronniere.webp",
  },
  {
    compositionName: "The Madonna of the Lake",
    author: ["Giuseppe Longhi", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/276654",
    dateCreated: "19th century",
    imageUrl: "images/The_Madonna_of_the_Lake.webp",
  },
  {
    compositionName: "Madonna and Child with Donor",
    author: ["Giuseppe Longhi", "Guiseppe Marri", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/277465",
    dateCreated: "19th century",
    imageUrl: "images/Madonna_and_Child_with_Donor.webp",
  },
  {
    compositionName: "Head of the Savior",
    author: ["Raphael Morghen", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278501",
    dateCreated: "18th-19th century",
    imageUrl: "images/Head_of_the_Savior.webp",
  },
  {
    compositionName: "Flora; or Vanity",
    author: ["Antoine Louis Romanet", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279041",
    dateCreated: "18th century",
    imageUrl: "images/Flora__or_Vanity.webp",
  },
  {
    compositionName: "Magdalene",
    author: ["Antonio Ricciani", "After Leonardo da Vinci"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/279303",
    dateCreated: "19th century",
    imageUrl: "images/Magdalene.webp",
  },
{
  compositionName: "The Village Shoemaker",
  author: ["Leonardo Alenza y Nieto"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/295072",
  dateCreated: "19th century",
  imageUrl: "images/The_Village_Shoemaker.webp",
},
{
  compositionName: "A Village Scene",
  author: ["Leonardo Alenza y Nieto"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/295073",
  dateCreated: "19th century",
  imageUrl: "images/A_Village_Scene.webp",
},
{
  compositionName: "Street Musicians",
  author: ["Leonardo Alenza y Nieto"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/295235",
  dateCreated: "19th century",
  imageUrl: "images/Street_Musicians.webp",
},
{
  compositionName: "Two Grotesque Heads",
  author: ["Copy after Leonardo da Vinci", "Possibly by Francesco Melzi"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/295282",
  dateCreated: "15th-16th century",
  imageUrl: "images/Two_Grotesque_Heads.webp",
},
{
  compositionName: "Three Grotesque Heads",
  author: ["Copy after Leonardo da Vinci", "Possibly by Francesco Melzi"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/295350",
  dateCreated: "15th-16th century",
  imageUrl: "images/Three_Grotesque_Heads.webp",
},
{
  compositionName:
    "Two Deformed Heads (the figure on the left possibly a caricature of Dante)",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255867",
  dateCreated: "1645",
  imageUrl:
    "images/Two_Deformed_Heads__the_figure_on_the_left_possibly_a_caricature_of_Dante_.webp",
},
{
  compositionName: "Two Deformed Heads Facing Inward",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255868",
  dateCreated: "1645",
  imageUrl: "images/Two_Deformed_Heads_Facing_Inward.webp",
},
{
  compositionName: "Two  Deformed Heads Facing Each Other",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255939",
  dateCreated: "1645",
  imageUrl: "images/Two__Deformed_Heads_Facing_Each_Other.webp",
},
{
  compositionName: "A  Deformed Couple Facing Each Other",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255940",
  dateCreated: "1645",
  imageUrl: "images/A__Deformed_Couple_Facing_Each_Other.webp",
},
{
  compositionName: "Two Deformed Heads Facing Each Other",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255941",
  dateCreated: "1645",
  imageUrl: "images/Two_Deformed_Heads_Facing_Each_Other.webp",
},
{
  compositionName:
    "A Female with Tied Back Hair and a Bald Man Facing Each Other",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255962",
  dateCreated: "1645",
  imageUrl:
    "images/A_Female_with_Tied_Back_Hair_and_a_Bald_Man_Facing_Each_Other.webp",
},
{
  compositionName: "A Large Man with a Bald Head Facing a Grotesque Female",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255963",
  dateCreated: "1645",
  imageUrl:
    "images/A_Large_Man_with_a_Bald_Head_Facing_a_Grotesque_Female.webp",
},
{
  compositionName: "Combat of Four Horsemen for the Standard",
  author: ["G\u00e9rard Edelinck", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/256749",
  dateCreated: "17th century",
  imageUrl: "images/Combat_of_Four_Horsemen_for_the_Standard.webp",
},
{
  compositionName: "A Couple with a Procuress",
  author: ["Agostino Veneziano", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/257939",
  dateCreated: "16th century",
  imageUrl: "images/A_Couple_with_a_Procuress.webp",
},
{
  compositionName: 'X-radiograph(s) of "Youth Saluting a King"',
  author: [
    "Artist of original: Antonio Cicognara",
    "Artist of original: Also att. to Leonardo di Zanino Scaletti",
  ],
  tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1091\r\n\r\nX-Radiograph(s) of: \r\nArtist: Cicognara, Antonio, Italian, active 1486-1500\r\nArtist: Also att. to Scaletti, Leonardo di Zanino, Italian, active 1457-ca.1487\r\nArtist: Also att. to North Italian School\r\nTitle: Youth Saluting a King\r\nDescription: Wood (cradle) ; 20 1/2 x 17 1/8 (52,1 x 43,5)\r\nOwner: Harvard University Art Museums\r\nObject Number: 1916.479",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/344799",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Youth_Saluting_a_King_.webp",
},
{
  compositionName: 'X-radiograph(s) of "Leda (copy)"',
  author: ["Artist of original: Leonardo da Vinci"],
  tale: "X-Radiograph Description: Print\r\n\r\nBurroughs Number: 1175\r\n\r\nX-Radiograph(s) of: \r\nArtist: Leonardo da Vinci, Italian, 1452-1519\r\nTitle: Leda (copy)\r\nDescription: (under Flemish School ca 1540)\r\nOwner: Philadelphia Museum of Art (Johnson Collection), PA\r\nObject Number: 393 ",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/344884",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Leda__copy__.webp",
},
{
  compositionName: 'X-radiograph(s) of "Madonna and Child"',
  author: [
    "Artist of original: Francesco Napolitano",
    "Artist of original: Also att. to School of Leonardo da Vinci",
  ],
  tale: "X-Radiograph Description: Negative\r\n\r\nBurroughs Number: 1176\r\n\r\nX-Radiograph(s) of: \r\nArtist: Francesco Napolitano, Italian\r\nArtist: Also att. to School of Leonardo da Vinci\r\nTitle: Madonna and Child\r\nOwner: Cleveland Museum, OH\r\nObject Number: 16.779",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/344885",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Madonna_and_Child_.webp",
},
{
  compositionName: 'X-radiograph(s) of "Madonna of the Rocks"',
  author: [
    "Artist of original: Giovanni Antonio Boltraffio",
    "Artist of original: And Leonardo da Vinci",
  ],
  tale: "X-Radiograph Description: Prints (4 details)\r\n\r\nBurroughs Number: 1177\r\n\r\nX-Radiograph(s) of: \r\nArtist: Boltraffio, Giovanni Antonio, Italian, 1466 or 1467-1516\r\nArtist: And Leonardo da Vinci, Italian, 1452-1519\r\nTitle: Madonna of the Rocks\r\nOwner: National Gallery, London\r\nObject Number: 1093",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/344886",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Madonna_of_the_Rocks_.webp",
},
{
  compositionName: 'X-radiograph(s) of "Mona Lisa (Copy)"',
  author: ["Artist of original: Leonardo da Vinci"],
  tale: "X-Radiograph Description: X-Radiograph; Details : half top and half bottom of painting\r\n\r\nBurroughs Number: 1179\r\n\r\nX-Radiograph(s) of: \r\nArtist: Leonardo da Vinci, Italian, 1452-1519\r\nTitle: Mona Lisa (Copy)\r\nDescription: Canvas\r\nOwner: Private Collection\r\n",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/344888",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Mona_Lisa__Copy__.webp",
},
{
  compositionName: 'X-radiograph(s) of "Mona Lisa"',
  author: ["Artist of original: After Leonardo da Vinci"],
  tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 2842\r\n\r\nX-Radiograph(s) of: \r\nArtist: French School\r\nArtist: After Leonardo da Vinci, Italian, 1452-1519\r\nTitle: Mona Lisa\r\nOwner: Private Collection",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/346542",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Mona_Lisa_.webp",
},
{
  compositionName: 'X-radiograph(s) of "St. Jerome"',
  author: ["Artist of original: Leonardo da Vinci"],
  tale: "X-Radiograph Description: Print (nothing shows)\r\n\r\nBurroughs Number: 3045\r\n\r\nX-Radiograph(s) of: \r\nArtist: Leonardo da Vinci, Italian, 1452-1519\r\nTitle: St. Jerome\r\nOwner: Vatican Museum, Rome\r\n",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/346719",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__St__Jerome_.webp",
},
{
  compositionName: 'X-radiograph(s) of "Baptism of Christ"',
  author: [
    "Artist of original: Leonardo da Vinci",
    "Artist of original: Also att. to Andrea del Verrocchio",
  ],
  tale: "X-Radiograph Description: X-Radiograph (4 details)\r\n\r\nBurroughs Number: 3126\r\n\r\nX-Radiograph(s) of: \r\nArtist: Leonardo da Vinci, Italian, 1452-1519\r\nArtist: Also att. to Verrocchio, Andrea del, Italian, 1435-1488\r\nTitle: Baptism of Christ\r\nOwner: Galleria degli Uffizi, Florence\r\nObject Number: 8358",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/346771",
  dateCreated: "",
  imageUrl: "images/X_radiograph_s__of__Baptism_of_Christ_.webp",
},
{
  compositionName: "pelada#594",
  author: ["Leonardo Finotti"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/369295",
  dateCreated: "2012",
  imageUrl: "images/pelada_594.webp",
},
{
  compositionName: "pelada#215",
  author: ["Leonardo Finotti"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/369296",
  dateCreated: "2012",
  imageUrl: "images/pelada_215.webp",
},
{
  compositionName: "The Battle of Anghiari, after Leonardo da Vinci",
  author: [
    "Pierre-Nolasque Bergeret",
    "Printed by Fran\u00e7ois Villain",
    "After Leonardo da Vinci",
  ],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/379130",
  dateCreated: "1834",
  imageUrl: "images/The_Battle_of_Anghiari__after_Leonardo_da_Vinci.webp",
},
{
  compositionName: "The Last Supper",
  author: ["Alexander L. Dick", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/31111",
  dateCreated: "19th century",
  imageUrl: "images/The_Last_Supper.webp",
},
{
  compositionName: "Virgin and Child, with Saint Catherine and Saint Barbara",
  author: ["Joseph Steinm\u00fcller", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/58243",
  dateCreated: "1827",
  imageUrl:
    "images/Virgin_and_Child__with_Saint_Catherine_and_Saint_Barbara.webp",
},
{
  compositionName: "The Last Supper, after Leonardo",
  author: ["Francesco Putinati", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/95079",
  dateCreated: "1816",
  imageUrl: "images/The_Last_Supper__after_Leonardo.webp",
},
{
  compositionName: "Christ, Saviour of the World",
  author: ["Johann Michael Enzing-M\u00fcller", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/242708",
  dateCreated: "19th century",
  imageUrl: "images/Christ__Saviour_of_the_World.webp",
},
{
  compositionName: "Christ Disputing with the Doctors",
  author: [
    "George Jakob Felsing",
    "After Bernardino Luini",
    "After Leonardo da Vinci",
  ],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/244330",
  dateCreated: "19th century",
  imageUrl: "images/Christ_Disputing_with_the_Doctors.webp",
},
{
  compositionName: "Christ Bearing the Cross",
  author: ["Guiseppe Beretta", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/245954",
  dateCreated: "19th century",
  imageUrl: "images/Christ_Bearing_the_Cross.webp",
},
{
  compositionName: "Madonna and Child",
  author: ["Guiseppe Beretta", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/245955",
  dateCreated: "19th century",
  imageUrl: "images/Madonna_and_Child.webp",
},
{
  compositionName: "Mater Amabilis",
  author: ["Xaver Steifensand", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/247680",
  dateCreated: "19th century",
  imageUrl: "images/Mater_Amabilis.webp",
},
{
  compositionName: "Madonna of Count Sch\u00f6nborn at Pommersefelden",
  author: ["Albrecht Christoph Reindel", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/247751",
  dateCreated: "19th century",
  imageUrl: "images/Madonna_of_Count_Schonborn_at_Pommersefelden.webp",
},
{
  compositionName: "Leonardo de Vinci",
  author: ["James Posselwhite", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/248429",
  dateCreated: "19th century",
  imageUrl: "images/Leonardo_de_Vinci.webp",
},
{
  compositionName: "The Holy Catherine",
  author: ["Johann Gotthard von M\u00fcller", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/248513",
  dateCreated: "18th century",
  imageUrl: "images/The_Holy_Catherine.webp",
},
{
  compositionName: "Christ Proclaiming the Law",
  author: [
    "Raphael Morghen",
    "Manuel Esquivel Sotomayor",
    "After Leonardo da Vinci",
  ],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/248724",
  dateCreated: "18th century",
  imageUrl: "images/Christ_Proclaiming_the_Law.webp",
},
{
  compositionName: "Modesty and Vanity",
  author: ["Francesco Scotto", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/249416",
  dateCreated: "18th century",
  imageUrl: "images/Modesty_and_Vanity.webp",
},
{
  compositionName: "A Variety of Heads",
  author: ["Wenceslaus Hollar", "After Leonardo da Vinci"],
  tale: "",
  harvardPage: "https://www.harvardartmuseums.org/collections/object/255829",
  dateCreated: "1645",
  imageUrl: "images/A_Variety_of_Heads.webp",
},
{
  compositionName: "The Barbarian Dance (Before Salom\u00e9 and Herod)",
  author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261226",
    dateCreated: "1905",
    imageUrl: "images/The_Barbarian_Dance__Before_Salome_and_Herod_.webp",
  },
  {
    compositionName: "Head of a Woman: Madeline",
    author: ["Pablo Ruiz Picasso", "Madeline"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278681",
    dateCreated: "1905",
    imageUrl: "images/Head_of_a_Woman__Madeline.webp",
  },
  {
    compositionName: "The Source (Three Women at the Fountain)",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278682",
    dateCreated: "1921",
    imageUrl: "images/The_Source__Three_Women_at_the_Fountain_.webp",
  },
  {
    compositionName: "Painter and Knitting Model",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278683",
    dateCreated: "1927",
    imageUrl: "images/Painter_and_Knitting_Model.webp",
  },
  {
    compositionName:
      "Self-Portrait in Three Forms: The Crowned Painter, the Sculpted Head, and the Amorous Minotaur",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278684",
    dateCreated: "1933",
    imageUrl:
      "images/Self_Portrait_in_Three_Forms__The_Crowned_Painter__the_Sculpted_Head__and_the_Amorous_Minotaur.webp",
  },
  {
    compositionName: "The Woman with the Necklace",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278686",
    dateCreated: "1947",
    imageUrl: "images/The_Woman_with_the_Necklace.webp",
  },
  {
    compositionName: "David and Bethsheba",
    author: ["Pablo Ruiz Picasso", "After Lucas Cranach the Elder"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278687",
    dateCreated: "1947",
    imageUrl: "images/David_and_Bethsheba.webp",
  },
  {
    compositionName: "Woman in the Armchair No. 4 (from the violet)",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278688",
    dateCreated: "1948",
    imageUrl: "images/Woman_in_the_Armchair_No__4__from_the_violet_.webp",
  },
  {
    compositionName: "The Lobster",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278689",
    dateCreated: "1949",
    imageUrl: "images/The_Lobster.webp",
  },
  {
    compositionName: "Mother and Children",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278690",
    dateCreated: "1953",
    imageUrl: "images/Mother_and_Children.webp",
  },
  {
    compositionName: "Interior Scene",
    author: ["Pablo Ruiz Picasso"],
    tale: 'According to Mourlot: "Crayon on stone composition."',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278710",
    dateCreated: "1926",
    imageUrl: "images/Interior_Scene.webp",
  },
  {
    compositionName: "Large Still-Life with Fruit Dish",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278711",
    dateCreated: "1947",
    imageUrl: "images/Large_Still_Life_with_Fruit_Dish.webp",
  },
  {
    compositionName: "The Three Friends",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278726",
    dateCreated: "1923",
    imageUrl: "images/The_Three_Friends.webp",
  },
  {
    compositionName: "Cinésias and his Family",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278727",
    dateCreated: "1934",
    imageUrl: "images/CinÃ_sias_and_his_Family.webp",
  },
  {
    compositionName: "The Feast",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278728",
    dateCreated: "1934",
    imageUrl: "images/The_Feast.webp",
  },
  {
    compositionName: "The Two Turtle-Doves (I)",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278734",
    dateCreated: "1946",
    imageUrl: "images/The_Two_Turtle_Doves__I_.webp",
  },
  {
    compositionName: "Saltimbanque at Rest",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278773",
    dateCreated: "1905",
    imageUrl: "images/Saltimbanque_at_Rest.webp",
  },
  {
    compositionName: "Salomé",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278774",
    dateCreated: "1905",
    imageUrl: "images/SalomÃ_.webp",
  },
  {
    compositionName: "Two Women Looking at Nude Model",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278775",
    dateCreated: "1923",
    imageUrl: "images/Two_Women_Looking_at_Nude_Model.webp",
  },
  {
    compositionName: "The Three Bathers, III",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278776",
    dateCreated: "1923",
    imageUrl: "images/The_Three_Bathers__III.webp",
  },
  {
    compositionName: "The Women's Oath, II",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/278777",
    dateCreated: "1934",
    imageUrl: "images/The_Women_s_Oath__II.webp",
  },
  {
    compositionName: "Woman in Blue",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227565",
    dateCreated: "1949",
    imageUrl: "images/Woman_in_Blue.webp",
  },
  {
    compositionName: "Seated Woman",
    author: [
      "Attributed to Domingues",
      "Previously attributed to imitator of Pablo Ruiz Picasso",
    ],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227734",
    dateCreated: "1927",
    imageUrl: "images/Seated_Woman.webp",
  },
  {
    compositionName: "Plaster Head and Bowl of Fruit",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227738",
    dateCreated: "1933",
    imageUrl: "images/Plaster_Head_and_Bowl_of_Fruit.webp",
  },
  {
    compositionName: "Le Modèle Classique",
    author: ["Imitator of Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/227848",
    dateCreated: "20th century",
    imageUrl: "images/Le_ModÃ_le_Classique.webp",
  },
  {
    compositionName: "Spanish Village",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/228852",
    dateCreated: "1901",
    imageUrl: "images/Spanish_Village.webp",
  },
  {
    compositionName: "Woman with a Chignon",
    author: ["Pablo Ruiz Picasso"],
    tale: "Verso of a two-sided canvas (recto: 1951.55.2)",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/229046",
    dateCreated: "1901",
    imageUrl: "images/Woman_with_a_Chignon.webp",
  },
  {
    compositionName: "Young Girl Wearing a Large Hat",
    author: ["Pablo Ruiz Picasso"],
    tale: "Recto of a two-sided canvas (verso: 1951.55.1)",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/229047",
    dateCreated: "1901",
    imageUrl: "images/Young_Girl_Wearing_a_Large_Hat.webp",
  },
  {
    compositionName: "Still Life with Inkwell",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/232805",
    dateCreated: "c. 1911-1912",
    imageUrl: "images/Still_Life_with_Inkwell.webp",
  },
  {
    compositionName: "Two Nude Women, II",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236086",
    dateCreated: "1930",
    imageUrl: "images/Two_Nude_Women__II.webp",
  },
  {
    compositionName: "Head of a Man",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/236382",
    dateCreated: "1905",
    imageUrl: "images/Head_of_a_Man.webp",
  },
  {
    compositionName: "Minatauromachia",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/252215",
    dateCreated: "20th century",
    imageUrl: "images/Minatauromachia.webp",
  },
  {
    compositionName: "Guitar and Sheet Music on Table",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/253394",
    dateCreated: "20th century",
    imageUrl: "images/Guitar_and_Sheet_Music_on_Table.webp",
  },
  {
    compositionName: "Plate VII",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259601",
    dateCreated: "20th century",
    imageUrl: "images/Plate_VII.webp",
  },
  {
    compositionName: "Plate VIII",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259602",
    dateCreated: "20th century",
    imageUrl: "images/Plate_VIII.webp",
  },
  {
    compositionName: "Plate V",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259912",
    dateCreated: "20th century",
    imageUrl: "images/Plate_V.webp",
  },
  {
    compositionName: "Plate VI",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259920",
    dateCreated: "20th century",
    imageUrl: "images/Plate_VI.webp",
  },
  {
    compositionName: "Reclining Nude",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296539",
    dateCreated: "1923",
    imageUrl: "images/Reclining_Nude.webp",
  },
  {
    compositionName: "Pierrot",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296540",
    dateCreated: "1918",
    imageUrl: "images/Pierrot.webp",
  },
  {
    compositionName: "In the Café",
    author: ["Imitator of Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296589",
    dateCreated: "20th century",
    imageUrl: "images/In_the_CafÃ_.webp",
  },
  {
    compositionName: "Three Graces",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296654",
    dateCreated: "1923",
    imageUrl: "images/Three_Graces.webp",
  },
  {
    compositionName: "Portrait of a Man",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296748",
    dateCreated: "1919",
    imageUrl: "images/Portrait_of_a_Man.webp",
  },
  {
    compositionName: "Mother and Daughter",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296887",
    dateCreated: "1904",
    imageUrl: "images/Mother_and_Daughter.webp",
  },
  {
    compositionName: "Head of a Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/296904",
    dateCreated: "1903",
    imageUrl: "images/Head_of_a_Woman.webp",
  },
  {
    compositionName: "The Blind Man",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/297470",
    dateCreated: "1903",
    imageUrl: "images/The_Blind_Man.webp",
  },
  {
    compositionName: "Portrait of Josep Rocarol",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298059",
    dateCreated: "1899-1900",
    imageUrl: "images/Portrait_of_Josep_Rocarol.webp",
  },
  {
    compositionName: "Weeping Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298060",
    dateCreated: "Oct. 28, 1937",
    imageUrl: "images/Weeping_Woman.webp",
  },
  {
    compositionName: "Woman Having Her Hair Combed",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/298061",
    dateCreated: "1905 - 1906",
    imageUrl: "images/Woman_Having_Her_Hair_Combed.webp",
  },
  {
    compositionName: "Henry Kahnweiler I",
    author: ["Pablo Ruiz Picasso", "Henry Kahnweiler, M.D."],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299855",
    dateCreated: "1957",
    imageUrl: "images/Henry_Kahnweiler_I.webp",
  },
  {
    compositionName: "The Nude Model",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299869",
    dateCreated: "1927",
    imageUrl: "images/The_Nude_Model.webp",
  },
  {
    compositionName: "Head of a Man with a Hat",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299935",
    dateCreated: "1912",
    imageUrl: "images/Head_of_a_Man_with_a_Hat.webp",
  },
  {
    compositionName: "Mother and Child",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299993",
    dateCreated: "c. 1901",
    imageUrl: "images/Mother_and_Child.webp",
  },
  {
    compositionName: "Man with a Pipe",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299994",
    dateCreated: "1911",
    imageUrl: "images/Man_with_a_Pipe.webp",
  },
  {
    compositionName:
      "A Mother and Child and Four Studies of Her Right Hand, 1904; verso:  Self-Portrait Standing, 1903",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/299997",
    dateCreated: "1903-1904",
    imageUrl:
      "images/A_Mother_and_Child_and_Four_Studies_of_Her_Right_Hand__1904__verso___Self_Portrait_Standing__1903.webp",
  },
  {
    compositionName: "Mademoiselle Léonie in a Lounge Chair",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/303585",
    dateCreated: "1910",
    imageUrl: "images/Mademoiselle_LÃ_onie_in_a_Lounge_Chair.webp",
  },
  {
    compositionName: "Still Life with Guitar, Clarinet, Bottle and Sheet Music",
    author: ["Pablo Ruiz Picasso"],
    tale: "Blue decorative stamps on verso.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/312222",
    dateCreated: "1912",
    imageUrl:
      "images/Still_Life_with_Guitar__Clarinet__Bottle_and_Sheet_Music.webp",
  },
  {
    compositionName: "Standing Nude Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/312360",
    dateCreated: "1907",
    imageUrl: "images/Standing_Nude_Woman.webp",
  },
  {
    compositionName: "The Glass",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/312361",
    dateCreated: "1914",
    imageUrl: "images/The_Glass.webp",
  },
  {
    compositionName: "Dream and Lie of Franco",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/322080",
    dateCreated: "1937",
    imageUrl: "images/Dream_and_Lie_of_Franco.webp",
  },
  {
    compositionName: "Poisson d'Avril/April fool",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/342747",
    dateCreated: "1937",
    imageUrl: "images/Poisson_d_Avril_April_fool.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Plaster Head and Fruit"',
    author: ["Pablo Ruiz Picasso"],
    tale: "Burroughs Number: 3770\r\n\r\nX-Radiograph(s) of: \r\nArtist: Picasso, Pablo, Spanish, 1881-1973\r\nTitle: Plaster Head and Fruit\r\nOwner: Harvard University Art Museums\r\nObject Number: 1966.138",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347359",
    dateCreated: null,
    imageUrl: "images/X_radiograph_s__of__Plaster_Head_and_Fruit_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Maternite"',
    author: ["Pablo Ruiz Picasso"],
    tale: "Burroughs Number: 3800\r\n\r\nX-Radiograph(s) of: \r\nArtist: Picasso, Pablo, Spanish, 1881-1973\r\nTitle: Maternite\r\nOwner: Harvard University Art Museums (Wertheim Collection)\r\nObject Number: 1951.57",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347387",
    dateCreated: null,
    imageUrl: "images/X_radiograph_s__of__Maternite_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Spanish Village"',
    author: ["Pablo Ruiz Picasso"],
    tale: "X-Radiograph Description: X-Radiograph\r\n\r\nBurroughs Number: 3936\r\n\r\nX-Radiograph(s) of: \r\nArtist: Picasso, Pablo, Spanish, 1881-1973\r\nTitle: Spanish Village\r\nDate: ca. 1901\r\nOwner: Harvard University Art Museums\r\nObject Number: 1954.38",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347507",
    dateCreated: null,
    imageUrl: "images/X_radiograph_s__of__Spanish_Village_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Maternite"',
    author: ["Pablo Ruiz Picasso"],
    tale: "X-Radiograph Description: 15 separate sheets scanned in xray database, 4345.3e shows both heads\r\n\r\nX-Radiograph Settings: 35 kv, 5 ma, 6 min\r\n\r\nBurroughs Number: 4345\r\n\r\nX-Radiograph(s) of: \r\nArtist: Picasso, Pablo, Spanish, 1881-1973\r\nTitle: Maternite \r\nOwner: Harvard University Art Museums (Wertheim Collection)\r\nObject Number: 1951.57",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347727",
    dateCreated: null,
    imageUrl: "images/X_radiograph_s__of__Maternite__.webp",
  },
  {
    compositionName:
      'X-radiograph(s) of "Woman with a Chignon" and "Girl with a Large Hat"',
    author: ["Pablo Ruiz Picasso"],
    tale: 'X-Radiograph Description: 4 films\r\n\r\nX-Radiograph Settings: 35 kV, 5 mA, 4 minutes 30 seconds, 91" focal distance\r\n\r\nBurroughs Number: 4991\r\n\r\nX-Radiograph(s) of: \r\nArtist: Picasso, Pablo, Spanish, 1881-1973\r\nTitle: "Woman with a Chignon" and "Girl with a Large Hat"\r\nDescription: double sided oil on canvas\r\nOwner: Harvard Art Museums\r\nObject Number: 1951.55.1 and 1951.55.2',
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347905",
    dateCreated: "July 1, 2012",
    imageUrl:
      "images/X_radiograph_s__of__Woman_with_a_Chignon__and__Girl_with_a_Large_Hat_.webp",
  },
  {
    compositionName: 'X-radiograph(s) of "Maternite, Mother and Child"',
    author: ["Pablo Ruiz Picasso"],
    tale: "X-Radiograph Settings: 35 kV, 5 mA, 4 minutes\r\n\r\nBurroughs Number: 4993\r\n\r\nX-Radiograph(s) of: \r\nArtist: Picasso, Pablo, Spanish, 1881-1973\r\nTitle: Maternite, Mother and Child\r\nDescription: oil on glue-lined canvas\r\nOwner: Harvard Art Museums\r\nObject Number: 1951.57",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/347908",
    dateCreated: "August 1, 2012",
    imageUrl: "images/X_radiograph_s__of__Maternite__Mother_and_Child_.webp",
  },
  {
    compositionName: "Jacqueline with Glossy Hair (state i/v: beige)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362467",
    dateCreated: "1962",
    imageUrl: "images/Jacqueline_with_Glossy_Hair__state_i_v__beige_.webp",
  },
  {
    compositionName: "Jacqueline with Glossy Hair (state i-ii/v: yellow)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362468",
    dateCreated: "1962",
    imageUrl: "images/Jacqueline_with_Glossy_Hair__state_i_ii_v__yellow_.webp",
  },
  {
    compositionName:
      "Jacqueline with Glossy Hair (state ii/v: yellow on beige)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362469",
    dateCreated: "1962",
    imageUrl:
      "images/Jacqueline_with_Glossy_Hair__state_ii_v__yellow_on_beige_.webp",
  },
  {
    compositionName: "Jacqueline with Glossy Hair (state ii-iii/v: red)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362470",
    dateCreated: "1962",
    imageUrl: "images/Jacqueline_with_Glossy_Hair__state_ii_iii_v__red_.webp",
  },
  {
    compositionName:
      "Jacqueline with Glossy Hair (state iii/v: red on yellow on beige)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362471",
    dateCreated: "1962",
    imageUrl:
      "images/Jacqueline_with_Glossy_Hair__state_iii_v__red_on_yellow_on_beige_.webp",
  },
  {
    compositionName: "Jacqueline with Glossy Hair (state iii-iv/v: blue)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362472",
    dateCreated: "1962",
    imageUrl: "images/Jacqueline_with_Glossy_Hair__state_iii_iv_v__blue_.webp",
  },
  {
    compositionName:
      "Jacqueline with Glossy Hair (state iv/v: blue on red on yellow on beige)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362473",
    dateCreated: "1962",
    imageUrl:
      "images/Jacqueline_with_Glossy_Hair__state_iv_v__blue_on_red_on_yellow_on_beige_.webp",
  },
  {
    compositionName: "Jacqueline with Glossy Hair (state iv-v/v: black)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362474",
    dateCreated: "1962",
    imageUrl: "images/Jacqueline_with_Glossy_Hair__state_iv_v_v__black_.webp",
  },
  {
    compositionName:
      "Jacqueline with Glossy Hair (state v/v: black on blue on red on yellow on beige)",
    author: ["Pablo Ruiz Picasso", "Printed by Hidalgo Arnéra"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/362475",
    dateCreated: "1962",
    imageUrl:
      "images/Jacqueline_with_Glossy_Hair__state_v_v__black_on_blue_on_red_on_yellow_on_beige_.webp",
  },
  {
    compositionName: "Wood-Owl Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "A white turned vase with black decorative paint representing a woman's head.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/96465",
    dateCreated: "1951",
    imageUrl: "images/Wood_Owl_Woman.webp",
  },
  {
    compositionName: "Woman beside the Sea",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/142856",
    dateCreated: "1924",
    imageUrl: "images/Woman_beside_the_Sea.webp",
  },
  {
    compositionName: "Bather with a Bath Towel",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/186119",
    dateCreated: "1940",
    imageUrl: "images/Bather_with_a_Bath_Towel.webp",
  },
  {
    compositionName: "Seated Nude and Head of a Man with his Arm Raised",
    author: ["Pablo Ruiz Picasso"],
    tale: "framed",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/193677",
    dateCreated: "1967",
    imageUrl: "images/Seated_Nude_and_Head_of_a_Man_with_his_Arm_Raised.webp",
  },
  {
    compositionName: "Dishevelled Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "White earthenware with relief decoration under partial brushed colored (ivory, blue, green and black) glazes.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/212500",
    dateCreated: "1963",
    imageUrl: "images/Dishevelled_Woman.webp",
  },
  {
    compositionName: "Glass of Absinthe and Cigarette",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/220256",
    dateCreated: "1914",
    imageUrl: "images/Glass_of_Absinthe_and_Cigarette.webp",
  },
  {
    compositionName: "The Pomegranate",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/222185",
    dateCreated: "1911-1912",
    imageUrl: "images/The_Pomegranate.webp",
  },
  {
    compositionName: "Zeit-Echo, no. 1",
    author: ["Rudolf Grossmann", "Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/223385",
    dateCreated: "1915-1916",
    imageUrl: "images/Zeit_Echo__no__1.webp",
  },
  {
    compositionName: "Two Nude Figures",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/226233",
    dateCreated: "1909",
    imageUrl: "images/Two_Nude_Figures.webp",
  },
  {
    compositionName: "Leiris Gallery Poster for the 1957 Exhibition",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260909",
    dateCreated: "1957",
    imageUrl: "images/Leiris_Gallery_Poster_for_the_1957_Exhibition.webp",
  },
  {
    compositionName: "Working Painter observed by Nude Model",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261154",
    dateCreated: "1927-1928",
    imageUrl: "images/Working_Painter_observed_by_Nude_Model.webp",
  },
  {
    compositionName: "Painter before His Painting",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261202",
    dateCreated: "1927",
    imageUrl: "images/Painter_before_His_Painting.webp",
  },
  {
    compositionName: "Female Nude putting flowers in her hair",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261203",
    dateCreated: "1930",
    imageUrl: "images/Female_Nude_putting_flowers_in_her_hair.webp",
  },
  {
    compositionName: "Fish Subject",
    author: ["Pablo Ruiz Picasso"],
    tale: "This fish-shaped turned pitcher is part of an unnumbered edition of 500, produced by Madoura Pottery.",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/172984",
    dateCreated: "1952",
    imageUrl: "images/Fish_Subject.webp",
  },
  {
    compositionName: "Plate IX",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259921",
    dateCreated: "20th century",
    imageUrl: "images/Plate_IX.webp",
  },
  {
    compositionName: "Plate X",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259922",
    dateCreated: "20th century",
    imageUrl: "images/Plate_X.webp",
  },
  {
    compositionName: "Plate XIII",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259923",
    dateCreated: "20th century",
    imageUrl: "images/Plate_XIII.webp",
  },
  {
    compositionName: "Plate XIV",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259924",
    dateCreated: "20th century",
    imageUrl: "images/Plate_XIV.webp",
  },
  {
    compositionName: "The Ostrich",
    author: ["Pablo Ruiz Picasso", "Printed by Roger Lacourière"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/259977",
    dateCreated: "1936 - 1942",
    imageUrl: "images/The_Ostrich.webp",
  },
  {
    compositionName: "The Ram",
    author: ["Pablo Ruiz Picasso", "Printed by Roger Lacourière"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260038",
    dateCreated: "1936-1942",
    imageUrl: "images/The_Ram.webp",
  },
  {
    compositionName: "Plate XVI",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260054",
    dateCreated: "20th century",
    imageUrl: "images/Plate_XVI.webp",
  },
  {
    compositionName: "Plate XVII",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260055",
    dateCreated: "20th century",
    imageUrl: "images/Plate_XVII.webp",
  },
  {
    compositionName: "Plate IV",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260281",
    dateCreated: "20th century",
    imageUrl: "images/Plate_IV.webp",
  },
  {
    compositionName: "Plate III",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260302",
    dateCreated: "20th century",
    imageUrl: "images/Plate_III.webp",
  },
  {
    compositionName:
      'Illustration to "Helène chez Archimède," by Andres Suarès',
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260372",
    dateCreated: "20th century",
    imageUrl:
      "images/Illustration_to__HelÃ_ne_chez_ArchimÃ_de___by_Andres_SuarÃ_s.webp",
  },
  {
    compositionName: "Plate XI",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260398",
    dateCreated: "20th century",
    imageUrl: "images/Plate_XI.webp",
  },
  {
    compositionName: "Plate XII",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260399",
    dateCreated: "20th century",
    imageUrl: "images/Plate_XII.webp",
  },
  {
    compositionName: "Little girl with hoop",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261427",
    dateCreated: "c. 1920",
    imageUrl: "images/Little_girl_with_hoop.webp",
  },
  {
    compositionName: "Toros Vallauris",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261428",
    dateCreated: "1958",
    imageUrl: "images/Toros_Vallauris.webp",
  },
  {
    compositionName: "Goat Skull on Table",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260837",
    dateCreated: "1953",
    imageUrl: "images/Goat_Skull_on_Table.webp",
  },
  {
    compositionName:
      "Variations on the Theme of Las Meninas: Visitors to the Studio",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260838",
    dateCreated: "1955",
    imageUrl:
      "images/Variations_on_the_Theme_of_Las_Meninas__Visitors_to_the_Studio.webp",
  },
  {
    compositionName: "The Woman in the Armchair",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260842",
    dateCreated: "1947",
    imageUrl: "images/The_Woman_in_the_Armchair.webp",
  },
  {
    compositionName: "Vase of Flowers with Floral Design Carpet",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260843",
    dateCreated: "1947",
    imageUrl: "images/Vase_of_Flowers_with_Floral_Design_Carpet.webp",
  },
  {
    compositionName: "Cover Mourlot II, Claude (right)",
    author: ["Pablo Ruiz Picasso", "Claude Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260844",
    dateCreated: "1950",
    imageUrl: "images/Cover_Mourlot_II__Claude__right_.webp",
  },
  {
    compositionName: "Cover Mourlot II, Paloma (left)",
    author: ["Pablo Ruiz Picasso", "Paloma Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260845",
    dateCreated: "1950",
    imageUrl: "images/Cover_Mourlot_II__Paloma__left_.webp",
  },
  {
    compositionName: "Portrait of Max Jacob",
    author: ["Pablo Ruiz Picasso", "Max Jacob"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260846",
    dateCreated: "1953",
    imageUrl: "images/Portrait_of_Max_Jacob.webp",
  },
  {
    compositionName: "Jacqueline Reading",
    author: ["Pablo Ruiz Picasso", "Jacqueline Roque Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260847",
    dateCreated: "1957",
    imageUrl: "images/Jacqueline_Reading.webp",
  },
  {
    compositionName: "Woman on the Balcony",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260848",
    dateCreated: "1960",
    imageUrl: "images/Woman_on_the_Balcony.webp",
  },
  {
    compositionName: "Pierrot and Harlequin",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260849",
    dateCreated: "20th century",
    imageUrl: "images/Pierrot_and_Harlequin.webp",
  },
  {
    compositionName: "Jacqueline in a Black Hat",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260850",
    dateCreated: "1962",
    imageUrl: "images/Jacqueline_in_a_Black_Hat.webp",
  },
  {
    compositionName: "The Fauns Dance",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260854",
    dateCreated: "1957",
    imageUrl: "images/The_Fauns_Dance.webp",
  },
  {
    compositionName: "The Horsewoman",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260855",
    dateCreated: "1960",
    imageUrl: "images/The_Horsewoman.webp",
  },
  {
    compositionName: "Pierrot, Orchestra Conductor",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260856",
    dateCreated: "c. 1920",
    imageUrl: "images/Pierrot__Orchestra_Conductor.webp",
  },
  {
    compositionName: "Portrait of Ambroise Vollard, III",
    author: ["Pablo Ruiz Picasso", "Ambroise Vollard"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260901",
    dateCreated: "1937",
    imageUrl: "images/Portrait_of_Ambroise_Vollard__III.webp",
  },
  {
    compositionName: "Dream and Lie of Franco, I",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260902",
    dateCreated: "1937",
    imageUrl: "images/Dream_and_Lie_of_Franco__I.webp",
  },
  {
    compositionName: "The Dance of the Banderillas",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260905",
    dateCreated: "1954",
    imageUrl: "images/The_Dance_of_the_Banderillas.webp",
  },
  {
    compositionName: "Pierrot and Harlequin in a Café",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/260906",
    dateCreated: "20th century",
    imageUrl: "images/Pierrot_and_Harlequin_in_a_CafÃ_.webp",
  },
  {
    compositionName: "Still Life, Bottle of Marc",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261227",
    dateCreated: "1911",
    imageUrl: "images/Still_Life__Bottle_of_Marc.webp",
  },
  {
    compositionName: "Satyr Unveiling a Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261256",
    dateCreated: "1936",
    imageUrl: "images/Satyr_Unveiling_a_Woman.webp",
  },
  {
    compositionName: "Female Nude with Bent Knee",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261275",
    dateCreated: "1931",
    imageUrl: "images/Female_Nude_with_Bent_Knee.webp",
  },
  {
    compositionName: "Still Life with Fruit Stand",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261289",
    dateCreated: "1945",
    imageUrl: "images/Still_Life_with_Fruit_Stand.webp",
  },
  {
    compositionName: "Two Nude Women",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261290",
    dateCreated: "1945",
    imageUrl: "images/Two_Nude_Women.webp",
  },
  {
    compositionName: "The Watering-Place",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261303",
    dateCreated: "1906",
    imageUrl: "images/The_Watering_Place.webp",
  },
  {
    compositionName: "The Bath",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261304",
    dateCreated: "1905",
    imageUrl: "images/The_Bath.webp",
  },
  {
    compositionName: "The Studio",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261305",
    dateCreated: "1927",
    imageUrl: "images/The_Studio.webp",
  },
  {
    compositionName:
      "Harpy with the Head of a Bull, and Four Small Children on Top of a Tower",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261320",
    dateCreated: "1934",
    imageUrl:
      "images/Harpy_with_the_Head_of_a_Bull__and_Four_Small_Children_on_Top_of_a_Tower.webp",
  },
  {
    compositionName: "Young Sculptor Finishing a Bust",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261321",
    dateCreated: "1933",
    imageUrl: "images/Young_Sculptor_Finishing_a_Bust.webp",
  },
  {
    compositionName: "Sculptor at Rest with Marie-Thérèse as the Bashful Venus",
    author: ["Pablo Ruiz Picasso", "Walter, Marie-Thérèse"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261322",
    dateCreated: "1933",
    imageUrl:
      "images/Sculptor_at_Rest_with_Marie_ThÃ_rÃ_se_as_the_Bashful_Venus.webp",
  },
  {
    compositionName:
      "Dreaming Sculptor, Black Haired Model, and Bowl with three Anemones",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261323",
    dateCreated: "1933",
    imageUrl:
      "images/Dreaming_Sculptor__Black_Haired_Model__and_Bowl_with_three_Anemones.webp",
  },
  {
    compositionName: "Reclining Woman",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261362",
    dateCreated: "1924",
    imageUrl: "images/Reclining_Woman.webp",
  },
  {
    compositionName: "The Black Owl",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261364",
    dateCreated: "1947",
    imageUrl: "images/The_Black_Owl.webp",
  },
  {
    compositionName: "Woman Reading",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261370",
    dateCreated: "1947",
    imageUrl: "images/Woman_Reading.webp",
  },
  {
    compositionName: "Portrait of Ambroise Vollard, I",
    author: ["Pablo Ruiz Picasso", "Ambroise Vollard"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261377",
    dateCreated: "1937",
    imageUrl: "images/Portrait_of_Ambroise_Vollard__I.webp",
  },
  {
    compositionName: "The Picador",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261378",
    dateCreated: "1952",
    imageUrl: "images/The_Picador.webp",
  },
  {
    compositionName: "Chicken",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261379",
    dateCreated: "1952",
    imageUrl: "images/Chicken.webp",
  },
  {
    compositionName: "Cover Mourlot I (right)",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261386",
    dateCreated: "1949",
    imageUrl: "images/Cover_Mourlot_I__right_.webp",
  },
  {
    compositionName: "Cover Mourlot I (left)",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261387",
    dateCreated: "1949",
    imageUrl: "images/Cover_Mourlot_I__left_.webp",
  },
  {
    compositionName: "Composed Figure II",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261388",
    dateCreated: "1949",
    imageUrl: "images/Composed_Figure_II.webp",
  },
  {
    compositionName: "Head of a Girl",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261391",
    dateCreated: "1948",
    imageUrl: "images/Head_of_a_Girl.webp",
  },
  {
    compositionName: "The Madam's Party",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261392",
    dateCreated: "1971",
    imageUrl: "images/The_Madam_s_Party.webp",
  },
  {
    compositionName: "Pigeon and Her Chicks",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261401",
    dateCreated: "1947",
    imageUrl: "images/Pigeon_and_Her_Chicks.webp",
  },
  {
    compositionName: "Composition with a Vase of Flowers",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261402",
    dateCreated: "1947",
    imageUrl: "images/Composition_with_a_Vase_of_Flowers.webp",
  },
  {
    compositionName: "Faun Musician, No. 4",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261403",
    dateCreated: "1948",
    imageUrl: "images/Faun_Musician__No__4.webp",
  },
  {
    compositionName: "Dances",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261404",
    dateCreated: "1954",
    imageUrl: "images/Dances.webp",
  },
  {
    compositionName: "Bull at Play",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261405",
    dateCreated: "1954",
    imageUrl: "images/Bull_at_Play.webp",
  },
  {
    compositionName: "Jacqueline",
    author: ["Pablo Ruiz Picasso", "Roque, Jacqueline"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261406",
    dateCreated: "1956",
    imageUrl: "images/Jacqueline.webp",
  },
  {
    compositionName: "Two Sitting Nudes",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261407",
    dateCreated: "1930",
    imageUrl: "images/Two_Sitting_Nudes.webp",
  },
  {
    compositionName: "Two Female Nudes in a Tree",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261408",
    dateCreated: "1931",
    imageUrl: "images/Two_Female_Nudes_in_a_Tree.webp",
  },
  {
    compositionName: "The Minotaur's Revels",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261409",
    dateCreated: "1933",
    imageUrl: "images/The_Minotaur_s_Revels.webp",
  },
  {
    compositionName: "Portrait of Ambroise Vollard, II",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261410",
    dateCreated: "1937",
    imageUrl: "images/Portrait_of_Ambroise_Vollard__II.webp",
  },
  {
    compositionName: "Figure, Bather in the Hut",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261416",
    dateCreated: "1929",
    imageUrl: "images/Figure__Bather_in_the_Hut.webp",
  },
  {
    compositionName: "Woman's Head",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261417",
    dateCreated: "1945",
    imageUrl: "images/Woman_s_Head.webp",
  },
  {
    compositionName: "The Fauns and the Centauress",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261418",
    dateCreated: "1947",
    imageUrl: "images/The_Fauns_and_the_Centauress.webp",
  },
  {
    compositionName: "Table with guitar and sheet music",
    author: ["Pablo Ruiz Picasso"],
    tale: "",
    harvardPage: "https://www.harvardartmuseums.org/collections/object/261426",
    dateCreated: "20th century",
    imageUrl: "images/Table_with_guitar_and_sheet_music.webp",
  },
];
export default compositionsFetched;